import { Schema } from "js-data";
import * as PASchema from "./PAdbSchema";
import * as _ from "lodash";

import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default,
    KeyGenSpecs_Poolsize_200,
    KeyGenSpecs_Poolsize_250,
    KeyGenSpecs_Poolsize_50,
    KeyGenSpecs_Poolsize_500,
    KeyGenSpecs_Poolsize_2000,
    KeyGenSpecs_BigInt_default,
    KeyGenSpecs_BigInt_PoolSize_2000,
} from "./PAdbSchema";

// Define Schema
export const WB_Entity = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Sets", // optional
    description: "Schema for Entity records", // optional
    type: "object",
    track: true,
    properties: {
        WB_ENTITY_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        ENTITY_ID: {
            type: "string",
            length: 50,
        },
        ENTITY_NAME: {
            type: "string",
            length: 256,
        },
        ENTITY_DIMENSION: {
            type: "string",
            length: 50,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        SET_TYPE: {
            type: "string",
            length: 20,
        },
        WB_UI_APPEXEC_ID: {
            type: "number",
        },
        META_TYPE: {
            type: "string",
            length: 50,
        },
        META_WB_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Entity_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet",
        },
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObject",
        },
        [PASchema.esWB_UI_AppExecutable]: {
            foreignKey: "WB_UI_APPEXEC_ID",
            foreignKeyImmutable: true,
            localField: "UIAppExec",
        },
    },
    hasMany: {
        [PASchema.esWB_Entity_AttributeType]: {
            foreignKey: "WB_ENTITY_ID",
            foreignKeyImmutable: true,
            localField: "AttributeTypeRels",
        },
    },
};

export const WB_Entity_AttributeType = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Sets", // optional
    description: "Schema for EntityAMR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_ENTITYAMR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_ENTITY_ID: {
            type: "number",
        },
        WB_ATTRIBUTEM_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Entity_AttributeType_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Entity]: { foreignKey: "WB_ENTITY_ID", foreignKeyImmutable: true, localField: "Entity" },
        [PASchema.esWB_AttributeType]: {
            foreignKey: "WB_ATTRIBUTEM_ID",
            foreignKeyImmutable: true,
            localField: "AttributeType",
        },
    },
};

export const WB_AttributeType = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Attribute Types", // optional
    description: "Schema for AttributeM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_ATTRIBUTEM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        ENTITY_DIMENSION: {
            type: "string",
            length: 50,
        },
        ATTRIBUTEM_ID: {
            type: "string",
            length: 50,
        },
        ATTRIBUTEM_NAME: {
            type: "string",
            length: 256,
        },
        SALESAREA_IND: {
            type: "string",
            length: 1,
        },
        DATATYPE: {
            type: "string",
            length: 50,
        },
        DISPLAYTYPE: {
            type: "string",
            length: 50,
        },
        DISPLAYFORMAT: {
            type: "string",
            length: 50,
        },
        WB_ENTITY_ID_TARGET: {
            type: "number",
        },
        EFFECTIVE_DT_IND: {
            type: "string",
            length: 1,
        },
        CORE_IND: {
            type: "string",
            length: 1,
        },
        CORE_STARTMAPPER: {
            type: "string",
            length: 50,
        },
        CORE_PATH: {
            type: "string",
            length: 500,
        },
        CORE_ROWMAPPER: {
            type: "string",
            length: 50,
        },
        CORE_ENTITY_ID_TARGET: {
            type: "string",
            length: 50,
        },
        CORE_VALUE_FIELDNAME: {
            type: "string",
            length: 50,
        },
        CORE_SALESAREA_FIELDNAME: {
            type: "string",
            length: 50,
        },
        CORE_STARTDT_FIELDNAME: {
            type: "string",
            length: 50,
        },
        CORE_ENDDT_FIELDNAME: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_AttributeType_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet",
        },
        [PASchema.esWB_Entity]: {
            foreignKey: "WB_ENTITY_ID_TARGET",
            foreignKeyImmutable: true,
            localField: "TargetEntity",
        },
    },
};
//Approval
export const WB_Approval = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Approval", // optional
    description: "Schema for WB_Approval records", // optional
    type: "object",
    track: true,
    properties: {
        WB_APPROVAL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        APPROVAL_ID: {
            type: "string",
            length: 50,
        },
        APPROVAL_NAME: {
            type: "string",
            length: 256,
        },
        APPROVAL_TYPE_ID: {
            type: "string",
            length: 50,
        },
        APPROVAL_SUBTYPE_ID: {
            type: "string",
            length: 50,
        },
        APPROVAL_NOTES: {
            type: "string",
            length: 1333,
        },
        APPROVAL_SUBSET_ID: {
            type: "string",
            length: 50,
        },
        EVALUATION_ORDER: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        WB_PMTTYPE_ID: {
            type: "number",
        },
        RATEBASIS_OPTIONS: {
            type: "string",
            length: 100,
        },
        RATEUOM_OPTIONS: {
            type: "string",
            length: 100,
        },
        PAYMENTMETHOD_OPTIONS: {
            type: "string",
            length: 100,
        },
        USE_RANGE_IND: {
            type: "string",
            length: 1,
        },
        RANGE_BOUND_TYPE: {
            type: "string",
            length: 50,
        },
        RANGE_LOWER_BOUND_AMT: {
            type: "number",
        },
        RANGE_UPPER_BOUND_AMT: {
            type: "number",
        },
        REVISED_THRESHOLD_FIXED_AMT: {
            type: "number",
        },
        REVISED_THRESHOLD_PCNT: {
            type: "number",
        },
        APPROVAL_ACTION: {
            type: "string",
            length: 50,
        },
        REQUIRED_ROLE_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});
export const WB_Approval_JSData_RELs = {};

// DataObject
export const WB_DataObject = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DataObject", // optional
    description: "Schema for WB_DataObject records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DATAOBJECT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        DATAOBJECT_ID: {
            type: "string",
            length: 50,
        },
        DATAOBJECT_NAME: {
            type: "string",
            length: 256,
        },
        DATAOBJECT_TYPE: {
            type: "string",
            length: 50,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        MAPPER_ID: {
            type: "string",
            length: 50,
        },
        INTERFACE_IND: {
            type: "string",
            length: 1,
        },
        INTERFACE_SUBJECTAREA: {
            type: "string",
            length: 256,
        },
        INTERFACE_LZ_PATH: {
            type: "string",
            length: 256,
        },
        WB_DATAOBJECT_ID_CLIENTRAW: {
            type: "number",
        },
        WB_DATAOBJECT_ID_ERROR: {
            type: "number",
        },
        WB_DATAOBJECT_ID_ARCHIVE: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_DataObject_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_DataObject_Text]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectText",
        },
        [PASchema.esWB_DataObject_Column]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectColumn",
        },
        [PASchema.esWB_DataObject_Message]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectMessage",
        },
        [PASchema.esWB_Staging]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "Staging",
        },
        [PASchema.esWB_Staging_ClientRaw]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "StagingClientRaw",
        },
        [PASchema.esWB_Staging_Archive]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "StagingArchive",
        },
    },
};

export const WB_DataObjectT = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DataObjectT", // optional
    description: "Schema for WB_DataObjectT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DATAOBJECTT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },

        SHORTTEXT: {
            type: "string",
            length: 256,
        },
        TOOLTIP: {
            type: "string",
            length: 256,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_DataObjectT_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObject",
        },
    },
};

export const WB_DataObject_Column = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DataObject_Column", // optional
    description: "Schema for WB_DataObject_Column records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DATAOBJECT_COLUMN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        COLUMN_ID: {
            type: "string",
            length: 128,
        },
        COLUMN_NAME: {
            type: "string",
            length: 256,
        },
        COLUMN_METATYPE: {
            type: "string",
            length: 50,
        },
        COLUMN_DATATYPE: {
            type: "string",
            length: 50,
        },
        COLUMN_LENGTH: {
            type: "number",
        },
        COLUMN_PRECISION: {
            type: "number",
        },
        DISPLAYTYPE: {
            type: "string",
            length: 50,
        },
        DISPLAYFORMAT: {
            type: "string",
            length: 50,
        },
        DISPLAYDOMAIN: {
            type: "string",
            length: 50,
        },
        METRIC_GROUP: {
            type: "string",
            length: 50,
        },
        METRIC_VERSION: {
            type: "string",
            length: 50,
        },
        METRIC_SORT: {
            type: "number",
        },
        METRIC_EDITABLE_IND: {
            type: "string",
            length: 1,
        },
        METRIC_WB_ENABLED_IND: {
            type: "string",
            length: 1,
        },
        METRIC_CUBESOURCE_VISIBLE_IND: {
            type: "string",
            length: 1,
        },
        METRIC_PUSHDOWN_METHOD: {
            type: "string",
            length: 50,
        },
        METRIC_PUSHDOWN_ALLOCATEBY: {
            type: "string",
            length: 50,
        },
        METRIC_AGGR_METHOD: {
            type: "string",
            length: 50,
        },
        METRIC_AGGR_WEIGHTBY: {
            type: "string",
            length: 50,
        },
        UOM_NUM: {
            type: "string",
            length: 50,
        },
        UOM_AMOUNT_TYPE_NUM: {
            type: "string",
            length: 50,
        },
        UOM_CONVERTER_NUM: {
            type: "string",
            length: 50,
        },
        UOM_DENOM: {
            type: "string",
            length: 50,
        },
        UOM_AMOUNT_TYPE_DENOM: {
            type: "string",
            length: 50,
        },
        UOM_CONVERTER_DENOM: {
            type: "string",
            length: 50,
        },
        PLOT_AXIS_NAME: {
            type: "string",
            length: 256,
        },
        PLOT_DATA_SHAPE: {
            type: "string",
            length: 128,
        },
        PLOT_DATA_COLOR: {
            type: "string",
            length: 128,
        },
        PLOT_DATA_PATTERN: {
            type: "string",
            length: 128,
        },
        FOREIGNKEY_IND: {
            type: "string",
            length: 1,
        },
        WB_DATAOBJECT_COLUMN_ID_PK: {
            type: "number",
        },
        LOGICALKEY_IND: {
            type: "string",
            length: 1,
        },
        CUSTOM_IND: {
            type: "string",
            length: 1,
        },
        MAPPER_IND: {
            type: "string",
            length: 1,
        },
        ENTITY_SERVICE_IND: {
            type: "string",
            length: 1,
        },
        SYNC_NOTES: {
            type: "string",
            length: 256,
        },
        INTERFACE_SORT: {
            type: "number",
        },
        INTERFACE_DESCRIPTION: {
            type: "string",
            length: 500,
        },
        INTERFACE_EXAMPLE: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_DataObject_Column_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObj",
        },
    },
    hasMany: {
        [PASchema.esWB_DataObject_Column_Text]: {
            foreignKey: "WB_DATAOBJECT_COLUMN_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectColumnText",
        },
    },
};

export const WB_DataObject_ColumnT = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DataObject_ColumnT", // optional
    description: "Schema for WB_DataObject_ColumnT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DATAOBJECT_COLUMNT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DATAOBJECT_COLUMN_ID: {
            type: "number",
        },
        USAGE: {
            type: "string",
            length: 50,
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },

        SHORTTEXT: {
            type: "string",
            length: 256,
        },
        ABBREVIATION: {
            type: "string",
            length: 50,
        },
        TOOLTIP: {
            type: "string",
            length: 256,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_DataObject_ColumnT_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject_Column]: {
            foreignKey: "WB_DATAOBJECT_COLUMN_ID",
            foreignKeyImmutable: true,
            localField: "DataObjColumn",
        },
    },
};

export const WB_DataObject_Message = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DataObjectT", // optional
    description: "Schema for WB_DataObject_Message records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DATAOBJECT_MESSAGE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        MESSAGE_ID: {
            type: "string",
            length: 50,
        },
        MESSAGE_TYPE: {
            type: "string",
            length: 50,
        },
        MESSAGE_PARAMS: {
            type: "string",
            length: 500,
        },
        CUSTOM_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_DataObject_Message_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObj",
        },
    },
    hasMany: {
        [PASchema.esWB_DataObject_Message_Text]: {
            foreignKey: "WB_DATAOBJECT_MESSAGE_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectMessageText",
        },
    },
};

export const WB_DataObject_MessageT = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DataObjectT", // optional
    description: "Schema for WB_DataObject_MessageT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DATAOBJECT_MESSAGET_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DATAOBJECT_MESSAGE_ID: {
            type: "number",
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },
        SHORTTEXT: {
            type: "string",
            length: 256,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_DataObject_MessageT_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject_Message]: {
            foreignKey: "WB_DATAOBJECT_MESSAGE_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectMsg",
        },
    },
};

// Circular Config

export const WB_Circular_Config = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Circular_Config", // optional
    description: "Schema for WB_Circular_Config records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CIRCULARCONFIG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        CONFIG_ID: {
            type: "string",
            length: 20,
        },
        CONFIG_NAME: {
            type: "string",
            length: 50,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        WB_PRDH_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Circular_Config_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Circular_ConfigCR]: {
            foreignKey: "WB_CIRCULARCONFIG_ID",
            foreignKeyImmutable: true,
            localField: "CircularConfigColumns",
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "CircularMDSet",
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "CircularSalesOrg",
        },
    },
};

export const WB_Circular_ConfigCR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Circular_ConfigCR", // optional
    description: "Schema for WB_Circular_ConfigCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CIRCULARCONFIGCR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CIRCULARCONFIG_ID: {
            type: "number",
        },
        WB_DATAOBJECT_COLUMN_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Circular_ConfigCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Circular_Config]: {
            foreignKey: "WB_CIRCULARCONFIG_ID",
            foreignKeyImmutable: true,
            localField: "CircularConfig",
        },
        [PASchema.esWB_DataObject_Column]: {
            foreignKey: "WB_DATAOBJECT_COLUMN_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectColumn",
        },
    },
};

// Circulars
export const WB_Circular_AdBlock = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Circular_AdBlock", // optional
    description: "Schema for WB_Circular_AdBlock records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CIRCULARADBLOCK_ID: {
            type: "number",
            id: true,
            required: true,
        },
        ADBLOCK_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Circular_AdBlock_JSData_RELs = {};

export const WB_Circular = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Circular", // optional
    description: "Schema for WB_Circular records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CIRCULAR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        CIRCULAR_ID: {
            type: "string",
            length: 20,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        WB_CIRCULARADBLOCK_ID: {
            type: "number",
        },
        ADBLOCK_ID: {
            type: "string",
            length: 50,
        },
        WB_CIRCULARADBLOCK_ID_PRNT: {
            type: "number",
        },
        ADBLOCK_ID_PRNT: {
            type: "string",
            length: 50,
        },
        ADBLOCK_URL: {
            type: "string",
            length: 256,
        },
        PAGE_URL: {
            type: "string",
            length: 256,
        },
        PAGE_NUMBER: {
            type: "number",
        },
        PAGE_TYPE: {
            type: "string",
            length: 50,
        },
        SALES_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SALES_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        RETAILER: {
            type: "string",
            length: 50,
        },
        PARENT_RETAILER: {
            type: "string",
            length: 50,
        },
        PRODUCT: {
            type: "string",
            length: 50,
        },
        BRAND: {
            type: "string",
            length: 50,
        },
        MANUFACTURER: {
            type: "string",
            length: 500,
        },
        SIZE: {
            type: "string",
            length: 1333,
        },
        AD_PRICE: {
            type: "number",
        },
        REGULAR_PRICE: {
            type: "number",
        },
        OFFER: {
            type: "string",
            length: 1333,
        },
        OFFER_TYPE: {
            type: "string",
            length: 1333,
        },
        UNIT_PRICES: {
            type: "string",
            length: 1333,
        },
        UNIT_PRICE: {
            type: "number",
        },
        NET_UNIT_PRICE: {
            type: "number",
        },
        INCENTIVE: {
            type: "string",
            length: 1333,
        },
        PAGE_INCENTIVE: {
            type: "string",
            length: 1333,
        },
        CIRCULAR_INCENTIVE: {
            type: "string",
            length: 1333,
        },
        SUBCATEGORY: {
            type: "string",
            length: 50,
        },
        CATEGORY: {
            type: "string",
            length: 50,
        },
        SEGMENT: {
            type: "string",
            length: 50,
        },
        DEPARTMENT: {
            type: "string",
            length: 50,
        },
        LIMITS: {
            type: "string",
            length: 50,
        },
        BONUS_CARD_IND: {
            type: "string",
            length: 1,
        },
        COUPON_IND: {
            type: "string",
            length: 1,
        },
        COUPON_AMT: {
            type: "number",
        },
        REBATE_IND: {
            type: "string",
            length: 1,
        },
        REBATE_AMT: {
            type: "number",
        },
        LIMITED_TIME_IND: {
            type: "string",
            length: 1,
        },
        MEDIA_TYPE: {
            type: "string",
            length: 50,
        },
        EVENTS: {
            type: "string",
            length: 1333,
        },
        NEW_ITEM_IND: {
            type: "string",
            length: 1,
        },
        ATTRIBUTES: {
            type: "string",
            length: 500,
        },
        MEAL_DEAL_IND: {
            type: "string",
            length: 1,
        },
        SHOW_THE_MATCH_IND: {
            type: "string",
            length: 1,
        },
        NET_UNIT_PRICE_AFTER_INCENTIVE: {
            type: "number",
        },
        FSI_SAME_WEEK_IND: {
            type: "string",
            length: 1,
        },
        COUPON_BOOK_SAME_WEEK_IND: {
            type: "string",
            length: 1,
        },
        DIGITAL_OFFER_SAME_WEEK_IND: {
            type: "string",
            length: 1,
        },
        DIGITAL_EQUITY_AD_IND: {
            type: "string",
            length: 1,
        },
        MULTI_PRODUCT_AD_IND: {
            type: "string",
            length: 1,
        },
        MULTI_MANUFACTURER_AD_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Circular_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_CircularCR]: {
            foreignKey: "WB_CIRCULAR_ID",
            foreignKeyImmutable: true,
            localField: "CircularCustomers",
        },
        [PASchema.esWB_CircularPR]: {
            foreignKey: "WB_CIRCULAR_ID",
            foreignKeyImmutable: true,
            localField: "CircularProducts",
        },
    },
    belongsTo: {
        [PASchema.esWB_Circular_AdBlock]: [
            { foreignKey: "WB_CIRCULARADBLOCK_ID", foreignKeyImmutable: true, localField: "AdBlock" },
            { foreignKey: "WB_CIRCULARADBLOCK_ID_PRNT", foreignKeyImmutable: true, localField: "AdBlockParent" },
        ],
    },
};

export const WB_CircularCR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CircularCR", // optional
    description: "Schema for WB_CircularCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CIRCULARCR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CIRCULARADBLOCK_ID: {
            type: "number",
        },
        WB_CIRCULAR_ID: {
            type: "string",
            length: 50,
        },
        WB_CUST_ID: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_CircularCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Circular]: { foreignKey: "WB_CIRCULAR_ID", foreignKeyImmutable: true, localField: "Circular" },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_CircularPR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CircularPR", // optional
    description: "Schema for WB_CircularPR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CIRCULARPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CIRCULARADBLOCK_ID: {
            type: "number",
        },
        WB_CIRCULAR_ID: {
            type: "string",
            length: 50,
        },
        WB_PROD_ID: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_CircularPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Circular]: { foreignKey: "WB_CIRCULAR_ID", foreignKeyImmutable: true, localField: "Circular" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

// Domain BO
export const WB_Domain = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Dom", // optional
    description: "Schema for WB_Dom records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DOM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        DOMAIN_ID: {
            type: "string",
            length: 50,
        },
        DOMAIN_NAME: {
            type: "string",
            length: 256,
        },
        DOMAIN_COMMENTS: {
            type: "string",
            length: 1333,
        },
        DOMAIN_EDIT_POLICY: {
            type: "string",
            length: 1,
        },
        DOMAIN_ITEM_VALUE_SQL: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Domain_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Domain_Text]: { foreignKey: "WB_DOM_ID", foreignKeyImmutable: true, localField: "Texts" },
        [PASchema.esWB_Domain_Item]: { foreignKey: "WB_DOM_ID", foreignKeyImmutable: true, localField: "Items" },
    },
};

export const WB_Domain_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DomT", // optional
    description: "Schema for WB_DomT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DOMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DOM_ID: {
            type: "number",
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Domain_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Domain]: { foreignKey: "WB_DOM_ID", foreignKeyImmutable: true, localField: "Domain" },
    },
};

export const WB_Domain_Item = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DomItem", // optional
    description: "Schema for WB_DomItem records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DOMITEM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DOM_ID: {
            type: "number",
        },
        DOMAIN_ITEM_ID: {
            type: "string",
            length: 50,
        },
        DOMAIN_ITEM_NAME: {
            type: "string",
            length: 256,
        },
        DOMAIN_ITEM_SORT: {
            type: "string",
            length: 20,
        },
        DOMAIN_ITEM_SUBCODE: {
            type: "string",
            length: 50,
        },
        DOMAIN_ITEM_VALUE: {
            type: "number",
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1,
        },
        DEFAULT_IND: {
            type: "string",
            length: 1,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Domain_Item_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Domain]: { foreignKey: "WB_DOM_ID", foreignKeyImmutable: true, localField: "Domain" },
    },
    hasMany: {
        [PASchema.esWB_Domain_Item_Text]: {
            foreignKey: "WB_DOMITEM_ID",
            foreignKeyImmutable: true,
            localField: "Texts",
        },
    },
};

export const WB_Domain_Item_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_DomItemT", // optional
    description: "Schema for WB_DomItemT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DOMITEMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DOM_ID: {
            type: "number",
        },
        WB_DOMITEM_ID: {
            type: "number",
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Domain_Item_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Domain_Item]: {
            foreignKey: "WB_DOMITEM_ID",
            foreignKeyImmutable: true,
            localField: "DomainItem",
        },
    },
};

// Custom Column BO
export const WB_Custom_Column = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Custom_Column", // optional
    description: "Schema for WB_Custom_Column records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTOM_COLUMN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        GENERATED_IND: {
            type: "string",
            length: 1,
        },
        MAPPER_ID: {
            type: "string",
            length: 256,
        },
        TABLE_NAME: {
            type: "string",
            length: 256,
        },
        COLUMN_NAME: {
            type: "string",
            length: 256,
        },
        COLUMN_DATATYPE: {
            type: "string",
            length: 256,
        },
        COLUMN_LENGTH: {
            type: "number",
        },
        COLUMN_PRECISION: {
            type: "number",
        },
        NOTES: {
            type: "string",
            length: 1333,
        },
        WB_APP_ID: {
            type: "number",
        },
        APP_ID: {
            type: "string",
            length: 256,
        },
        APPMGR_ID: {
            type: "string",
            length: 256,
        },
        SERVER_MODEL_ID: {
            type: "string",
            length: 256,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Custom_Column_JSData_RELs = {
    hasMany: {},
};

// Product Condition BO
export const WB_Product_Condition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Prod_Cnd", // optional
    description: "Schema for Prod_Cnd records", // optional
    type: "object",
    track: true,
    properties: {
        PROD_CND_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        PROD_CNDM_ID: {
            type: "number",
        },
        REL_SOURCE_ID: {
            type: "string",
            length: 255,
        },
        CONDITION_TYPE: {
            type: "string",
            length: 50,
        },
        PRODUCT_ID: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_ID: {
            type: "string",
            length: 50,
        },
        CUSTOMER_ID: {
            type: "string",
            length: 50,
        },
        PLANT_ID: {
            type: "string",
            length: 50,
        },
        VALUE_RATEAMOUNT: {
            type: "number",
        },
        VALUE_UOM: {
            type: "string",
            length: 20,
        },
        VALUE_BASISQTY: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CURRENCY_ID: {
            type: "string",
            length: 50,
        },
        SALESORG: {
            type: "string",
            length: 20,
        },
        DIVISION: {
            type: "string",
            length: 20,
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 20,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_DIVISION_ID: {
            type: "number",
        },
        WB_DISTRIBCHANNEL_ID: {
            type: "number",
        },
        WB_CUSTSR_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        BUSINESS_MODIFIED: {
            type: "number",
        },
    },
});
export const WB_Product_Condition_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Condition_Type]: {
            foreignKey: "PROD_CNDM_ID",
            foreignKeyImmutable: true,
            localField: "ProductConditionType",
        },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Fund_Type]: { foreignKey: "WB_FUNDTYPE_ID", foreignKeyImmutable: true, localField: "FundType" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

// Product Condition Type
export const WB_Product_Condition_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Prod_CndM", // optional
    description: "Schema for Prod_CndM records", // optional
    type: "object",
    track: true,
    properties: {
        PRD_CNDM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_POLICYAREA_ID: {
            type: "number",
            default: 0,
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        CONDITION_TYPE: {
            type: "string",
            length: 50,
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50,
        },
        CONDITION_TYPE_NAME: {
            type: "string",
            length: 256,
        },
        CONDITION_TYPE_SORT: {
            type: "number",
        },
        CUST_POLICY: {
            type: "string",
            length: 1,
        },
        PRD_POLICY: {
            type: "string",
            length: 1,
        },
        PRDGRP_POLICY: {
            type: "string",
            length: 1,
        },
        FNDTYPE_POLICY: {
            type: "string",
            length: 1,
        },
        CURRENCY_POLICY: {
            type: "string",
            length: 1,
        },
        CUSTOMER_TYPE: {
            type: "string",
            length: 50,
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: "number",
            default: 0,
        },
        PRDGRP_LEVEL_ID: {
            type: "string",
            length: 50,
        },
        WB_ENTITY_ID_PRODUCT: {
            type: "number",
            default: 0,
        },
        WB_ENTITY_ID_SUPPLY: {
            type: "number",
            default: 0,
        },
        NUMBER_VALUE_MIN: {
            type: "number",
        },
        NUMBER_VALUE_MAX: {
            type: "number",
        },
        SALESAREA_POLICY: {
            type: "string",
            length: 50,
        },
        DATE_INTERVAL_POLICY: {
            type: "string",
            length: 50,
        },
        SEARCH_POLICY: {
            type: "string",
            length: 50,
        },
        EDIT_POLICY: {
            type: "string",
            length: 50,
        },
        EDIT_POLICY_COND: {
            type: "string",
            length: 100,
        },
        LEASE_PERIOD: {
            type: "number",
        },
        LEASE_SUBJECT: {
            type: "string",
            length: 50,
        },
        LEASE_SUBJECT_ALT: {
            type: "string",
            length: 50,
        },
        LEASE_SUBJECT_ALT_COND: {
            type: "string",
            length: 50,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        EDIT_ROLES: {
            type: "string",
            length: 256,
        },
        VIEW_ROLES: {
            type: "string",
            length: 256,
        },
        VALUE_UOM_POLICY: {
            type: "string",
            length: 1,
        },
        VALUE_UOM_DEFAULT: {
            type: "string",
            length: 256,
        },
        SOURCE_POLICY: {
            type: "string",
            length: 1,
        },
        SOURCE_DEFAULT: {
            type: "string",
            length: 256,
        },
        COMMENTS: {
            type: "string",
            default: "",
            length: 256,
        },
        WB_POLICYCUBE_ID: {
            type: "number",
            default: 0,
        },
        WB_POLICYTERM_ID: {
            type: "number",
            default: 0,
        },
        RESERVED_TERM_ID: {
            type: "string",
            length: 50,
        },
    },
});
export const WB_Product_Condition_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet",
        },
        [PASchema.esWB_Entity]: [
            { foreignKey: "WB_ENTITY_ID_CUSTOMER", foreignKeyImmutable: true, localField: "CustomerType" },
            { foreignKey: "WB_ENTITY_ID_PRODUCT", foreignKeyImmutable: true, localField: "ProductType" },
        ],
    },
};

// Spend Allocation Rule
export const WB_Spend_Allocation_Rule = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_SpendRL", // optional
    description: "Schema for WB_SpendRL records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SPENDRL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SPEND_RULE_ID: {
            type: "string",
            length: 50,
        },
        SPEND_RULE_NAME: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Spend_Allocation_Rule_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Spend_Allocation_Rule_Item]: {
            foreignKey: "WB_SPENDRL_ID",
            foreignKeyImmutable: true,
            localField: "Items",
        },
    },
};

export const WB_Spend_Allocation_Rule_Item = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_SpendRLR", // optional
    description: "Schema for WB_SpendRLR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SPENDRLR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SPENDRL_ID: {
            type: "number",
        },
        EVALUATION_ORDER: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        WB_SPENDM_ID: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        SPEND_ALLOCATION_RULE: {
            type: "string",
            length: 50,
        },
        BASIS_RATE_AMT: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Spend_Allocation_Rule_Item_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Spend_Allocation_Rule]: {
            foreignKey: "WB_SPENDRL_ID",
            foreignKeyImmutable: true,
            localField: "SpendAllocationRule",
        },
    },
};

// Spend Calc Method Rule
export const WB_Spend_Method_Rule = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_SpendClR", // optional
    description: "Schema for WB_SpendClR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SPENDCLR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        EVALUATION_ORDER: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_SPENDM_ID: {
            type: "number",
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        SPEND_CALC_METHOD: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Spend_Method_Rule_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Spend_Type]: {
            foreignKey: "WB_SPENDM_ID",
            foreignKeyImmutable: true,
            localField: "SpendMethod",
        },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

// Meta BO
export const WB_Meta = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Meta", // optional
    description: "Schema for WB_Meta records", // optional
    type: "object",
    track: true,
    properties: {
        WB_META_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 10,
        },
        META_TYPE_ID: {
            type: "string",
            length: 50,
        },
        META_ID: {
            type: "string",
            length: 50,
        },
        META_NAME: {
            type: "string",
            length: 256,
        },
        META_SORT_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        DEFAULT_IND: {
            type: "string",
            length: 1,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Meta_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet",
        },
    },
    hasMany: {
        [PASchema.esWB_Meta_Text]: { foreignKey: "WB_META_ID", foreignKeyImmutable: true, localField: "Texts" },
        [PASchema.esWB_Meta_Tags]: { foreignKey: "WB_META_ID", foreignKeyImmutable: true, localField: "Tags" },
    },
};

export const WB_Meta_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_MetaT", // optional
    description: "Schema for WB_MetaT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_METAT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_META_ID: {
            type: "number",
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },
        SHORTTEXT: {
            type: "string",
            length: 256,
        },
        ABBREVIATION: {
            type: "string",
            length: 50,
        },
        TOOLTIP: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Meta_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Meta]: { foreignKey: "WB_META_ID", foreignKeyImmutable: true, localField: "Meta" },
    },
};

export const WB_Meta_Tags = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TagMetaR", // optional
    description: "Schema for WB_TagMetaR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAGMETAR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TAG_ID: {
            type: "number",
        },
        WB_META_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Meta_Tags_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Meta]: { foreignKey: "WB_META_ID", foreignKeyImmutable: true, localField: "Meta" },
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" },
    },
};

// Tags
export const WB_Tag = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tag", // optional
    description: "Schema for WB_Tag records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TAG_ID: {
            type: "string",
            length: 50,
        },
        TAG_NAME: {
            type: "string",
            length: 256,
        },
        TAG_KEYWORDS: {
            type: "string",
            length: 256,
        },
        TAG_SORT: {
            type: "number",
        },
        TAG_TYPE: {
            type: "string",
            length: 50,
        },
        WB_TAG_SOURCE_ID: {
            type: "number",
            length: 10,
        },
        TAG_SELECTION_POLICY: {
            type: "string",
            length: 50,
        },
        TAG_COLOR: {
            type: "string",
            length: 50,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TAG_NUM_VALUE: {
            type: "number",
        },
        TAG_STR_VALUE: {
            type: "string",
            length: 50,
        },
        MODEL_TAG_TYPE: {
            type: "string",
            length: 50,
        },
        MODEL_TAG_RESERVED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Tag_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag_Source]: {
            foreignKey: "WB_TAG_SOURCE_ID",
            foreignKeyImmutable: true,
            localField: "TagSource",
        },
    },
    hasMany: {
        [PASchema.esWB_Tag_Relationship]: [
            {
                foreignKey: "WB_TAG_ID_PRNT",
                foreignKeyImmutable: true,
                localField: "Children",
            },
            { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Parent" },
        ],
        [PASchema.esWB_Tag_Text]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Texts" },
        [PASchema.esWB_Meta_Tags]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Metas" },
        [PASchema.esWB_Tag_Metric]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Metrics" },
        [PASchema.esWB_Tag_Rule]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "TagRules" },
    },
};

export const WB_Tag_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TagR", // optional
    description: "Schema for WB_TagR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAGR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TAG_ID: {
            type: "number",
        },
        WB_TAG_ID_PRNT: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag]: [
            { foreignKey: "WB_TAG_ID_PRNT", foreignKeyImmutable: true, localField: "Parent" },
            { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Child" },
        ],
    },
};

export const WB_Tag_Source = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tag_Source", // optional
    description: "Schema for WB_Tag_Source records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAG_SOURCE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TAG_SOURCE_ID: {
            type: "string",
            length: 50,
        },
        TAG_SOURCE_NAME: {
            type: "string",
            length: 256,
        },
        SOURCE_TABLENAME: {
            type: "string",
            length: 256,
        },
        TAG_FIELDNAME: {
            type: "string",
            length: 128,
        },
        EVENT_FIELDNAME: {
            type: "string",
            length: 128,
        },
        CUSTOMER_FIELDNAME: {
            type: "string",
            length: 128,
        },
        PRODUCT_FIELDTYPE: {
            type: "string",
            length: 50,
        },
        PRODUCT_FIELDNAME: {
            type: "string",
            length: 128,
        },
        PERIOD_METHOD: {
            type: "string",
            length: 20,
        },
        PERIOD_FIELDNAME: {
            type: "string",
            length: 128,
        },
        EFFECTIVE_START_DT_FIELDNAME: {
            type: "string",
            length: 128,
        },
        EFFECTIVE_END_DT_FIELDNAME: {
            type: "string",
            length: 128,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Tag_Source_JSData_RELs = {};

export const WB_Tag_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TagT", // optional
    description: "Schema for WB_TagT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAGT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TAG_ID: {
            type: "number",
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Tag_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" },
    },
};

export const WB_Tag_Metric = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TagMtrcR", // optional
    description: "Schema for WB_TagMtrcR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAGMTRCR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TAG_ID: {
            type: "number",
        },
        METRIC_ID: {
            type: "string",
            length: 50,
        },
        LOWER_BOUND: {
            type: "number",
        },
        UPPER_BOUND: {
            type: "number",
        },
    },
});
export const WB_Tag_Metric_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" },
    },
};

export const WB_Tag_Function = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tag_Function", // optional
    description: "Schema for WB_Tag_Function records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAG_FUNCTION_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TAG_FUNCTION_ID: {
            type: "string",
            length: 50,
        },
        TAG_FUNCTION_NAME: {
            type: "string",
            length: 256,
        },
        TAG_TARGET: {
            type: "string",
            length: 50,
        },
        COMMENTS: {
            type: "string",
            length: 1333,
        },
        CLASS_TYPE_ID: {
            type: "string",
            length: 50,
        },
        CLASS_ID: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Tag_Function_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Tag_Function_Param]: {
            foreignKey: "WB_TAG_FUNCTION_ID",
            foreignKeyImmutable: true,
            localField: "TagFunctionParam",
        },
    },
};

export const WB_Tag_Function_Param = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tag_Function_Param", // optional
    description: "Schema for WB_Tag_Function_Param records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAG_FUNCTION_PARAM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TAG_FUNCTION_ID: {
            type: "number",
        },
        PARAM_ID: {
            type: "string",
            length: 50,
        },
        PARAM_NAME: {
            type: "string",
            length: 256,
        },
        TAG_TARGET: {
            type: "string",
            length: 50,
        },
        PARAM_DATATYPE: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Tag_Function_Param_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag_Function]: {
            foreignKey: "WB_TAG_FUNCTION_ID",
            foreignKeyImmutable: true,
            localField: "TagFunction",
        },
    },
};

//Tag rule
export const WB_Tag_Rule = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tag_Rule", // optional
    description: "Schema for WB_Tag_Rule records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAG_RULE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TAG_RULE_ID: {
            type: "string",
            length: 50,
        },
        TAG_RULE_NAME: {
            type: "string",
            length: 256,
        },
        WB_TAG_FUNCTION_ID: {
            type: "number",
            length: 10,
        },
        WB_TAG_ID: {
            type: "number",
            length: 10,
        },
        COMMENTS: {
            type: "string",
            length: 1333,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Tag_Rule_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" },
        // TODO: Comment back after tag function table is ready
        // [PASchema.esWB_Tag_Function]: {foreignKey: 'WB_TAG_FUNCTION_ID', foreignKeyImmutable: true, localField: 'TagFunction'}
    },
    hasMany: {
        [PASchema.esWB_Tag_Rule_Param]: {
            foreignKey: "WB_TAG_RULE_ID",
            foreignKeyImmutable: true,
            localField: "TagRuleParam",
        },
    },
};

export const WB_Tag_Rule_Param = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tag_Rule_Param", // optional
    description: "Schema for WB_Tag_Rule_Param records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TAG_RULE_PARAM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TAG_RULE_ID: {
            type: "number",
        },
        WB_TAG_FUNCTION_PARAM_ID: {
            type: "number",
        },
        PARAM_NUM_VALUE: {
            type: "number",
        },
        PARAM_STR_VALUE: {
            type: "string",
            length: 256,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Tag_Rule_Param_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag_Rule]: { foreignKey: "WB_TAG_RULE_ID", foreignKeyImmutable: true, localField: "TagRule" },
        // TODO: Comment back after tag function param table is ready
        // [PASchema.esWB_Tag_Function_Param]: {foreignKey: 'WB_TAG_FUNCTION_PARAM_ID', foreignKeyImmutable: true, localField: 'TagFunctionParam'}
    },
};

// Metric
export const WB_Metric = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Metric", // optional
    description: "Schema for WB_Metric records", // optional
    type: "object",
    track: true,
    properties: {
        WB_METRIC_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        REFERENCE_ID: {
            type: "number",
        },
        REFERENCE_ID_UI: {
            type: "string",
            length: 50,
        },
        REFERENCE_LEVEL_ID: {
            type: "string",
            length: 20,
        },
        METRIC_TYPE_ID: {
            type: "string",
            length: 20,
        },
        CNSMP_BASE_UNITS: {
            type: "number",
        },
        CNSMP_BASE_WT: {
            type: "number",
        },
        CNSMP_BASE_STAT: {
            type: "number",
        },
        CNSMP_BASE_LISTSLS: {
            type: "number",
        },
        CNSMP_BASE_NETLISTSLS: {
            type: "number",
        },
        CNSMP_BASE_RTLSLS: {
            type: "number",
        },
        CNSMP_BASE_PRFTCNTRB: {
            type: "number",
        },
        CNSMP_EDLP_UNITS: {
            type: "number",
        },
        CNSMP_EDLP_WT: {
            type: "number",
        },
        CNSMP_EDLP_STAT: {
            type: "number",
        },
        CNSMP_EDLP_LISTSLS: {
            type: "number",
        },
        CNSMP_EDLP_NETLISTSLS: {
            type: "number",
        },
        CNSMP_EDLP_RTLSLS: {
            type: "number",
        },
        CNSMP_EDLP_PRFTCNTRB: {
            type: "number",
        },
        CNSMP_INCR_UNITS: {
            type: "number",
        },
        CNSMP_INCR_WT: {
            type: "number",
        },
        CNSMP_INCR_STAT: {
            type: "number",
        },
        CNSMP_INCR_LISTSLS: {
            type: "number",
        },
        CNSMP_INCR_NETLISTSLS: {
            type: "number",
        },
        CNSMP_INCR_RTLSLS: {
            type: "number",
        },
        CNSMP_INCR_PRFTCNTRB: {
            type: "number",
        },
        CNSMP_DISP_INCR_UNITS: {
            type: "number",
        },
        CNSMP_DISP_INCR_WT: {
            type: "number",
        },
        CNSMP_DISP_INCR_STAT: {
            type: "number",
        },
        CNSMP_DISP_INCR_LISTSLS: {
            type: "number",
        },
        CNSMP_DISP_INCR_NETLISTSLS: {
            type: "number",
        },
        CNSMP_DISP_INCR_RTLSLS: {
            type: "number",
        },
        CNSMP_DISP_INCR_PRFTCNTRB: {
            type: "number",
        },
        CNSMP_TOTAL_UNITS: {
            type: "number",
        },
        CNSMP_TOTAL_WT: {
            type: "number",
        },
        CNSMP_TOTAL_STAT: {
            type: "number",
        },
        CNSMP_TOTAL_LISTSLS: {
            type: "number",
        },
        CNSMP_TOTAL_NETLISTSLS: {
            type: "number",
        },
        CNSMP_TOTAL_RTLSLS: {
            type: "number",
        },
        CNSMP_TOTAL_PRFTCNTRB: {
            type: "number",
        },
        CNSMP_PROMO_UNITS: {
            type: "number",
        },
        CNSMP_PROMO_WT: {
            type: "number",
        },
        CNSMP_PROMO_STAT: {
            type: "number",
        },
        CNSMP_PROMO_LISTSLS: {
            type: "number",
        },
        CNSMP_PROMO_NETLISTSLS: {
            type: "number",
        },
        CNSMP_PROMO_RTLSLS: {
            type: "number",
        },
        CNSMP_PROMO_PRFTCNTRB: {
            type: "number",
        },
        CNSMP_NONPROMO_UNITS: {
            type: "number",
        },
        CNSMP_NONPROMO_WT: {
            type: "number",
        },
        CNSMP_NONPROMO_STAT: {
            type: "number",
        },
        CNSMP_NONPROMO_LISTSLS: {
            type: "number",
        },
        CNSMP_NONPROMO_NETLISTSLS: {
            type: "number",
        },
        CNSMP_NONPROMO_RTLSLS: {
            type: "number",
        },
        CNSMP_NONPROMO_PRFTCNTRB: {
            type: "number",
        },
        CNSMP_ADJ_INCR_UNITS: {
            type: "number",
        },
        CNSMP_ADJ_INCR_WT: {
            type: "number",
        },
        CNSMP_ADJ_INCR_STAT: {
            type: "number",
        },
        CNSMP_ADJ_INCR_LISTSLS: {
            type: "number",
        },
        CNSMP_ADJ_INCR_NETLISTSLS: {
            type: "number",
        },
        CNSMP_ADJ_INCR_RTLSLS: {
            type: "number",
        },
        CNSMP_ADJ_INCR_PRFTCNTRB: {
            type: "number",
        },
        MERCH_FEATUREONLY_ACV_N: {
            type: "number",
        },
        MERCH_DISPLAYONLY_ACV_N: {
            type: "number",
        },
        MERCH_FEATUREDISPLAY_ACV_N: {
            type: "number",
        },
        MERCH_TPRONLY_ACV_N: {
            type: "number",
        },
        MERCH_PROMOTED_ACV_N: {
            type: "number",
        },
        MERCH_DIST_ACV_N: {
            type: "number",
        },
        MERCH_ACV_D: {
            type: "number",
        },
        MERCH_FEATUREONLY_UNITS: {
            type: "number",
        },
        MERCH_DISPLAYONLY_UNITS: {
            type: "number",
        },
        MERCH_FEATUREDISPLAY_UNITS: {
            type: "number",
        },
        MERCH_TPRONLY_UNITS: {
            type: "number",
        },
        MERCH_PROMOTED_UNITS: {
            type: "number",
        },
        SHIPMENT_ORDER_QTY: {
            type: "number",
        },
        SHIPMENT_BUOM_QTY: {
            type: "number",
        },
        SHIPMENT_UNITS: {
            type: "number",
        },
        SHIPMENT_WT: {
            type: "number",
        },
        SHIPMENT_STAT: {
            type: "number",
        },
        SHIPMENT_LISTSLS: {
            type: "number",
        },
        SHIPMENT_NETLISTSLS: {
            type: "number",
        },
        SHIPMENT_PRFTCNTRB: {
            type: "number",
        },
        RETURN_ORDER_QTY: {
            type: "number",
        },
        RETURN_BUOM_QTY: {
            type: "number",
        },
        RETURN_UNITS: {
            type: "number",
        },
        RETURN_WT: {
            type: "number",
        },
        RETURN_STAT: {
            type: "number",
        },
        RETURN_LISTSLS: {
            type: "number",
        },
        RETURN_NETLISTSLS: {
            type: "number",
        },
        RETURN_PRFTCNTRB: {
            type: "number",
        },
        SPEND_TOTAL: {
            type: "number",
        },
        SPEND_VARIABLE: {
            type: "number",
        },
        SPEND_FIXED: {
            type: "number",
        },
        SPEND_TRADE: {
            type: "number",
        },
        SPEND_VARIABLE_TRADE: {
            type: "number",
        },
        SPEND_FIXED_TRADE: {
            type: "number",
        },
        SPEND_PA_LE: {
            type: "number",
        },
        SPEND_ALLIN: {
            type: "number",
        },
        SPEND_CONSUMERDISCOUNT: {
            type: "number",
        },
        SPEND_SHOPPER_MARKETING: {
            type: "number",
        },
        SPEND_OTHER_WB: {
            type: "number",
        },
        SPEND_RATEBYCNSMP: {
            type: "number",
        },
        SPEND_RATEBYSHIPMENT: {
            type: "number",
        },
        SPEND_LIABILITY_QTY_OVRD: {
            type: "number",
        },
        SPEND_MARGINAL_OVERLAP: {
            type: "number",
        },
        LIST_PRICE: {
            type: "number",
        },
        LIFT_BYUNITS_PCNT: {
            type: "number",
        },
        LIFT_BYWT_PCNT: {
            type: "number",
        },
        VCM_CNSMP_INCR_PCNT: {
            type: "number",
        },
        VCM_CNSMP_PCNT: {
            type: "number",
        },
        VCM_SHIP_PCNT: {
            type: "number",
        },
        TRADETOSALES_CNSMP_PCNT: {
            type: "number",
        },
        TRADETOSALES_SHIP_PCNT: {
            type: "number",
        },
        RETAILER_TRUE_BASE_PRICE: {
            type: "number",
        },
        RETAILER_BASE_PRICE: {
            type: "number",
        },
        RETAILER_PROMOTED_PRICE: {
            type: "number",
        },
        RETAILER_AVG_PRICE: {
            type: "number",
        },
        RETAILER_MARGIN_EVERYDAY_PCNT: {
            type: "number",
        },
        RETAILER_MARGIN_PROMOTED_PCNT: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },

    },
});
export const WB_Metric_JSData_RELs = {};
// Exchange Rate
export const WB_ExchangeRateM = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_ExchangeRateM", // optional
    description: "Schema for WB_ExchangeRateM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EXCHANGERATEM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        EXCHANGE_RATE_TYPE_ID: {
            type: "string",
            length: 50,
        },
        EXCHANGE_RATE_TYPE_NAME: {
            type: "string",
            length: 256,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        INVERTABLE_IND: {
            type: "string",
            length: 1,
        },
        WB_CURRENCY_ID_REF: {
            type: "number",
            id: true,
        },
        WB_EXCHANGERATEM_ID_BUY: {
            type: "number",
            id: true,
        },
        WB_EXCHANGERATEM_ID_SELL: {
            type: "number",
            id: true,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_ExchangeRateM_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_ExchangeRateMT]: {
            foreignKey: "WB_EXCHANGERATEM_ID",
            foreignKeyImmutable: true,
            localField: "ExchangeRateMT",
        },
        [PASchema.esWB_ExchangeRateMR]: {
            foreignKey: "WB_EXCHANGERATEM_ID",
            foreignKeyImmutable: true,
            localField: "ExchangeRateMR",
        },
    },
};

export const WB_ExchangeRateMT = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Metric", // optional
    description: "Schema for WB_ExchangeRateMT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EXCHANGERATEMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EXCHANGERATEM_ID: {
            type: "number",
            id: true,
        },
        USAGE: {
            type: "string",
            length: 50,
        },
        LANGUAGE: {
            type: "string",
            length: 20,
        },
        TEXT: {
            type: "string",
            length: 256,
        },
        SHORTTEXT: {
            type: "string",
            length: 256,
        },
        ABBREVIATION: {
            type: "string",
            length: 50,
        },
        TOOLTIP: {
            type: "string",
            length: 256,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_ExchangeRateMT_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ExchangeRateM]: {
            foreignKey: "WB_EXCHANGERATEM_ID",
            foreignKeyImmutable: true,
            localField: "ExchangeRateM",
        },
    },
};

export const WB_ExchangeRateMR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Metric", // optional
    description: "Schema for WB_ExchangeRateMR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EXCHANGERATEMR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EXCHANGERATEM_ID: {
            type: "number",
            id: true,
        },
        WB_CURRENCY_ID_FROM: {
            type: "number",
            id: true,
        },
        WB_CURRENCY_ID_TO: {
            type: "number",
            id: true,
        },
        EXCHANGE_RATE: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_ExchangeRateMR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ExchangeRateM]: {
            foreignKey: "WB_EXCHANGERATEM_ID",
            foreignKeyImmutable: true,
            localField: "ExchangeRateM",
        },
        [PASchema.esWB_Currency]: [
            {
                foreignKey: "WB_CURRENCY_ID_TO",
                foreignKeyImmutable: true,
                localField: "ExchangeRateMRTo",
            },
            {
                foreignKey: "WB_CURRENCY_ID_FROM",
                foreignKeyImmutable: true,
                localField: "ExchangeRateMRFrom",
            },
        ],
    },
};

// Cube Source
export const WB_CubeSource = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CubeSource", // optional
    description: "Schema for WB_CubeSource records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUBESOURCE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        CUBESOURCE_ID: {
            type: "string",
            length: 50,
        },
        CUBESOURCE_NAME: {
            type: "string",
            length: 256,
        },
        CLASS_ID: {
            type: "string",
            length: 50,
        },
        PARAMETER1_NAME: {
            type: "string",
            length: 256,
        },

        PARAMETER2_NAME: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_CubeSource_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_CubeSource_Dimension]: {
            foreignKey: "WB_CUBESOURCE_ID",
            foreignKeyImmutable: true,
            localField: "Dimensions",
        },
        [PASchema.esWB_CubeSource_DataSource]: {
            foreignKey: "WB_CUBESOURCE_ID",
            foreignKeyImmutable: true,
            localField: "DataSources",
        },
    },
};

export const WB_CubeSource_Dimension = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CubeSourceDR", // optional
    description: "Schema for WB_CubeSourceDR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUBESOURCEDR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CUBESOURCE_ID: {
            type: "number",
        },
        DIMENSION_TYPE: {
            type: "string",
            length: 50,
        },
        HIERARCHY_POLICY: {
            type: "string",
            length: 50,
        },
        SORT_ORDER: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_CubeSource_Dimension_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CubeSource]: {
            foreignKey: "WB_CUBESOURCE_ID",
            foreignKeyImmutable: true,
            localField: "CubeSource",
        },
    },
};

export const WB_CubeSource_DataSource = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CubeSourceDSR", // optional
    description: "Schema for WB_CubeSourceDSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUBESOURCEDSR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CUBESOURCE_ID: {
            type: "number",
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        ALIAS_ID: {
            type: "string",
            length: 50,
        },
        PARAMETER1_FIELDNAME: {
            type: "string",
            length: 128,
        },
        PARAMETER2_FIELDNAME: {
            type: "string",
            length: 128,
        },
        FILTER_CONDITION: {
            type: "string",
            length: 1333,
        },
        METRIC_POLICY: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_CubeSource_DataSource_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CubeSource]: {
            foreignKey: "WB_CUBESOURCE_ID",
            foreignKeyImmutable: true,
            localField: "CubeSource",
        },
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObject",
        },
    },
    hasMany: {
        [PASchema.esWB_CubeSource_DataSource_Dimension]: {
            foreignKey: "WB_CUBESOURCEDSR_ID",
            foreignKeyImmutable: true,
            localField: "DataSourceDimensions",
        },
    },
};

export const WB_CubeSource_DataSource_Dimension = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CubeSourceDSDR", // optional
    description: "Schema for WB_CubeSourceDSDR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUBESOURCEDSDR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CUBESOURCEDSR_ID: {
            type: "number",
        },
        DIMENSION_TYPE: {
            type: "string",
            length: 50,
        },
        KEY_FIELDNAME: {
            type: "string",
            length: 128,
        },
        KEY_POLICY: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_CubeSource_DataSource_Dimension_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CubeSource_DataSource]: {
            foreignKey: "WB_CUBESOURCEDSR_ID",
            foreignKeyImmutable: true,
            localField: "DataSource",
        },
    },
};

// Plan Group BO
export const WB_Plan_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanGrp", // optional
    description: "Schema for WB_PlanGrp records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANGRP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        PLAN_GROUP_ID: {
            type: "string",
            length: 50,
        },
        PLAN_GROUP_NAME: {
            type: "string",
            length: 256,
        },
        PLAN_GROUP_LEVEL: {
            type: "string",
            length: 50,
        },
        FK_WB_PLANGRP_ID: {
            type: "number",
        },
        PLAN_GROUP_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Plan_Group_JSData_RELs = {};

// Plan Type
export const WB_Plan_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanType", // optional
    description: "Schema for WB_PlanM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        PLANM_ID: {
            type: "string",
            length: 50,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_PERIODH_ID: {
            type: "number",
        },
        WB_PERIODM_ID: {
            type: "number",
        },
        CONSUMPTION_PLANNING_MODE: {
            type: "string",
            length: 50,
        },
        SHIPMENT_PLANNING_MODE: {
            type: "string",
            length: 50,
        },
        STANDARDCALCULATORCLASS: {
            type: "string",
            length: 50,
        },
        PLANCALCULATORCLASS: {
            type: "string",
            length: 50,
        },
        PRECREATE_PGS_IND: {
            type: "string",
            length: 1,
        },
        PLANM_NAME: {
            type: "string",
            length: 256,
        },
        BASELINEPY_SOURCES: {
            type: "string",
            length: 100,
        },
        BASELINEALT_SOURCES: {
            type: "string",
            length: 100,
        },
        BASELINEPY_SOURCE_DEFAULT: {
            type: "string",
            length: 50,
        },
        BASELINEALT_SOURCE_DEFAULT: {
            type: "string",
            length: 50,
        },
        WB_PERIODM_ID_MONTH: {
            type: "number",
        },
        WB_PERIODH_ID_MONTH: {
            type: "number",
        },
        PERIODH_MONTH_SHOW_IN_HR_IND: {
            type: "string",
            length: 1,
        },
        QUANTITY_UOM: {
            type: "string",
            length: 20,
        },
        QUANTITY_CONVERTABLE_UOMS: {
            type: "string",
            length: 256,
        },
        WB_PRDH_ID: {
            type: "number",
        },
        PRDGRP_LEVEL_ID: {
            type: "string",
            length: 50,
        },
        PERIOD_ALLOC_METHOD_ID: {
            type: "string",
            length: 50,
        },
        METRICVIEWS: {
            type: "string",
            length: 500,
        },
        METRICVIEW_DEFAULT: {
            type: "string",
            length: 50,
        },
        SVFMETRICVIEWS: {
            type: "string",
            length: 500,
        },
        SVFMETRICVIEW_DEFAULT: {
            type: "string",
            length: 50,
        },
        BVPMETRICVIEWS: {
            type: "string",
            length: 100,
        },
        BVPMETRICVIEW_DEFAULT: {
            type: "string",
            length: 50,
        },
        MTRCVIEWS: {
            type: "string",
            length: 100,
        },
        MTRCVIEW_DEFAULT: {
            type: "string",
            length: 50,
        },
        METRICVIEWPERIODSUMMARY_DEFAULT: {
            type: "string",
            length: 50,
        },
        METRICVIEWSPERIODSUMMARY: {
            type: "string",
            length: 100,
        },
        CURRENCY: {
            type: "string",
            length: 20,
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        WB_CUSTH_ID_SUBPLANNING: {
            type: "number",
        },
        SUBPLANNING_LEVEL_ID: {
            type: "string",
            length: 50,
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        WB_TAG_ID_USAGE: {
            type: "number",
        },
        VALID_FROM: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        VALID_THRU: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        WHOLESALER_DECOUPLED_IND: {
            type: "string",
            length: 1,
        },
        BVP_SHOW_IND: {
            type: "string",
            length: 1,
        },
        EVENTCALENDAR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        EVENT_PRELOAD_THRESHOLD: {
            type: "number",
        },
        RETAIL_CALENDAR_START_DEFAULT: {
            type: "string",
            length: 20,
        },
        SHIPPERTAB_SHOW_IND: {
            type: "string",
            length: 1,
        },
        DISPLAY_HANDLING_METHOD_ID: {
            type: "string",
            length: 50,
        },
        HYPERRECTANGLEUI_IND: {
            type: "string",
            length: 1,
        },
        WB_CUBESOURCE_ID: {
            type: "number",
        },
        HR_LAZYLOAD_IND: {
            type: "string",
            length: 1,
        },
        HR_LAZYLOAD_PG_THRESHOLD: {
            type: "number",
        },
        SVF_TABLE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        SVF_PERSPECTIVE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        METRIC_TABLE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        METRIC_PERSPECTIVE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        BVP_TABLE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        BVP_PERSPECTIVE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        ACTUALIZATION_OFFSET_CNS: {
            type: "number",
            id: true,
        },
        ACTUALIZATION_OFFSET_SHP: {
            type: "number",
            id: true,
        },
        ACTUALIZATION_OFFSET_INDSHP: {
            type: "number",
            id: true,
        },

        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Plan_Type_Event_Type]: {
            foreignKey: "WB_PLANM_ID",
            foreignKeyImmutable: true,
            localField: "EventTypes",
        },
        [PASchema.esWB_Plan_Type_Fund_Type]: {
            foreignKey: "WB_PLANM_ID",
            foreignKeyImmutable: true,
            localField: "FundTypes",
        },
    },
    belongsTo: {
        [PASchema.esWB_Period_Type]: [
            {
                foreignKey: "WB_PERIODM_ID",
                foreignKeyImmutable: true,
                localField: "PeriodType",
            },
            { foreignKey: "WB_PERIODM_ID_MONTH", foreignKeyImmutable: true, localField: "PeriodTypeMonth" },
        ],
        [PASchema.esWB_BusinessUnit]: [
            {
                foreignKey: "WB_BUSINESSUNIT_ID",
                foreignKeyImmutable: true,
                localField: "BusinessUnit",
            },
        ],
    },
};

// Plan Type
export const WB_Plan_Type_Fund_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanTypeFundType", // optional
    description: "Schema for WB_PlanMFnd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANMFND_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLANM_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        REL_SORT: {
            type: "string",
            length: 20,
        },
        CALCULATORCLASS: {
            type: "string",
            length: 50,
        },
        PRD_CNDM_ID_STD: {
            type: "number",
        },
        PRD_CNDM_ID_ADDL: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
    },
});
export const WB_Plan_Type_Fund_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan_Type]: { foreignKey: "WB_PLANM_ID", foreignKeyImmutable: true, localField: "PlanType" },
        [PASchema.esWB_Fund_Type]: { foreignKey: "WB_FUNDTYPE_ID", foreignKeyImmutable: true, localField: "FundType" },
    },
};

export const WB_Plan_Type_Event_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanTypeEventType", // optional
    description: "Schema for WB_PlanMEvt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANMEVTT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLANM_ID: {
            type: "number",
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        REL_SORT: {
            type: "string",
            length: 20,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
    },
});
export const WB_Plan_Type_Event_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan_Type]: { foreignKey: "WB_PLANM_ID", foreignKeyImmutable: true, localField: "PlanType" },
        [PASchema.esWB_Event_Type]: { foreignKey: "WB_EVTTYPE_ID", foreignKeyImmutable: true, localField: "EventType" },
    },
};

// Plan BO
export const WB_Plan = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Plan", // optional
    description: "Schema for WB_Plan records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLAN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLANGRP_ID: {
            type: "number",
        },
        PLAN_ID: {
            type: "string",
            length: 50,
        },
        TPM_SET_ID: {
            type: "string",
            length: 10,
        },
        PLAN_NAME: {
            type: "string",
            length: 256,
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_CUST_ID_SUBPLANNING: {
            type: "number",
        },
        PLANNING_LEVEL_ID: {
            type: "string",
            length: 50,
        },
        PLANNING_LEVEL_NAME: {
            type: "string",
            length: 256,
        },
        WORKFLOW_STATUS_ID: {
            type: "number",
        },
        RETAILER_FORMAT_ID: {
            type: "number",
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        SALESORG: {
            type: "string",
            length: 20,
        },
        DIVISION: {
            type: "string",
            length: 20,
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 20,
        },
        ACTIVE_IND: {
            type: "string",
            length: 1,
        },
        PLAN_COMMENTS: {
            type: "string",
            length: 1333,
        },
        INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        PLAN_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        METRICVIEWSELECTED: {
            type: "string",
            length: 50,
        },
        PERIODMETRICVIEWSELECTED: {
            type: "string",
            length: 50,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        WB_PRDGRP_ID_PLANLEVEL: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        WB_PLNMGMT_ID: {
            type: "number",
        },
        WB_PLANM_ID: {
            type: "number",
        },
        WB_BASELINE_ID_PY: {
            type: "number",
        },
        WB_BASELINE_ID_ALT: {
            type: "number",
        },
        WB_BASELINE_ID_CNS_PY: {
            type: "number",
        },
        WB_BASELINE_ID_CNS_ALT: {
            type: "number",
        },
        WB_BASELINE_ID_SHIP_PY: {
            type: "number",
        },
        WB_BASELINE_ID_SHIP_ALT: {
            type: "number",
        },
        QTY_UOM: {
            type: "string",
            length: 20,
        },
        LAST_CALC_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        LAST_CALC_TM: {
            type: "string",
            length: 8,
        },
        CURRENCY: {
            type: "string",
            length: 20,
        },
        SVF_TABLE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        SVF_PERSPECTIVE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        METRIC_TABLE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        METRIC_PERSPECTIVE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        BVP_TABLE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        BVP_PERSPECTIVE_OPTIONS: {
            type: "string",
            length: 2500,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan_Group]: { foreignKey: "WB_PLANGRP_ID", foreignKeyImmutable: true, localField: "PlanGroup" },
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID_PLANNING",
                foreignKeyImmutable: false,
                localField: "PlanningCustomer",
            },
            { foreignKey: "WB_CUST_ID_SUBPLANNING", foreignKeyImmutable: false, localField: "SubPlanningCustomer" },
        ],
        [PASchema.esWB_Meta]: [
            {
                foreignKey: "WORKFLOW_STATUS_ID",
                foreignKeyImmutable: false,
                localField: "WorkflowStatus",
            },
        ],
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID_PLANLEVEL",
            foreignKeyImmutable: true,
            localField: "PlanningLevel",
        },
        [PASchema.esWB_Plan_Management]: {
            foreignKey: "WB_PLNMGMT_ID",
            foreignKeyImmutable: true,
            localField: "PlanManagement",
        },
        [PASchema.esWB_Plan_Type]: { foreignKey: "WB_PLANM_ID", foreignKeyImmutable: true, localField: "PlanType" },
    },
    hasOne: {
        [PASchema.esWB_Plan_Override]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Overrides" },
    },
    hasMany: {
        [PASchema.esWB_Plan_Product_Group]: {
            foreignKey: "WB_PLAN_ID",
            foreignKeyImmutable: true,
            localField: "PlanProductGroups",
        },
        [PASchema.esWB_Plan_Volume_Metrics]: {
            foreignKey: "WB_PLAN_ID",
            foreignKeyImmutable: true,
            localField: "PlanVolumeMetrics",
        },
        [PASchema.esWB_Plan_Funding_Metrics]: {
            foreignKey: "WB_PLAN_ID",
            foreignKeyImmutable: true,
            localField: "PlanFundingMetrics",
        },
        [PASchema.esWB_Plan_Product_Metrics]: {
            foreignKey: "WB_PLAN_ID",
            foreignKeyImmutable: true,
            localField: "PlanProductMetrics",
        },
    },
};

export const WB_Plan_Product_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanPG", // optional
    description: "Schema for WB_PlanPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        PG_DECOMP_METHOD: {
            type: "string",
            length: 50,
        },
    },
});
export const WB_Plan_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
    hasMany: {
        [PASchema.esWB_Plan_Product]: {
            foreignKey: "WB_PLANPG_ID",
            foreignKeyImmutable: true,
            localField: "PlanProducts",
        },
    },
};

export const WB_Plan_Product = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanPrd", // optional
    description: "Schema for WB_PlanPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PLANPG_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        ALLOCATION_PCNT: {
            type: "number",
        },
        ALLOCATION_UNITS: {
            type: "number",
        },
        ALLOCATION_RTLSLS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan_Product_Group]: {
            foreignKey: "WB_PLANPG_ID",
            foreignKeyImmutable: true,
            localField: "PlanProductGroup",
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

export const WB_Plan_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanO", // optional
    description: "Schema for WB_Plan) records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLAN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_METRIC_ID_ACTUAL: {
            type: "number",
        },
        NOTES: {
            type: "string",
            length: 1333,
        },
        PROCESSED_IND: {
            type: "string",
            length: 1,
        },
        PROCESSED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Plan_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Metric]: {
            foreignKey: "WB_METRIC_ID_ACTUAL",
            foreignKeyImmutable: true,
            localField: "ActualMetrics",
        },
    },
};

// TPM Plan BO
export const WB_Plan_Volume_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanVMt", // optional
    description: "Schema for WB_PlanVMt) records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANVMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        ROW_SOURCE: {
            type: "string",
            length: 50,
        },
        CREATE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        RETAILER_BASE_PRICE: {
            type: "number",
        },
        RETAILER_EDLP_PRICE: {
            type: "number",
        },
        RETAILER_PROMO_PRICE: {
            type: "number",
        },
        RETAILER_PRICE: {
            type: "number",
        },
        UNIT_FACTOR: {
            type: "number",
        },
        WT_FACTOR: {
            type: "number",
        },
        STATCS_FACTOR: {
            type: "number",
        },
        CNS_BASELN_PY_QTY: {
            type: "number",
        },
        CNS_BASELN_ALT_QTY: {
            type: "number",
        },
        CNS_BASELN_CY_QTY: {
            type: "number",
        },
        CNS_BASELN_ADJ_QTY: {
            type: "number",
        },
        CNS_BASELN_EFF_QTY: {
            type: "number",
        },
        CNS_BASE_QTY: {
            type: "number",
        },
        CNS_EDLP_QTY: {
            type: "number",
        },
        CNS_INCR_QTY: {
            type: "number",
        },
        CNS_TOTAL_QTY: {
            type: "number",
        },
        SHIP_BASELN_PY_QTY: {
            type: "number",
        },
        SHIP_BASELN_ALT_QTY: {
            type: "number",
        },
        SHIP_BASELN_CY_QTY: {
            type: "number",
        },
        SHIP_BASELN_ADJ_QTY: {
            type: "number",
        },
        SHIP_BASELN_EFF_QTY: {
            type: "number",
        },
        SHIP_BASE_QTY: {
            type: "number",
        },
        SHIP_INCR_QTY: {
            type: "number",
        },
        SHIP_FORWARDBUY_QTY: {
            type: "number",
        },
        SHIP_ADJ_QTY: {
            type: "number",
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_BOM_COMP_QTY: {
            type: "number",
        },
        SHIP_OS_PCNT: {
            type: "number",
        },
        SHIP_IND_UNITS: {
            type: "number",
        },
        SHIP_IND_STAT: {
            type: "number",
        },
        SHIP_IND_GRSLSTSLS: {
            type: "number",
        },
        SHIP_IND_NETLSTSLS: {
            type: "number",
        },
        SHIP_DISTRIBUTED_QTY: {
            type: "number",
        },
        SHIP_NET_TOTAL_QTY: {
            type: "number",
        },
        SHIP_EXP_RECV_QTY: {
            type: "number",
        },
        SHIP_EXP_RECV_UNITS: {
            type: "number",
        },
        SHIP_EXP_RECV_STAT: {
            type: "number",
        },
        SHIP_EXP_RECV_GRSLSTSLS: {
            type: "number",
        },
        SHIP_EXP_RECV_NETLSTSLS: {
            type: "number",
        },
        FEATUREONLY_ACV: {
            type: "number",
        },
        DISPLAYONLY_ACV: {
            type: "number",
        },
        FEATUREDISPLAY_ACV: {
            type: "number",
        },
        TPRONLY_ACV: {
            type: "number",
        },
        PROMOTED_ACV: {
            type: "number",
        },
        ACT_CNS_BASE_UNITS: {
            type: "number",
        },
        ACT_CNS_BASE_RTLSLS: {
            type: "number",
        },
        ACT_CNS_BASE_WT: {
            type: "number",
        },
        ACT_CNS_BASE_STAT: {
            type: "number",
        },
        ACT_CNS_EDLP_UNITS: {
            type: "number",
        },
        ACT_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        ACT_CNS_EDLP_WT: {
            type: "number",
        },
        ACT_CNS_EDLP_STAT: {
            type: "number",
        },
        ACT_CNS_INCR_UNITS: {
            type: "number",
        },
        ACT_CNS_INCR_RTLSLS: {
            type: "number",
        },
        ACT_CNS_INCR_WT: {
            type: "number",
        },
        ACT_CNS_INCR_STAT: {
            type: "number",
        },
        ACT_CNS_TOTAL_UNITS: {
            type: "number",
        },
        ACT_CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        ACT_CNS_TOTAL_WT: {
            type: "number",
        },
        ACT_CNS_TOTAL_STAT: {
            type: "number",
        },
        ACT_PY_CNS_BASE_UNITS: {
            type: "number",
        },
        ACT_PY_CNS_BASE_RTLSLS: {
            type: "number",
        },
        ACT_PY_CNS_EDLP_UNITS: {
            type: "number",
        },
        ACT_PY_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        ACT_PY_CNS_INCR_UNITS: {
            type: "number",
        },
        ACT_PY_CNS_INCR_RTLSLS: {
            type: "number",
        },
        ACT_PY_CNS_TOTAL_UNITS: {
            type: "number",
        },
        ACT_PY_CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        ACT_FEATUREONLY_ACV: {
            type: "number",
        },
        ACT_FEATUREDISPLAY_ACV: {
            type: "number",
        },
        ACT_TPROONLY_ACV: {
            type: "number",
        },
        ACT_PROMOTED_ACV: {
            type: "number",
        },
        LE_CNS_BASE_UNITS: {
            type: "number",
        },
        LE_CNS_BASE_RTLSLS: {
            type: "number",
        },
        LE_CNS_BASE_WT: {
            type: "number",
        },
        LE_CNS_BASE_STAT: {
            type: "number",
        },
        LE_CNS_EDLP_UNITS: {
            type: "number",
        },
        LE_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        LE_CNS_EDLP_WT: {
            type: "number",
        },
        LE_CNS_EDLP_STAT: {
            type: "number",
        },
        LE_CNS_INCR_UNITS: {
            type: "number",
        },
        LE_CNS_INCR_RTLSLS: {
            type: "number",
        },
        LE_CNS_INCR_WT: {
            type: "number",
        },
        LE_CNS_INCR_STAT: {
            type: "number",
        },
        LE_CNS_TOTAL_UNITS: {
            type: "number",
        },
        LE_CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        LE_CNS_TOTAL_WT: {
            type: "number",
        },
        LE_CNS_TOTAL_STAT: {
            type: "number",
        },
        LE_SHIP_UNITS: {
            type: "number",
        },
        LE_SHIP_WT: {
            type: "number",
        },
        LE_SHIP_STAT: {
            type: "number",
        },
        LE_SHIP_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_COSTS: {
            type: "number",
        },
        NET_LIST_PRICE_INDIRECT: {
            type: "number",
        },
        SHIP_EDLP_QTY: {
            type: "number",
        },
        SHIP_DIR_BASE_QTY: {
            type: "number",
        },
        SHIP_DIR_EDLP_QTY: {
            type: "number",
        },
        SHIP_DIR_INCR_QTY: {
            type: "number",
        },
        SHIP_DIR_FORWARDBUY_QTY: {
            type: "number",
        },
        SHIP_DIR_ADJ_QTY: {
            type: "number",
        },
        SHIP_DIR_TOTAL_QTY: {
            type: "number",
        },
        SHIP_IND_PCNT: {
            type: "number",
        },
        SHIP_IND_BASE_QTY: {
            type: "number",
        },
        SHIP_IND_EDLP_QTY: {
            type: "number",
        },
        SHIP_IND_INCR_QTY: {
            type: "number",
        },
        SHIP_IND_FORWARDBUY_QTY: {
            type: "number",
        },
        SHIP_IND_ADJ_QTY: {
            type: "number",
        },
        SHIP_IND_TOTAL_QTY: {
            type: "number",
        },
        SHIP_IND_EST_TOTAL_QTY: {
            type: "number",
        },
        SHIP_DISTRIB_PCNT: {
            type: "number",
        },
        ACT_DISPLAYONLY_ACV: {
            type: "number",
        },
        ACT_SHIP_DIR_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIR_WT: {
            type: "number",
        },
        ACT_SHIP_DIR_STAT: {
            type: "number",
        },
        ACT_SHIP_DIR_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_COSTS: {
            type: "number",
        },
        ACT_RTN_DIR_UNITS: {
            type: "number",
        },
        ACT_RTN_DIR_WT: {
            type: "number",
        },
        ACT_RTN_DIR_STAT: {
            type: "number",
        },
        ACT_RTN_DIR_GRSLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_NETLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_COSTS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_WT: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_STAT: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_COSTS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_UNITS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_WT: {
            type: "number",
        },
        ACT_RTN_DIR_OS_STAT: {
            type: "number",
        },
        ACT_RTN_DIR_OS_GRSLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_NETLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_COSTS: {
            type: "number",
        },
        ACT_SHIP_IND_UNITS: {
            type: "number",
        },
        ACT_SHIP_IND_WT: {
            type: "number",
        },
        ACT_SHIP_IND_STAT: {
            type: "number",
        },
        ACT_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_IND_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIST_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIST_WT: {
            type: "number",
        },
        ACT_SHIP_DIST_STAT: {
            type: "number",
        },
        ACT_SHIP_DIST_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIST_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_UNITS: {
            type: "number",
        },
        LE_SHIP_DIR_WT: {
            type: "number",
        },
        LE_SHIP_DIR_STAT: {
            type: "number",
        },
        LE_SHIP_DIR_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_COSTS: {
            type: "number",
        },
        LE_SHIP_IND_UNITS: {
            type: "number",
        },
        LE_SHIP_IND_WT: {
            type: "number",
        },
        LE_SHIP_IND_STAT: {
            type: "number",
        },
        LE_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_IND_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_UNITS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_WT: {
            type: "number",
        },
        LE_SHIP_DIR_OS_STAT: {
            type: "number",
        },
        LE_SHIP_DIR_OS_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_COSTS: {
            type: "number",
        },
        LE_SHIP_OS_UNITS: {
            type: "number",
        },
        LE_SHIP_OS_WT: {
            type: "number",
        },
        LE_SHIP_OS_STAT: {
            type: "number",
        },
        LE_SHIP_OS_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_OS_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_OS_COSTS: {
            type: "number",
        },
        VCM: {
            type: "number",
        },
        SPND_VARIABLE: {
            type: "number",
        },
        SPND_FIXED: {
            type: "number",
        },
        ACT_SPND_VARIABLE: {
            type: "number",
        },
        ACT_SPND_FIXED: {
            type: "number",
        },
        LE_SPND_VARIABLE: {
            type: "number",
        },
        LE_SPND_FIXED: {
            type: "number",
        },
        SHP_EXP_RECV_PCNT_TOTAL: {
            type: "number",
        },
        BASELN_START: {
            type: "number",
        },
        BASELN_DRV1: {
            type: "number",
        },
        BASELN_DRV2: {
            type: "number",
        },
        BASELN_DRV3: {
            type: "number",
        },
        BASELN_DRV4: {
            type: "number",
        },
        BASELN_DRV5: {
            type: "number",
        },
        BASELN_DRV6: {
            type: "number",
        },
        BASELN_EFF_QTY: {
            type: "number",
        },
    },
});
export const WB_Plan_Volume_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

export const WB_Plan_Approval_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanAMt", // optional
    description: "Schema for WB_PlanAMt) records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANAMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        APPROVAL_ID: {
            type: "string",
            length: 50,
        },

        PLAN_STD_FUNDING_AMT: {
            type: "number",
        },
        PLAN_ADDL_FUNDING_AMT: {
            type: "number",
        },

        ACT_STD_FUNDING_AMT: {
            type: "number",
        },
        ACT_ADDL_FUNDING_AMT: {
            type: "number",
        },

        LE_STD_FUNDING_AMT: {
            type: "number",
        },
        LE_ADDL_FUNDING_AMT: {
            type: "number",
        },

        FIXED_FUNDING_AMT: {
            type: "number",
        },

        PLAN_SPND_VARIABLE: {
            type: "number",
        },
        PLAN_SPND_FIXED: {
            type: "number",
        },

        APRV_SPND_VARIABLE: {
            type: "number",
        },
        APRV_SPND_FIXED: {
            type: "number",
        },

        ACT_SPND_VARIABLE: {
            type: "number",
        },
        ACT_SPND_FIXED: {
            type: "number",
        },

        LE_SPND_VARIABLE: {
            type: "number",
        },
        LE_SPND_FIXED: {
            type: "number",
        },

        LE_CNS_EDLP_UNITS: {
            type: "number",
        },
        LE_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        LE_CNS_EDLP_PROFIT: {
            type: "number",
        },

        LE_CNS_INCR_UNITS: {
            type: "number",
        },
        LE_CNS_INCR_RTLSLS: {
            type: "number",
        },
        LE_CNS_INCR_PROFIT: {
            type: "number",
        },

        LE_SHIP_GRSLISTSLS: {
            type: "number",
        },

        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_Approval_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
    },
};

export const WB_Plan_Product_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanPrdMt", // optional
    description: "Schema for WB_PlanPrdMt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANPRDMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        ROW_SOURCE: {
            type: "string",
            length: 50,
        },
        CREATE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ROW_TYPE: {
            type: "string",
            length: 20,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        UNIT_FACTOR: {
            type: "number",
        },
        WT_FACTOR: {
            type: "number",
        },
        STATCS_FACTOR: {
            type: "number",
        },
        CNS_TOTAL_QTY: {
            type: "number",
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_WB_TEVT_IDS: {
            type: "string",
            length: 1333,
        },
        SHIP_DIR_TOTAL_QTY: {
            type: "number",
        },
        SHIP_IND_TOTAL_QTY: {
            type: "number",
        },
        ACT_CNS_TOTAL_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIR_UNITS: {
            type: "number",
        },
        ACT_SHIP_IND_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIR_QTY: {
            type: "number",
        },
        ACT_SHIP_IND_QTY: {
            type: "number",
        },
        LE_CNS_TOTAL_UNITS: {
            type: "number",
        },
        LE_SHIP_DIR_UNITS: {
            type: "number",
        },
        LE_SHIP_IND_UNITS: {
            type: "number",
        },
        LE_SHIP_DIR_QTY: {
            type: "number",
        },
        LE_SHIP_IND_QTY: {
            type: "number",
        },
        SOP_BB_RATE: {
            type: "number",
        },
        SOP_BB_OS_RATE: {
            type: "number",
        },
        SOP_BB_COMP_RATE: {
            type: "number",
        },
        SOP_OI_RATE: {
            type: "number",
        },
        SOP_OI_OS_RATE: {
            type: "number",
        },
        SOP_OI_COMP_RATE: {
            type: "number",
        },
        SPND_VARIABLE: {
            type: "number",
        },
        LE_SPND_VARIABLE: {
            type: "number",
        },
    },
});
export const WB_Plan_Product_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

export const WB_Plan_Redistrib_Volume_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanRVMt", // optional
    description: "Schema for WB_PlanRVMt) records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANRVMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        SUPPLYDIRECTION: {
            type: "string",
            length: 50,
        },

        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE_INDIRECT: {
            type: "number",
        },
        VCM: {
            type: "number",
        },
        UNIT_FACTOR: {
            type: "number",
        },
        WT_FACTOR: {
            type: "number",
        },
        STATCS_FACTOR: {
            type: "number",
        },

        SHIP_IND_PCNT: {
            type: "number",
        },
        SHIP_IND_QTY: {
            type: "number",
        },
        SHIP_IND_UNITS: {
            type: "number",
        },
        SHIP_IND_STAT: {
            type: "number",
        },
        SHIP_IND_GRSLSTSLS: {
            type: "number",
        },
        SHIP_IND_NETLSTSLS: {
            type: "number",
        },

        SHIP_EXP_RECV_PCNT: {
            type: "number",
        },
        SHIP_EXP_RECV_QTY: {
            type: "number",
        },
        SHIP_EXP_RECV_UNITS: {
            type: "number",
        },
        SHIP_EXP_RECV_STAT: {
            type: "number",
        },
        SHIP_EXP_RECV_GRSLSTSLS: {
            type: "number",
        },
        SHIP_EXP_RECV_NETLSTSLS: {
            type: "number",
        },

        ACT_SHIP_IND_UNITS: {
            type: "number",
        },
        ACT_SHIP_IND_WT: {
            type: "number",
        },
        ACT_SHIP_IND_STAT: {
            type: "number",
        },
        ACT_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_IND_NETLISTSLS: {
            type: "number",
        },

        LE_SHIP_IND_UNITS: {
            type: "number",
        },
        LE_SHIP_IND_WT: {
            type: "number",
        },
        LE_SHIP_IND_STAT: {
            type: "number",
        },
        LE_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_IND_NETLISTSLS: {
            type: "number",
        },
    },
});
export const WB_Plan_Redistrib_Volume_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_Plan_Volume_Monthly_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanMMt", // optional
    description: "Schema for WB_PlanMMt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANMMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        ROW_SOURCE: {
            type: "string",
            length: 50,
        },
        CREATE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CNS_TOTAL_UNITS: {
            type: "number",
        },
        CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        CNS_TOTAL_WT: {
            type: "number",
        },
        CNS_TOTAL_STAT: {
            type: "number",
        },
        CNS_TOTAL_GRSLISTSLS: {
            type: "number",
        },
        CNS_TOTAL_NETLISTSLS: {
            type: "number",
        },
        SHIP_UNITS: {
            type: "number",
        },
        SHIP_WT: {
            type: "number",
        },
        SHIP_STAT: {
            type: "number",
        },
        SHIP_GRSLISTSLS: {
            type: "number",
        },
        SHIP_NETLISTSLS: {
            type: "number",
        },
    },
});
export const WB_Plan_Volume_Monthly_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

export const WB_Plan_Funding_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanFMt", // optional
    description: "Schema for WB_PlanFMt) records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANFMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        ROW_SOURCE: {
            type: "string",
            length: 50,
        },
        CREATE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        PLAN_BASIS_QTY: {
            type: "number",
        },
        ACT_BASIS_QTY: {
            type: "number",
        },
        LE_BASIS_QTY: {
            type: "number",
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        STD_FUNDING_RATE: {
            type: "number",
        },
        ADDL_FUNDING_RATE: {
            type: "number",
        },
        PLAN_STD_FUNDING_AMT: {
            type: "number",
        },
        PLAN_ADDL_FUNDING_AMT: {
            type: "number",
        },
        ACT_STD_FUNDING_AMT: {
            type: "number",
        },
        ACT_ADDL_FUNDING_AMT: {
            type: "number",
        },
        LE_STD_FUNDING_AMT: {
            type: "number",
        },
        LE_ADDL_FUNDING_AMT: {
            type: "number",
        },
    },
});
export const WB_Plan_Funding_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

// Event BO
export const WB_Event = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Evt", // optional
    description: "Schema for WB_Evt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        EVENT_ID: {
            type: "string",
            length: 50,
        },
        TPM_SET_ID: {
            type: "string",
            length: 10,
        },
        EVENT_NAME: {
            type: "string",
            length: 256,
        },
        EVENT_TYPE_ID: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_CUSTSR_ID_PLANNING: {
            type: "number",
        },
        WB_CUST_ID_SUBPLANNING: {
            type: "number",
        },
        WORKFLOW_STATUS_ID: {
            type: "number",
        },
        PLANNING_PROFILE_GROUP_ID: {
            type: "number",
        },
        EVENT_COMMENTS: {
            type: "string",
            length: 1333,
        },
        INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        EVENT_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        PROCESS_ID: {
            type: "string",
            length: 256,
        },
        WB_PARTITION_ID: {
            type: "number",
        },
        WB_CONTROL_POINTMPR_ID: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Event_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID_PLANNING",
                foreignKeyImmutable: true,
                localField: "PlanningCustomer",
            },
            { foreignKey: "WB_CUST_ID_SUBPLANNING", foreignKeyImmutable: true, localField: "SubPlanningCustomer" },
        ],
        [PASchema.esWB_Meta]: [
            {
                foreignKey: "PLANNING_PROFILE_GROUP_ID",
                foreignKeyImmutable: false,
                localField: "PlanningProfileGroup",
            },
            { foreignKey: "WORKFLOW_STATUS_ID", foreignKeyImmutable: false, localField: "WorkflowStatus" },
        ],
        [PASchema.esWB_Event_Type]: { foreignKey: "EVENT_TYPE_ID", foreignKeyImmutable: true, localField: "EventType" },
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" },
    },
    hasOne: {
        [PASchema.esWB_Event_Override]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "Overrides" },
    },
    hasMany: {
        [PASchema.esWB_Event_Product_Group]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventProductGroups",
        },
        [PASchema.esWB_Event_Spend]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventSpends",
        },
        [PASchema.esWB_Event_Spend_PrdGrp]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProductGroups",
        },
        [PASchema.esWB_Event_Spend_PrdGrp_Redistrib]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendRedistribution",
        },
        [PASchema.esWB_Event_Customer]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventSourceCustomers",
        },
        [PASchema.esWB_Event_Meta]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "EventMetas" },
        [PASchema.esWB_Event_Tag]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "EventTags" },
        [PASchema.esWB_Event_Relationship]: [
            {
                foreignKey: "WB_EVT_ID",
                foreignKeyImmutable: true,
                localField: "EventRelsSource",
            },
            { foreignKey: "WB_EVT_ID_REL", foreignKeyImmutable: true, localField: "EventRelsTarget" },
        ],
        [PASchema.esWB_Event_Circular]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventCirculars",
        },
        [PASchema.esWB_EventFR]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "EventFR" },
        [PASchema.esWB_EvtShipPrd]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventShipProduct",
        },
        [PASchema.esWB_EvtSShpPrd]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendShipProduct",
        },
        [PASchema.esWB_FC_Override]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "FCOverrides",
        },
    },
};

export const WB_Event_Product_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtPG", // optional
    description: "Schema for WB_EvtPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        PG_DECOMP_METHOD: {
            type: "string",
            length: 50,
        },
        WB_METRIC_ID_PLANNED: {
            type: "number",
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Event_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
            createIndex: true,
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Metric]: {
            foreignKey: "WB_METRIC_ID_PLANNED",
            foreignKeyImmutable: true,
            localField: "PlannedMetrics",
            createIndex: true,
        },
    },
    hasOne: {
        [PASchema.esWB_Event_Product_Group_Override]: {
            foreignKey: "WB_EVTPG_ID",
            foreignKeyImmutable: true,
            localField: "Overrides",
        },
    },
    hasMany: {
        [PASchema.esWB_Event_Product]: {
            foreignKey: "WB_EVTPG_ID",
            foreignKeyImmutable: true,
            localField: "EventProducts",
        },
    },
};

export const WB_Event_Product = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtPrd", // optional
    description: "Schema for WB_EvtPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVTPG_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        ALLOCATION_PCNT: {
            type: "number",
        },
        ALLOCATION_UNITS: {
            type: "number",
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Event_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Product_Group]: {
            foreignKey: "WB_EVTPG_ID",
            foreignKeyImmutable: true,
            localField: "EventProductGroup",
            createIndex: true,
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

export const WB_Event_Customer = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSCst", // optional
    description: "Schema for WB_EvtSCst records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSCUST_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_CUST_ID_SOURCE: {
            type: "number",
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Event_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
            createIndex: true,
        },
        [PASchema.esWB_Customer]: {
            foreignKey: "WB_CUST_ID_SOURCE",
            foreignKeyImmutable: true,
            localField: "Customer",
        },
    },
};

export const WB_Event_Meta = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtMetaR", // optional
    description: "Schema for WB_EvtMetaR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTMETAR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        ATTRIBUTE_ID: {
            type: "string",
            length: 50,
        },
        WB_META_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ATR_STRING_VALUE: {
            type: "string",
            length: 256,
        },
        ATR_NUMBER_VALUE: {
            type: "number",
        },
        ATR_DATE_VALUE: {
            type: "string",
            length: 8,
        },
    },
});
export const WB_Event_Meta_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
            createIndex: true,
        },
        [PASchema.esWB_Meta]: { foreignKey: "WB_META_ID", foreignKeyImmutable: true, localField: "Meta" },
    },
};

export const WB_Event_Tag = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtTagR", // optional
    description: "Schema for WB_EvtTagR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTTAG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_TAG_ID: {
            type: "number",
        },
        TAG_METHOD: {
            type: "string",
            length: 50,
        },
        TAGGED_BY: {
            type: "string",
            length: 256,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Event_Tag_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
            createIndex: true,
        },
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" },
    },
};

export const WB_EvtFR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtFR", // optional
    description: "Schema for WB_EvtFR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTFR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVT_ID_REL: {
            type: "number",
        },
        WB_METRIC_ID_FUNDING: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_EvtFR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: [
            {
                foreignKey: "WB_EVT_ID",
                foreignKeyImmutable: true,
                localField: "Event",
                createIndex: true,
            },
            { foreignKey: "WB_EVT_ID_REL", foreignKeyImmutable: true, localField: "EventTarget", createIndex: true },
        ],

        [PASchema.esWB_Metric]: {
            foreignKey: "WB_METRIC_ID_FUNDING",
            foreignKeyImmutable: true,
            localField: "EDLCCalcedMetric",
            createIndex: true,
        },
    },
};

export const WB_Event_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtR", // optional
    description: "Schema for WB_EvtR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        REL_TYPE: {
            type: "string",
            length: 50,
        },
        WB_EVT_ID_REL: {
            type: "number",
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Event_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: [
            {
                foreignKey: "WB_EVT_ID",
                foreignKeyImmutable: true,
                localField: "Event",
                createIndex: true,
            },
            { foreignKey: "WB_EVT_ID_REL", foreignKeyImmutable: true, localField: "EventTarget", createIndex: true },
        ],
    },
};

export const WB_Event_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtO", // optional
    description: "Schema for WB_EvtO records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_METRIC_ID_ACTUAL: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD_PENDING: {
            type: "number",
        },
        WB_METRIC_ID_FUNDING: {
            type: "number",
        },
        INSTORE_START_DT_OVRD: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT_OVRD: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT_OVRD: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT_OVRD: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        NOTES: {
            type: "string",
            length: 1333,
        },
        PROCESSED_IND: {
            type: "string",
            length: 1,
        },
        PROCESSED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ACTUAL_VOL_METHOD_ID: {
            type: "string",
            length: 50,
        },
        SHOW_OVERLAP_SPEND_IND: {
            type: "string",
            length: 1,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        INSTORE_START_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT_ALIGNED: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT_ALIGNED: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        ANCHOR_SYNC_POLICY: {
            type: "string",
            length: 50,
        },
        ANCHOR_SYNC_SOURCE: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Event_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "Event" }, //createIndex: true  not needed, same FK= PK
        [PASchema.esWB_Metric]: [
            {
                foreignKey: "WB_METRIC_ID_ACTUAL",
                foreignKeyImmutable: true,
                localField: "ActualMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD",
                foreignKeyImmutable: true,
                localField: "ActualOvrdMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD_PENDING",
                foreignKeyImmutable: true,
                localField: "ActualOvrdPendingMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_FUNDING",
                foreignKeyImmutable: true,
                localField: "FundingOvrdMetrics",
                createIndex: true,
            },
        ],
    },
};

export const WB_Event_Product_Group_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtPGO", // optional
    description: "Schema for WB_EvtPGO records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_METRIC_ID_ACTUAL: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD_PENDING: {
            type: "number",
        },
        CNSMP_BASE_QTY_OVRD: {
            type: "number",
        },
        CNSMP_INCR_QTY_OVRD: {
            type: "number",
        },
        CNSMP_EDLP_QTY_OVRD: {
            type: "number",
        },
        SHIPMENT_QTY_OVRD: {
            type: "number",
        },
        RETURN_QTY_OVRD: {
            type: "number",
        },
        TRUE_BASE_PRICE_OVRD: {
            type: "number",
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Event_Product_Group_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Product_Group]: {
            foreignKey: "WB_EVTPG_ID",
            foreignKeyImmutable: true,
            localField: "EventProductGroup",
        }, //createIndex: true  not needed, same FK= PK
        [PASchema.esWB_Metric]: [
            {
                foreignKey: "WB_METRIC_ID_ACTUAL",
                foreignKeyImmutable: true,
                localField: "ActualMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD",
                foreignKeyImmutable: true,
                localField: "ActualOvrdMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD_PENDING",
                foreignKeyImmutable: true,
                localField: "ActualOvrdPendingMetrics",
                createIndex: true,
            },
        ],
    },
};

export const WB_Event_Spend = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtS", // optional
    description: "Schema for WB_EvtS records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_ID: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_NAME: {
            type: "string",
            length: 256,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        RATE_UOM: {
            type: "string",
            length: 50,
        },
        RATE_CURRENCY: {
            type: "string",
            length: 50,
        },
        PAYMENT_METHOD_ID: {
            type: "string",
            length: 50,
        },
        SPEND_TYPE_ID: {
            type: "number",
        },
        RATE_CATEGORY_ID: {
            type: "number",
        },
        RATE_SPEND_METHOD_ID: {
            type: "number",
        },
        RATE_DISC_METHOD_ID: {
            type: "number",
        },
        EXPENSE_TYPE_ID: {
            type: "number",
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        WORKFLOW_STATUS_ID: {
            type: "number",
        },
        CLOSED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});
export const WB_Event_Spend_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
            createIndex: true,
        },
        [PASchema.esWB_Event_Spend_Type]: {
            foreignKey: "WB_EVTSTYPE_ID",
            foreignKeyImmutable: true,
            localField: "SpendType",
        },
    },
    hasMany: {
        [PASchema.esWB_Event_Spend_PrdGrp]: {
            foreignKey: "WB_EVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProductGroups",
        },
    },
};

export const WB_Event_Spend_PrdGrp = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSPG", // optional
    description: "Schema for WB_EvtSPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVTS_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        ROW_TYPE: {
            type: "string",
            length: 20,
        },
        WB_SPENDM_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        PG_DECOMP_METHOD: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_ID: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_NAME: {
            type: "string",
            length: 256,
        },
        WORKFLOW_STATUS_ID: {
            type: "number",
        },
        DEAL_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DEAL_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        RATE_AMT: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        RATE_UOM: {
            type: "string",
            length: 50,
        },
        RATE_CURRENCY: {
            type: "string",
            length: 50,
        },
        REDEMPTION_PCNT: {
            type: "number",
        },
        PAYMENT_METHOD_ID: {
            type: "number",
        },
        SPEND_TYPE_ID: {
            type: "number",
        },
        RATE_CATEGORY_ID: {
            type: "number",
        },
        RATE_SPEND_METHOD_ID: {
            type: "number",
        },
        RATE_DISC_METHOD_ID: {
            type: "number",
        },
        CONDITION_TYPE_ID: {
            type: "number",
        },
        RATE_DATE_TYPE_ID: {
            type: "number",
        },
        EXPENSE_TYPE_ID: {
            type: "number",
        },
        RATE_AMT_PER_UNIT: {
            type: "number",
        },
        SPEND_PLANNED: {
            type: "number",
        },
        SPEND_ACTUAL: {
            type: "number",
        },
        SPEND_ACTUAL_FINAL: {
            type: "number",
        },
        SPEND_TPM_LE: {
            type: "number",
        },
        SPEND_PA_LE: {
            type: "number",
        },
        SPEND_RTE_CUSTOM: {
            type: "number",
        },
        EVENT_SPEND_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CLOSED_IND: {
            type: "string",
            length: 1,
        }
    },
});
export const WB_Event_Spend_PrdGrp_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
            createIndex: true,
        },
        [PASchema.esWB_Event_Spend]: {
            foreignKey: "WB_EVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
            createIndex: true,
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Spend_Type]: { foreignKey: "WB_SPENDM_ID", foreignKeyImmutable: true, localField: "SpendType" },
    },
    hasOne: {
        [PASchema.esWB_Event_Spend_PrdGrp_Override]: {
            foreignKey: "WB_EVTSPG_ID",
            foreignKeyImmutable: true,
            localField: "Overrides",
        },
    },
    hasMany: {
        [PASchema.esWB_Event_Spend_Prd]: {
            foreignKey: "WB_EVTSPG_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProducts",
        },
        [PASchema.esWB_Event_Spend_PrdGrp_Customer]: {
            foreignKey: "WB_EVTSPG_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendCustomers",
        },
    },
};

export const WB_Event_Spend_Prd = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSPrd", // optional
    description: "Schema for WB_EvtSPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVTSPG_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        ALLOCATION_PCNT: {
            type: "number",
        },
        ALLOCATION_UNITS: {
            type: "number",
        },
        ALLOCATION_BASIS_QTY_OVRD: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Event_Spend_Prd_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Spend_PrdGrp]: {
            foreignKey: "WB_EVTSPG_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProductGroup",
            createIndex: true,
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        }
    },
};

export const WB_Event_Spend_PrdGrp_Customer = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSPGC", // optional
    description: "Schema for WB_EvtSPGC records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSPGC_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVTSPG_ID: {
            type: "number",
        },
        WB_CUST_ID_SOURCE: {
            type: "number",
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Event_Spend_PrdGrp_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Spend_PrdGrp]: {
            foreignKey: "WB_EVTSPG_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProductGroup",
            createIndex: true,
        },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_Event_Spend_PrdGrp_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSPGO", // optional
    description: "Schema for WB_EvtSPGO records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_METRIC_ID_ACTUAL: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD_PENDING: {
            type: "number",
        },
        SPEND_CALC_METHOD: {
            type: "string",
            length: 50,
        },
        INSTORE_START_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT_ALIGNED: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        INSTORE_START_DT_OVRD: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT_OVRD: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        INSTOREDT_PARENTLINK_IND: {
            type: "string",
            length: 1,
        },
        SHIPMENT_START_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT_ALIGNED: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT_OVRD: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT_OVRD: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENTDT_PARENTLINK_IND: {
            type: "string",
            length: 1,
        },
        RATE_AMT_OVRD: {
            type: "number",
        },
        LIABILITY_QTY: {
            type: "number",
        },
        LIABILITY_QTY_OVRD: {
            type: "number",
        },
        SPEND_OVRD: {
            type: "number",
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        REDEMPTION_PCNT_OVRD_IND: {
            "type": "string",
            "length": 1,
        },
        REDEMPTION_PCNT_OVRD: {
            type: "number",
        },
        MARGINAL_SPEND_IND: {
            type: "string",
            length: 1,
        },
        WB_SPENDM_ID_OVRD: {
            type: "number",
        },
        SPEND_LEVEL_OVRD: {
            type: "number",
        },
        CLOSED_IND_OVRD: {
            type: "string",
            length: 1,
        },
        OVRD_ACTUALSPEND_IND: {
            type: "string",
            length: 1,
        }
    },
});
export const WB_Event_Spend_PrdGrp_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Spend_PrdGrp]: {
            foreignKey: "WB_EVTSPG_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProductGroup",
            createIndex: true,
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Metric]: [
            {
                foreignKey: "WB_METRIC_ID_ACTUAL",
                foreignKeyImmutable: true,
                localField: "ActualMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD",
                foreignKeyImmutable: true,
                localField: "ActualOvrdMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD_PENDING",
                foreignKeyImmutable: true,
                localField: "ActualOvrdPendingMetrics",
                createIndex: true,
            },
        ],
    },
};

export const WB_Event_Spend_PrdGrp_Redistrib = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtRSPG", // optional
    description: "Schema for WB_EvtRSPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTRSPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_EVTSPG_ID: {
            type: "number",
        },
        OVRLP_INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRLP_INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        OVRLP_INSTORE_PCNT: {
            type: "number",
        },
        OVRLP_SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRLP_SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        OVRLP_SHIPMENT_PCNT: {
            type: "number",
        },
        OVRLP_SPEND: {
            type: "number",
        },
        OVRLP_SPEND_CALC_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        WB_SPENDRL_ID: {
            type: "number",
        },
        BASIS_ID: {
            type: "number",
        },
        BASIS_RATE_AMT: {
            type: "number",
        },
        ALLOCATED_SPEND: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        WB_METRIC_ID_OVRLP: {
            type: "number",
        },
        OVRLP_SPEND_CNS: {
            type: "number",
        },
        OVRLP_SPEND_SHIP: {
            type: "number",
        },
    },
});
export const WB_Event_Spend_PrdGrp_Redistrib_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Event_Spend_PrdGrp]: {
            foreignKey: "WB_EVTSPG_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProductGroup",
            createIndex: true,
        },
        [PASchema.esWB_Metric]: {
            foreignKey: "WB_METRIC_ID_OVRLP",
            foreignKeyImmutable: true,
            localField: "OvrlpMetrics",
            createIndex: true,
        },
    },
};

export const WB_Event_Circular = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtCir", // optional
    description: "Schema for WB_EvtCir records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTCIR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_CIRCULAR_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Event_Circular_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
            createIndex: true,
        },
        [PASchema.esWB_Circular]: { foreignKey: "WB_CIRCULAR_ID", foreignKeyImmutable: true, localField: "Circular" },
    },
};

export const WB_EvtShipPrd = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtShipPrd", // optional
    description: "Schema for WB_EvtShipPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSHIPPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
            id: true,
        },
        WB_PROD_ID: {
            type: "number",
            id: true,
        },
        PLN_SHIP_QTY: {
            type: "number",
        },
        ACT_SHIP_QTY: {
            type: "number",
        },
        OVRD_SHIP_QTY: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_EvtShipPrd_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Events",
        },
    },
    hasMany: {
        [PASchema.esWB_EvtShipCPrd]: {
            foreignKey: "WB_EVTSHIPPRD_ID",
            foreignKeyImmutable: true,
            localField: "EventShipCProduct",
        },
    },
};

export const WB_EvtShipCPrd = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtShipCPrd", // optional
    description: "Schema for WB_EvtShipCPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSHIPCPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVTSHIPPRD_ID: {
            type: "number",
            id: true,
        },
        WB_PRDGRP_ID: {
            type: "number",
            id: true,
        },
        WB_PROD_IDS: {
            type: "string",
            length: 500,
        },
        COMPONENT_QTY: {
            type: "number",
        },
        COMPONENT_UOM: {
            type: "string",
            length: 20,
        },
        CNSMP_BASE_UNITS: {
            type: "number",
        },
        CNSMP_EDLP_UNITS: {
            type: "number",
        },
        CNSMP_INCR_UNITS: {
            type: "number",
        },
        CNSMP_TOTAL_UNITS: {
            type: "number",
        },
        SHIPMENT_UNITS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_EvtShipCPrd_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_EvtShipPrd]: {
            foreignKey: "WB_EVTSHIPPRD_ID",
            foreignKeyImmutable: true,
            localField: "EventShipProduct",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
};

export const WB_EvtSShpPrd = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSShpPrd", // optional
    description: "Schema for WB_EvtSShpPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSSHPPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        WB_SPENDM_ID: {
            type: "number",
        },
        EVENT_SPEND_ID: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_NAME: {
            type: "string",
            length: 256,
        },
        WORKFLOW_STATUS_ID: {
            type: "number",
        },
        DEAL_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DEAL_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        RATE_AMT: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        RATE_UOM: {
            type: "string",
            length: 50,
        },
        RATE_CURRENCY: {
            type: "string",
            length: 50,
        },
        PAYMENT_METHOD_ID: {
            type: "number",
        },
        SPEND_TYPE_ID: {
            type: "number",
        },
        RATE_CATEGORY_ID: {
            type: "number",
        },
        RATE_SPEND_METHOD_ID: {
            type: "number",
        },
        RATE_DISC_METHOD_ID: {
            type: "number",
        },
        CONDITION_TYPE_ID: {
            type: "number",
        },
        RATE_DATE_TYPE_ID: {
            type: "number",
        },
        EXPENSE_TYPE_ID: {
            type: "number",
        },
        SPEND_PLANNED: {
            type: "number",
        },
        SPEND_ACTUAL: {
            type: "number",
        },
        SPEND_ACTUAL_FINAL: {
            type: "number",
        },
        SPEND_TPM_LE: {
            type: "number",
        },
        SPEND_PA_LE: {
            type: "number",
        },
        CLOSED_IND: {
            type: "string",
            length: 1,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_EvtSShpPrd_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
        [PASchema.esWB_Spend_Type]: { foreignKey: "WB_SPENDM_ID", foreignKeyImmutable: true, localField: "SpendType" },
    },
    hasOne: {
        [PASchema.esWB_EvtSShpPrdO]: {
            foreignKey: "WB_EVTSSHPPRD_ID",
            foreignKeyImmutable: true,
            localField: "Overrides",
        },
    },
};

export const WB_EvtSShpPrdO = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSShpPrd_Override", // optional
    description: "Schema for WB_EvtSShpPrdO records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSSHPPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        SPEND_CALC_METHOD: {
            type: "string",
            length: 50,
        },
        INSTORE_START_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_START_DT_OVRD: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT_OVRD: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        INSTOREDT_PARENTLINK_IND: {
            type: "string",
            length: 1,
        },
        SHIPMENT_START_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT_ALIGNED: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_START_DT_OVRD: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT_OVRD: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENTDT_PARENTLINK_IND: {
            type: "string",
            length: 1,
        },
        RATE_AMT_OVRD: {
            type: "number",
        },
        LIABILITY_QTY: {
            type: "number",
        },
        LIABILITY_QTY_OVRD: {
            type: "number",
        },
        WB_METRIC_ID_ACTUAL: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD: {
            type: "number",
        },
        WB_METRIC_ID_ACTUALOVRD_PENDING: {
            type: "number",
        },
        MARGINAL_SPEND_IND: {
            type: "string",
            length: 1,
        },
        SPEND_LEVEL_OVRD: {
            type: "number",
        },
        CLOSED_IND_OVRD: {
            type: "string",
            length: 1,
        },
        INDIRECT_RATE_IND_OVRD: {
            type: "string",
            length: 1,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});

export const WB_EvtSShpPrdO_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_EvtSShpPrd]: {
            foreignKey: "WB_EVTSSHPPRD_ID",
            foreignKeyImmutable: true,
            localField: "Overrides",
        },
        [PASchema.esWB_Event]: { foreignKey: "WB_EVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
        [PASchema.esWB_Metric]: [
            {
                foreignKey: "WB_METRIC_ID_ACTUAL",
                foreignKeyImmutable: true,
                localField: "ActualMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD",
                foreignKeyImmutable: true,
                localField: "ActualOvrdMetrics",
                createIndex: true,
            },
            {
                foreignKey: "WB_METRIC_ID_ACTUALOVRD_PENDING",
                foreignKeyImmutable: true,
                localField: "ActualOvrdPendingMetrics",
                createIndex: true,
            },
        ],
    },
};

// TPM Event BO
export const WB_TPM_Event = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvt", // optional
    description: "Schema for WB_TEvt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        EVENT_ID: {
            type: "string",
            length: 50,
        },
        EVENT_NAME: {
            type: "string",
            length: 256,
        },
        EVENT_COMMENTS: {
            type: "string",
            length: 1333,
        },
        ACTIVE_IND: {
            type: "string",
            length: 1,
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_CUST_ID_SUBPLANNING: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        ORDER_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ORDER_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        DISTRIBUTION_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DISTRIBUTION_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        WORKFLOW_STATUS_ID: {
            type: "number",
        },
        WORKFLOW_STATUS_ID_NEXT: {
            type: "number",
        },
        WB_AUTHUSR_ID_WF_NEXT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        COVERAGE_FACTOR: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        PLANNED_SPEND: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        PAID_IN_FULL_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_TPM_Event_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID_PLANNING",
                foreignKeyImmutable: false,
                localField: "PlanningCustomer",
            },
            { foreignKey: "WB_CUST_ID_SUBPLANNING", foreignKeyImmutable: false, localField: "SubPlanningCustomer" },
        ],
        [PASchema.esWB_Event_Type]: { foreignKey: "WB_EVTTYPE_ID", foreignKeyImmutable: true, localField: "EventType" },
        [PASchema.esWB_Workflow_Status]: {
            foreignKey: "WORKFLOW_STATUS_ID",
            foreignKeyImmutable: false,
            localField: "WorkflowStatus",
        },
        [PASchema.esWB_User]: {
            foreignKey: "WB_AUTHUSR_ID_CREATEDBY",
            foreignKeyImmutable: true,
            localField: "UserCreatedBy",
        },
    },
    hasMany: {
        [PASchema.esWB_TPM_Event_Product_Group]: {
            foreignKey: "WB_TEVT_ID",
            foreignKeyImmutable: true,
            localField: "EventProductGroups",
        },
        [PASchema.esWB_TPM_Event_Product]: {
            foreignKey: "WB_TEVT_ID",
            foreignKeyImmutable: true,
            localField: "EventProducts",
        },
        [PASchema.esWB_TPM_Event_Tag]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "EventTags" },
        [PASchema.esWB_TPM_Event_Metrics]: {
            foreignKey: "WB_TEVT_ID",
            foreignKeyImmutable: true,
            localField: "EventMetrics",
        },
        [PASchema.esWB_TPM_Event_Product_Metrics]: {
            foreignKey: "WB_TEVT_ID",
            foreignKeyImmutable: true,
            localField: "EventProductMetrics",
        },
        [PASchema.esWB_TPM_Event_Spend]: {
            foreignKey: "WB_TEVT_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
    },
};

export const WB_TPM_Event_Tag = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtTagR", // optional
    description: "Schema for WB_TEvtTagR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTTAGR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVT_ID: {
            type: "number",
        },
        WB_TAG_ID: {
            type: "number",
        },
        TAG_METHOD: {
            type: "string",
            length: 50,
        },
        TAGGED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_TPM_Event_Tag_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" },
    },
};

export const WB_TPM_Event_Product_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtPG", // optional
    description: "Schema for WB_TEvtPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVT_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        ROW_TYPE: {
            type: "string",
            length: 20,
        },
        BASE_PRICE: {
            type: "number",
        },
        EDLP_PRICE: {
            type: "number",
        },
        PROMOTED_PRICE: {
            type: "number",
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        COVERAGE_FACTOR: {
            type: "number",
        },
        CNS_PLAN_BASE_QTY: {
            type: "number",
        },
        CNS_LIFT_PCNT: {
            type: "number",
        },
        CNS_LIFT_PCNT_OVRD: {
            type: "number",
        },
        CNS_BASE_QTY: {
            type: "number",
        },
        CNS_EDLP_QTY: {
            type: "number",
        },
        CNS_INCR_QTY: {
            type: "number",
        },
        CNS_TOTAL_QTY: {
            type: "number",
        },
        MERCH_FEATUREONLY_ACV: {
            type: "number",
        },
        MERCH_DISPLAYONLY_ACV: {
            type: "number",
        },
        MERCH_FEATUREDISPLAY_ACV: {
            type: "number",
        },
        MERCH_TPRONLY_ACV: {
            type: "number",
        },
        SHIP_PLAN_BASE_QTY: {
            type: "number",
        },
        SHIP_BASE_QTY: {
            type: "number",
        },
        CNS_FORWARD_BUY_PCNT: {
            type: "number",
        },
        SHIP_FORWARD_BUY_QTY: {
            type: "number",
        },
        SHIP_EDLP_QTY: {
            type: "number",
        },
        SHIP_INCR_QTY: {
            type: "number",
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_DISPLAY_QTY: {
            type: "number",
        },
        SHIP_INDIRECT_QTY: {
            type: "number",
        },
        OES_SENT_TO_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DISCOUNT_AMT: {
            type: "number",
        },
        DISCOUNT_PCNT: {
            type: "number",
        },
        CNS_PLAN_EDLP_QTY: {
            type: "number",
        },
        CNS_BASEANDEDLP_QTY: {
            type: "number",
        },
        CNS_CANN_QTY: {
            type: "number",
        },
        SHIP_PLAN_EDLP_QTY: {
            type: "number",
        },
        SHIP_BASEANDEDLP_QTY: {
            type: "number",
        },
        SHIP_ADJ_QTY: {
            type: "number",
        },
        SHIP_PLAN_ADJ_QTY: {
            type: "number",
        },
        OPENSTOCK_IND: {
            type: "string",
        },
        DISPLAY_COMP_IND: {
            type: "string",
        },
        SHIP_PLAN_DISPLAY_QTY: {
            type: "number",
        },
        SHIP_OS_QTY: {
            type: "number",
        },
        SHIP_DISPLAY_PCNT: {
            type: "number",
        },
    },
});
export const WB_TPM_Event_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
};

export const WB_TPM_Event_Product = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtPrd", // optional
    description: "Schema for WB_TEvtPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVT_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        ROW_TYPE: {
            type: "string",
            length: 20,
        },
        PARENT_ROW_ID: {
            type: "number",
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_DISPLAY_QTY: {
            type: "number",
        },
        SHIP_BUOM_QTY: {
            type: "number",
        },
        OES_SENT_TO_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_TPM_Event_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

export const WB_TPM_Event_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtMt", // optional
    description: "Schema for WB_TEvtMt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVT_ID: {
            type: "number",
            id: 2,
        },
        WB_PRDGRP_ID: {
            type: "number",
            id: 3,
        },
        WB_PERIOD_ID: {
            type: "number",
            id: 4,
        },
        ROW_SOURCE: {
            type: "string",
            length: 50,
        },
        CREATE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE_INDIRECT: {
            type: "number",
        },
        VCM: {
            type: "number",
        },
        RETAILER_BASE_PRICE: {
            type: "number",
        },
        RETAILER_EDLP_PRICE: {
            type: "number",
        },
        RETAILER_PROMO_PRICE: {
            type: "number",
        },
        UNIT_FACTOR: {
            type: "number",
        },
        WT_FACTOR: {
            type: "number",
        },
        STATCS_FACTOR: {
            type: "number",
        },
        CNS_BASE_QTY: {
            type: "number",
        },
        CNS_EDLP_QTY: {
            type: "number",
        },
        CNS_INCR_QTY: {
            type: "number",
        },
        CNS_CANN_QTY: {
            type: "number",
        },
        CNS_TOTAL_QTY: {
            type: "number",
        },
        SHIP_BASE_QTY: {
            type: "number",
        },
        SHIP_EDLP_QTY: {
            type: "number",
        },
        SHIP_INCR_QTY: {
            type: "number",
        },
        SHIP_FORWARDBUY_QTY: {
            type: "number",
        },
        SHIP_ADJ_QTY: {
            type: "number",
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_BOM_COMP_QTY: {
            type: "number",
        },
        SHIP_OS_PCNT: {
            type: "number",
        },
        SHIP_DIR_TOTAL_QTY: {
            type: "number",
        },
        SHIP_DIR_PCNT: {
            type: "number",
        },
        SHIP_IND_TOTAL_QTY: {
            type: "number",
        },
        SHIP_IND_PCNT: {
            type: "number",
        },
        SHIP_DISTRIB_PCNT: {
            type: "number",
        },
        SHIP_DISTRIBUTED_QTY: {
            type: "number",
        },
        SHIP_NET_TOTAL_QTY: {
            type: "number",
        },
        SHP_EXP_RECV_PCNT_TOTAL: {
            type: "number",
        },
        FEATUREONLY_ACV: {
            type: "number",
        },
        DISPLAYONLY_ACV: {
            type: "number",
        },
        FEATUREDISPLAY_ACV: {
            type: "number",
        },
        TPRONLY_ACV: {
            type: "number",
        },
        PROMOTED_ACV: {
            type: "number",
        },
        ACT_CNS_BASE_UNITS: {
            type: "number",
        },
        ACT_CNS_BASE_RTLSLS: {
            type: "number",
        },
        ACT_CNS_BASE_WT: {
            type: "number",
        },
        ACT_CNS_BASE_STAT: {
            type: "number",
        },
        ACT_CNS_EDLP_UNITS: {
            type: "number",
        },
        ACT_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        ACT_CNS_EDLP_WT: {
            type: "number",
        },
        ACT_CNS_EDLP_STAT: {
            type: "number",
        },
        ACT_CNS_INCR_UNITS: {
            type: "number",
        },
        ACT_CNS_INCR_RTLSLS: {
            type: "number",
        },
        ACT_CNS_INCR_WT: {
            type: "number",
        },
        ACT_CNS_INCR_STAT: {
            type: "number",
        },
        ACT_CNS_TOTAL_UNITS: {
            type: "number",
        },
        ACT_CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        ACT_CNS_TOTAL_WT: {
            type: "number",
        },
        ACT_CNS_TOTAL_STAT: {
            type: "number",
        },
        ACT_FEATUREONLY_ACV: {
            type: "number",
        },
        ACT_DISPLAYONLY_ACV: {
            type: "number",
        },
        ACT_FEATUREDISPLAY_ACV: {
            type: "number",
        },
        ACT_TPRONLY_ACV: {
            type: "number",
        },
        ACT_PROMOTED_ACV: {
            type: "number",
        },
        ACT_SHIP_DIR_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIR_WT: {
            type: "number",
        },
        ACT_SHIP_DIR_STAT: {
            type: "number",
        },
        ACT_SHIP_DIR_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_COSTS: {
            type: "number",
        },
        ACT_RTN_DIR_UNITS: {
            type: "number",
        },
        ACT_RTN_DIR_WT: {
            type: "number",
        },
        ACT_RTN_DIR_STAT: {
            type: "number",
        },
        ACT_RTN_DIR_GRSLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_NETLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_COSTS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_WT: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_STAT: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_OS_COSTS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_UNITS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_WT: {
            type: "number",
        },
        ACT_RTN_DIR_OS_STAT: {
            type: "number",
        },
        ACT_RTN_DIR_OS_GRSLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_NETLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_OS_COSTS: {
            type: "number",
        },
        ACT_SHIP_IND_UNITS: {
            type: "number",
        },
        ACT_SHIP_IND_WT: {
            type: "number",
        },
        ACT_SHIP_IND_STAT: {
            type: "number",
        },
        ACT_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_IND_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIST_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIST_WT: {
            type: "number",
        },
        ACT_SHIP_DIST_STAT: {
            type: "number",
        },
        ACT_SHIP_DIST_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIST_NETLISTSLS: {
            type: "number",
        },
        LE_CNS_BASE_UNITS: {
            type: "number",
        },
        LE_CNS_BASE_RTLSLS: {
            type: "number",
        },
        LE_CNS_BASE_WT: {
            type: "number",
        },
        LE_CNS_BASE_STAT: {
            type: "number",
        },
        LE_CNS_EDLP_UNITS: {
            type: "number",
        },
        LE_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        LE_CNS_EDLP_WT: {
            type: "number",
        },
        LE_CNS_EDLP_STAT: {
            type: "number",
        },
        LE_CNS_INCR_UNITS: {
            type: "number",
        },
        LE_CNS_INCR_RTLSLS: {
            type: "number",
        },
        LE_CNS_INCR_WT: {
            type: "number",
        },
        LE_CNS_INCR_STAT: {
            type: "number",
        },
        LE_CNS_TOTAL_UNITS: {
            type: "number",
        },
        LE_CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        LE_CNS_TOTAL_WT: {
            type: "number",
        },
        LE_CNS_TOTAL_STAT: {
            type: "number",
        },
        LE_SHIP_UNITS: {
            type: "number",
        },
        LE_SHIP_WT: {
            type: "number",
        },
        LE_SHIP_STAT: {
            type: "number",
        },
        LE_SHIP_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_COSTS: {
            type: "number",
        },
        LE_SHIP_DIR_UNITS: {
            type: "number",
        },
        LE_SHIP_DIR_WT: {
            type: "number",
        },
        LE_SHIP_DIR_STAT: {
            type: "number",
        },
        LE_SHIP_DIR_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_COSTS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_UNITS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_WT: {
            type: "number",
        },
        LE_SHIP_DIR_OS_STAT: {
            type: "number",
        },
        LE_SHIP_DIR_OS_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_OS_COSTS: {
            type: "number",
        },
        LE_SHIP_OS_UNITS: {
            type: "number",
        },
        LE_SHIP_OS_WT: {
            type: "number",
        },
        LE_SHIP_OS_STAT: {
            type: "number",
        },
        LE_SHIP_OS_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_OS_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_OS_COSTS: {
            type: "number",
        },
        LE_SHIP_IND_UNITS: {
            type: "number",
        },
        LE_SHIP_IND_WT: {
            type: "number",
        },
        LE_SHIP_IND_STAT: {
            type: "number",
        },
        LE_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_IND_NETLISTSLS: {
            type: "number",
        },
        SPND_VARIABLE: {
            type: "number",
        },
        SPND_FIXED: {
            type: "number",
        },
        ACT_SPND_VARIABLE: {
            type: "number",
        },
        ACT_SPND_FIXED: {
            type: "number",
        },
        LE_SPND_VARIABLE: {
            type: "number",
        },
        LE_SPND_FIXED: {
            type: "number",
        },
        EST_SPND_VARIABLE: {
            type: "number",
        },
        EST_SPND_FIXED: {
            type: "number",
        },
    },
});
export const WB_TPM_Event_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

export const WB_TPM_Event_Spend = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtS", // optional
    description: "Schema for WB_TEvtS records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVT_ID: {
            type: "number",
        },
        EVENT_SPEND_ID: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_NAME: {
            type: "string",
            length: 256,
        },
        EVENT_SPEND_COMMENTS: {
            type: "string",
            length: 1333,
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        ACTIVE_IND: {
            type: "string",
            length: 1,
        },
        WB_STATUS_ID: {
            type: "number",
        },
        WB_STATUS_ID_NEXT: {
            type: "number",
        },
        RATE_AMT: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        RATE_UOM: {
            type: "string",
            length: 50,
        },
        RATE_PRDVOLBASIS: {
            type: "string",
            length: 50,
        },
        WB_CUST_ID_INDIRECT: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        PAYMENT_METHOD: {
            type: "string",
            length: 50,
        },
        REDEMPTION_RATE_PCNT: {
            type: "number",
        },
        PLANNED_SPEND: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        PAID_IN_FULL_IND: {
            type: "string",
            length: 1,
        },
        INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        DISTRIBUTION_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DISTRIBUTION_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        ACCRUAL_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ACCRUAL_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        OES_SENT_TO_IND: {
            type: "string",
            length: 1,
        },
        OES_SENT_TO_DTTS: {
            type: "number",
        },
        OES_INTEGRATION_ID: {
            type: "string",
            length: 50,
        },
        WB_STATUS_ID_CUSTPMT: {
            type: "number",
        },
        WB_STATUS_ID_NEXT_CUSTPMT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ORDER_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ORDER_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        WB_GLACCT_ID: {
            type: "number",
        },
    },
});
export const WB_TPM_Event_Spend_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Event_Spend_Type]: {
            foreignKey: "WB_EVTSTYPE_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendType",
        },
        [PASchema.esWB_Workflow_Status]: [
            {
                foreignKey: "WB_STATUS_ID",
                foreignKeyImmutable: true,
                localField: "WorkflowStatus",
            },
        ],
        [PASchema.esWB_General_Ledger_Account]: {
            foreignKey: "WB_GLACCT_ID",
            foreignKeyImmutable: true,
            localField: "GLAccount",
        },
    },
    hasMany: {
        [PASchema.esWB_TPM_Event_Spend_Product_Group]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProductGroups",
        },
        [PASchema.esWB_TPM_Event_Spend_Product]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendProducts",
        },
        [PASchema.esWB_TPM_Event_Spend_Metrics]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendMetrics",
        },
        [PASchema.esWB_TPM_Event_Spend_Customer]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendCustomers",
        },
    },
};

export const WB_TPM_Event_Spend_Customer = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtSCsts", // optional
    description: "Schema for WB_TEvtSCsts records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTSCST_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        OES_SENT_TO_IND: {
            type: "string",
            length: 1,
        },
        OES_SENT_TO_DTTS: {
            type: "number",
        },
        OES_INTEGRATION_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_TPM_Event_Spend_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event_Spend]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_TPM_Event_Spend_PrdGrp = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtSPG", // optional
    description: "Schema for WB_TEvtSPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTSPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        ROW_TYPE: {
            type: "string",
            length: 20,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        RATE_AMT: {
            type: "number",
        },
        REDEMPTION_RATE_PCNT: {
            type: "number",
        },
        SOP_BB_RATE: {
            type: "number",
        },
        SOP_BB_OS_RATE: {
            type: "number",
        },
        SOP_BB_COMP_RATE: {
            type: "number",
        },
        SOP_OI_RATE: {
            type: "number",
        },
        SOP_OI_OS_RATE: {
            type: "number",
        },
        SOP_OI_COMP_RATE: {
            type: "number",
        },
        PLANNED_SPEND: {
            type: "number",
        },
        PLANNED_SPEND_BOM_COMP: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        OES_SENT_TO_IND: {
            type: "string",
            length: 1,
        },
        OES_SENT_TO_DTTS: {
            type: "number",
        },
        OES_INTEGRATION_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_DISPLAY_QTY: {
            type: "number",
        },
        SHIP_BUOM_QTY: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        INCLUDE_IND: {
            type: "string",
            length: 1,
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        OPENSTOCK_IND: {
            type: "string",
            length: 1,
        },
        DISPLAY_COMP_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_TPM_Event_Spend_PrdGrp_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event_Spend]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
};

export const WB_TPM_Event_Spend_Prd = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtSPrd", // optional
    description: "Schema for WB_TEvtSPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTSPRD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        ROW_TYPE: {
            type: "string",
            length: 20,
        },
        PARENT_ROW_ID: {
            type: "number",
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        INCLUDE_IND: {
            type: "string",
            length: 1,
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        RATE_AMT: {
            type: "number",
        },
        RATE_AMT_BUOM: {
            type: "number",
        },
        REDEMPTION_RATE_PCNT: {
            type: "number",
        },
        SOP_BB_RATE: {
            type: "number",
        },
        SOP_BB_OS_RATE: {
            type: "number",
        },
        SOP_BB_COMP_RATE: {
            type: "number",
        },
        SOP_OI_RATE: {
            type: "number",
        },
        SOP_OI_OS_RATE: {
            type: "number",
        },
        SOP_OI_COMP_RATE: {
            type: "number",
        },
        PLANNED_SPEND: {
            type: "number",
        },
        PLANNED_SPEND_BOM_COMP: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        OES_SENT_TO_IND: {
            type: "string",
            length: 1,
        },
        OES_SENT_TO_DTTS: {
            type: "number",
        },
        OES_INTEGRATION_ID: {
            type: "string",
            length: 50,
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_DISPLAY_QTY: {
            type: "number",
        },
        SHIP_BUOM_QTY: {
            type: "number",
        },
        ACT_SHIP_TOTAL_QTY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_TPM_Event_Spend_Prd_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event_Spend]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

export const WB_TPM_Event_Spend_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtSMt", // optional
    description: "Schema for WB_TEvtSMt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTSMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        ROW_SOURCE: {
            type: "string",
            length: 50,
        },
        CREATE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        VCM: {
            type: "number",
        },
        CNS_TOTAL_UNITS: {
            type: "number",
        },
        CNS_TOTAL_WT: {
            type: "number",
        },
        CNS_TOTAL_STAT: {
            type: "number",
        },
        SHIP_OS_PCT: {
            type: "number",
        },
        SHIP_UNITS: {
            type: "number",
        },
        SHIP_WT: {
            type: "number",
        },
        SHIP_STAT: {
            type: "number",
        },
        PLANNED_SPEND: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        EST_CNS_TOTAL_UNITS: {
            type: "number",
        },
        EST_CNS_TOTAL_WT: {
            type: "number",
        },
        EST_CNS_TOTAL_STAT: {
            type: "number",
        },
        EST_SHIP_UNITS: {
            type: "number",
        },
        EST_SHIP_WT: {
            type: "number",
        },
        EST_SHIP_STAT: {
            type: "number",
        },
    },
});
export const WB_TPM_Event_Spend_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event_Spend]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

// TPM Lift Table
export const WB_Lift = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Lift", // optional
    description: "Schema for WB_Lift records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LIFT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        LIFT_LEVER_ID: {
            type: "string",
            length: 50,
        },
        LEVER_MIN: {
            type: "number",
        },
        LEVER_MAX: {
            type: "number",
        },
        LIFT_PCNT: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Lift_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: {
            foreignKey: "WB_CUST_ID",
            foreignKeyImmutable: false,
            localField: "Customer",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: false,
            localField: "ProductGroup",
        },
    },
};

// TPM Spend Type

export const WB_TPM_Event_Spend_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSType", // optional
    description: "Schema for WB_EvtSType records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSTYPE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SPENDTYPE_ID: {
            type: "string",
            length: 50,
        },
        SPEND_TYPE_NAME: {
            type: "string",
            length: 256,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        ACTIVE_IND: {
            type: "string",
            length: 1,
        },
        RATE_LEVEL: {
            type: "string",
            length: 20,
        },
        RATEBASIS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        RATEBASIS_OPTIONS: {
            type: "string",
            length: 100,
        },
        RATEBASIS_DEFAULT: {
            type: "string",
            length: 50,
        },
        RATEUOM_SHOW_IND: {
            type: "string",
            length: 1,
        },
        RATEUOM_OPTIONS: {
            type: "string",
            length: 100,
        },
        RATEUOM_DEFAULT: {
            type: "string",
            length: 50,
        },
        PRDVOLBASIS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRDVOLBASIS_BB_DEFAULT: {
            type: "string",
            length: 50,
        },
        PRDVOLBASIS_BB_OPTIONS: {
            type: "string",
            length: 100,
        },
        PRDVOLBASIS_OI: {
            type: "string",
            length: 50,
        },
        PRDVOLBASIS_REBATE: {
            type: "string",
            length: 50,
        },
        INDIRECT_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PAYMENTMETHOD_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PAYMENTMETHOD_OPTIONS: {
            type: "string",
            length: 100,
        },
        PAYMENTMETHOD_DEFAULT: {
            type: "string",
            length: 50,
        },
        FUNDTYPE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        FUNDTYPE_OPTIONS: {
            type: "string",
            length: 50,
        },
        FUNDTYPE_DEFAULT: {
            type: "number",
        },
        REDEMPTIONRATE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        REDEMPTIONRATE_LEVEL: {
            type: "string",
            length: 20,
        },
        WORKFLOW_SHOW_IND: {
            type: "string",
            length: 1,
        },
        WB_WORKFLOW_ID: {
            type: "number",
        },
        WORKFLOW_POLICY: {
            type: "string",
            length: 50,
        },
        PLANNED_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PLANNED_SPEND_BOM_COMP_SHOW_IND: {
            type: "string",
            length: 1,
        },
        APPROVED_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        ACTUAL_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        LE_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CUSTPMT_WORKFLOW_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CUSTPMT_WORKFLOW_ID: {
            type: "number",
        },
        PAIDINFULL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        THIRDPARTY_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCT_SUMMARY_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PROCUCT_INCL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCT_SYNC_POLICY: {
            type: "string",
            length: 20,
        },
        DISPLAY_BUOM_QTY_SHOW_IND: {
            type: "string",
            length: 1,
        },
        DISPLAY_QTY_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCTGROUP_SUMMARY_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCTGROUP_INCL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCTGROUP_SYNC_POLICY: {
            type: "string",
            length: 20,
        },
        PAYMENTS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        OFFINVOICELOG_SHOW_IND: {
            type: "string",
            length: 1,
        },
        COMMENTS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        SUBCUSTOMER_SHOW_IND: {
            type: "string",
            length: 1,
        },
        INSTOREDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        INSTOREDATES_POLICY: {
            type: "string",
            length: 50,
        },
        SHIPMENTDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        SHIPMENTDATES_POLICY: {
            type: "string",
            length: 50,
        },
        ORDERDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        ORDERDATES_POLICY: {
            type: "string",
            length: 50,
        },
        DISTRIBUTIONDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        DISTRIBUTIONDATES_POLICY: {
            type: "string",
            length: 50,
        },
        SPENDTYPE_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        NAME_SHOW_IND: {
            type: "string",
            length: 1,
        },
        NETLISTPRICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        GROSSLISTPRICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        MAINTABGRID: {
            type: "string",
            length: 50,
        },
        MARGIN_CALCULATOR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CNDM_ID_ORDERDT_OFFSET: {
            type: "number",
        },
        CNDM_ID_DISTRIBDT_OFFSET: {
            type: "number",
        },
        CNDM_ID_SHIPDIR_OFFSET: {
            type: "number",
        },
        CNDM_ID_SHIPDIRDFT_OFFSET: {
            type: "number",
        },
        CNDM_ID_SHIPIND_OFFSET: {
            type: "number",
        },
        CNDM_ID_SHIPINDDFT_OFFSET: {
            type: "number",
        },
        CNDM_ID_SHIPPRF_OFFSET: {
            type: "number",
        },
        CNDM_ID_SHIPPRFDFT_OFFSET: {
            type: "number",
        },
        TPM_IND: {
            type: "string",
            length: 1,
        },
        PEA_IND: {
            type: "string",
            length: 1,
        },
        TRADEIND: {
            type: "string",
            length: 1,
        },
        CONSUMERDISCOUNTIND: {
            type: "string",
            length: 1,
        },
        RETAILERMARGININD: {
            type: "string",
            length: 1,
        },
        RATE_ROUNDING_POLICY: {
            type: "string",
            length: 5,
        },
    },
});
export const WB_TPM_Event_Spend_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Event_Spend_Type_Account]: {
            foreignKey: "WB_EVTSTYPE_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendAccounts",
        },
    },
};

export const WB_TPM_Event_Spend_Type_Account = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSAcct", // optional
    description: "Schema for WB_EvtSAcct records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSACCT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        PAYMENT_METHOD: {
            type: "string",
            length: 50,
        },
        GL_EXPENSETYPE_ID: {
            type: "string",
            length: 50,
        },
        WB_GLACCT_ID_LIABILITY: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_GLACCT_ID_EXPENSE: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_TPM_Event_Spend_Type_Account_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_General_Ledger_Account]: [
            { foreignKey: "WB_GLACCT_ID_LIABILITY", foreignKeyImmutable: true, localField: "GLAccountLiability" },
            { foreignKey: "WB_GLACCT_ID_EXPENSE", foreignKeyImmutable: true, localField: "GLAccountExpense" },
        ],
        [PASchema.esWB_Event_Spend_Type]: {
            foreignKey: "WB_EVTSTYPE_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendType",
        },
    },
};

// TPM Event Type Relatioship
export const WB_TPM_Event_Spend_Type_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtSTypeR", // optional
    description: "Schema for WB_EvtSTypeR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTSTYPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        REL_SORT: {
            type: "string",
            length: 20,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
    },
});
export const WB_TPM_Event_Spend_Type_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Type]: { foreignKey: "WB_EVTTYPE_ID", foreignKeyImmutable: true, localField: "EventType" },
        [PASchema.esWB_Event_Spend_Type]: {
            foreignKey: "WB_EVTSTYPE_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendType",
        },
    },
};

// TPM Product Metrics

export const WB_TPM_Event_Product_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TEvtPrdMt", // optional
    description: "Schema for WB_TEvtPrdMt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTPRDMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TEVT_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        ROW_SOURCE: {
            type: "string",
            length: 20,
        },
        CREATE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ROW_TYPE: {
            type: "string",
            length: 20,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        UNIT_FACTOR: {
            type: "number",
        },
        WT_FACTOR: {
            type: "number",
        },
        STATCS_FACTOR: {
            type: "number",
        },
        SHIP_DISPLAY_QTY: {
            type: "number",
        },
        SHIP_BUOM_QTY: {
            type: "number",
        },
        SOP_BB_RATE: {
            type: "number",
        },
        SOP_BB_OS_RATE: {
            type: "number",
        },
        SOP_BB_COMP_RATE: {
            type: "number",
        },
        SOP_OI_RATE: {
            type: "number",
        },
        SOP_OI_OS_RATE: {
            type: "number",
        },
        SOP_OI_COMP_RATE: {
            type: "number",
        },
        LE_SPND_VARIABLE: {
            type: "number",
        },
        PLN_SPND_VARIABLE: {
            type: "number",
        },
        ACT_SPND_VARIABLE: {
            type: "number",
        },
        EST_SPND_VARIABLE: {
            type: "number",
        },
        PLN_SPND_FIXED: {
            type: "number",
        },
        ACT_SPND_FIXED: {
            type: "number",
        },
        LE_SPND_FIXED: {
            type: "number",
        },
        EST_SPND_FIXED: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_TPM_Event_Product_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_TPM_Event]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};
// Spend Type (PEA)
export const WB_Spend_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_SpendM", // optional
    description: "Schema for WB_SpendM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SPENDM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SPEND_TYPE_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        WB_SOURCE_ID: {
            type: "number",
        },
        SPEND_TYPE_NAME: {
            type: "string",
            length: 256,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        TRADEIND: {
            type: "string",
            length: 1,
        },
        RETAILERMARGININD: {
            type: "string",
            length: 1,
        },
        EDLPIND: {
            type: "string",
            length: 1,
        },
        EDLCIND: {
            type: "string",
            length: 1,
        },
        CONSUMERDISCOUNTIND: {
            type: "string",
            length: 1,
        },
        DISPLAYIND: {
            type: "string",
            length: 1,
        },
        FEATUREADIND: {
            type: "string",
            length: 1,
        },
        COUPONIND: {
            type: "string",
            length: 1,
        },
        COOPIND: {
            type: "string",
            length: 1,
        },
        SHOPPERMARKETINGIND: {
            type: "string",
            length: 1,
        },
        MARGINALSPENDIND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        PROMOIND: {
            type: "string",
            length: 1,
        },
        POSTAUDITIND: {
            type: "string",
            length: 1,
        },
        DEFAULT_IND: {
            type: "string",
            length: 1,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Spend_Type_JSData_RELs = {};

// Event Accruals
export const WB_Event_Accrual = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Event_Accruals", // optional
    description: "Schema for WB_EvtAcr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTACR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SALEAREA_ID: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        PLAN_ID: {
            type: "string",
            length: 50,
        },
        PLAN_NAME: {
            type: "string",
            length: 256,
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_PERIOD_ID_PLAN: {
            type: "number",
        },
        WB_PERIOD_ID_FY: {
            type: "number",
        },
        WB_PRDGRP_ID_PLANLEVEL: {
            type: "number",
        },
        EVENT_ID: {
            type: "string",
            length: 50,
        },
        EVENT_NAME: {
            type: "string",
            length: 256,
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        WB_STATUS_ID_EVT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CRBY_EVT: {
            type: "number",
        },
        EVENT_SPEND_ID: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_NAME: {
            type: "string",
            length: 256,
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        WB_STATUS_ID_EVTS: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        ACTIVE_IND: {
            type: "string",
            length: 1,
        },
        RATE_AMT: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        RATE_UOM: {
            type: "string",
            length: 50,
        },
        PAYMENT_METHOD: {
            type: "string",
            length: 50,
        },
        REDEMPTION_RATE_PCNT: {
            type: "number",
        },
        PLANNED_SPEND: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        PAID_IN_FULL_IND: {
            type: "string",
            length: 1,
        },
        INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        INSTORE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        SHIPMENT_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        ORDER_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ORDER_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        DISTRIBUTION_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DISTRIBUTION_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        ACCRUAL_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        ACCRUAL_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        WB_GLRL_ID: {
            type: "number",
        },
        WB_GLACCT_ID: {
            type: "number",
        },
        WB_GLACCT_ID_LIABILITY: {
            type: "number",
        },
        WB_PRDGRP_ID_SNAPSHOT: {
            type: "number",
        },
        WB_CUST_ID_ACCRUAL: {
            type: "number",
        },
        WB_PRDGRP_ID_ACCRUAL: {
            type: "number",
        },
        WB_PERIOD_ID_ACCRUAL: {
            type: "number",
        },
        ACCRUAL_AMT: {
            type: "number",
        },
        GLTXN_ACCRUED_AMT: {
            type: "number",
        },
        CURRENCY: {
            type: "string",
            length: 20,
        },
    },
});
export const WB_Event_Accrual_JSData_RELs = {};

// Claim Type BO
export const WB_Claim_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Claim_Type", // optional
    description: "Schema for WB_ClmType records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLMTYPE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        CLAIM_TYPE_ID: {
            type: "string",
            length: 50,
        },
        CLAIM_TYPE_NAME: {
            type: "string",
            length: 256,
        },
        CLAIM_TYPE_COMMENTS: {
            type: "string",
            length: 1333,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        SETTLEMENT_POLICY: {
            type: "string",
            length: 50,
        },
        CURRENCY_POLICY: {
            type: "string",
            length: 50,
        },
        CURRENCY_DEFAULT: {
            type: "string",
            length: 50,
        },
        CURRENCY_OPTIONS: {
            type: "string",
            length: 256,
        },

        PLANNING_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PLANNING_CUST_POLICY: {
            type: "string",
            length: 50,
        },

        CLAIM_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CLAIM_CUST_POLICY: {
            type: "string",
            length: 50,
        },
        REASON_CODE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        REASON_CODE_POLICY: {
            type: "string",
            length: 50,
        },
        REASON_CODE_DEFAULT: {
            type: "string",
            length: 50,
        },
        REASON_CODE_OPTIONS: {
            type: "string",
            length: 256,
        },
        CUSTOMER_INVOICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CUSTOMER_INVOICE_POLICY: {
            type: "string",
            length: 50,
        },
        CREATE_POLICY: {
            type: "string",
            length: 50,
        },
        WORKFLOW_POLICY: {
            type: "string",
            length: 50,
        },
        WB_WORKFLOW_ID: {
            type: "number",
        },
        PLN_MATCH_POLICY: {
            type: "string",
            length: 50,
        },

        CLAIMS_AGING_DEFAULT_IND: {
            type: "string",
            length: 1,
        },

        WRITE_OFF_IND: {
            type: "string",
            length: 1,
        },
        WRITE_OFF_AMT: {
            type: "number",
        },
        WB_PMTTYPE_ID_WRITE_OFF: {
            type: "number",
        },
        WB_GLACCT_ID_WRITE_OFF: {
            type: "number",
        },

        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Claim_Type_JSData_RELs = {
    belongsTo: {},
    hasMany: {
        [PASchema.esWB_Claim_Type_Payment_Type]: {
            foreignKey: "WB_CLMTYPE_ID",
            foreignKeyImmutable: true,
            localField: "PaymentTypes",
        },
    },
};

export const WB_Claim_Type_Payment_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_ClmTypePmtTR", // optional
    description: "Schema for WB_ClmTypePmtTR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLMTYPEPMTTR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CLMTYPE_ID: {
            type: "number",
        },
        WB_PMTTYPE_ID: {
            type: "number",
        },
        DEFAULT_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Claim_Type_Payment_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Claim_Type]: {
            foreignKey: "WB_CLMTYPE_ID",
            foreignKeyImmutable: true,
            localField: "ClaimType",
        },
        [PASchema.esWB_Payment_Type]: {
            foreignKey: "WB_PMTTYPE_ID",
            foreignKeyImmutable: true,
            localField: "PaymentType",
        },
    },
};

// Claim BO
export const WB_Claim = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Claim", // optional
    description: "Schema for WB_Clm records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        CLAIM_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        CLAIM_NAME: {
            type: "string",
            length: 256,
        },
        CLAIM_COMMENTS: {
            type: "string",
            length: 1333,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        WB_CLMTYPE_ID: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_CUST_ID_CLAIM: {
            type: "number",
        },
        CUSTOMER_INVOICE: {
            type: "string",
            length: 256,
        },
        REASON_ID: {
            type: "string",
            length: 50,
        },
        CLAIM_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CLAIM_AMT: {
            type: "number",
        },
        CURRENCY: {
            type: "string",
            length: 20,
        },
        WB_STATUS_ID: {
            type: "number",
        },
        WB_STATUS_ID_NEXT: {
            type: "number",
        },
        WB_AUTHUSR_ID_WF_NEXT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Claim_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Claim_Type]: { foreignKey: "WB_CLMTYPE_ID", foreignKeyImmutable: true, localField: "ClaimType" },
        [PASchema.esWB_User]: {
            foreignKey: "WB_AUTHUSR_ID_CREATEDBY",
            foreignKeyImmutable: true,
            localField: "UserCreatedBy",
        },
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID_CLAIM",
                foreignKeyImmutable: true,
                localField: "ClaimCustomer",
            },
            { foreignKey: "WB_CUST_ID_PLANNING", foreignKeyImmutable: true, localField: "PlanningCustomer" },
        ],
        [PASchema.esWB_Workflow_Status]: {
            foreignKey: "WB_STATUS_ID",
            foreignKeyImmutable: true,
            localField: "CurrentStatus",
        },
    },
    hasMany: {
        [PASchema.esWB_Claim_Plan_Match]: {
            foreignKey: "WB_CLM_ID",
            foreignKeyImmutable: true,
            localField: "ClaimMatches",
        },
        [PASchema.esWB_Payment_Claim]: { foreignKey: "WB_CLM_ID", foreignKeyImmutable: true, localField: "Claim" },
    },
};

export const WB_Claim_Plan_Match = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Claim", // optional
    description: "Schema for WB_Clm records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLMPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        REL_TYPE: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_CUST_ID_SUBPLANNING: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_TEVT_ID: {
            type: "number",
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        WB_EVT_ID: {
            type: "number",
        },
        WB_EVTS_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Claim_Plan_Match_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Claim]: { foreignKey: "WB_CLM_ID", foreignKeyImmutable: true, localField: "Claim" },
        [PASchema.esWB_Customer]: [
            { foreignKey: "WB_CUST_ID_PLANNING", foreignKeyImmutable: true, localField: "PlanningCustomer" },
            { foreignKey: "WB_CUST_ID_SUBPLANNING", foreignKeyImmutable: true, localField: "SubPlanningCustomer" },
        ],
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        [PASchema.esWB_TPM_Event]: { foreignKey: "WB_TEVT_ID", foreignKeyImmutable: true, localField: "Event" },
        [PASchema.esWB_TPM_Event_Spend]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
    },
};

// Payment Type BO
export const WB_Payment_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Payment_Type", // optional
    description: "Schema for WB_PmtType records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PMTTYPE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        PAYMENT_TYPE_ID: {
            type: "string",
            length: 50,
        },
        PAYMENT_TYPE_NAME: {
            type: "string",
            length: 256,
        },
        PAYMENT_TYPE_COMMENTS: {
            type: "string",
            length: 1333,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        ACTIVE_IND: {
            type: "string",
            length: 1,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        PLANNING_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        FUNDING_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PAYTO_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        EXPENSETO_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        WORKFLOW_POLICY: {
            type: "string",
            length: 50,
        },
        WB_WORKFLOW_ID: {
            type: "number",
        },
        CREATE_POLICY: {
            type: "string",
            length: 50,
        },
        CURRENCY_POLICY: {
            type: "string",
            length: 50,
        },
        CURRENCY_DEFAULT: {
            type: "string",
            length: 50,
        },
        CURRENCY_OPTIONS: {
            type: "string",
            length: 256,
        },
        NEGATIVE_PAYMENT_IND: {
            type: "string",
            length: 1,
        },
        EVENT_SPEND_POLICY: {
            type: "string",
            length: 50,
        },
        FUND_SPEND_POLICY: {
            type: "string",
            length: 50,
        },
        SHOW_CORRECTION_IND: {
            type: "string",
            length: 1,
        },
        SHOW_CHECK_IND: {
            type: "string",
            length: 1,
        },
        SHOW_CREDIT_MEMO_IND: {
            type: "string",
            length: 1,
        },
        CLAIM_POLICY: {
            type: "string",
            length: 50,
        },
        SHOW_OFF_INVOICE_IND: {
            type: "string",
            length: 1,
        },
        DEFAULT_IND: {
            type: "string",
            length: 1,
        },
        SORT_ORDER: {
            type: "number",
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Payment_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Claim_Type_Payment_Type]: {
            foreignKey: "WB_PMTTYPE_ID",
            foreignKeyImmutable: true,
            localField: "ClaimTypes",
        },
    },
};

// Payment BO
export const WB_Payment = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Payment", // optional
    description: "Schema for WB_Pmt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        PAYMENT_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50,
        },
        PAYMENT_SET_ID: {
            type: "string",
            length: 10,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        PAYMENT_NAME: {
            type: "string",
            length: 256,
        },
        WB_PMTTYPE_ID: {
            type: "number",
        },
        PAYMENT_COMMENTS: {
            type: "string",
            length: 1333,
        },
        PAYMENT_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        REQUESTED_AMT: {
            type: "number",
        },
        REASON_ID: {
            type: "string",
            length: 50,
        },
        PAYMENT_AMT: {
            type: "number",
        },
        CURRENCY: {
            type: "string",
            length: 20,
        },
        WB_CUST_ID_FUNDING: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_CUST_ID_SUBPLANNING: {
            type: "number",
        },
        WB_CUST_ID_PAYTO: {
            type: "number",
        },
        WB_STATUS_ID: {
            type: "number",
        },
        WB_STATUS_ID_NEXT: {
            type: "number",
        },
        WB_AUTHUSR_ID_WF_NEXT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        APPROVED_DTTS: {
            type: "number",
        },
        WB_PMT_ID_REFERENCE: {
            type: "number",
        },
        WB_PMT_ID_CORRECTION: {
            type: "number",
        },
        ERP_SENT_TO_IND: {
            type: "string",
            length: 1,
        },
        ERP_SENT_TO_DTTS: {
            type: "number",
        },
        ERP_INTEGRATION_ID: {
            type: "string",
            length: 50,
        },
        POSTING_DTTS: {
            type: "number",
        },
        CHECK_CONFIRMATION_IND: {
            type: "string",
            length: 1,
        },
        CHECK_NUMBER: {
            type: "string",
            length: 50,
        },
        CHECK_MEMO: {
            type: "string",
            length: 256,
        },
        CHECK_RELEASE_DTTS: {
            type: "number",
        },
        CHECK_VOID_CONFIRMATION_IND: {
            type: "string",
            length: 1,
        },
        CHECK_VOID_DTTS: {
            type: "number",
        },
        ERP_DOC_ID: {
            type: "string",
            length: 50,
        },
        ERP_CLEARING_DOC_ID: {
            type: "string",
            length: 50,
        },
        BILLING_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Payment_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            { foreignKey: "WB_CUST_ID_FUNDING", foreignKeyImmutable: true, localField: "FundingCustomer" },
            { foreignKey: "WB_CUST_ID_PLANNING", foreignKeyImmutable: true, localField: "PlanningCustomer" },
            { foreignKey: "WB_CUST_ID_SUBPLANNING", foreignKeyImmutable: true, localField: "SubPlanningCustomer" },
            { foreignKey: "WB_CUST_ID_PAYTO", foreignKeyImmutable: true, localField: "PayTo" },
        ],
        [PASchema.esWB_Payment_Type]: {
            foreignKey: "WB_PMTTYPE_ID",
            foreignKeyImmutable: true,
            localField: "PaymentType",
        },
        [PASchema.esWB_Workflow_Status]: {
            foreignKey: "WB_STATUS_ID",
            foreignKeyImmutable: true,
            localField: "WorkflowStatus",
        },
        [PASchema.esWB_User]: [
            {
                foreignKey: "WB_AUTHUSR_ID_CREATEDBY",
                foreignKeyImmutable: true,
                localField: "UserCreatedBy",
            },
            { foreignKey: "WB_AUTHUSR_ID_WF_NEXT", foreignKeyImmutable: true, localField: "UserApprovedBy" },
        ],
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
    },
    hasMany: {
        [PASchema.esWB_Payment_Event_Spend]: {
            foreignKey: "WB_PMT_ID",
            foreignKeyImmutable: true,
            localField: "PaymentEventSpend",
        },
        [PASchema.esWB_Payment_Fund]: {
            foreignKey: "WB_PMT_ID",
            foreignKeyImmutable: true,
            localField: "PaymentFund",
        },
        [PASchema.esWB_Payment_Claim]: {
            foreignKey: "WB_PMT_ID",
            foreignKeyImmutable: true,
            localField: "PaymentClaim",
        },
    },
};

export const WB_Payment_Claims = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PmtClmR", // optional
    description: "Schema for WB_PmtClmR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PMTCLMR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PMT_ID: {
            type: "number",
        },
        WB_CLM_ID: {
            type: "number",
        },
        PAYMENT_AMT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Payment_Claims_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Claim]: { foreignKey: "WB_CLM_ID", foreignKeyImmutable: true, localField: "Claim" },
        [PASchema.esWB_Payment]: { foreignKey: "WB_PMT_ID", foreignKeyImmutable: true, localField: "Payment" },
    },
};

export const WB_Payment_Event_Spend = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Payment_Event_Spend", // optional
    description: "Schema for WB_PmtEvtS records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PMTEVTS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PMT_ID: {
            type: "number",
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        WB_EVTS_ID: {
            type: "number",
        },
        PAYMENT_AMT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Payment_Event_Spend_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Payment]: { foreignKey: "WB_PMT_ID", foreignKeyImmutable: true, localField: "Payment" },
        [PASchema.esWB_TPM_Event_Spend]: {
            foreignKey: "WB_TEVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
    },
    hasMany: {
        [PASchema.esWB_Payment_Event_Spend_Product_Group]: {
            foreignKey: "WB_PMTEVTS_ID",
            foreignKeyImmutable: true,
            localField: "PaymentEventSpendPrds",
        },
    },
};

export const WB_Payment_Event_Spend_Product_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Payment_Event_Spend_Product_Group", // optional
    description: "Schema for WB_PmtEvtSP records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PMTEVTSP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PMTEVTS_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        PAYMENT_AMT: {
            type: "number",
        },
        ALLOCATION_BASIS_AMT: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Payment_Event_Spend_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Payment_Event_Spend]: {
            foreignKey: "WB_PMTEVTS_ID",
            foreignKeyImmutable: true,
            localField: "PaymentEventSpend",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
};

export const WB_Payment_Fund = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Payment_Fund", // optional
    description: "Schema for WB_PmtFnd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PMTFND_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PMT_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        WB_CUST_ID_FUNDING: {
            type: "number",
        },
        WB_PRDGRP_ID_FUNDING: {
            type: "number",
        },
        WB_PERIOD_ID_FUNDING: {
            type: "number",
        },
        EXPENSE_TYPE: {
            type: "string",
            length: 50,
        },
        WB_GLACCT_ID: {
            type: "number",
        },
        PAYMENT_AMT: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Payment_Fund_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Payment]: { foreignKey: "WB_PMT_ID", foreignKeyImmutable: true, localField: "Payment" },
        [PASchema.esWB_Customer]: {
            foreignKey: "WB_CUST_ID_FUNDING",
            foreignKeyImmutable: true,
            localField: "FundingCustomer",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID_FUNDING",
            foreignKeyImmutable: true,
            localField: "FundingProductGroup",
        },
        [PASchema.esWB_Period]: {
            foreignKey: "WB_PERIOD_ID_FUNDING",
            foreignKeyImmutable: true,
            localField: "FundingPeriod",
        },
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
        // Add other FKs
    },
    hasMany: {
        [PASchema.esWB_Payment_Fund_Product_Group]: {
            foreignKey: "WB_PMTFND_ID",
            foreignKeyImmutable: true,
            localField: "PaymentFundPrds",
        },
    },
};

export const WB_Payment_Fund_Product_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Payment_Fund_Product_Group", // optional
    description: "Schema for WB_PmtFund records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PMTFNDP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PMTFND_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        PAYMENT_AMT: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Payment_Fund_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Payment_Fund]: {
            foreignKey: "WB_PMTFND_ID",
            foreignKeyImmutable: true,
            localField: "PaymentFund",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
};

// Auth Provider BO
export const WB_Auth_Provider = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_AuthPrvd", // optional
    description: "Schema for WB_AuthPrvd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_AUTHPRVD_ID: {
            type: "number",
            id: true,
            required: true,
        },
        AUTHPRVD_ID: {
            type: "string",
            length: 50,
        },
        AUTHPRVD_NAME: {
            type: "string",
            length: 256,
        },
        SORT: {
            type: "number",
        },
        CLASS: {
            type: "string",
            length: 50,
        },
        REQUIRES_USER_NAME: {
            type: "string",
            length: 1,
        },
        REQUIRES_PASSWORD: {
            type: "string",
            length: 1,
        },
        AUTH_KEY: {
            type: "string",
            length: 256,
        },
        AUTH_SECRET: {
            type: "string",
            length: 256,
        },
        AUTH_REQUEST_TOKEN_URL: {
            type: "string",
            length: 1333,
        },
        AUTH_REQUEST_CALLBACK_URL: {
            type: "string",
            length: 1333,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        DEFAULT_USERCUST: {
            type: "string",
            length: 1,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        AUTH_LOGOUT_URL: {
            type: "string",
            length: 1333,
        },
        USER_EDIT_ROLES: {
            type: "string",
            length: 256,
        },
        USER_EDIT_FIELDS: {
            type: "string",
            length: 256,
        },
        USER_CREATE_POLICY: {
            type: "string",
            length: 50,
        },
    },
});
export const WB_Auth_Provider_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHPRVD_ID", foreignKeyImmutable: true, localField: "Users" },
    },
};

// User BO
export const WB_User = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_AuthUsr", // optional
    description: "Schema for WB_AuthUsr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_AUTHUSR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_AUTHPRVD_ID: {
            type: "number",
        },
        AUTHUSR_ID: {
            type: "string",
            length: 50,
        },
        AUTHUSR_NAME: {
            type: "string",
            length: 256,
        },
        AUTHUSR_TYPE: {
            type: "string",
            length: 50,
        },
        AUTHUSR_FIRSTNAME: {
            type: "string",
            length: 50,
        },
        AUTHUSR_LASTNAME: {
            type: "string",
            length: 50,
        },
        AUTHUSR_LOGIN: {
            type: "string",
            length: 50,
        },
        AUTHUSR_URL: {
            type: "string",
            length: 256,
        },
        AUTHUSR_EMAIL: {
            type: "string",
            length: 100,
        },
        AUTHUSR_PWD: {
            type: "string",
            length: 256,
        },
        AUTHUSR_LANG: {
            type: "string",
            length: 50,
        },
        LOGOFF_POLICY: {
            type: "string",
            length: 50,
        },
        COMMENTS: {
            type: "string",
            length: 512,
        },
        LAST_AUTHORIZED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        WB_WORKSPACE_ID_LANDING: {
            type: "number",
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_User_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_User_Customer]: {
            foreignKey: "WB_AUTHUSR_ID",
            foreignKeyImmutable: true,
            localField: "Customers",
        },
        [PASchema.esWB_User_Role]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "Roles" },
        [PASchema.esWB_Session]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "Sessions" },
        [PASchema.esWB_User_Group_User]: {
            foreignKey: "WB_AUTHUSR_ID",
            foreignKeyImmutable: true,
            localField: "UserGroups",
        },
        [PASchema.esWB_Plan_Management_User]: {
            foreignKey: "WB_AUTHUSR_ID",
            foreignKeyImmutable: true,
            localField: "PlanManagements",
        },
        [PASchema.esWB_BusinessUnit_User]: {
            foreignKey: "WB_AUTHUSR_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnitUsers",
        },
        [PASchema.esWB_User_Dimension]: {
            foreignKey: "WB_AUTHUSR_ID",
            foreignKeyImmutable: true,
            localField: "Dimensions",
        },
    },
    belongsTo: {
        [PASchema.esWB_Auth_Provider]: {
            foreignKey: "WB_AUTHPRVD_ID",
            foreignKeyImmutable: true,
            localField: "AuthProvider",
        },
    },
};

export const WB_User_Customer = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UsrCustR", // optional
    description: "Schema for WB_UsrCustR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRCUSTR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_User_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_User_Role = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UsrRoleR", // optional
    description: "Schema for WB_UsrRoleR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRROLER_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        WB_DOMITEM_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_User_Role_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
        [PASchema.esWB_Domain_Item]: { foreignKey: "WB_DOMITEM_ID", foreignKeyImmutable: true, localField: "Role" },
    },
    hasOne: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_User_Dimension = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UsrDimR", // optional
    description: "Schema for WB_UsrDimR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRDIMR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        WB_DIMENSION_ID: {
            type: "number",
        },
        SELECTEDHIERARCHY: {
            type: "string",
            length: 256,
        },
        SELECTEDKEYS: {
            type: "string",
            length: 256,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_User_Dimension_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
        [PASchema.esWB_Dimension]: {
            foreignKey: "WB_DIMENSION_ID",
            foreignKeyImmutable: true,
            localField: "Dimension",
        },
    },
};

// Session BO
export const WB_Session = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Session", // optional
    description: "Schema for WB_Session records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SESSION_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SESSION_GUID: {
            type: "string",
            length: 100,
        },
        AUTH_REQUEST_TOKEN: {
            type: "string",
            length: 1333,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        SOURCE_NETWORK_ADDRESS: {
            type: "string",
            length: 50,
        },
        LAST_LOGIN_SUCCESS_TS: {
            type: "string",
            length: 50,
        },
        SESSION_EXPIRATION_TS: {
            type: "string",
            length: 50,
        },
        LAST_ERROR: {
            type: "string",
            length: 1333,
        },
        LAST_ERROR_TS: {
            type: "string",
            length: 50,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Session_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
};

// Audit Log
export const WB_Audit_Log = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_AuditLog", // optional
    description: "Schema for WB_AuditLog records", // optional
    type: "object",
    track: true,
    properties: {
        WB_AUDITLOG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        AUDITLOG_TYPE: {
            type: "string",
            length: 50,
        },
        WB_REFERENCE_TYPE: {
            type: "string",
            length: 50,
        },
        WB_REFERENCE_ID: {
            type: "number",
        },
        WB_JOBPROCESS_ID: {
            type: "number",
        },
        WB_JOB_PROCESS_QUEUE_ID: {
            type: "number",
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        WB_SESSION_ID: {
            type: "number",
        },
        LOG_MESSAGE: {
            type: "string",
            length: 1333,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_TM: {
            type: "string",
            length: 6,
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_SECREF_ID: {
            type: "number",
        },
        SECREF_ID: {
            type: "string",
            length: 50,
        },
        REFERENCE_AMT: {
            type: "number",
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_INTEGRATION_ID: {
            type: "string",
            length: 50,
        },
        PREVIOUS_VALUE: {
            type: "string",
            length: 256,
        },
        NEW_VALUE: {
            type: "string",
            length: 256,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Audit_Log_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
};

//Business Unit
export const WB_BusinessUnit = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "BusinessUnit", // optional
    description: "Schema for BusinessUnit records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BUSINESSUNIT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        BUSINESSUNIT_ID: {
            type: "string",
            length: 50,
        },
        BUSINESSUNIT_NAME: {
            type: "string",
            length: 256,
        },
        COMPANY_CODE: {
            type: "string",
            length: 50,
        },
        WB_BUSINESSUNIT_ID_PRNT: {
            type: "number",
        },
        WB_PRICINGENGINE_ID: {
            type: "number",
        },
        WB_CIRCULARCONFIG_ID: {
            type: "number",
        },
        CREATED_DT: {
            type: "string",
            length: 14,
        },
        MODIFIED_DT: {
            type: "string",
            length: 14,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_BusinessUnit_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_BusinessUnit_Source]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnitSources",
        },
        [PASchema.esWB_BusinessUnit_User]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "UsrBusinessUnits",
        },
        [PASchema.esWB_License]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "LicBusinessUnits",
        },
        [PASchema.esWB_Benchmark]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BenchmarkBusinessUnits",
        },
    },
};

export const WB_BusinessUnit_Source_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_BusinessUnitSR", // optional
    description: "Schema for WB_BusinessUnitSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BUSINESSUNITSR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        WB_SOURCE_ID: {
            type: "number",
        },
        CREATED_DT: {
            type: "string",
            length: 14,
        },
        MODIFIED_DT: {
            type: "string",
            length: 14,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_BusinessUnit_Source_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" },
    },
};

export const WB_BusinessUnit_User_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UsrBusinessUnitR", // optional
    description: "Schema for WB_UsrBusinessUnitR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRBUSINESSUNITR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        CREATED_DT: {
            type: "string",
            length: 14,
        },
        MODIFIED_DT: {
            type: "string",
            length: 14,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_BusinessUnit_User_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
};

//Pricing Engine
export const WB_Pricing_Engine = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Pricing_Engine", // optional
    description: "Schema for WB_Pricing_Engine records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRICINGENGINE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        PRICINGENGINE_ID: {
            type: "string",
            length: 50,
        },
        PRICINGENGINE_NAME: {
            type: "string",
            length: 256,
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        WB_PRDH_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Pricing_Engine_JSData_Rels = {
    hasMany: {
        [PASchema.esWB_Pricing_Engine_Price_Relationship]: {
            foreignKey: "WB_PRICINGENGINE_ID",
            foreignKeyImmutable: true,
            localField: "PricingEnginePRs",
        },
    },
};

export const WB_Pricing_Engine_Price_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Pricing_Engine_PR", // optional
    description: "Schema for WB_Pricing_Engine_PR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRICINGENGINEPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PRICINGENGINE_ID: {
            type: "number",
        },
        PRICE_TYPE: {
            type: "string",
            length: 50,
        },
        PRD_CNDM_ID: {
            type: "number",
        },
        WB_CUSTH_ID_ALT: {
            type: "number",
        },
        WB_PRDH_ID_ALT: {
            type: "number",
        },
        CALCULATE_CNDM_IND: {
            type: "string",
            length: 1,
        },
        PRCCLC_ID: {
            type: "number",
        },
        CURRENCY: {
            type: "string",
            length: 10,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Pricing_Engine_Price_Relationship_JSData_Rels = {
    belongsTo: {
        [PASchema.esWB_Pricing_Engine]: {
            foreignKey: "WB_PRICINGENGINE_ID",
            foreignKeyImmutable: true,
            localField: "PricingEngine",
        },
    },
};

// Jobs
export const WB_Job = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Jobs", // optional
    description: "Schema for Jobs records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOB_ID: {
            type: "number",
            id: true,
            required: true,
        },
        JOB_ID: {
            type: "string",
            length: 50,
        },
        JOB_NAME: {
            type: "string",
            length: 256,
        },
        JOB_DESCRIPTION: {
            type: "string",
            length: 1333,
        },
        JOB_TYPE: {
            type: "string",
            length: 50,
        },
        ETL_NAME: {
            type: "string",
            length: 50,
        },
        JOB_TECHNICAL_NAME: {
            type: "string",
            length: 50,
        },
        JOB_OPTIONS: {
            type: "string",
            length: 1333,
        },
        DISPLAY_IND: {
            type: "string",
            length: 1,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Job_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Job_Run]: { foreignKey: "WB_JOB_ID", foreignKeyImmutable: true, localField: "JobRuns" },
    },
};

// Job Run
export const WB_JobRun = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "JobRun", // optional
    description: "Schema for JobRun records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOB_RUN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_JOB_ID: {
            type: "number",
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        STARTDT: {
            type: "string",
            length: 14,
        },
        ENDDT: {
            type: "string",
            length: 14,
        },
        FINISH_DESCRIPTION: {
            type: "string",
            length: 256,
        },
        LOAD_COUNT: {
            type: "number",
        },
        ERROR_TIME: {
            type: "string",
            length: 14,
        },
        ERROR_COUNT: {
            type: "number",
        },
        ERROR_DESCRIPTION: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_Job_Run_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job]: { foreignKey: "WB_JOB_ID", foreignKeyImmutable: true, localField: "Job" },
    },
};

//Job Schedule Process start
export const WB_Job_Schedule_Process_RelationShip = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Schedule", // optional
    description: "Schema for Job Schedule records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOBSCHEDULEPROCESS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_JOBSCHEDULE_ID: {
            type: "number",
        },
        RUN_STAMP: {
            type: "string",
            length: 50,
        },
        PROCESS_STATUS: {
            type: "string",
            length: 50,
        },
        PROCESS_START_DTTS: {
            type: "number",
        },
        PROCESS_END_DTTS: {
            type: "number",
        },
        PROCESS_ERROR_DTTS: {
            type: "number",
        },
        ERROR_IND: {
            type: "string",
            length: 1,
        },
        ERROR_MSG: {
            type: "string",
            length: 1333,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Job_Schedule_Process_RelationShip_JSData_RELs = {
    belongsTo: {},
};

//End Job Schedule Process
export const WB_Job_Processor = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Processor", // optional
    description: "Schema for Job Processor records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOBPROCESSOR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        JOBPROCESSOR_IDX: {
            type: "number",
        },
        JOBPROCESSOR_HOSTNAME: {
            type: "string",
            length: 100,
        },
        JOBPROCESSOR_PID: {
            type: "string",
            length: 50,
        },
        JOB_TYPE: {
            type: "string",
            length: 50,
        },
        JOBPROCESSOR_STATUS: {
            type: "string",
            length: 50,
        },
        JOBPROCESSOR_HB_DTTS: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Job_Processor_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Job_Process]: {
            foreignKey: "WB_JOBPROCESSOR_ID",
            foreignKeyImmutable: true,
            localField: "JobProcesses",
        },
    },
};

export const WB_Job_Processor_ConfigR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Processor Config Relationship records", // optional
    description: "Schema for Job Processor Config R records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOBPROCESSOR_CONFIGR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        MACHINE_TYPE_ID: {
            type: "string",
            length: 100,
        },
        JOB_PROCESSOR_TYPE: {
            type: "string",
            length: 100,
        },
        WORKER_COUNT: {
            type: "number",
        },
        POLLING_INTERVAL_SECONDS: {
            type: "number",
        },
        QUEUE_ALLOWABLE_FAILURE_COUNT: {
            type: "number",
        },
        QUEUE_TIMEOUT_THRESHOLD_SECONDS: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Job_Processor_ConfigR_JSData_RELs = {};

export const WB_Job_Process = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Process", // optional
    description: "Schema for Job Process records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOBPROCESS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_JOB_PARAMSR_ID: {
            type: "number",
        },
        WB_JOB_PARAM_ID: {
            type: "number",
        },
        WB_UI_APPEXEC_ID_OUTPUT: {
            type: "number",
        },
        WB_ID_OUTPUT: {
            type: "number",
        },
        RUN_ID: {
            type: "string",
            length: 50,
        },
        QUEUE_IND: {
            type: "string",
            length: 1,
        },
        PROCESS_STATUS: {
            type: "string",
            length: 50,
        },
        QUEUE_CREATE_STATUS: {
            type: "string",
            length: 50,
        },
        PROCESS_START_DTTS: {
            type: "number",
        },
        PROCESS_END_DTTS: {
            type: "number",
        },
        PROCESS_CLAIMED_DTTS: {
            type: "number",
        },
        PROCESS_TIMEOUT_DTTS: {
            type: "number",
        },
        PROCESS_ERROR_DTTS: {
            type: "number",
        },
        PROCESS_PROGRESS_PCNT: {
            type: "number",
        },
        PROCESS_PROGRESS_D: {
            type: "number",
        },
        ERROR_IND: {
            type: "string",
            length: 1,
        },
        ERROR_MSG: {
            type: "string",
            length: 1333,
        },
        WB_JOBPROCESSOR_ID: {
            type: "number",
        },
        JOBPROCESSOR_HB_DTTS: {
            type: "number",
        },
        WB_QUEUE_CREATED_DTTS: {
            type: "number",
        },
        ALLOWABLE_FAILURE_COUNT: {
            type: "number",
        },
        TIMEOUT_THRESHOLD_SECONDS: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Job_Process_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Processor]: {
            foreignKey: "WB_JOBPROCESSOR_ID",
            foreignKeyImmutable: true,
            localField: "JobProcessor",
        },
        [PASchema.esWB_Job_Param]: {
            foreignKey: "WB_JOB_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "JobParam",
        },
    },
};

export const WB_Job_Process_Queue = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Process Queue", // optional
    description: "Schema for Job Process Queue records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOB_PROCESS_QUEUE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        QUEUE_ID: {
            type: "string",
            length: 50,
        },
        ITEM_TYPE: {
            type: "string",
            length: 50,
        },
        WB_JOB_PROCESS_QUEUE_ID_PARENT: {
            type: "number",
        },
        WB_UI_APPEXEC_ID_ITEM: {
            type: "number",
        },
        ITEM_WB_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        PROCESS_STATUS: {
            type: "string",
            length: 50,
        },
        FAILURE_COUNT: {
            type: "number",
        },
        WB_JOBPROCESS_ID: {
            type: "number",
        },
        JOB_PROCESSOR_TYPE: {
            type: "string",
            length: 50,
        },
        WB_JOBPROCESSOR_ID: {
            type: "number",
        },
        RUN_ID: {
            type: "number",
        },
        PROCESS_CLAIMED_DTTS: {
            type: "number",
        },
        PROCESS_TIMEOUT_DTTS: {
            type: "number",
        },
        PROCESS_START_DTTS: {
            type: "number",
        },
        PROCESS_END_DTTS: {
            type: "number",
        },
        MESSAGE: {
            type: "string",
            length: 1333,
        },
        ALLOWABLE_FAILURE_COUNT: {
            type: "number",
        },
        TIMEOUT_THRESHOLD_SECONDS: {
            type: "number",
        },
    },
});

export const WB_Job_Process_Queue_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Processor]: {
            foreignKey: "WB_JOBPROCESSOR_ID",
            foreignKeyImmutable: true,
            localField: "JobProcessor",
        },
    },
};

// Job Params
export const WB_Job_Param = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Parameters", // optional
    description: "Schema for Job Parameter records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOB_PARAM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        JOB_PARAM_ID: {
            type: "string",
            length: 250,
        },
        JOB_PARAM_NAME: {
            type: "string",
            length: 250,
        },
        WB_ID_TARGET: {
            type: "number",
        },
        JOB_MODULE_ID: {
            type: "string",
            length: 50,
        },
        JOB_PROCESSOR_TYPE: {
            type: "string",
            length: 50,
        },
        DEPENDENT_TRIGGER_ID: {
            type: "string",
            length: 50,
        },
        JOB_OPTIONS: {
            type: "string",
            length: 1333,
        },
        CREATE_ITEM_QUEUE_IND: {
            type: "string",
            length: 1,
        },
        DISABLED_IND: {
            type: "string",
            length: 1,
        },
        WB_UI_APPEXEC_ID_TARGET: {
            type: "number",
        },
        SOURCE_TYPE: {
            type: "string",
            length: 50,
        },
        SOURCE_WB_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Job_Param_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "JobParamMdSet",
        },
        [PASchema.esWB_Company]: {
            foreignKey: "WB_COMPANY_ID",
            foreignKeyImmutable: true,
            localField: "JobParamCompany",
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "JobParamSalesOrg",
        },
        [PASchema.esWB_UI_AppExecutable]: {
            foreignKey: "WB_UI_APPEXEC_ID_TARGET",
            foreignKeyImmutable: true,
            localField: "JobParamExec",
        },
    },
    hasMany: {
        [PASchema.esWB_Job_ParamSR]: {
            foreignKey: "WB_JOB_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "JobParamScheduleXref",
        },
    },
};

export const WB_Job_ParamSR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Parameter Schedule Xref", // optional
    description: "Schema for Job Parameter Schedule Xref records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOB_PARAMSR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_JOB_PARAM_ID: {
            type: "number",
        },
        WB_SCHEDULE_ID: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Job_ParamSR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Param]: {
            foreignKey: "WB_JOB_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "JobParam",
        },
        [PASchema.esWB_Schedule]: {
            foreignKey: "WB_SCHEDULE_ID",
            foreignKeyImmutable: true,
            localField: "JobParamSchedule",
        },
    },
};

// Job Trigger
export const WB_Job_Trigger = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Job Triggers", // optional
    description: "Schema for Job Trigger records", // optional
    type: "object",
    track: true,
    properties: {
        WB_JOB_TRIGGER_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        TRIGGER_ID: {
            type: "string",
            length: 50,
        },
        TRIGGER_DTTS: {
            type: "number",
        },
    },
});

export const WB_Job_Trigger_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "JobParamMdSet",
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "JobParamSalesOrg",
        },
        [PASchema.esWB_Company]: {
            foreignKey: "WB_COMPANY_ID",
            foreignKeyImmutable: true,
            localField: "JobTriggerCompany",
        },
    },
};

// Batch Process
export const WB_BatchProcess = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Batch Process", // optional
    description: "Schema for Batch Process records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BATCHPROCESS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        BATCHPROCESS_ID: {
            type: "string",
            length: 50,
        },
        BATCHPROCESS_NAME: {
            type: "string",
            length: 50,
        },
        JOB_ID: {
            type: "string",
            length: 50,
        },
        WB_BATCHSCOPE_ID: {
            type: "number",
            required: true,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_BatchProcess_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchScope",
        },
    },
};

export const WB_BatchScope = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Batch Scope", // optional
    description: "Schema for Batch Scope records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BATCHSCOPE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        BATCHSCOPE_ID: {
            type: "string",
            length: 50,
        },
        BATCHSCOPE_NAME: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});

export const WB_BatchScope_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_BatchProcess]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchProcesses",
        },
        [PASchema.esWB_BatchScopeCR]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchScopeCRs",
        },
        [PASchema.esWB_BatchScopeMR]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchScopeMRs",
        },
        [PASchema.esWB_BatchScopeSR]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchScopeSRs",
        },
    },
};

export const WB_BatchScopeCR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Batch Scope MDSet", // optional
    description: "Schema for Batch Scope MDSet records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BATCHSCOPECR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_BATCHSCOPE_ID: {
            type: "number",
            required: true,
        },
        WB_COMPANY_ID: {
            type: "number",
            required: true,
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_BatchScopeCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchScope",
        },
        [PASchema.esWB_Company]: {
            foreignKey: "WB_COMPANY_ID",
            foreignKeyImmutable: true,
            localField: "Company",
        },
    },
};

export const WB_BatchScopeMR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Batch Scope MDSet", // optional
    description: "Schema for Batch Scope MDSet records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BATCHSCOPEMR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_BATCHSCOPE_ID: {
            type: "number",
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
            required: true,
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_BatchScopeMR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchScope",
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MDSet",
        },
    },
};

export const WB_BatchScopeSR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Batch Scope MDSet", // optional
    description: "Schema for Batch Scope MDSet records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BATCHSCOPESR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_BATCHSCOPE_ID: {
            type: "number",
            required: true,
        },
        WB_SALESORG_ID: {
            type: "number",
            required: true,
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_BatchScopeSR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: "WB_BATCHSCOPE_ID",
            foreignKeyImmutable: true,
            localField: "BatchScope",
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SalesOrg",
        },
    },
};

// Queues
export const WB_Queue = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Jobs", // optional
    description: "Schema for Jobs records", // optional
    type: "object",
    track: true,
    properties: {
        WB_QUEUE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        QUEUE_ID: {
            type: "string",
            length: 50,
        },
        ITEM_TYPE: {
            type: "string",
            length: 50,
        },
        WB_QUEUE_ID_PARENT: {
            type: "number",
        },
        WB_UI_APPEXEC_ID_ITEM: {
            type: "number",
        },
        ITEM_WB_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        PROCESS_STATUS: {
            type: "string",
            length: 50,
        },
        FAILURE_COUNT: {
            type: "number",
        },
        WB_JOBPROCESS_ID: {
            type: "number",
        },
        JOB_PROCESSOR_TYPE: {
            type: "string",
            length: 50,
        },
        WB_JOBPROCESSOR_ID: {
            type: "number",
        },
        RUN_ID: {
            type: "number",
        },
        PROCESS_CLAIMED_DTTS: {
            type: "number",
        },
        PROCESS_TIMEOUT_DTTS: {
            type: "number",
        },
        PROCESS_START_DTTS: {
            type: "number",
        },
        PROCESS_END_DTTS: {
            type: "number",
        },
        MESSAGE: {
            type: "string",
            length: 1333,
        },
        ALLOWABLE_FAILURE_COUNT: {
            type: "number",
        },
        TIMEOUT_THRESHOLD_SECONDS: {
            type: "number",
        },
    },
});
export const WB_Queue_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Processor]: {
            foreignKey: "WB_JOBPROCESSOR_ID",
            foreignKeyImmutable: true,
            localField: "JobProcessor",
        },
    },
};

// Connection
export const WB_Connection = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Connection", // optional
    description: "Schema for Connection records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CONNECTION_ID: {
            type: "number",
            id: true,
            required: true,
        },
        CONNECTION_ID: {
            type: "string",
            length: 50,
        },
        CONNECTION_NAME: {
            type: "string",
            length: 256,
        },
        CONNECTION_TYPE_ID: {
            type: "string",
            length: 50,
        },
        CONNECTION_OPTIONS: {
            type: "string",
            length: 1333,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Connection_JSData_RELs = {};

// Dimension
export const WB_Dimension = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Dimension", // optional
    description: "Schema for Dimension records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DIMENSION_ID: {
            type: "number",
            id: true,
            required: true,
        },
        DIMENSION_ID: {
            type: "string",
            length: 50,
        },
        DIMENSION_NAME: {
            type: "string",
            length: 256,
        },
        WB_CONNECTION_ID: {
            type: "number",
        },
        TECHNICAL_NAME: {
            type: "string",
            length: 50,
        },
        SORT_ORDER: {
            type: "number",
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        WORKSPACE_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        WB_DIMENSION_ID_VALUELINK: {
            type: "number",
        },
        VALUELINK_USER_ROLE_RQD: {
            type: "string",
            length: 50,
        },
        VALUELINK_POLICY: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Dimension_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Connection]: {
            foreignKey: "WB_CONNECTION_ID",
            foreignKeyImmutable: true,
            localField: "Connection",
        },
    },
};

// Report
export const WB_ReportTile = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Report Tile", // optional
    description: "Schema for Report Tile records", // optional
    type: "object",
    track: true,
    properties: {
        WB_REPORTTILE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        REPORT_ID: {
            type: "string",
            length: 50,
        },
        REPORT_NAME: {
            type: "string",
            length: 256,
        },
        REPORT_DESCRIPTION: {
            type: "string",
            length: 256,
        },
        REPORT_KEYWORDS: {
            type: "string",
            length: 256,
        },
        REPORT_TYPE_ID: {
            type: "string",
            length: 50,
        },
        REPORT_HELP_URL: {
            type: "string",
            length: 256,
        },
        WB_CONNECTION_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        SHARED_IND: {
            type: "string",
            length: 1,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_ReportTile_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Connection]: {
            foreignKey: "WB_CONNECTION_ID",
            foreignKeyImmutable: true,
            localField: "Connection",
        },
    },
    hasMany: {
        [PASchema.esWB_ReportTile_Dimension]: {
            foreignKey: "WB_REPORTTILE_ID",
            foreignKeyImmutable: true,
            localField: "ReportTileDimensions",
        },
    },
};

export const WB_ReportTile_Dimension = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Report Tile Dimension", // optional
    description: "Schema for Report Tile records", // optional
    type: "object",
    track: true,
    properties: {
        WB_RPTTLDR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_REPORTTILE_ID: {
            type: "number",
        },
        WB_DIMENSION_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_ReportTile_Dimension_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ReportTile]: {
            foreignKey: "WB_REPORTTILE_ID",
            foreignKeyImmutable: true,
            localField: "ReportTile",
        },
        [PASchema.esWB_Dimension]: {
            foreignKey: "WB_DIMENSION_ID",
            foreignKeyImmutable: true,
            localField: "Dimension",
        },
    },
};

export const WB_Subject_Area = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Subject Area", // optional
    description: "Schema for Subject Area records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SUBJECTAREA_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SUBJECT_AREA_ID: {
            type: "string",
            length: 50,
        },
        SUBJECT_AREA_NAME: {
            type: "string",
            length: 256,
        },
        SOURCE_NAME: {
            type: "string",
            length: 256,
        },
        GENERATE_IND: {
            type: "string",
            length: 1,
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
        },
        CUSTOMER_IND: {
            type: "string",
            length: 1,
        },
        CUSTOMER_REL_IND: {
            type: "string",
            length: 1,
        },
        CUSTOMER_SRC_IND: {
            type: "string",
            length: 1,
        },
        SUPPLYDIRECTION_IND: {
            type: "string",
            length: 1,
        },
        PRODUCTGROUP_IND: {
            type: "string",
            length: 1,
        },
        PERIOD_IND: {
            type: "string",
            length: 1,
        },
        PLAN_HIER_IND: {
            type: "string",
            length: 1,
        },
        SNAPSHOT_IND: {
            type: "string",
            length: 1,
        },
        GLACCOUNT_IND: {
            type: "string",
            length: 1,
        },
        EVENT_TYPE_IND: {
            type: "string",
            length: 1,
        },
        EVENT_SPEND_TYPE_IND: {
            type: "string",
            length: 1,
        },
        FUND_TYPE_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Subject_Area_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_SUBJECTAREA_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinitions",
        },
    },
};

// Loader
export const WB_Loader = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Loader", // optional
    description: "Schema for Loader records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LOADER_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        LOADER_ID: {
            type: "string",
            length: 50,
        },
        LOADER_NAME: {
            type: "string",
            length: 256,
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
        },
        WB_LOADERSOURCE_ID: {
            type: "number",
        },
        SOURCE_FILTER: {
            type: "string",
            length: 2000,
        },
        LOADERTARGET_TYPE: {
            type: "string",
            length: 50,
        },
        LOADERTARGET_ID: {
            type: "string",
            length: 256,
        },
        WB_LOADERTARGET_ID: {
            type: "number",
        },
        WORKER_COUNT: {
            type: "number",
        },
        WB_JOB_ID_OVRD: {
            type: "number",
        },
        RESTATEMENT_POLICY: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Loader_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
        [PASchema.esWB_Loader_Source]: {
            foreignKey: "WB_LOADERSOURCE_ID",
            foreignKeyImmutable: true,
            localField: "LoaderSource",
        },
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
        [PASchema.esWB_Company]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" },
    },
    hasMany: {
        [PASchema.esWB_Loader_KeyMap]: {
            foreignKey: "WB_LOADER_ID",
            foreignKeyImmutable: true,
            localField: "LoaderKeyMaps",
        },
        [PASchema.esWB_Loader_MetricMap]: {
            foreignKey: "WB_LOADER_ID",
            foreignKeyImmutable: true,
            localField: "LoaderMetricMaps",
        },
    },
};

export const WB_Loader_KeyMap = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Loader KeyMap", // optional
    description: "Schema for Loader KeyMap records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LOADERKEYMAP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_LOADER_ID: {
            type: "number",
        },
        DIMENSION_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_TYPE: {
            type: "string",
            length: 50,
        },
        SOURCE_FIELDNAME: {
            type: "string",
            length: 128,
        },
        SOURCE_VALUE_CONSTANT: {
            type: "string",
            length: 256,
        },
        TRANSLATION_OPERATION_ID: {
            type: "number",
        },
        AGGREGATION_OPERATION_ID: {
            type: "number",
        },
        ALLOCATION_OPERATION_ID: {
            type: "number",
        },
    },
});
export const WB_Loader_KeyMap_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Loader]: { foreignKey: "WB_LOADER_ID", foreignKeyImmutable: true, localField: "Loader" },
    },
};

export const WB_Loader_MetricMap = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Loader MetricMap", // optional
    description: "Schema for Loader MetricMap records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LOADERMETRICMAP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_LOADER_ID: {
            type: "number",
        },
        WB_MTRDFN_ID: {
            type: "number",
        },
        METRIC_FIELDNAME: {
            type: "string",
            length: 128,
        },
        SOURCE_FIELDNAME: {
            type: "string",
            length: 128,
        },
        CALCULATION_POLICY: {
            type: "string",
            length: 50,
        },
        FORMULA: {
            type: "string",
            length: 1024,
        },
    },
});
export const WB_Loader_MetricMap_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Loader]: { foreignKey: "WB_LOADER_ID", foreignKeyImmutable: true, localField: "Loader" },
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinition",
        },
    },
    hasMany: {
        [PASchema.esWB_Loader_MetricTerm]: {
            foreignKey: "WB_LOADERMETRICMAP_ID",
            foreignKeyImmutable: true,
            localField: "LoaderMetricTerms",
        },
    },
};

export const WB_Loader_MetricTerm = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Loader MetricTerm", // optional
    description: "Schema for Loader MetricTerm records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LOADERMETRICTERM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_LOADERMETRICMAP_ID: {
            type: "number",
        },
        TERM_ID: {
            type: "string",
            length: 50,
        },
        PRD_CNDM_ID: {
            type: "number",
        },
        DEFAULT_VALUE: {
            type: "number",
        },
        CUSTOMER_LEVEL: {
            type: "string",
            length: 50,
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        PRODUCT_LEVEL: {
            type: "string",
            length: 50,
        },
        WB_PRDH_ID: {
            type: "number",
        },
    },
});
export const WB_Loader_MetricTerm_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Loader_MetricMap]: {
            foreignKey: "WB_LOADERMETRICMAP_ID",
            foreignKeyImmutable: true,
            localField: "LoaderMetricMap",
        },
    },
};

export const WB_Loader_Operation = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Loader Operation", // optional
    description: "Schema for Loader Operation records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LOADEROPERATION_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        LOADEROPERATION_ID: {
            type: "string",
            length: 50,
        },
        LOADEROPERATION_NAME: {
            type: "string",
            length: 256,
        },
        REQUIRED_DIMENSIONS: {
            type: "string",
            length: 256,
        },
        OPERATION_TYPE: {
            type: "string",
            length: 50,
        },
        DIMENSION_ID: {
            type: "string",
            length: 50,
        },
        CLASS_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_TYPE: {
            type: "string",
            length: 50,
        },
        WB_CONNECTION_ID: {
            type: "number",
        },
        SOURCE_TABLE: {
            type: "string",
            length: 256,
        },
        SOURCE_FILTER: {
            type: "string",
            length: 1333,
        },
        SOURCE_FIELDNAME: {
            type: "string",
            length: 128,
        },
        TARGET_FIELDNAME: {
            type: "string",
            length: 128,
        },
        TARGET_ALLOCATION_BASIS_FIELDNAME: {
            type: "string",
            length: 128,
        },
        TARGET_ALLOCATION_BASIS_TYPE: {
            type: "string",
            length: 50,
        },
        SOURCE_FIELDNAME2: {
            type: "string",
            length: 128,
        },
        DATE_RELEVANT_IND: {
            type: "string",
            length: 1,
        },
        STARTDT_FIELDNAME: {
            type: "string",
            length: 128,
        },
        ENDDT_FIELDNAME: {
            type: "string",
            length: 128,
        },
        TARGET_DIMENSION_ID: {
            type: "string",
            length: 50,
        },
        SUPPLYDIRECTION_POLICY: {
            type: "string",
            length: 50,
        },
        SEARCH_POLICY: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Loader_Operation_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
        [PASchema.esWB_Company]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" },
    },
};

export const WB_Loader_Source = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Loader Source", // optional
    description: "Schema for Loader Source records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LOADERSOURCE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        LOADERSOURCE_TYPE: {
            type: "string",
            length: 50,
        },
        LOADERSOURCE_ID: {
            type: "string",
            length: 256,
        },
        FILE_SCHEMA: {
            type: "string",
            length: 2000,
        },
        WB_CONNECTION_ID: {
            type: "number",
        },
        CUSTOMER_LEVEL: {
            type: "string",
            length: 50,
        },
        PRODUCT_LEVEL: {
            type: "string",
            length: 50,
        },
        WB_PERIODM_ID: {
            type: "number",
        },
        PARTITION_FIELDNAME: {
            type: "string",
            length: 128,
        },
        PARTITIONQUEUESIZE: {
            type: "number",
        },
    },
});
export const WB_Loader_Source_JSData_RELs = {
    belongsTo: {},
};

// Report product hierarchy
export const WB_Report_ProductGroupH = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Report Product Group Hierarchy", // optional
    description: "Schema for Report Product Group Hierarchy records", // optional
    type: "object",
    track: true,
    properties: {
        WB_RPT_PRDGRPH_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PRDGRP_ID: {
            type: "number",
            id: false,
            required: true,
        },
        PRODUCT_GROUP_ID: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_SET_ID: {
            type: "string",
            length: 10,
        },
        PRODUCT_GROUP_NAME: {
            type: "string",
            length: 256,
        },
        LEVEL_ID: {
            type: "string",
            length: 50,
        },
        WB_PRDH_ID: {
            type: "number",
            id: false,
            required: true,
        },
        WB_PRDGRP_ID_PRNT: {
            type: "number",
            id: false,
            required: true,
        },
        PRODUCT_GROUP_ID_PRNT: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_SET_ID_PRNT: {
            type: "string",
            length: 10,
        },
        PRODUCT_GROUP_NAME_PRNT: {
            type: "string",
            length: 256,
        },
        LEVEL_ID_PRNT: {
            type: "string",
            length: 50,
        },
        WB_MDSET_ID: {
            type: "number",
            id: false,
            required: true,
        },
        CURRENT_IND: {
            type: "string",
            length: 1,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Report_ProductGroupH_JSData_RELs = {};

// Report Customer hierarchy
export const WB_Report_CustomerH = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Report Customer Hierarchy", // optional
    description: "Schema for Report Customer Hierarchy records", // optional
    type: "object",
    track: true,
    properties: {
        WB_RPT_CUSTH_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_CUST_ID: {
            type: "number",
            id: false,
            required: true,
        },
        CUSTOMER_ID: {
            type: "string",
            length: 50,
        },
        CUSTOMER_SET_ID: {
            type: "string",
            length: 10,
        },
        CUSTOMER_NAME: {
            type: "string",
            length: 256,
        },
        CUSTOMER_TYPE: {
            type: "string",
            length: 50,
        },
        WB_CUSTH_ID: {
            type: "number",
            id: false,
            required: true,
        },
        WB_CUST_ID_PRNT: {
            type: "number",
            id: false,
            required: true,
        },
        CUSTOMER_ID_PRNT: {
            type: "string",
            length: 50,
        },
        CUSTOMER_SET_ID_PRNT: {
            type: "string",
            length: 10,
        },
        CUSTOMER_NAME_PRNT: {
            type: "string",
            length: 256,
        },
        CUSTOMER_TYPE_PRNT: {
            type: "string",
            length: 50,
        },
        WB_MDSET_ID: {
            type: "number",
            id: false,
            required: true,
        },
        CURRENT_IND: {
            type: "string",
            length: 1,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Report_CustomerH_JSData_RELs = {};

// Report time hierarchy
export const WB_Report_TimeH = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Report Customer Hierarchy", // optional
    description: "Schema for Report Customer Hierarchy records", // optional
    type: "object",
    track: true,
    properties: {
        WB_RPT_TIMEH_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PERIOD_ID: {
            type: "number",
            id: false,
            required: true,
        },
        WB_PERIODH_ID: {
            type: "number",
        },
        PERIOD_ID: {
            type: "string",
            length: 50,
        },
        PERIOD_NAME: {
            type: "string",
            length: 256,
        },
        PERIOD_TYPE_ID: {
            type: "string",
            length: 50,
        },
        WB_PERIOD_ID_PRNT: {
            type: "number",
            id: false,
            required: true,
        },
        PERIOD_ID_PRNT: {
            type: "string",
            length: 50,
        },
        PERIOD_NAME_PRNT: {
            type: "string",
            length: 256,
        },
        PERIOD_TYPE_ID_PRNT: {
            type: "string",
            length: 50,
        },
        WB_MDSET_ID: {
            type: "number",
            id: false,
            required: true,
        },
        CURRENT_IND: {
            type: "string",
            length: 1,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Report_TimeH_JSData_RELs = {};

// Workspace
export const WB_Workspace = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Workspace", // optional
    description: "Schema for Workspace records", // optional
    type: "object",
    track: true,
    properties: {
        WB_WORKSPACE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WORKSPACE_ID: {
            type: "string",
            length: 50,
        },
        WORKSPACE_NAME: {
            type: "string",
            length: 256,
        },
        WORKSPACE_TYPE_ID: {
            type: "string",
            length: 50,
        },
        WB_UI_APP_ID_CREATED: {
            type: "number",
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        RENDER_MODE: {
            type: "string",
            length: 256,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        RENDER_COLUMN_COUNT: {
            type: "number",
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        SHARED_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Workspace_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
    hasMany: {
        [PASchema.esWB_Workspace_Dimension]: {
            foreignKey: "WB_WORKSPACE_ID",
            foreignKeyImmutable: true,
            localField: "WorkspaceDimensions",
        },
        [PASchema.esWB_Workspace_Report]: {
            foreignKey: "WB_WORKSPACE_ID",
            foreignKeyImmutable: true,
            localField: "WorkspaceReports",
        },
    },
};

// Workspace Dimension
export const WB_Workspace_Dimension = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Workspace Dimension", // optional
    description: "Schema for Workspace Dimension records", // optional
    type: "object",
    track: true,
    properties: {
        WB_WORKSPACE_DIM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_WORKSPACE_ID: {
            type: "number",
        },
        WB_DIMENSION_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        SELECTEDHIERARCHY: {
            type: "string",
            length: 50,
        },
        SELECTEDKEYS: {
            type: "string",
            length: 1333,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Workspace_Dimension_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Workspace]: {
            foreignKey: "WB_WORKSPACE_ID",
            foreignKeyImmutable: true,
            localField: "Workspace",
        },
        [PASchema.esWB_Dimension]: {
            foreignKey: "WB_DIMENSION_ID",
            foreignKeyImmutable: true,
            localField: "Dimension",
        },
    },
};

// Workspace Report
export const WB_Workspace_Report = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Workspace Report", // optional
    description: "Schema for Workspace Report records", // optional
    type: "object",
    track: true,
    properties: {
        WB_WORKSPACE_RPTL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_WORKSPACE_ID: {
            type: "number",
        },
        WB_REPORTTILE_ID: {
            type: "number",
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Workspace_Report_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Workspace]: {
            foreignKey: "WB_WORKSPACE_ID",
            foreignKeyImmutable: true,
            localField: "Workspace",
        },
        [PASchema.esWB_ReportTile]: { foreignKey: "WB_REPORTTILE_ID", foreignKeyImmutable: true, localField: "Report" },
    },
    hasMany: {
        [PASchema.esWB_Workspace_Report_Dimension]: {
            foreignKey: "WB_WORKSPACE_RPTL_ID",
            foreignKeyImmutable: true,
            localField: "ReportDimensions",
        },
    },
};

// Workspace Report Dimension
export const WB_Workspace_Report_Dimension = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Workspace Report Dimension", // optional
    description: "Schema for Workspace Report Dimension records", // optional
    type: "object",
    track: true,
    properties: {
        WB_WORKSPACE_RTDM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_WORKSPACE_RPTL_ID: {
            type: "number",
        },
        WB_DIMENSION_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        SELECTEDHIERARCHY: {
            type: "string",
            length: 50,
        },
        SELECTEDKEYS: {
            type: "string",
            length: 1333,
        },
        LOCKED_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Workspace_Report_Dimension_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Workspace_Report]: {
            foreignKey: "WB_WORKSPACE_RPTL_ID",
            foreignKeyImmutable: true,
            localField: "WorkspaceReport",
        },
        [PASchema.esWB_Dimension]: {
            foreignKey: "WB_DIMENSION_ID",
            foreignKeyImmutable: true,
            localField: "Dimension",
        },
    },
};

//Note BO
export const WB_Note = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Note", // optional
    description: "Schema for WB_Note records", // optional
    type: "object",
    track: true,
    properties: {
        WB_NOTE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        NOTE_TYPE: {
            type: "string",
            length: 50,
        },
        NOTE_TEXT: {
            type: "string",
            length: 1333,
        },
        NOTE_URL: {
            type: "string",
            length: 256,
        },
        APP_TYPE: {
            type: "string",
            length: 50,
        },
        WB_APP_ID: {
            type: "number",
        },
        NOTE_TITLE: {
            type: "string",
            length: 100,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});
export const WB_Note_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Note_User]: { foreignKey: "WB_NOTE_ID", foreignKeyImmutable: true, localField: "UserNotes" },
    },
};

export const WB_Note_User = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_NoteUsrR", // optional
    description: "Schema for WB_NoteUsrR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_NOTEUSRR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_NOTE_ID: {
            type: "number",
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Note_User_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Note]: { foreignKey: "WB_NOTE_ID", foreignKeyImmutable: true, localField: "Note" },
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
};

// File BO
export const WB_File = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Files", // optional
    description: "Schema for File records", // optional
    type: "object",
    track: true,
    properties: {
        WB_FILE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        FILE_ID: {
            type: "string",
            length: 50,
        },
        FILE_DESCRIPTION: {
            type: "string",
            length: 256,
        },
        FILE_TYPE_ID: {
            type: "string",
            length: 50,
        },
        MIME_TYPE: {
            type: "string",
            length: 256,
        },
        FILE_NAME: {
            type: "string",
            length: 256,
        },
        FILE_PATH: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        ATTACHMENT_IND: {
            type: "string",
            length: 1,
        },
        WB_ID: {
            type: "number",
        },
        APP_ID: {
            type: "string",
            length: 50,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_File_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: {
            foreignKey: "WB_AUTHUSR_ID",
            foreignKeyImmutable: true,
            localField: "creator",
        },
    },
};

//  Snapshot
export const WB_Snapshot = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Snapshots", // optional
    description: "Schema for Snapshot records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        SNAPSHOT_ID: {
            type: "string",
            length: 50,
        },
        SNAPSHOT_NAME: {
            type: "string",
            length: 256,
        },
        WB_SNAPSHOTM_ID: {
            type: "number",
        },
        RECURRING_IND: {
            type: "string",
            length: 1,
        },
        SNAPSHOT_TYPE: {
            type: "string",
            length: 50,
        },
        REFERENCE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        REFERENCE_OFFSET: {
            type: "number",
        },
        WB_SNAPSHOT_ID_PARENT: {
            type: "number",
        },
        WB_SNAPSHOT_ID_PREV: {
            type: "number",
        },
        WB_PERIOD_ID_PARENT: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        JOB_OPTIONS: {
            type: "string",
            length: 1333,
        },
        PRODUCT_LEVEL: {
            type: "string",
            length: 50,
        },
        CUSTOMER_LEVEL: {
            type: "string",
            length: 50,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        SNAPSHOT_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        METRIC_LIST: {
            type: "string",
            length: 4000,
        },
        CREATED_DTTS: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATED_BY: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        SCHEDULED_RUN_DTTS: {
            type: "number",
        },
        PROCESSED_START_DTTS: {
            type: "number",
        },
        PROCESSED_END_DTTS: {
            type: "number",
        },
        WORKFLOW_STATUS_ID: {
            type: "number",
        },
        WORKFLOW_STATUS_ID_NEXT: {
            type: "number",
        },
        WB_AUTHUSR_ID_WF_NEXT: {
            type: "number",
        },
        AUTO_RUN_ENABLE_IND: {
            type: "string",
            length: 1,
        },
        AUTO_RUN_DTTS: {
            type: "number",
        },
        AUTO_RUN_DAYS: {
            type: "string",
            length: 100,
        },
        STATUS_ID: {
            type: "string",
            length: 50,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Type]: {
            foreignKey: "WB_SNAPSHOTM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotType",
        },
        [PASchema.esWB_Workflow_Status]: {
            foreignKey: "WORKFLOW_STATUS_ID",
            foreignKeyImmutable: false,
            localField: "WorkflowStatus",
        },
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotpParam",
        },
    },
    hasMany: {
        [PASchema.esWB_Snapshot_Customer_Relationship]: {
            foreignKey: "WB_SNAPSHOT_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotCustomer",
        },
        [PASchema.esWB_Snapshot_ProductGroup_Relationship]: {
            foreignKey: "WB_SNAPSHOT_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotProductGroup",
        },
        [PASchema.esWB_Snapshot_Period_Relationship]: {
            foreignKey: "WB_SNAPSHOT_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotPeriod",
        },
        [PASchema.esWB_Snapshot_Plan_Relationship]: {
            foreignKey: "WB_SNAPSHOT_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotPlan",
        },
    },
};

// Snapshot Customer Relationship
export const WB_Snapshot_Customer_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_Snapshot_CustR", // optional
    description: "Schema for WB_Snapshot_CustR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_CUSTR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Snapshot_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot]: { foreignKey: "WB_SNAPSHOT_ID", foreignKeyImmutable: true, localField: "Snapshot" },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

// Snapshot Product Groupd Relationship
export const WB_Snapshot_ProductGroup_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_Snapshot_CustR", // optional
    description: "Schema for WB_Snapshot_CustR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PRDR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Snapshot_ProductGroup_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot]: { foreignKey: "WB_SNAPSHOT_ID", foreignKeyImmutable: true, localField: "Snapshot" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
};

// Snapshot Period Relationship
export const WB_Snapshot_Period_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_Snapshot_PeriodR", // optional
    description: "Schema for WB_Snapshot_PeriodR Rcords", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PERIODR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Snapshot_Period_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot]: { foreignKey: "WB_SNAPSHOT_ID", foreignKeyImmutable: true, localField: "Snapshot" },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

// Snapshot Plan Relationship
export const WB_Snapshot_Plan_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_Snapshot_PlanR", // optional
    description: "Schema for WB_Snapshot_PlanR Rcords", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PLANR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Snapshot_Plan_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot]: { foreignKey: "WB_SNAPSHOT_ID", foreignKeyImmutable: true, localField: "Snapshot" },
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLAN_ID", foreignKeyImmutable: true, localField: "Plan" },
    },
};

//  Snapshot
export const WB_Snapshot_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotTypes", // optional
    description: "Schema for Snapshot Type records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOTM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SNAPSHOT_TYPE_ID: {
            type: "string",
            length: 50,
        },
        SNAPSHOT_TYPE_NAME: {
            type: "string",
            length: 256,
        },
        PARENT_PERIOD_SHOW_IND: {
            type: "string",
            length: 1,
        },
        WB_PERIODM_ID_PARENT: {
            type: "number",
        },
        PERIOD_SHOW_IND: {
            type: "string",
            length: 1,
        },
        WB_PERIODM_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        WB_MDSET_ID: {
            type: "number",
        },
        ENTERPRISE_POLICY: {
            type: "string",
            length: 50,
        },
        PREV_SNAPSHOT_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PARENT_SNAPSHOT_SHOW_IND: {
            type: "string",
            length: 1,
        },
        RECURRING_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CUSTOMER_LIST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCTGROUP_LIST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PERIOD_LIST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PLAN_LIST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        EVENT_SPEND_ACCRUAL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        DAY_OFFSET_SHOW_IND: {
            type: "string",
            length: 1,
        },
        OFFSET_BASIS_ID: {
            type: "string",
            length: 50,
        },
        SERVER_PROCESS_ID: {
            type: "string",
            length: 50,
        },
        WB_JOB_ID: {
            type: "number",
        },
        JOB_OPTIONS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        JOB_OPTIONS_DEFAULT: {
            type: "string",
            length: 1333,
        },
        WORKFLOW_SHOW_IND: {
            type: "string",
            length: 1,
        },
        WB_WORKFLOW_ID: {
            type: "number",
        },
        PROD_LEVEL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CUST_LEVEL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        EDIT_ROLES: {
            type: "string",
            length: 256,
        },
        VIEW_ROLES: {
            type: "string",
            length: 256,
        },
        SUBJECT_AREA_SHOW_IND: {
            type: "string",
            length: 1,
        },
        GLRULE_SUBSET_IDS: {
            type: "string",
            length: 500,
        },
        PAYMENTMETHOD_OPTIONS: {
            type: "string",
            length: 50,
        },
        AUTO_RUN_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Snapshot_Msar]: {
            foreignKey: "WB_SNAPSHOTM_ID",
            foreignKeyImmutable: true,
            localField: "SnapShotMsar",
        },
        [PASchema.esWB_Snapshot]: { foreignKey: "WB_SNAPSHOTM_ID", foreignKeyImmutable: true, localField: "SnapShot" },
    },
    belongsTo: {
        [PASchema.esWB_Company]: {
            foreignKey: "WB_COMPANY_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotCompany",
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotMDSet",
        },
    },
};

//Snapshot Param
export const WB_Snapshot_Param = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParams", // optional
    description: "Schema for Snapshot Param records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        PARAM_ID: {
            type: "string",
            length: 50,
        },
        PARAM_NAME: {
            type: "string",
            length: 256,
        },
        PARAM_TYPE: {
            type: "string",
            length: 50,
        },
        PARAM_SERIES_NAME: {
            type: "string",
            length: 256,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        WB_PARTITION_ID: {
            type: "number",
        },
        PLANNING_YEAR_IND: {
            type: "string",
            length: 1,
        },
        WB_PERIOD_ID_PLANNING_YEAR: {
            type: "number",
        },
        SOURCE_LEVEL: {
            type: "string",
            length: 50,
        },
        DATE_RANGE_IND: {
            type: "string",
            length: 1,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        EXCLUDE_OI_IND: {
            type: "string",
            length: 1,
        },
        SELECT_TACTICS_IND: {
            type: "string",
            length: 1,
        },
        EVENT_STATUS_CSV: {
            type: "string",
            length: 1000,
        },
        WB_EVTSTYPE_ID_CSV: {
            type: "string",
            length: 1000,
        },
        ALL_SALESAREA_IND: {
            type: "string",
            length: 1,
        },
        ALL_PLAN_IND: {
            type: "string",
            length: 1,
        },
        ALL_EVENT_IND: {
            type: "string",
            length: 1,
        },
        SCOPE_COMMENTS: {
            type: "string",
            length: 500,
        },
        TACTIC_STATUS_CSV: {
            type: "string",
            length: 1000,
        },
        WB_ENTITY_ID_PRODUCT: {
            type: "number",
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: "number",
        },
        WB_ENTITY_ID_PERIOD: {
            type: "number",
        },
        WB_ENTITY_ID_PRODUCT_SNP: {
            type: "number",
        },
        WB_ENTITY_ID_PRODUCT_SNP_OPTIONS: {
            type: "string",
            length: 100,
        },
        RTE_METRIC_ID: {
            type: "string",
            length: 50,
        },
        GLH_SALESAREA_IND: {
            type: "string",
            length: 1,
        },
        SNH_SALESAREA_IND: {
            type: "string",
            length: 1,
        },
        WB_CUSTH_ID_GL: {
            type: "number",
        },
        WB_PRDH_ID_GL: {
            type: "number",
        },
        WB_AUTHUSR_ID_CREATED_BY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_Param_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Snapshot]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapShots",
        },
        [PASchema.esWB_Snapshot_ParamGLR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamGLRs",
        },
        [PASchema.esWB_Snapshot_ParamGLELR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamGLELRs",
        },
        [PASchema.esWB_Snapshot_ParamSAR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamSARs",
        },
        [PASchema.esWB_Snapshot_ParamAMR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamAMRs",
        },
        [PASchema.esWB_Snapshot_ParamCHR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamCHRs",
        },
        [PASchema.esWB_Snapshot_ParamPHR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamPHRs",
        },
        [PASchema.esWB_Snapshot_ParamGLPHR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamGLPHRs",
        },
        [PASchema.esWB_Snapshot_ParamGLCHR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamGLCHRs",
        },
        [PASchema.esWB_Snapshot_ParamPlnR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamPlnRs",
        },
        [PASchema.esWB_Snapshot_ParamETR]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParamETRs",
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotpParamMDSet",
        },
        [PASchema.esWB_Company]: {
            foreignKey: "WB_COMPANY_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotpParamCompany",
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotpParamSalesOrg",
        },
    },
};

//Snapshot ParamGLR
export const WB_Snapshot_ParamGLR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamGLRs", // optional
    description: "Schema for Snapshot Param GLR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMGLR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        EVALUATION_ORDER: {
            type: "number",
            length: 50,
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        PAYMENT_METHOD: {
            type: "string",
            length: 50,
        },
        GL_EXPENSETYPE_ID: {
            type: "string",
            length: 50,
        },
        WB_GLACCT_ID_EXPENSE: {
            type: "number",
        },
        WB_GLACCT_ID_POSTAUDIT: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamGLR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotpParam",
        },
    },
};

export const WB_Snapshot_ParamGLELR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamGLELRs", // optional
    description: "Schema for Snapshot Param GLELR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMGLELR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_GLACCT_ID_EXPENSE: {
            type: "number",
        },
        WB_GLACCT_ID_LIABILITY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamGLELR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotpParam",
        },
    },
};

//Snapshot ParamSAR
export const WB_Snapshot_ParamSAR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamSARs", // optional
    description: "Schema for Snapshot Param SAR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMSAR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamSAR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea",
        },
    },
};

//Snapshot ParamPlnR
export const WB_Snapshot_ParamPlnR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamPlnRs", // optional
    description: "Schema for Snapshot Param PlnR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMPLNR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamPlnR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_Plan]: {
            foreignKey: "WB_PLAN_ID",
            foreignKeyImmutable: true,
            localField: "Plan",
        },
    },
};

//Snapshot ParamETR
export const WB_Snapshot_ParamETR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamETRs", // optional
    description: "Schema for Snapshot Param ETR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMETR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamETR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_Event_Type]: {
            foreignKey: "WB_EVTTYPE_ID",
            foreignKeyImmutable: true,
            localField: "EventType",
        },
    },
};

//Snapshot ParamAMR
export const WB_Snapshot_ParamAMR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamAMRs", // optional
    description: "Schema for Snapshot Param AMR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMAMR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        EVALUATION_ORDER: {
            type: "number",
            length: 50,
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        CUSTOMER_ALLOCATION_METHOD: {
            type: "string",
            length: 50,
        },
        PRODUCT_ALLOCATION_METHOD: {
            type: "string",
            length: 50,
        },
        TIME_ALLOCATION_METHOD: {
            type: "string",
            length: 50,
        },
        COST_RECOGNITION_DATES: {
            type: "string",
            length: 50,
        },
        CNDM_ID_OFFSET: {
            type: "number",
        },
        CNDM_ID_DFT_OFFSET: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamAMR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_Product_Condition_Type]: [
            {
                foreignKey: "CNDM_ID_OFFSET",
                foreignKeyImmutable: true,
                localField: "ProductConditionType",
            },
            {
                foreignKey: "CNDM_ID_DFT_OFFSET",
                foreignKeyImmutable: true,
                localField: "ProductConditionTypeDefault",
            },
        ],
    },
};

// SnapshotCHR
export const WB_Snapshot_ParamCHR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamChr", // optional
    description: "Schema for SnapshotParam CustH records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMCHR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamCHR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "CustomerHier",
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea",
        },
    },
};

// SnapshotPHR
export const WB_Snapshot_ParamPHR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamPhr", // optional
    description: "Schema for SnapshotParamPhr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMPHR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        WB_ENTITY_ID_PRODUCT_SRC: {
            type: "number",
        },
        WB_PRDH_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamPHR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "ProductHier",
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea",
        },
        [PASchema.esWB_Entity]: {
            foreignKey: "WB_ENTITY_ID_PRODUCT_SRC",
            foreignKeyImmutable: true,
            localField: "SrcPrdEntity",
        },
    },
};

export const WB_Snapshot_ParamGLCHR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamChr", // optional
    description: "Schema for SnapshotParam GL CustH records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMGLCHR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamGLCHR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "CustomerHier",
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea",
        },
    },
};

// SnapshotPHR
export const WB_Snapshot_ParamGLPHR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotParamGLPhr", // optional
    description: "Schema for SnapshotParamGLPhr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOT_PARAMGLPHR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_PARAM_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        WB_PRDH_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Snapshot_ParamGLPHR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Param]: {
            foreignKey: "WB_SNAPSHOT_PARAM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotParam",
        },
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "ProductHier",
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea",
        },
    },
};

// SnapshotMAMR
export const WB_SnapshotMSAR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotMsar", // optional
    description: "Schema for Snapshot Type records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SNAPSHOTMSAR_ID: {
            type: "number",
            id: true,
            required: true,
        },

        WB_SNAPSHOTM_ID: {
            type: "number",
        },
        WB_SUBJECTAREA_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_SnapshotMSAR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Snapshot_Type]: {
            foreignKey: "WB_SNAPSHOTM_ID",
            foreignKeyImmutable: true,
            localField: "SnapshotType",
        },
        [PASchema.esWB_Subject_Area]: {
            foreignKey: "WB_SUBJECTAREA_ID",
            foreignKeyImmutable: true,
            localField: "SubjectArea",
        },
    },
};

// Snapshot Metrics
export const WB_Plan_Volume_Metrics_Snapshot = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotSVF", // optional
    description: "Schema for Snapshot SVF records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANVMTS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        PLAN_ID: {
            type: "string",
            length: 50,
        },
        PLAN_NAME: {
            type: "string",
            length: 256,
        },
        WB_PLANM_ID: {
            type: "number",
        },
        PLANM_ID: {
            type: "string",
            length: 50,
        },
        PLANM_NAME: {
            type: "string",
            length: 256,
        },
        WB_CUST_ID: {
            type: "number",
        },
        CUSTOMER_ID: {
            type: "string",
            length: 50,
        },
        CUSTOMER_NAME: {
            type: "string",
            length: 256,
        },
        WB_PRDGRP_ID_PLANLEVEL: {
            type: "number",
        },
        PRODUCT_GROUP_ID_PLANLEVEL: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_NAME_PLANLEVEL: {
            type: "string",
            length: 256,
        },
        WB_PERIOD_ID_PLANLEVEL: {
            type: "number",
        },
        PERIOD_ID_PLANLEVEL: {
            type: "string",
            length: 50,
        },
        PERIOD_NAME_PLANLEVEL: {
            type: "string",
            length: 256,
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        PRODUCT_GROUP_ID: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_NAME: {
            type: "string",
            length: 256,
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        PERIOD_ID: {
            type: "string",
            length: 50,
        },
        PERIOD_NAME: {
            type: "string",
            length: 256,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE_INDIRECT: {
            type: "number",
        },
        VCM: {
            type: "number",
        },
        RETAILER_BASE_PRICE: {
            type: "number",
        },
        RETAILER_EDLP_PRICE: {
            type: "number",
        },
        RETAILER_PROMO_PRICE: {
            type: "number",
        },
        RETAILER_PRICE: {
            type: "number",
        },
        UNIT_FACTOR: {
            type: "number",
        },
        WT_FACTOR: {
            type: "number",
        },
        STATCS_FACTOR: {
            type: "number",
        },
        CNS_BASE_QTY: {
            type: "number",
        },
        CNS_EDLP_QTY: {
            type: "number",
        },
        CNS_INCR_QTY: {
            type: "number",
        },
        CNS_CANN_QTY: {
            type: "number",
        },
        CNS_TOTAL_QTY: {
            type: "number",
        },
        SHIP_BASE_QTY: {
            type: "number",
        },
        SHIP_EDLP_QTY: {
            type: "number",
        },
        SHIP_INCR_QTY: {
            type: "number",
        },
        SHIP_FORWARDBUY_QTY: {
            type: "number",
        },
        SHIP_ADJ_QTY: {
            type: "number",
        },
        SHIP_TOTAL_QTY: {
            type: "number",
        },
        SHIP_BOM_COMP_QTY: {
            type: "number",
        },
        SHIP_OS_PCNT: {
            type: "number",
        },
        SHIP_DIR_BASE_QTY: {
            type: "number",
        },
        SHIP_DIR_EDLP_QTY: {
            type: "number",
        },
        SHIP_DIR_INCR_QTY: {
            type: "number",
        },
        SHIP_DIR_FORWARDBUY_QTY: {
            type: "number",
        },
        SHIP_DIR_ADJ_QTY: {
            type: "number",
        },
        SHIP_DIR_TOTAL_QTY: {
            type: "number",
        },
        SHIP_IND_PCNT: {
            type: "number",
        },
        SHIP_IND_BASE_QTY: {
            type: "number",
        },
        SHIP_IND_EDLP_QTY: {
            type: "number",
        },
        SHIP_IND_INCR_QTY: {
            type: "number",
        },
        SHIP_IND_FORWARDBUY_QTY: {
            type: "number",
        },
        SHIP_IND_ADJ_QTY: {
            type: "number",
        },
        SHIP_IND_TOTAL_QTY: {
            type: "number",
        },
        SHIP_IND_UNITS: {
            type: "number",
        },
        SHIP_IND_STAT: {
            type: "number",
        },
        SHIP_IND_GRSLSTSLS: {
            type: "number",
        },
        SHIP_IND_NETLSTSLS: {
            type: "number",
        },
        SHIP_DISTRIB_PCNT: {
            type: "number",
        },
        SHIP_DISTRIBUTED_QTY: {
            type: "number",
        },
        SHIP_NET_TOTAL_QTY: {
            type: "number",
        },
        SHIP_EXP_RECV_QTY: {
            type: "number",
        },
        SHIP_EXP_RECV_UNITS: {
            type: "number",
        },
        SHIP_EXP_RECV_STAT: {
            type: "number",
        },
        SHIP_EXP_RECV_GRSLSTSLS: {
            type: "number",
        },
        SHIP_EXP_RECV_NETLSTSLS: {
            type: "number",
        },
        ACT_CNS_BASE_UNITS: {
            type: "number",
        },
        ACT_CNS_BASE_RTLSLS: {
            type: "number",
        },
        ACT_CNS_EDLP_UNITS: {
            type: "number",
        },
        ACT_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        ACT_CNS_INCR_UNITS: {
            type: "number",
        },
        ACT_CNS_INCR_RTLSLS: {
            type: "number",
        },
        ACT_CNS_TOTAL_UNITS: {
            type: "number",
        },
        ACT_CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        LE_CNS_BASE_UNITS: {
            type: "number",
        },
        LE_CNS_BASE_RTLSLS: {
            type: "number",
        },
        LE_CNS_EDLP_UNITS: {
            type: "number",
        },
        LE_CNS_EDLP_RTLSLS: {
            type: "number",
        },
        LE_CNS_INCR_UNITS: {
            type: "number",
        },
        LE_CNS_INCR_RTLSLS: {
            type: "number",
        },
        LE_CNS_TOTAL_UNITS: {
            type: "number",
        },
        LE_CNS_TOTAL_RTLSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIR_WT: {
            type: "number",
        },
        ACT_SHIP_DIR_STAT: {
            type: "number",
        },
        ACT_SHIP_DIR_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIR_COSTS: {
            type: "number",
        },
        ACT_RTN_DIR_UNITS: {
            type: "number",
        },
        ACT_RTN_DIR_WT: {
            type: "number",
        },
        ACT_RTN_DIR_STAT: {
            type: "number",
        },
        ACT_RTN_DIR_GRSLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_NETLISTSLS: {
            type: "number",
        },
        ACT_RTN_DIR_COSTS: {
            type: "number",
        },
        ACT_SHIP_IND_UNITS: {
            type: "number",
        },
        ACT_SHIP_IND_WT: {
            type: "number",
        },
        ACT_SHIP_IND_STAT: {
            type: "number",
        },
        ACT_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_IND_NETLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIST_UNITS: {
            type: "number",
        },
        ACT_SHIP_DIST_WT: {
            type: "number",
        },
        ACT_SHIP_DIST_STAT: {
            type: "number",
        },
        ACT_SHIP_DIST_GRSLISTSLS: {
            type: "number",
        },
        ACT_SHIP_DIST_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_UNITS: {
            type: "number",
        },
        LE_SHIP_WT: {
            type: "number",
        },
        LE_SHIP_STAT: {
            type: "number",
        },
        LE_SHIP_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_COSTS: {
            type: "number",
        },
        LE_SHIP_DIR_UNITS: {
            type: "number",
        },
        LE_SHIP_DIR_WT: {
            type: "number",
        },
        LE_SHIP_DIR_STAT: {
            type: "number",
        },
        LE_SHIP_DIR_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_NETLISTSLS: {
            type: "number",
        },
        LE_SHIP_DIR_COSTS: {
            type: "number",
        },
        LE_SHIP_IND_UNITS: {
            type: "number",
        },
        LE_SHIP_IND_WT: {
            type: "number",
        },
        LE_SHIP_IND_STAT: {
            type: "number",
        },
        LE_SHIP_IND_GRSLISTSLS: {
            type: "number",
        },
        LE_SHIP_IND_NETLISTSLS: {
            type: "number",
        },
        SPND_VARIABLE: {
            type: "number",
        },
        SPND_FIXED: {
            type: "number",
        },
        ACT_SPND_VARIABLE: {
            type: "number",
        },
        ACT_SPND_FIXED: {
            type: "number",
        },
        LE_SPND_VARIABLE: {
            type: "number",
        },
        LE_SPND_FIXED: {
            type: "number",
        },
    },
});
export const WB_Plan_Volume_Metrics_Snapshot_JSData_RELs = {};

// Snapshot Promotion Tactic
export const WB_Event_Spend_Metrics_Snapshot = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotPromotionTactic", // optional
    description: "Schema for Snapshot Promotion Tactic records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TEVTSMTS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        PLAN_ID: {
            type: "string",
            length: 50,
        },
        PLAN_NAME: {
            type: "string",
            length: 256,
        },
        WB_PLANM_ID: {
            type: "number",
        },
        PLANM_ID: {
            type: "string",
            length: 50,
        },
        PLANM_NAME: {
            type: "string",
            length: 256,
        },
        WB_CUST_ID: {
            type: "number",
        },
        CUSTOMER_ID: {
            type: "string",
            length: 50,
        },
        CUSTOMER_NAME: {
            type: "string",
            length: 256,
        },
        WB_PRDGRP_ID_PLANLEVEL: {
            type: "number",
        },
        PRODUCT_GROUP_ID_PLANLEVEL: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_NAME_PLANLEVEL: {
            type: "string",
            length: 256,
        },
        WB_PERIOD_ID_PLANLEVEL: {
            type: "number",
        },
        PERIOD_ID_PLANLEVEL: {
            type: "string",
            length: 50,
        },
        PERIOD_NAME_PLANLEVEL: {
            type: "string",
            length: 256,
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        PRODUCT_GROUP_ID: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_NAME: {
            type: "string",
            length: 256,
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        PERIOD_ID: {
            type: "string",
            length: 50,
        },
        PERIOD_NAME: {
            type: "string",
            length: 256,
        },
        WB_TEVT_ID: {
            type: "number",
        },
        EVENT_ID: {
            type: "string",
            length: 50,
        },
        EVENT_NAME: {
            type: "string",
            length: 256,
        },
        WB_EVTTYPE_ID: {
            type: "number",
        },
        TYPE_ID: {
            type: "string",
            length: 50,
        },
        TYPE_NAME: {
            type: "string",
            length: 256,
        },
        WB_CUST_ID_SUB: {
            type: "number",
        },
        CUSTOMER_ID_SUB: {
            type: "string",
            length: 50,
        },
        CUSTOMER_NAME_SUB: {
            type: "string",
            length: 256,
        },
        WB_STATUS_ID_EVT: {
            type: "number",
        },
        STATUS_ID_EVT: {
            type: "string",
            length: 50,
        },
        STATUS_NAME_EVT: {
            type: "string",
            length: 256,
        },
        COVERAGE_FACTOR: {
            type: "number",
        },
        WB_TEVTS_ID: {
            type: "number",
        },
        EVENT_SPEND_ID: {
            type: "string",
            length: 50,
        },
        EVENT_SPEND_NAME: {
            type: "string",
            length: 256,
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        SPENDTYPE_ID: {
            type: "string",
            length: 50,
        },
        SPENDTYPE_NAME: {
            type: "string",
            length: 256,
        },
        WB_STATUS_ID_EVTS: {
            type: "number",
        },
        STATUS_ID_EVTS: {
            type: "string",
            length: 50,
        },
        STATUS_NAME_EVTS: {
            type: "string",
            length: 256,
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        FUNDTYPE_ID: {
            type: "string",
            length: 50,
        },
        FUNDTYPE_NAME: {
            type: "string",
            length: 256,
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        RATE_AMT: {
            type: "number",
        },
        RATE_UOM: {
            type: "string",
            length: 50,
        },
        RATE_PRDVOLBASIS: {
            type: "string",
            length: 50,
        },
        PAYMENT_METHOD: {
            type: "string",
            length: 50,
        },
        REDEMPTION_RATE_PCNT: {
            type: "number",
        },
        PAID_IN_FULL_IND: {
            type: "string",
            length: 1,
        },
        GROSS_LIST_PRICE: {
            type: "number",
        },
        NET_LIST_PRICE: {
            type: "number",
        },
        VCM: {
            type: "number",
        },
        PLANNED_SPEND: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        CURRENCY: {
            type: "string",
            length: 20,
        },
    },
});
export const WB_Event_Spend_Metrics_Snapshot_JSData_RELs = {};

// Snapshot Promotion Tactic
export const WB_Plan_NFP_Snapshot = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SnapshotNFP", // optional
    description: "Schema for Snapshot NFP records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLANNFPS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_PLAN_ID: {
            type: "number",
        },
        PLAN_ID: {
            type: "string",
            length: 50,
        },
        PLAN_NAME: {
            type: "string",
            length: 256,
        },
        WB_PLANM_ID: {
            type: "number",
        },
        PLANM_ID: {
            type: "string",
            length: 50,
        },
        PLANM_NAME: {
            type: "string",
            length: 256,
        },
        WB_CUST_ID: {
            type: "number",
        },
        CUSTOMER_ID: {
            type: "string",
            length: 50,
        },
        CUSTOMER_NAME: {
            type: "string",
            length: 256,
        },
        WB_PRDGRP_ID_PLANLEVEL: {
            type: "number",
        },
        PRODUCT_GROUP_ID_PLANLEVEL: {
            type: "string",
            length: 50,
        },
        PRODUCT_GROUP_NAME_PLANLEVEL: {
            type: "string",
            length: 256,
        },
        WB_PERIOD_ID_PLANLEVEL: {
            type: "number",
        },
        PERIOD_ID_PLANLEVEL: {
            type: "string",
            length: 50,
        },
        PERIOD_NAME_PLANLEVEL: {
            type: "string",
            length: 256,
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        FUNDTYPE_ID: {
            type: "string",
            length: 50,
        },
        FUNDTYPENAME: {
            type: "string",
            length: 256,
        },
        PLAN_STD_FUNDING_AMT: {
            type: "number",
        },
        PLAN_ADDL_FUNDING_AMT: {
            type: "number",
        },
        ACT_STD_FUNDING_AMT: {
            type: "number",
        },
        ACT_ADDL_FUNDING_AMT: {
            type: "number",
        },
        LE_ACT_YTD_STD_FUNDING_AMT: {
            type: "number",
        },
        LE_ACT_YTD_ADDL_FUNDING_AMT: {
            type: "number",
        },
        LE_PLAN_YTD_STD_FUNDING_AMT: {
            type: "number",
        },
        LE_PLAN_YTD_ADDL_FUNDING_AMT: {
            type: "number",
        },
        LE_STD_FUNDING_AMT: {
            type: "number",
        },
        LE_ADDL_FUNDING_AMT: {
            type: "number",
        },
        ACT_FIXED_FUNDING_AMT: {
            type: "number",
        },
        PLANNED_SPEND: {
            type: "number",
        },
        APPROVED_SPEND: {
            type: "number",
        },
        ACTUAL_SPEND: {
            type: "number",
        },
        ESTIMATED_SPEND: {
            type: "number",
        },
        LE_SPEND: {
            type: "number",
        },
        SETTLED_SPEND: {
            type: "number",
        },
        COMMITTED_SPEND: {
            type: "number",
        },
        AVAILABLE_TO_SPEND: {
            type: "number",
        },
        COMMITTED_UNSETTLED_SPEND: {
            type: "number",
        },
        CURRENCY: {
            type: "string",
            default: "",
            length: 20,
        },
    },
});
export const WB_Plan_NFP_Snapshot_JSData_RELs = {};

//  Event Type
export const WB_Event_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_EvtType", // optional
    description: "Schema for Event Type records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTTYPE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TYPE_ID: {
            type: "string",
            length: 50,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        TYPE_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DEFAULT_IND: {
            type: "string",
            length: 1,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        WB_PRDH_ID: {
            type: "number",
        },
        TYPE_NAME: {
            type: "string",
            length: 256,
        },
        ACTIVE_IND: {
            type: "string",
            length: 1,
        },
        PLANNING_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        SUBPLANNING_CUST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        COVERAGEFACTOR_LEVEL: {
            type: "string",
            length: 20,
        },
        MERCH_ACV_LEVEL: {
            type: "string",
            length: 50,
        },
        COVERAGEFACTOR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        COVERAGEFACTOR_WARNING_SHOW_IND: {
            type: "string",
            length: 1,
        },
        INSTOREDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        INSTOREDATES_POLICY: {
            type: "string",
            length: 50,
        },
        SHIPMENTDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        SHIPMENTDATES_POLICY: {
            type: "string",
            length: 50,
        },
        ORDERDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        ORDERDATES_POLICY: {
            type: "string",
            length: 50,
        },
        DISTRIBUTIONDATES_SHOW_IND: {
            type: "string",
            length: 1,
        },
        DISTRIBUTIONDATES_POLICY: {
            type: "string",
            length: 50,
        },
        INSTORE_PGOVERLAP_POLICY: {
            type: "string",
            length: 50,
        },
        INSTORE_PRDOVERLAP_POLICY: {
            type: "string",
            length: 50,
        },
        SHIPMENT_PGOVERLAP_POLICY: {
            type: "string",
            length: 50,
        },
        SHIPMENT_PRDOVERLAP_POLICY: {
            type: "string",
            length: 50,
        },
        OVERLAP_ERROR_STATUS_IDS: {
            type: "string",
            length: 50,
        },
        OVERLAP_WARNING_STATUS_IDS: {
            type: "string",
            length: 50,
        },
        PAIDINFULL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        WB_WORKFLOW_ID: {
            type: "number",
        },
        DISPLAYS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCTGROUPS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PLANNED_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        APPROVED_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        ACTUAL_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        LE_SPEND_SHOW_IND: {
            type: "string",
            length: 1,
        },
        COPY_POLICY: {
            type: "string",
            length: 50,
        },
        STANDARDCALCULATORCLASS: {
            type: "string",
            length: 50,
        },
        EVENTCALCULATORCLASS: {
            type: "string",
            length: 50,
        },
        WORKFLOW_POLICY: {
            type: "string",
            length: 50,
        },
        TAGS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        WB_TAGS_ID_USAGES: {
            type: "number",
        },
        COMMENTS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        CREATOR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PLAN_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PLAN_POLICY: {
            type: "string",
            length: 50,
        },
        CALC_VOLUMELAYER_ID: {
            type: "string",
            length: 20,
        },
        PGGROSSLISTPRICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGNETLISTPRICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGBASEPRICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGBASEPRICE_POLICY: {
            type: "string",
            length: 20,
        },
        PGBASEPRICE_REQUIRED_IND: {
            type: "string",
            length: 1,
        },
        PGEDLPPRICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGEDLPPRICE_POLICY: {
            type: "string",
            length: 20,
        },
        PGEDLPPRICE_REQUIRED_IND: {
            type: "string",
            length: 1,
        },
        PGPROMOTEDPRICE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGPROMOTEDPRICE_POLICY: {
            type: "string",
            length: 20,
        },
        PGPROMOTEDPRICE_REQUIRED_IND: {
            type: "string",
            length: 1,
        },
        PGDISCOUNTPCNT_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGDISCOUNTPCNT_POLICY: {
            type: "string",
            length: 20,
        },
        PGDISCOUNTPCNT_REQUIRED_IND: {
            type: "string",
            length: 1,
        },
        PGDISCOUNTAMT_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGDISCOUNTAMT_POLICY: {
            type: "string",
            length: 20,
        },
        PGDISCOUNTAMT_REQUIRED_IND: {
            type: "string",
            length: 1,
        },
        PGCNSBASE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSBASEEDLP_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSEDLP_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSEDLP_POLICY: {
            type: "string",
            length: 20,
        },
        PGCNSINCR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSINCR_POLICY: {
            type: "string",
            length: 20,
        },
        PGCNSCANN_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSCANN_POLICY: {
            type: "string",
            length: 20,
        },
        PGCNSTOTAL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSTOTAL_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPBASE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPBASEEDLP_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPEDLP_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPEDLP_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPINCR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPINCR_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPFWDBUYPCNT_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPFWDBUYPCNT_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPFWDBUY_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPADJ_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPADJ_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPTOTAL_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPTOTAL_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPDISP_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPDISP_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPDISPPCNT_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPDISPPCNT_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPOS_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGSHPOS_POLICY: {
            type: "string",
            length: 20,
        },
        PGCNSLIFTPCNT_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSLIFTPCNT_POLICY: {
            type: "string",
            length: 20,
        },
        PGCNSLIFTPCNTOVR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PGCNSLIFTPCNTOVR_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPFWDBUY_POLICY: {
            type: "string",
            length: 20,
        },
        PGCNSVOL_POLICY: {
            type: "string",
            length: 20,
        },
        PGSHPVOL_POLICY: {
            type: "string",
            length: 20,
        },
        METRICSVIEWSSUMMARY: {
            type: "string",
            length: 100,
        },
        METRICSVIEWSPERIODSUMMARY: {
            type: "string",
            length: 100,
        },
        PROD_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PROD_PERIOD_SHOW_IND: {
            type: "string",
            length: 1,
        },
        PRODUCT_PERIOD_PRDTYPES: {
            type: "string",
            length: 50,
        },
        CONSUMER_PRODUCT_POLICY: {
            type: "string",
            length: 20,
        },
        FINISHED_PRODUCT_POLICY: {
            type: "string",
            length: 20,
        },
        PGCNSEDLP_EDIT_IND: {
            type: "string",
            length: 1,
        },
        PGCNSINCR_EDIT_IND: {
            type: "string",
            length: 1,
        },
        ANALYSIS_TYPE: {
            type: "string",
            length: 20,
        },
        CALENDAR_ICON: {
            type: "string",
            length: 20,
        },
        CALENDAR_COLOR: {
            type: "string",
            length: 20,
        },
        EVENT_LAYER: {
            type: "string",
            length: 50,
        },
    },
});
export const WB_Event_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Event_Spend_Type_Relationship]: {
            foreignKey: "WB_EVTTYPE_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendTypes",
        },
    },
};

//General Ledger BO
export const WB_General_Ledger = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_GeneralLedger", // optional
    description: "Schema for WB_GeneralLedger records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0,
        },
        GENERAL_LEDGER_ID: {
            type: "string",
            default: "",
            length: 50,
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 10,
        },
        GENERAL_LEDGER_NAME: {
            type: "string",
            default: "",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            default: "",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
            default: 0,
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0,
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_General_Ledger_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_General_Ledger_Account]: {
            foreignKey: "WB_GL_ID",
            foreignKeyImmutable: true,
            localField: "GeneralLedgerAccounts",
        },
        [PASchema.esWB_Company]: {
            foreignKey: "WB_GL_ID",
            foreignKeyImmutable: true,
            localField: "Companies",
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet",
        },
    },
};

//General Ledger Account BO
export const WB_General_Ledger_Acct = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "GLAccountApp", // optional
    description: "Schema for GLAccountApp records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GLACCT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0,
        },
        GLACCOUNT_ID: {
            type: "string",
            default: "",
            length: 50,
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 10,
        },
        GLACCOUNT_NAME: {
            type: "string",
            default: "",
            length: 256,
        },
        WB_GL_ID: {
            type: "number",
            default: 0,
        },
        GLACCOUNT_TYPE: {
            type: "string",
            default: "",
            length: 50,
        },
        WB_GLACCT_ID_PRNT: {
            type: "number",
            default: 0,
        },
        GLACCOUNT_SORT: {
            type: "number",
            default: 0,
        },
        MANUAL_IND: {
            type: "string",
            default: "",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
            default: 0,
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0,
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_General_Ledger_Account_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_General_Ledger]: {
            foreignKey: "WB_GL_ID",
            foreignKeyImmutable: true,
            localField: "GeneralLedger",
        },
    },
    hasMany: {
        [PASchema.esWB_MetricDefinition_GLAccount]: {
            foreignKey: "WB_GLACCT_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinitionGLAccounts",
        },
    },
};

//General Ledger TPM Policy BO
export const WB_General_Ledger_Rule = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "GLRLApp", // optional
    description: "Schema for GLRLApp records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GLRL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        GLRULE_ID: {
            type: "string",
            length: 50,
        },
        GLRULE_NAME: {
            type: "string",
            length: 256,
        },
        EVALUATION_ORDER: {
            type: "number",
        },
        GLRULE_SUBSET_ID: {
            type: "string",
            length: 50,
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        WB_SPENDM_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        RATE_BASIS_ID: {
            type: "string",
            length: 50,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        ACCRUAL_METRIC_METHOD: {
            type: "string",
            length: 50,
        },
        CUSTOMER_ALLOCATION_METHOD: {
            type: "string",
            length: 50,
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        CUSTOMER_OUTPUT_LEVEL: {
            type: "string",
            length: 50,
        },
        PRODUCT_ALLOCATION_METHOD: {
            type: "string",
            length: 50,
        },
        WB_PRDH_ID: {
            type: "number",
        },
        PRODUCT_OUTPUT_LEVEL: {
            type: "string",
            length: 50,
        },
        TIME_ALLOCATION_METHOD: {
            type: "string",
            length: 50,
        },
        COST_RECOGNITION_DATES: {
            type: "string",
            length: 50,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        USE_RULE_GLACCT_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_General_Ledger_Policy_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet",
        },
        [PASchema.esWB_Company]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" },
    },
    hasMany: {
        [PASchema.esWB_General_Ledger_Policy_Account]: {
            foreignKey: "WB_GLRL_ID",
            foreignKeyImmutable: true,
            localField: "GeneralLedgerPolicyAccounts",
        },
    },
};

//General Ledger TPM Policy Account BO
export const WB_General_Ledger_Rule_Acct = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "GLRLAcctApp", // optional
    description: "Schema for GLRLAcctApp records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GLRLACCT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_GLRL_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        PAYMENT_METHOD: {
            type: "string",
            length: 50,
        },
        GL_EXPENSETYPE_ID: {
            type: "string",
            length: 50,
        },
        WB_GLACCT_ID: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_General_Ledger_Policy_Account_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_General_Ledger_Policy]: {
            foreignKey: "WB_GLRL_ID",
            foreignKeyImmutable: true,
            localField: "GeneralLedgerPolicy",
        },
    },
};

// Fund Type BO
export const WB_Fund_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_FundType", // optional
    description: "Schema for WB_FundType records", // optional
    type: "object",
    track: true,
    properties: {
        WB_FUNDTYPE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        FUNDTYPE_ID: {
            type: "string",
            length: 50,
        },
        FUNDTYPE_NAME: {
            type: "string",
            length: 256,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        WB_FK_ROW_ID: {
            type: "string",
            length: 100,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Fund_Type_JSData_RELs = {};

// Transaction Type BO
export const WB_Transaction_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_TransactionType", // optional
    description: "Schema for WB_TransactionType records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TXNTYPE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TXNTYPE_ID: {
            type: "string",
            length: 50,
        },
        TXNTYPE_NAME: {
            type: "string",
            length: 256,
        },
        CREDITDEBITPOLICY: {
            type: "string",
            length: 50,
        },
        BALANCEPOLICY: {
            type: "string",
            length: 50,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        WB_FK_ROW_ID: {
            type: "string",
            length: 100,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        FUNDTYPEPOLICY: {
            type: "string",
            length: 50,
        },
        CUSTOMERPOLICY: {
            type: "string",
            length: 50,
        },
        CUSTOMERLEVEL: {
            type: "string",
            length: 50,
        },
        PRDGRPPOLICY: {
            type: "string",
            length: 50,
        },
        PRDGRPLEVEL: {
            type: "string",
            length: 50,
        },
        PERIODPOLICY: {
            type: "string",
            length: 50,
        },
        WB_PERIODM_ID: {
            type: "number",
        },
    },
});
export const WB_Transaction_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Transaction]: {
            foreignKey: "WB_TXNTYPE_ID",
            foreignKeyImmutable: true,
            localField: "Transactions",
        },
    },
};

// Transaction BO
export const WB_Transaction = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Transaction", // optional
    description: "Schema for WB_Transaction records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TXN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TXN_ID: {
            type: "string",
            length: 256,
        },
        TXN_NAME: {
            type: "string",
            length: 256,
        },
        WB_TXNTYPE_ID: {
            type: "number",
        },
        TXN_DATE: {
            type: "string",
            length: 8,
        },
        TXN_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        TXN_AMOUNT: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Transaction_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Transaction_Item]: {
            foreignKey: "WB_TXN_ID",
            foreignKeyImmutable: true,
            localField: "TransactionItems",
        },
    },
    belongsTo: {
        [PASchema.esWB_Transaction_Type]: {
            foreignKey: "WB_TXNTYPE_ID",
            foreignKeyImmutable: true,
            localField: "TransactionType",
        },
    },
};
//

// GL Transactions
export const WB_GLTransaction = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_GLTxn", // optional
    description: "Schema for WB_GLTxn records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GLTXN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TXN_ID: {
            type: "string",
            length: 256,
        },
        TXN_NAME: {
            type: "string",
            length: 256,
        },
        TXN_TYPE: {
            type: "string",
            length: 256,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SNAPSHOT_ID: {
            type: "number",
        },
        WB_PERIOD_ID_PLAN: {
            type: "number",
        },
        WB_PERIOD_ID_FY: {
            type: "number",
        },
        WB_PERIOD_ID_MONTH: {
            type: "number",
        },
        POSTING_DATE: {
            type: "string",
            length: 8,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        STATUS_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});
export const WB_GLTransaction_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_GLTransaction_Item]: {
            foreignKey: "WB_GLTXN_ID",
            foreignKeyImmutable: true,
            localField: "GLTransactionItems",
        },
    },
};
//

// GL Transaction Item
export const WB_GLTransaction_Item = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_GLTxn_Item", // optional
    description: "Schema for WB_GLTxn_Item records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GLTXN_ITEM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_GLTXN_ID: {
            type: "number",
        },
        WB_GLACCT_ID_LIAB: {
            type: "number",
        },
        WB_GLACCT_ID_EXP: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        TXN_AMOUNT: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});
export const WB_GLTransaction_Item_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_GLTransaction]: {
            foreignKey: "WB_GLTXN_ID",
            foreignKeyImmutable: true,
            localField: "GLTransaction",
        },
        [PASchema.esWB_General_Ledger_Account]: {
            foreignKey: "WB_GLACCT_ID_EXPENSE",
            foreignKeyImmutable: true,
            localField: "GLAccountExp",
        },
    },
};
//

// GL Account Balance
export const WB_GLAccount_Balance = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_GLAcct_Bal", // optional
    description: "Schema for WB_GLAcct_Bal records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GLACCT_BAL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_GLACCT_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        AMOUNT: {
            type: "number",
        },
        START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});
export const WB_GLAccount_Balance_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_General_Ledger_Account]: {
            foreignKey: "WB_GLACCT_ID",
            foreignKeyImmutable: true,
            localField: "GLAccount",
        },
    },
};
//

// Transaction Item BO
export const WB_Transaction_Item = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Transaction_Item", // optional
    description: "Schema for WB_Transaction_Item records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TXNITEM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_TXN_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_FUNDTYPE_ID: {
            type: "number",
        },
        TXN_AMOUNT: {
            type: "number",
        },
        CREDITDEBIT: {
            type: "string",
            length: 20,
        },
        TXNITEM_ROW_ID: {
            type: "string",
            length: 50,
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        WB_PERIOD_ID: {
            type: "number",
        },
    },
});
export const WB_Transaction_Item_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Transaction]: { foreignKey: "WB_TXN_ID", foreignKeyImmutable: true, localField: "Transaction" },
    },
};

// Workflow BO
export const WB_Workflow = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Workflow", // optional
    description: "Schema for WB_Workflow records", // optional
    type: "object",
    track: true,
    properties: {
        WB_WORKFLOW_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WORKFLOW_ID: {
            type: "string",
            length: 50,
        },
        WORKFLOW_NAME: {
            type: "string",
            length: 256,
        },
        WORKFLOW_USAGE: {
            type: "string",
            length: 50,
        },
    },
});
export const WB_Workflow_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Workflow_Status]: {
            foreignKey: "WB_WORKFLOW_ID",
            foreignKeyImmutable: true,
            localField: "WorkflowStatuses",
        },
    },
};

export const WB_Workflow_Status = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Workflow_Status", // optional
    description: "Schema for WB_Workflow_Status records", // optional
    type: "object",
    track: true,
    properties: {
        WB_STATUS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        STATUS_ID: {
            type: "string",
            length: 50,
        },
        STATUS_NAME: {
            type: "string",
            length: 256,
        },
        STATUS_TYPE: {
            type: "string",
            length: 50,
        },
        WB_WORKFLOW_ID: {
            type: "number",
        },
        APPROVED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Workflow_Status_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Status_Relationship]: {
            foreignKey: "WB_STATUS_ID",
            foreignKeyImmutable: true,
            localField: "StateTransitions",
        },
    },
    belongsTo: {
        [PASchema.esWB_Workflow]: { foreignKey: "WB_WORKFLOW_ID", foreignKeyImmutable: true, localField: "Workflow" },
    },
};

export const WB_Status_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Status_Relationship", // optional
    description: "Schema for WB_StatusR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_STATUSR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_STATUS_ID: {
            type: "number",
        },
        WB_STATUS_ID_NEXT: {
            type: "number",
        },
        WB_DOMITEM_ID: {
            type: "number",
        },
    },
});
export const WB_Status_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Workflow_Status]: [
            {
                foreignKey: "WB_STATUS_ID",
                foreignKeyImmutable: true,
                localField: "Status",
            },
            { foreignKey: "WB_STATUS_ID_NEXT", foreignKeyImmutable: true, localField: "NextStatus" },
        ],
        [PASchema.esWB_Domain_Item]: { foreignKey: "WB_DOMITEM_ID", foreignKeyImmutable: true, localField: "Role" },
    },
};

// Status History / Log
export const WB_Status_History = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Status_History", // optional
    description: "Schema for WB_StatusH records", // optional
    type: "object",
    track: true,
    properties: {
        WB_STATUSH_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_APP_ID: {
            type: "number",
        },
        APP_ID: {
            type: "string",
            length: 50,
        },
        APPMGR_ID: {
            type: "string",
            length: 50,
        },
        WB_STATUS_ID: {
            type: "number",
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        STATUS_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        STATUS_TM: {
            type: "string",
            length: 20,
        },
    },
});
export const WB_Status_History_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Workflow_Status]: {
            foreignKey: "WB_STATUS_ID",
            foreignKeyImmutable: true,
            localField: "Status",
        },
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
    hasMany: {
        [PASchema.esWB_Status_History_Log]: {
            foreignKey: "WB_STATUSH_ID",
            foreignKeyImmutable: true,
            localField: "Log",
        },
    },
};

export const WB_Status_History_Log = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Status_History_Log", // optional
    description: "Schema for WB_StatusHL records", // optional
    type: "object",
    track: true,
    properties: {
        WB_STATUSHL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_STATUSH_ID: {
            type: "number",
        },
        LOG_SORT: {
            type: "string",
            length: 20,
        },
        LOG_MESSAGE_CD: {
            type: "string",
            length: 50,
        },
        LOG_MESSAGE: {
            type: "string",
            length: 1333,
        },
    },
});
export const WB_Status_History_Log_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Status_History]: {
            foreignKey: "WB_STATUSH_ID",
            foreignKeyImmutable: true,
            localField: "StatusHistory",
        },
    },
};

export const WB_User_Reviewer = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_User_Reviewer", // optional
    description: "Schema for WB_UsrRvwr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRRVWR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_APP_ID: {
            type: "number",
        },
        APP_ID: {
            type: "string",
            length: 50,
        },
        APPMGR_ID: {
            type: "string",
            length: 50,
        },
        CURRENT_IND: {
            type: "string",
            length: 1,
        },
        REQUEST_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        REVIEW_SORT: {
            type: "string",
            length: 20,
        },
        REQUIRED_ROLE_ID: {
            type: "number",
        },
        REVIEW_SUBJECT: {
            type: "string",
            length: 50,
        },
        REFERENCE1_ID: {
            type: "string",
            length: 50,
        },
        REFERENCE2_ID: {
            type: "string",
            length: 50,
        },
        REFERENCE_AMT: {
            type: "number",
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        RESPONSE_ID: {
            type: "string",
            length: 50,
        },
        RESPONSE_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        RESPONSE_COMMENTS: {
            type: "string",
            length: 1333,
        },
    },
});
export const WB_User_Reviewer_JSData_RELs = {};

// Baseline BO
export const WB_BaseLn = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_BaseLn", // optional
    description: "Schema for WB_BaseLn records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BASELINE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        BASELINE_ID: {
            type: "string",
            length: 50,
        },
        BASELINE_NAME: {
            type: "string",
            length: 256,
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        SOURCE_ID: {
            type: "string",
            length: 50,
        },
        BASELINE_TYPE_ID: {
            type: "string",
            length: 50,
        },
        LOAD_STATUS_ID: {
            type: "string",
            length: 50,
        },
        LOAD_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        HIST_DATATHRU_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_BaseLn_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_BaseLnMt]: { foreignKey: "WB_BASELINE_ID", foreignKeyImmutable: true, localField: "Metrics" },
    },
};

export const WB_BaseLnMt = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_BaseLnMt", // optional
    description: "Schema for WB_BaseLnMt records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BASELINE_METRIC_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_BASELINE_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        BASELINE_BUOM_QTY: {
            type: "number",
        },
        BASELINE_UNITS: {
            type: "number",
        },
        BASELINE_STATCS: {
            type: "number",
        },
        BASELINE_LISTSLS: {
            type: "number",
        },
        BASELINE_RTLSLS: {
            type: "number",
        },
        BASELINE_WT: {
            type: "number",
        },
    },
});
export const WB_BaseLnMt_JSData_RELs = {};

export const WB_Baseline = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Baseline", // optional
    description: "Schema for WB_Baseline records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BASELINE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        BASELINE_ID: {
            type: "string",
            length: 20,
        },
        BASELINE_NAME: {
            type: "string",
            length: 256,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        BASELINE_SOURCE_ID: {
            type: "string",
            length: 50,
        },
        BASELINE_TYPE_ID: {
            type: "string",
            length: 50,
        },
        WB_SCHEDULE_ID: {
            type: "number",
        },
        WB_PARTITION_ID: {
            type: "number",
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        CUSTOMER_LEVEL: {
            type: "string",
            length: 50,
        },
        WB_PRDH_ID: {
            type: "number",
        },
        PRODUCT_TYPE: {
            type: "string",
            length: 50,
        },
        PRODUCT_LEVEL: {
            type: "string",
            length: 50,
        },
        BOM_DECOMP_IND: {
            type: "string",
            length: 1,
        },
        WB_PERIODH_ID: {
            type: "number",
        },
        WB_PERIODM_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        UOM_ID: {
            type: "string",
            length: 20,
        },
        HIST_DATATHRU_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        LAST_REFRESH_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        REFRESH_CUTOFF_DAYS: {
            type: "number",
        },
        PROCESS_START_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        PROCESS_END_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Baseline_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Baseline_Metrics]: {
            foreignKey: "WB_BASELINE_ID",
            foreignKeyImmutable: true,
            localField: "Metrics",
        },
    },
    belongsTo: {
        [PASchema.esWB_Partition]: {
            foreignKey: "WB_PARTITION_ID",
            foreignKeyImmutable: true,
            localField: "Partition",
        },
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea",
        },
    },
};

export const WB_Baseline_Metrics = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_BaselineMT", // optional
    description: "Schema for WB_BaselineMT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BASELINEMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_BASELINE_ID: {
            type: "number",
            id: true,
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        BASELINE_QTY: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Baseline_Metrics_JSData_RELs = {};

// Plan Management BO
export const WB_Plan_Management = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanManagement", // optional
    description: "Schema for WB_PlanManagement records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLNMGMT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        PLNMGMT_ID: {
            type: "string",
            length: 50,
        },
        PLNMGMT_NAME: {
            type: "string",
            length: 256,
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_Management_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Plan_Management_Period]: {
            foreignKey: "WB_PLNMGMT_ID",
            foreignKeyImmutable: true,
            localField: "Periods",
        },
        [PASchema.esWB_Plan_Management_User]: {
            foreignKey: "WB_PLNMGMT_ID",
            foreignKeyImmutable: true,
            localField: "Users",
        },
        [PASchema.esWB_Plan_Management_User_Group]: {
            foreignKey: "WB_PLNMGMT_ID",
            foreignKeyImmutable: true,
            localField: "UserGroups",
        },
        [PASchema.esWB_Plan]: { foreignKey: "WB_PLNMGMT_ID", foreignKeyImmutable: true, localField: "Plans" },
    },
};

export const WB_Plan_Management_Period = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanManagementPeriod", // optional
    description: "Schema for WB_PlanManagementPeriod records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLNMGMTR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLNMGMT_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PLANM_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_Management_Period_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan_Management]: {
            foreignKey: "WB_PLNMGMT_ID",
            foreignKeyImmutable: true,
            localField: "PlanManagement",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
    },
};

export const WB_Plan_Management_User = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanManagementUser", // optional
    description: "Schema for WB_PlanManagementUser records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLNMGMTU_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLNMGMT_ID: {
            type: "number",
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        ACTIVITY_ID: {
            type: "string",
            length: 50,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_Management_User_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan_Management]: {
            foreignKey: "WB_PLNMGMT_ID",
            foreignKeyImmutable: true,
            localField: "PlanManagement",
        },
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "AuthUser" },
    },
};

export const WB_Plan_Management_User_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PlanManagementUserGroup", // optional
    description: "Schema for WB_PlanManagementUserGroup records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PLNMGMTG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_PLNMGMT_ID: {
            type: "number",
        },
        WB_USRGRP_ID: {
            type: "number",
        },
        ACTIVITY_ID: {
            type: "string",
            length: 50,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Plan_Management_User_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan_Management]: {
            foreignKey: "WB_PLNMGMT_ID",
            foreignKeyImmutable: true,
            localField: "PlanManagement",
        },
        [PASchema.esWB_User_Group]: { foreignKey: "WB_USRGRP_ID", foreignKeyImmutable: true, localField: "UserGroup" },
    },
};

// User Group BO
export const WB_User_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_User_Group", // optional
    description: "Schema for WB_UsrGrp Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRGRP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        USRGRP_ID: {
            type: "string",
            length: 50,
        },
        USRGRP_NAME: {
            type: "string",
            length: 256,
        },
        WB_USRGRPM_ID: {
            type: "number",
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        COMMENTS: {
            type: "string",
            length: 1333,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_User_Group_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_User_Group_Customer]: {
            foreignKey: "WB_USRGRP_ID",
            foreignKeyImmutable: true,
            localField: "UserGroupCustomers",
        },
        [PASchema.esWB_User_Group_User]: {
            foreignKey: "WB_USRGRP_ID",
            foreignKeyImmutable: true,
            localField: "UserGroupUsers",
        },
        [PASchema.esWB_User_Group_Role]: {
            foreignKey: "WB_USRGRP_ID",
            foreignKeyImmutable: true,
            localField: "UserGroupRoles",
        },
        [PASchema.esWB_Plan_Management_User_Group]: {
            foreignKey: "WB_USRGRP_ID",
            foreignKeyImmutable: true,
            localField: "PlanManagements",
        },
        [PASchema.esWB_User_Group_Relationship]: {
            foreignKey: "WB_USRGRP_ID_PRNT",
            foreignKeyImmutable: true,
            localField: "UserGroupRs",
        },
        [PASchema.esWB_User_Group_SalesArea]: {
            foreignKey: "WB_USRGRP_ID",
            foreignKeyImmutable: true,
            localField: "UserGroupSalesAreas",
        },
        [PASchema.esWB_User_Group_Product]: {
            foreignKey: "WB_USRGRP_ID",
            foreignKeyImmutable: true,
            localField: "UserGroupProducts",
        },
    },
    belongsTo: {
        [PASchema.esWB_User_Group_Type]: {
            foreignKey: "WB_USRGRPM_ID",
            foreignKeyImmutable: true,
            localField: "UserGroupType",
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet",
        },
    },
};

export const WB_User_Group_CR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_User_Group_CR", // optional
    description: "Schema for WB_UsrGrpCR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRGRPCR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_USRGRP_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
        },
        DELETED_DT: {
            type: "string",
        },
    },
});
export const WB_User_Group_CR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User_Group]: { foreignKey: "WB_USRGRP_ID", foreignKeyImmutable: true, localField: "UserGroup" },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_User_Group_PR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_User_Group_PR", // optional
    description: "Schema for WB_UsrGrpPR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRGRPPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_USRGRP_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
        },
        EFFECTIVE_END_DT: {
            type: "string",
        },
        MANUAL_IND: {
            type: "string",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
        },
        DELETED_DT: {
            type: "string",
        },
    },
});
export const WB_User_Group_PR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User_Group]: { foreignKey: "WB_USRGRP_ID", foreignKeyImmutable: true, localField: "UserGroup" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
    },
};

export const WB_User_Group_RR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_User_Group_RR", // optional
    description: "Schema for WB_UsrGrpRR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRGRPRR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_USRGRP_ID: {
            type: "number",
        },
        WB_DOMITEM_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_User_Group_RR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User_Group]: { foreignKey: "WB_USRGRP_ID", foreignKeyImmutable: true, localField: "UserGroup" },
        //[PASchema.esWB_Customer]:        { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer'},
        [PASchema.esWB_Domain_Item]: {
            foreignKey: "WB_DOMITEM_ID",
            foreignKeyImmutable: true,
            localField: "DomainItem",
        },
    },
    hasOne: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
    },
};

export const WB_User_Group_UR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_User_Group_UR", // optional
    description: "Schema for WB_UsrGrpUR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_USRGRPUR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_USRGRP_ID: {
            type: "number",
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        MODIFIED_BY: {
            type: "string",
            length: 256,
        },
    },
});
export const WB_User_Group_UR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User_Group]: { foreignKey: "WB_USRGRP_ID", foreignKeyImmutable: true, localField: "UserGroup" },
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
};

// Metric Definition BO
export const WB_Metric_Definition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Metric_Definition", // optional
    description: "Schema for WB_MtrDfn Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_MTRDFN_ID: {
            type: "number",
            id: true,
            required: true,
        },
        METRIC_ID: {
            type: "string",
            length: 50,
        },
        METRIC_NAME: {
            type: "string",
            length: 256,
        },
        METRIC_NOTES: {
            type: "string",
            length: 1333,
        },
        METRIC_TYPE: {
            type: "string",
            length: 50,
        },
        METRIC_DATATYPE: {
            type: "string",
            length: 20,
        },
        WB_CUBESOURCE_ID: {
            type: "number",
        },
        METRIC_USAGE: {
            type: "string",
            length: 50,
        },
        VISIBLE_IND: {
            type: "string",
            length: 1,
        },
        EDITABLE_IND: {
            type: "string",
            length: 1,
        },
        ROWCALC_WB_IND: {
            type: "string",
            length: 1,
        },
        DISPLAY_TYPE: {
            type: "string",
            length: 50,
        },
        DECIMAL_COUNT: {
            type: "number",
        },
        PERCENT_IND: {
            type: "string",
            length: 1,
        },
        MINVALUE_IND: {
            type: "string",
            length: 1,
        },
        MINVALUE: {
            type: "number",
        },
        MAXVALUE_IND: {
            type: "string",
            length: 1,
        },
        MAXVALUE: {
            type: "number",
        },
        METRIC_META_ID: {
            type: "string",
            length: 50,
        },
        METRIC_VERSION: {
            type: "string",
            length: 50,
        },
        METRIC_GROUP: {
            type: "string",
            length: 50,
        },
        SORT_ORDER_UI: {
            type: "number",
        },
        COPYPOLICY: {
            type: "string",
            length: 1,
        },
        FORMULA: {
            type: "string",
            length: 500,
        },
        WRITEBACK_METRIC_ID: {
            type: "string",
            length: 50,
        },
        WRITEBACK_FORMULA: {
            type: "string",
            length: 500,
        },
        UOM_NUM: {
            type: "string",
            length: 50,
        },
        UOM_AMOUNT_TYPE_NUM: {
            type: "string",
            length: 50,
        },
        UOM_CONVERTER_NUM: {
            type: "string",
            length: 50,
        },
        UOM_DENOM: {
            type: "string",
            length: 50,
        },
        UOM_AMOUNT_TYPE_DENOM: {
            type: "string",
            length: 50,
        },
        UOM_CONVERTER_DENOM: {
            type: "string",
            length: 50,
        },
        TOTALPOLICY: {
            type: "string",
            length: 1,
        },
        TOTAL_FORMULA: {
            type: "string",
            length: 256,
        },
        RECORD_PROPERTIES: {
            type: "string",
            length: 256,
        },
        TOTAL_AGGREGATION_TERMS: {
            type: "string",
            length: 1333,
        },
        METRIC_FORMAT: {
            type: "string",
            length: 1333,
        },
        OPTIONS: {
            type: "string",
            length: 256,
        },
        WB_SUBJECTAREA_ID: {
            type: "number",
        },
        SUBJECTAREA_COLUMNNAME: {
            type: "string",
            length: 128,
        },
        SCENARIO_COLUMNNAME: {
            type: "string",
            length: 128,
        },
        CURRENCY_IND: {
            type: "string",
            length: 1,
        },
        FILTER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        GL_ACCOUNT_FILTER_IND: {
            type: "string",
            length: 1,
        },
        EVTS_TYPE_FILTER_IND: {
            type: "string",
            length: 1,
        },
        PLOT_AXIS_NAME: {
            type: "string",
            length: 256,
        },
        PLOT_DATA_SHAPE: {
            type: "string",
            length: 128,
        },
        PLOT_DATA_COLOR: {
            type: "string",
            length: 128,
        },
        PLOT_DATA_PATTERN: {
            type: "string",
            length: 128,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Metric_Definition_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Subject_Area]: {
            foreignKey: "WB_SUBJECTAREA_ID",
            foreignKeyImmutable: true,
            localField: "SubjectArea",
        },
        [PASchema.esWB_CubeSource]: {
            foreignKey: "WB_CUBESOURCE_ID",
            foreignKeyImmutable: true,
            localField: "CubeSource",
        },
    },
    hasMany: {
        [PASchema.esWB_MetricDefinition_GLAccount]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinitionGLAccounts",
        },
        [PASchema.esWB_MetricDefinition_EventSpend_Type]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinitionEvtSTypes",
        },
        [PASchema.esWB_MetricDefinition_Component]: [
            {
                foreignKey: "WB_MTRDFN_ID",
                foreignKeyImmutable: true,
                localField: "MetricComponents",
            },
            {
                foreignKey: "WB_MTRDFN_ID_COMP",
                foreignKeyImmutable: true,
                localField: "MetricUsedBy",
            },
        ],
    },
};

export const WB_Metric_Definition_Component = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_MetricR", // optional
    description: "Schema for WB_MtrDfnR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_MTRDFNR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MTRDFN_ID: {
            type: "number",
            id: true,
        },
        DEPENDENCY_TYPE: {
            type: "string",
            length: 20,
        },
        WB_MTRDFN_ID_COMP: {
            type: "number",
            id: true,
        },
        WB_CUBESOURCEDSR_ID: {
            type: "number",
            id: true,
        },
        WB_DATAOBJECT_COLUMN_ID: {
            type: "number",
            id: true,
        },
        METRIC_META_ID: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_MetricR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinition",
        },
        [PASchema.esWB_CubeSource_DataSource]: {
            foreignKey: "WB_CUBESOURCEDSR_ID",
            foreignKeyImmutable: true,
            localField: "CubeSourceDSR",
        },
        [PASchema.esWB_DataObject_Column]: {
            foreignKey: "WB_DATAOBJECT_COLUMN_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectColumn",
        },
    },
};

export const WB_MetricDefinition_GLAccount = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_MetricDefinition_GLAccount", // optional
    description: "Schema for WB_MtrDfnGLR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_MTRDFNGLR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MTRDFN_ID: {
            type: "number",
        },
        WB_GLACCT_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_MetricDefinition_GLAccount_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinition",
        },
        [PASchema.esWB_General_Ledger_Account]: {
            foreignKey: "WB_GLACCT_ID",
            foreignKeyImmutable: true,
            localField: "GLAccount",
        },
    },
};

export const WB_MetricDefinition_EventSpend_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_MetricDefinition_EventSpend_Type", // optional
    description: "Schema for WB_MtrDfnEvtSTypeR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_MTRDFNEVTSTYPER_ID: {
            type: "number",
            default: "",
            id: true,
            required: true,
        },
        WB_MTRDFN_ID: {
            type: "number",
            default: "",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
            default: "",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
            default: "",
        },
        MODIFIED_DTTS: {
            type: "number",
            default: "",
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_MetricDefinition_EventSpend_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinition",
        },
        [PASchema.esWB_Event_Spend_Type]: {
            foreignKey: "WB_EVTSTYPE_ID",
            foreignKeyImmutable: true,
            localField: "EventSpendType",
        },
    },
};

export const WB_Metric_View = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Metric_View", // optional
    description: "Schema for WB_MtrView Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_MTRVIEW_ID: {
            type: "number",
            id: true,
            required: true,
        },
        METRIC_VIEW_ID: {
            type: "string",
            length: 50,
        },
        METRIC_VIEW_NAME: {
            type: "string",
            length: 256,
        },
        METRIC_VIEW_USAGE: {
            type: "string",
            length: 50,
        },
        WB_CUBESOURCE_ID: {
            type: "number",
        },
        OPTIONS: {
            type: "string",
            length: 256,
        },
        SORT_ORDER: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Metric_View_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Metric_View_Metric]: {
            foreignKey: "WB_MTRVIEW_ID",
            foreignKeyImmutable: true,
            localField: "Metrics",
        },
    },
};

export const WB_Metric_View_Metric = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Metric_View", // optional
    description: "Schema for WB_MtrViewR Records", // optional
    type: "object",
    track: true,
    properties: {
        WB_MTRVIEWR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MTRVIEW_ID: {
            type: "number",
        },
        WB_MTRDFN_ID: {
            type: "number",
        },
        WB_CUBESOURCEDSR_ID: {
            type: "number",
        },
        WB_DATAOBJECT_COLUMN_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Metric_View_Metric_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Metric_View]: {
            foreignKey: "WB_MTRVIEW_ID",
            foreignKeyImmutable: true,
            localField: "MetricView",
        },
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinition",
        },
        [PASchema.esWB_CubeSource_DataSource]: {
            foreignKey: "WB_CUBESOURCEDSR_ID",
            foreignKeyImmutable: true,
            localField: "CubeSourceDSR",
        },
        [PASchema.esWB_DataObject_Column]: {
            foreignKey: "WB_DATAOBJECT_COLUMN_ID",
            foreignKeyImmutable: true,
            localField: "DataObjectColumn",
        },
    },
};

export const WB_Timing = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Timings", // optional
    description: "Schema for Timing records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TIMING_ID: {
            type: "number",
            id: true,
            required: true,
        },
        TIMER_NAME: {
            type: "string",
            length: 100,
        },
        START_DTTS: {
            type: "number",
        },
        END_DTTS: {
            type: "number",
        },
        ERROR_IND: {
            type: "string",
            length: 1,
        },
        ERROR_DTTS: {
            type: "number",
        },
        WB_APP_ID: {
            type: "number",
        },
        APP_ID: {
            type: "string",
            length: 50,
        },
        APPMGR_ID: {
            type: "string",
            length: 50,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DURATION_SECONDS: {
            type: "number",
        },
    },
});
export const WB_Timing_JSData_RELs = {};

// Report schema
export const WB_Report = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Sources", // optional
    description: "Schema for Source records", // optional
    type: "object",
    track: true,
    properties: {
        WB_REPORT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SCHEDULE_ID: {
            type: "number",
        },
        REPORT_ID: {
            type: "string",
            length: 50,
        },
        REPORT_NAME: {
            type: "string",
            length: 256,
        },
        REPORT_DESCRIPTION: {
            type: "string",
            length: 256,
        },
        WB_COMPANY_ID: {
            type: "number",
        },

        REPORT_SUBJECT: {
            type: "string",
            length: 50,
        },
        REPORT_KEYWORDS: {
            type: "string",
            length: 256,
        },
        REPORT_TYPE_ID: {
            type: "string",
            length: 50,
        },
        SORT_ORDER: {
            type: "number",
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        METRIC_VERSIONS: {
            type: "string",
            length: 256,
        },
        WB_CUSTH_ID: {
            type: "number",
        },
        CUST_OUTPUT_LEVEL: {
            type: "string",
            length: 256,
        },
        CUSTOMER_NODE_SELECTED: {
            type: "string",
            length: 1333,
        },
        WB_PRDH_ID: {
            type: "number",
        },
        PRD_OUTPUT_LEVEL: {
            type: "string",
            length: 256,
        },
        PRODUCT_NODE_SELECTED: {
            type: "string",
            length: 1333,
        },
        WB_PERIODH_ID: {
            type: "number",
        },
        PERIOD_OUTPUT_LEVEL: {
            type: "string",
            length: 256,
        },
        PERIOD_NODE_SELECTED: {
            type: "string",
            length: 1333,
        },
        EXTRACT_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Report_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Report_Metric]: [
            {
                foreignKey: "WB_REPORT_ID",
                foreignKeyImmutable: true,
                localField: "ReportMetrics",
            },
        ],
    },
    belongsTo: {
        [PASchema.esWB_Company]: [{ foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" }],
        [PASchema.esWB_Schedule]: [{ foreignKey: "WB_SCHEDULE_ID", foreignKeyImmutable: true, localField: "Schedule" }],
    },
};

export const WB_Report_Metric = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Sources", // optional
    description: "Schema for Source records", // optional
    type: "object",
    track: true,
    properties: {
        WB_REPORTMETRICR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_REPORT_ID: {
            type: "number",
        },
        WB_MTRDFN_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        METRIC_VERSION_ID: {
            type: "string",
            length: 20,
        },
        METRIC_NAME_OVRD: {
            type: "string",
            length: 256,
        },
        METRIC_LAYOUT_OPTIONS: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Report_Metric_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Report]: { foreignKey: "WB_REPORT_ID", foreignKeyImmutable: true, localField: "Report" },
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinition",
        },
    },
};

export const WB_Report_Export = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Report Export", // optional
    description: "Schema for Report Export records", // optional
    type: "object",
    track: true,
    properties: {
        WB_REPORT_EXPORT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_REPORT_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        WB_PERIOD_ID: {
            type: "number",
        },
        WB_MTRDFN_ID: {
            type: "number",
        },
        METRIC_VERSION_ID: {
            type: "string",
            length: 10,
        },
        METRIC_NAME_OVRD: {
            type: "string",
            length: 256,
        },
        METRIC_SORT_ORDER: {
            type: "number",
        },
        METRIC_ID: {
            type: "string",
            length: 256,
        },
        METRIC_VALUE: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Report_Export_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Report]: { foreignKey: "WB_REPORT_ID", foreignKeyImmutable: true, localField: "Report" },
        [PASchema.esWB_Metric_Definition]: {
            foreignKey: "WB_MTRDFN_ID",
            foreignKeyImmutable: true,
            localField: "MetricDefinition",
        },
    },
};

//New UI Framework

//UI Framework
export const WB_UI_Profile = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_Profile", // optional
    description: "Schema for WB_UI_Profile records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_PROFILE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        PROFILE_ID: {
            type: "string",
            length: 50,
        },
        PROFILE_NAME: {
            type: "string",
            length: 256,
        },
        VIEW_ROLES: {
            type: "string",
            length: 1333,
        },
        SORT_ORDER: {
            type: "number",
            length: 10,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 500,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_Profile_JSData_RELs = {};

export const WB_UI_AppSuite_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_AppSuite_Type", // optional
    description: "Schema for WB_UI_AppSuiteM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_APPSUITEM_ID: {
            type: "number",
            id: true,
            required: true,
        },
        APPSUITETYPE_ID: {
            type: "string",
            length: 50,
        },
        APPSUITETYPE_NAME: {
            type: "string",
            length: 256,
        },
        UI5_ICON: {
            type: "string",
            length: 500,
        },
        SORT_ORDER: {
            type: "number",
            length: 10,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 500,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_AppSuite_Type_JSData_RELs = {};

export const WB_UI_AppSuite = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_AppSuite", // optional
    description: "Schema for WB_UI_AppSuite records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_APPSUITE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_UI_APPSUITEM_ID: {
            type: "number",
        },
        WB_UI_PROFILE_ID: {
            type: "number",
        },
        APPSUITE_ID: {
            type: "string",
            length: 50,
        },
        APPSUITE_NAME: {
            type: "string",
            length: 256,
        },
        APPSUITE_DESCRIPTION: {
            type: "string",
            length: 500,
        },
        SORT_ORDER: {
            type: "number",
            length: 10,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 500,
        },
        UI5_ICON: {
            type: "string",
            length: 500,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_AppSuite_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_UI_AppSuite_Type]: {
            foreignKey: "WB_UI_APPSUITEM_ID",
            foreignKeyImmutable: true,
            localField: "AppSuiteType",
        },
        [PASchema.esWB_UI_Profile]: {
            foreignKey: "WB_UI_PROFILE_ID",
            foreignKeyImmutable: true,
            localField: "Profile",
        },
    },
    hasMany: {
        [PASchema.esWB_UI_AppSuite_App_Relationship]: {
            foreignKey: "WB_UI_APPSUITE_ID",
            foreignKeyImmutable: true,
            localField: "AppSuiteRels",
        },
    },
};

export const WB_UI_AppSuite_App_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_AppSuiteAR", // optional
    description: "Schema for WB_UI_AppSuiteAR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_APPSUITEAR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_UI_APPSUITE_ID: {
            type: "number",
        },
        WB_UI_APP_ID: {
            type: "number",
        },
        APP_NAME_OVRD: {
            type: "string",
            length: 256,
        },
        APP_DESC_OVRD: {
            type: "string",
            length: 512,
        },
        GROUP_NAME_OVRD: {
            type: "string",
            length: 256,
        },
        UI5_ICON_OVRD: {
            type: "string",
            length: 256,
        },
        LAUNCH_POLICY: {
            type: "string",
            length: 50,
        },
        AUTO_LAUNCH_IND: {
            type: "string",
            length: 1,
        },
        SORT_ORDER: {
            type: "number",
            length: 10,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 500,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_AppSuite_App_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_UI_AppSuite]: {
            foreignKey: "WB_UI_APPSUITE_ID",
            foreignKeyImmutable: true,
            localField: "PA-AppSuite",
            createIndex: true,
        },
        [PASchema.esWB_UI_Application]: {
            foreignKey: "WB_UI_APP_ID",
            foreignKeyImmutable: true,
            localField: "Application",
        },
    },
};

export const WB_UI_Application = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_App", // optional
    description: "Schema for WB_UI_App records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_APP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        APP_ID: {
            type: "string",
            length: 50,
        },
        APP_NAME: {
            type: "string",
            length: 256,
        },
        APP_DESC: {
            type: "string",
            length: 512,
        },
        GROUP_NAME: {
            type: "string",
            length: 256,
        },
        LAUNCH_POLICY: {
            type: "string",
            length: 50,
        },
        MODULE_BAR_POLICY: {
            type: "string",
            length: 50,
        },
        TASK_BAR_POLICY: {
            type: "string",
            length: 50,
        },
        STARTUP_POLICY: {
            type: "string",
            length: 10,
        },
        APPFINDER_POLICY: {
            type: "string",
            length: 50,
        },
        REPORT_MODE_DFLT: {
            type: "string",
            length: 20,
        },
        SORT_ORDER: {
            type: "number",
            length: 10,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        UI5_ICON: {
            type: "string",
            length: 256,
        },
        VIEW_ROLES: {
            type: "string",
            length: 500,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_Application_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_UI_App_Report]: {
            foreignKey: "WB_UI_APP_ID",
            foreignKeyImmutable: true,
            localField: "ReportTiles",
        },
        [PASchema.esWB_UI_AppModule]: { foreignKey: "WB_UI_APP_ID", foreignKeyImmutable: true, localField: "Modules" },
    },
};

export const WB_UI_AppModule = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_AppModule", // optional
    description: "Schema for WB_UI_AppModule records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_APPMODULE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_UI_APP_ID: {
            type: "number",
        },
        WB_UI_APPEXEC_ID: {
            type: "number",
        },
        APPMODULE_SHORTNAME: {
            type: "string",
            length: 50,
        },
        APPMODULE_NAME: {
            type: "string",
            length: 256,
        },
        COMMENTS: {
            type: "string",
            length: 1333,
        },
        EXEC_PARAMETERS: {
            type: "string",
            length: 1333,
        },
        KEYWORDS: {
            type: "string",
            length: 1333,
        },
        SORT_ORDER: {
            type: "number",
            length: 10,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 500,
        },
        EDIT_ROLES: {
            type: "string",
            length: 1333,
        },
        VIEW_ROLES: {
            type: "string",
            length: 1333,
        },
        UI5_ICON: {
            type: "string",
            length: 256,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        PLACEMENT_POLICY: {
            type: "string",
            length: 50,
        },
        LAUNCH_POLICY: {
            type: "string",
            length: 50,
        },
        STARTUP_POLICY: {
            type: "string",
            length: 10,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_AppModule_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_UI_Application]: {
            foreignKey: "WB_UI_APP_ID",
            foreignKeyImmutable: true,
            localField: "Application",
            createIndex: true,
        },
        [PASchema.esWB_UI_AppExecutable]: {
            foreignKey: "WB_UI_APPEXEC_ID",
            foreignKeyImmutable: true,
            localField: "Executable",
        },
    },
};

export const WB_UI_AppExecutable = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_AppExec", // optional
    description: "Schema for WB_UI_AppExec records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_APPEXEC_ID: {
            type: "number",
            id: true,
            required: true,
        },
        APPEXEC_ID: {
            type: "string",
            length: 50,
        },
        APPEXEC_NAME: {
            type: "string",
            length: 256,
        },
        APPEXEC_TYPE: {
            type: "string",
            length: 50,
        },
        WB_UI_REPORTTILE_ID: {
            type: "number",
        },
        EDIT_ROLES: {
            type: "string",
            length: 1333,
        },
        VIEW_ROLES: {
            type: "string",
            length: 1333,
        },
        BO_CLASS: {
            type: "string",
            length: 256,
        },
        BO_CREATEOPTIONS: {
            type: "string",
            length: 1333,
        },
        BO_CREATENEWOPTIONS: {
            type: "string",
            length: 1333,
        },
        BO_CREATENEWWIZARD: {
            type: "string",
            length: 256,
        },
        BO_AFTERCREATENEWWIZARD: {
            type: "string",
            length: 256,
        },
        BO_COPYWIZARD: {
            type: "string",
            length: 256,
        },
        BO_AFTERCOPYWIZARD: {
            type: "string",
            length: 256,
        },
        BO_LOADOPTIONS: {
            type: "string",
            length: 1333,
        },
        BO_COPYOPTIONS: {
            type: "string",
            length: 1333,
        },
        BO_CREATENEWONSESSSIONCREATE: {
            type: "string",
            length: 1,
        },
        SEARCH_CLASS: {
            type: "string",
            length: 256,
        },
        SEARCH_OPTIONS: {
            type: "string",
            length: 1333,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 1333,
        },
        UI5_COMPONENT_ID: {
            type: "string",
            length: 256,
        },
        UI5_ICON: {
            type: "string",
            length: 256,
        },
        HEADERBAR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        UI5_HEADERBAR_ID: {
            type: "string",
            length: 256,
        },
        FOOTERBAR_SHOW_IND: {
            type: "string",
            length: 1,
        },
        UI5_FOOTERBAR_ID: {
            type: "string",
            length: 256,
        },
        UI5_RESOURCE_ROOT: {
            type: "string",
            length: 500,
        },
        UI5_RESOURCE_ROOT_PATH: {
            type: "string",
            length: 500,
        },
        TB_CREATENEW_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_SEARCH_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_SAVE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_DELETE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_CLOSE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_COPY_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_CREATENOTE_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_RELOAD_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_ID_DIALOG_SHOW_IND: {
            type: "string",
            length: 1,
        },
        TB_FILELIST_SHOW_IND: {
            type: "string",
            length: 1,
        },
        HELP_URL: {
            type: "string",
            length: 1333,
        },
        NAVIGATION_BO_CACHE_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_AppExecutable_JSData_RELs = {};

export const WB_UI_Usage = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_Usage", // optional
    description: "Schema for WB_UI_Usage records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_USAGE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        USAGE: {
            type: "string",
            length: 50,
        },
        SUBUSAGE: {
            type: "string",
            length: 50,
        },
        CLIP: {
            type: "string",
            length: 1333,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        WB_SESSION_ID: {
            type: "number",
        },
        WB_UI_APP_ID: {
            type: "number",
        },
        WB_UI_APPMODULE_ID: {
            type: "number",
        },
        BO_WB_ID: {
            type: "number",
        },
        BO_UI_ID: {
            type: "string",
            length: 50,
        },
        BO_NAME: {
            type: "string",
            length: 256,
        },
        START_DTTS: {
            type: "number",
        },
        END_DTTS: {
            type: "number",
        },
        ERROR_DTTS: {
            type: "number",
        },
        ERROR_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
    },
});
export const WB_UI_Usage_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_UI_Application]: {
            foreignKey: "WB_UI_APP_ID",
            foreignKeyImmutable: true,
            localField: "Application",
        },
        [PASchema.esWB_UI_AppModule]: {
            foreignKey: "WB_UI_APPMODULE_ID",
            foreignKeyImmutable: true,
            localField: "Module",
        },
        [PASchema.esWB_User]: { foreignKey: "WB_AUTHUSR_ID", foreignKeyImmutable: true, localField: "User" },
    },
};

export const WB_UI_App_Report = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UI_App_Report", // optional
    description: "Schema for WB_UI_App_Report records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UI_APP_REPORT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_UI_APP_ID: {
            type: "number",
        },
        WB_REPORTTILE_ID: {
            type: "number",
        },
        WB_UI_APPMODULE_ID: {
            type: "number",
        },
        TREE_PATH: {
            type: "string",
            length: 256,
        },
        SORT_ORDER: {
            type: "number",
            length: 10,
        },
        RENDER_OPTIONS: {
            type: "string",
            length: 500,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_UI_App_Report_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_UI_Application]: {
            foreignKey: "WB_UI_APP_ID",
            foreignKeyImmutable: true,
            localField: "Application",
            createIndex: true,
        },
        [PASchema.esWB_ReportTile]: {
            foreignKey: "WB_REPORTTILE_ID",
            foreignKeyImmutable: true,
            localField: "ReportTile",
        },
    },
};

// License
export const WB_License = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_License", // optional
    description: "Schema for WB_License records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LICENSE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        LICENSE_TYPE: {
            type: "string",
            length: 50,
        },
        LICENSE_KEY: {
            type: "string",
            length: 256,
        },
        WB_BUSINESSUNIT_ID: {
            type: "string",
            length: 1333,
        },
        WB_REPORTTILE_ID: {
            type: "string",
            length: 1,
        },
        WB_UI_APPEXEC_ID: {
            type: "string",
            length: 1333,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_License_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
        [PASchema.esWB_UI_AppExecutable]: {
            foreignKey: "WB_UI_APPEXEC_ID",
            foreignKeyImmutable: true,
            localField: "Executable",
        },
        [PASchema.esWB_ReportTile]: {
            foreignKey: "WB_REPORTTILE_ID",
            foreignKeyImmutable: true,
            localField: "ReportTile",
        },
    },
};

// Benchmark
export const WB_Benchmark = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Benchmark", // optional
    description: "Schema for WB_Benchmark records", // optional
    type: "object",
    track: true,
    properties: {
        WB_BENCHMARK_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_CUST_ID: {
            type: "number",
        },
        PLANNING_LEVEL_ID: {
            type: "string",
            length: 50,
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        BENCHMARK_TYPE_ID: {
            type: "string",
            length: 50,
        },
        BETTER_DIRECTION: {
            type: "string",
            length: 20,
        },
        MIN_THRESHOLD: {
            type: "number",
        },
        MAX_THRESHOLD: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Benchmark_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
    },
};

// Schedule
export const WB_Schedule = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Schedule", // optional
    description: "Schema for Schedule records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SCHEDULE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_MDSET_ID: {
            type: "number",
            required: true,
        },
        WB_SALESORG_ID: {
            type: "number",
            required: true,
        },
        SCHEDULE_NAME: {
            type: "string",
            length: 50,
        },
        SCHEDULE_TYPE: {
            type: "string",
            length: 20,
        },
        SCHEDULE_START_DTTS: {
            type: "number",
        },
        SCHEDULE_END_DTTS: {
            type: "number",
        },
        LAST_RUN_STAMP: {
            type: "string",
            length: 50,
        },
        RULE_TIMEZONE: {
            type: "string",
            length: 20,
        },
        RULE_FREQUENCY: {
            type: "string",
            length: 20,
        },
        RULE_COUNT: {
            type: "number",
        },
        RULE_INTERVAL: {
            type: "number",
        },
        RULE_WEEK_START_DAY: {
            type: "string",
            length: 20,
        },
        RULE_WEEK_DAYS: {
            type: "string",
            length: 100,
        },
        RULE_MONTHS: {
            type: "string",
            length: 100,
        },
        RULE_MONTH_LAST_DAY_IND: {
            type: "string",
            length: 1,
        },
        RULE_SET_POSITIONS: {
            type: "string",
            length: 100,
        },
        RULE_MONTH_DAYS: {
            type: "string",
            length: 100,
        },
        RULE_YEAR_DAYS: {
            type: "string",
            length: 100,
        },
        RULE_WEEK_NUMBERS: {
            type: "string",
            length: 100,
        },
        RULE_BY_HOURS: {
            type: "string",
            length: 100,
        },
        RULE_BY_MINUTES: {
            type: "string",
            length: 100,
        },
        RULE_BY_SECONDS: {
            type: "string",
            length: 100,
        },
        PROCESSED_START_DTTS: {
            type: "number",
        },
        PROCESSED_END_DTTS: {
            type: "number",
        },
        PROCESS_STATUS: {
            type: "string",
            length: 50,
        },
        OBJECT_TYPE_ID: {
            type: "string",
            length: 50,
        },
        OBJECT_WB_ID: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Schedule_JSData_RELs = {};

///Search
export const WB_Search = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Search", // optional
    description: "Schema for Search records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SEARCH_ID: {
            type: "number",
            id: true,
            required: true,
        },
        SEARCH_ID: {
            type: "string",
            length: 50,
        },
        SEARCH_TYPE: {
            type: "string",
            length: 50,
        },
        SEARCH_NAME: {
            type: "string",
            length: 256,
        },
        COMMENTS: {
            type: "string",
            length: 1333,
        },
        AUTOSEARCH_IND: {
            type: "string",
            length: 1,
        },
        BO_OPTIONS: {
            type: "string",
            length: 1333,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Search_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Search_Profile]: {
            foreignKey: "WB_SEARCH_ID",
            foreignKeyImmutable: true,
            localField: "SearchProfiles",
        },
    },
};

export const WB_Search_Profile = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SearchProfile", // optional
    description: "Schema for Search Profile records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SEARCH_PROFILE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SEARCH_ID: {
            type: "number",
        },
        PROFILE_ID: {
            type: "string",
            length: 50,
        },
        PROFILE_NAME: {
            type: "string",
            length: 256,
        },
        SORT_ORDER: {
            type: "number",
        },
        DEFAULT_IND: {
            type: "string",
            length: 1,
        },
        ROW_LIMIT: {
            type: "number",
        },
        DATASOURCE_TYPE: {
            type: "string",
            length: 50,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        SQL_QUERY: {
            type: "string",
            length: 5000,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Search_Profile_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Search]: {
            foreignKey: "WB_SEARCH_ID",
            foreignKeyImmutable: true,
            localField: "Search",
        },
    },
    hasMany: {
        [PASchema.esWB_Search_ProfileCR]: {
            foreignKey: "WB_SEARCH_PROFILE_ID",
            foreignKeyImmutable: true,
            localField: "SearchProfileCRs",
        },
        [PASchema.esWB_Search_ProfileFCR]: {
            foreignKey: "WB_SEARCH_PROFILE_ID",
            foreignKeyImmutable: true,
            localField: "SearchProfileFCRs",
        },
        [PASchema.esWB_Search_ProfileGCR]: {
            foreignKey: "WB_SEARCH_PROFILE_ID",
            foreignKeyImmutable: true,
            localField: "SearchProfileGCRs",
        },
    },
};

export const WB_Search_ProfileCR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SearchProfileCR", // optional
    description: "Schema for Search ProfileCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SEARCH_PROFILECR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SEARCH_PROFILE_ID: {
            type: "number",
        },
        COLUMN_ID: {
            type: "string",
            length: 50,
        },
        COLUMN_NAME: {
            type: "string",
            length: 256,
        },
        SORT_ORDER: {
            type: "number",
        },
        COLUMN_METATYPE: {
            type: "string",
            length: 50,
        },
        COLUMN_DATATYPE: {
            type: "string",
            length: 50,
        },
        COLUMN_LENGTH: {
            type: "number",
        },
        COLUMN_PRECISION: {
            type: "number",
        },
        DISPLAYTYPE: {
            type: "string",
            length: 50,
        },
        DISPLAYFORMAT: {
            type: "string",
            length: 50,
        },
        DISPLAYDOMAIN: {
            type: "string",
            length: 5000,
        },
        ALIGNMENT: {
            type: "string",
            length: 50,
        },
        COLUMNWIDTHCHARS: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Search_ProfileCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Search_Profile]: {
            foreignKey: "WB_SEARCH_PROFILE_ID",
            foreignKeyImmutable: true,
            localField: "SearchProfile",
        },
    },
    hasMany: {},
};

export const WB_Search_ProfileFCR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SearchProfileFCR", // optional
    description: "Schema for Search ProfileFCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SEARCH_PROFILEFCR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SEARCH_PROFILE_ID: {
            type: "number",
        },
        FILTER_NAME: {
            type: "string",
            length: 256,
        },
        SORT_ORDER: {
            type: "number",
        },
        COLUMN_ID: {
            type: "string",
            length: 50,
        },
        MULTISELECT_IND: {
            type: "string",
            length: 1,
        },
        QUICK_SEARCH_IND: {
            type: "string",
            length: 1,
        },
        HIDDEN_IND: {
            type: "string",
            length: 1,
        },
        REQUIRED_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Search_ProfileFCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Search_Profile]: {
            foreignKey: "WB_SEARCH_PROFILE_ID",
            foreignKeyImmutable: true,
            localField: "SearchProfile",
        },
    },
    hasMany: {},
};

export const WB_Search_ProfileGCR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SearchProfileGCR", // optional
    description: "Schema for Search ProfileGCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SEARCH_PROFILEGCR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_SEARCH_PROFILE_ID: {
            type: "number",
        },
        SORT_ORDER: {
            type: "number",
        },
        UI_COLUMN_TYPE: {
            type: "string",
            length: 50,
        },
        COLUMN_NAME: {
            type: "string",
            length: 256,
        },
        COLUMN_ID: {
            type: "string",
            length: 50,
        },
        HIDDEN_IND: {
            type: "string",
            length: 1,
        },
        HYPERLINK_IND: {
            type: "string",
            length: 1,
        },
        JOIN_TITLE: {
            type: "string",
            length: 256,
        },
        JOIN_COLUMNS: {
            type: "string",
            length: 1333,
        },
        JOIN_SEPARATOR: {
            type: "string",
            length: 50,
        },
        JOIN_ALIGNMENT: {
            type: "string",
            length: 50,
        },
        JOIN_COLUMNWIDTHCHARS: {
            type: "number",
        },
        LOCK_TITLE: {
            type: "string",
            length: 256,
        },
        LOCK_CLASS: {
            type: "string",
            length: 50,
        },
        LOCK_COLUMN_ID: {
            type: "string",
            length: 50,
        },
        LOCK_SHOW_ICON_IND: {
            type: "string",
            length: 1,
        },
        LOCK_SHOW_OWNER_IND: {
            type: "string",
            length: 1,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Search_ProfileGCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Search_Profile]: {
            foreignKey: "WB_SEARCH_PROFILE_ID",
            foreignKeyImmutable: true,
            localField: "SearchProfile",
        },
    },
    hasMany: {},
};

export const WB_Staging = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Staging", // optional
    description: "Schema for Search WB_Staging records", // optional
    type: "object",
    track: true,
    properties: {
        WB_STAGING_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        FILE_NAME: {
            type: "string",
            length: 256,
        },
        FILE_DTTS: {
            type: "number",
        },
        RECORD_COUNT: {
            type: "number",
        },
        ERROR_COUNT: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Staging_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObject",
        },
    },
};

export const WB_Staging_ClientRaw = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Staging_ClientRaw", // optional
    description: "Schema for Search WB_Staging_ClientRaw records", // optional
    type: "object",
    track: true,
    properties: {
        WB_STAGING_CLIENTRAW_ID: {
            type: "number",
            id: true,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        RECORD_SET: {
            type: "string",
            length: 256,
        },
        UPLOAD_DTTS: {
            type: "number",
        },
        RECORD_COUNT: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Staging_ClientRaw_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObject",
        },
    },
};

export const WB_Staging_Archive = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Staging_Archive", // optional
    description: "Schema for Search WB_Staging_Archive records", // optional
    type: "object",
    track: true,
    properties: {
        WB_STAGING_ARCHIVE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_DATAOBJECT_ID: {
            type: "number",
        },
        SOURCE_TYPE: {
            type: "string",
            length: 50,
        },
        RECORD_SET: {
            type: "string",
            length: 256,
        },
        RECORD_COUNT: {
            type: "number",
        },
        ERROR_COUNT: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_Staging_Archive_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataObject]: {
            foreignKey: "WB_DATAOBJECT_ID",
            foreignKeyImmutable: true,
            localField: "DataObject",
        },
    },
};

export const WB_PEA_Event_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Override", // optional
    description: "Schema for Search WB_Override records", // optional
    type: "object",
    track: true,
    properties: {
        WB_OVERRIDE_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_AUTHUSR_ID: {
            type: "number",
        },
        WB_EVT_ID: {
            type: "number",
        },
        OVERRIDE_ID: {
            type: "string",
            length: 50,
        },
        STATUS: {
            type: "string",
            length: 10,
        },
        OVERRIDE_TYPE: {
            type: "string",
            length: 10,
        },
        OVRD_INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRD_INSTORE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRD_SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRD_SHIPMENT_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_PEA_Event_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event]: {
            foreignKey: "WB_EVT_ID",
            foreignKeyImmutable: true,
            localField: "Event",
        },
    },
    hasMany: {
        [PASchema.esWB_PEA_Event_Spend_Override]: {
            foreignKey: "WB_OVERRIDE_ID",
            foreignKeyImmutable: true,
            localField: "Tactics",
        },

        [PASchema.esWB_PEA_Event_ProductGroup_Override]: {
            foreignKey: "WB_OVERRIDE_ID",
            foreignKeyImmutable: true,
            localField: "OverridePPGs",
        },
    },
};

export const WB_PEA_Event_ProductGroup_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Override_PrdGrp", // optional
    description: "Schema for Search WB_Override_PrdGrp records", // optional
    type: "object",
    track: true,
    properties: {
        WB_OVERRIDE_PRDGRP_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_OVERRIDE_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        STATUS: {
            type: "string",
            length: 10,
        },
        ACTION: {
            type: "string",
            length: 10,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_PEA_Event_ProductGroup_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PEA_Event_Override]: {
            foreignKey: "WB_OVERRIDE_ID",
            foreignKeyImmutable: true,
            localField: "OverrideTactic",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "OverridePPG",
        },
    },
};

export const WB_PEA_Event_Spend_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Override_EvtS", // optional
    description: "Schema for Search WB_Override_EvtS records", // optional
    type: "object",
    track: true,
    properties: {
        WB_OVERRIDE_EVTS_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_OVERRIDE_ID: {
            type: "number",
        },
        WB_EVTS_ID: {
            type: "number",
        },
        STATUS: {
            type: "string",
            length: 10,
        },
        ACTION: {
            type: "string",
            length: 10,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_PEA_Event_Spend_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Spend]: {
            foreignKey: "WB_EVTS_ID",
            foreignKeyImmutable: true,
            localField: "EventSpend",
        },
        [PASchema.esWB_PEA_Event_Override]: {
            foreignKey: "WB_OVERRIDE_ID",
            foreignKeyImmutable: true,
            localField: "Override",
        },
    },
    hasMany: {
        [PASchema.esWB_PEA_Event_Spend_ProductGroup_Override]: {
            foreignKey: "WB_OVERRIDE_EVTS_ID",
            foreignKeyImmutable: true,
            localField: "OverrideSpendPPGs",
        },
    },
};

export const WB_PEA_Event_Spend_ProductGroup_Override = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Override_EvtSPG", // optional
    description: "Schema for Search WB_Override_EvtSPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_OVERRIDE_EVTSPG_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_OVERRIDE_EVTS_ID: {
            type: "number",
        },
        WB_PRDGRP_ID: {
            type: "number",
        },
        STATUS: {
            type: "string",
            length: 10,
        },
        ACTION: {
            type: "string",
            length: 10,
        },
        OVRD_INSTORE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRD_INSTORE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRD_SHIPMENT_START_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        OVRD_SHIPMENT_END_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});

export const WB_PEA_Event_Spend_ProductGroup_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PEA_Event_Spend_Override]: {
            foreignKey: "WB_OVERRIDE_EVTS_ID",
            foreignKeyImmutable: true,
            localField: "OverrideTactic",
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "OverridePPG",
        },
    },
};
// Reference by mapper

_.defaults(dctSchemaByEntitySet, {
    [PASchema.esWB_Approval]: WB_Approval,
    [PASchema.esWB_AttributeType]: WB_AttributeType,
    [PASchema.esWB_Audit_Log]: WB_Audit_Log,
    [PASchema.esWB_Auth_Provider]: WB_Auth_Provider,
    [PASchema.esWB_BaseLn]: WB_BaseLn,
    [PASchema.esWB_BaseLnMt]: WB_BaseLnMt,
    [PASchema.esWB_Baseline]: WB_Baseline,
    [PASchema.esWB_Baseline_Metrics]: WB_Baseline_Metrics,
    [PASchema.esWB_BusinessUnit]: WB_BusinessUnit,
    [PASchema.esWB_BusinessUnit_Source]: WB_BusinessUnit_Source_Relationship,
    [PASchema.esWB_BusinessUnit_User]: WB_BusinessUnit_User_Relationship,
    [PASchema.esWB_Circular_AdBlock]: WB_Circular_AdBlock,
    [PASchema.esWB_Circular_Config]: WB_Circular_Config,
    [PASchema.esWB_Circular_ConfigCR]: WB_Circular_ConfigCR,
    [PASchema.esWB_Circular]: WB_Circular,
    [PASchema.esWB_CircularCR]: WB_CircularCR,
    [PASchema.esWB_CircularPR]: WB_CircularPR,
    [PASchema.esWB_Claim_Type]: WB_Claim_Type,
    [PASchema.esWB_Claim_Type_Payment_Type]: WB_Claim_Type_Payment_Type,
    [PASchema.esWB_Claim]: WB_Claim,
    [PASchema.esWB_Claim_Plan_Match]: WB_Claim_Plan_Match,
    [PASchema.esWB_Connection]: WB_Connection,
    [PASchema.esWB_CubeSource]: WB_CubeSource,
    [PASchema.esWB_CubeSource_Dimension]: WB_CubeSource_Dimension,
    [PASchema.esWB_CubeSource_DataSource]: WB_CubeSource_DataSource,
    [PASchema.esWB_CubeSource_DataSource_Dimension]: WB_CubeSource_DataSource_Dimension,
    [PASchema.esWB_ExchangeRateM]: WB_ExchangeRateM,
    [PASchema.esWB_ExchangeRateMT]: WB_ExchangeRateMT,
    [PASchema.esWB_ExchangeRateMR]: WB_ExchangeRateMR,
    [PASchema.esWB_Custom_Column]: WB_Custom_Column,
    [PASchema.esWB_DataObject]: WB_DataObject,
    [PASchema.esWB_DataObject_Text]: WB_DataObjectT,
    [PASchema.esWB_DataObject_Column]: WB_DataObject_Column,
    [PASchema.esWB_DataObject_Column_Text]: WB_DataObject_ColumnT,
    [PASchema.esWB_DataObject_Message]: WB_DataObject_Message,
    [PASchema.esWB_DataObject_Message_Text]: WB_DataObject_MessageT,
    [PASchema.esWB_Dimension]: WB_Dimension,
    [PASchema.esWB_Domain]: WB_Domain,
    [PASchema.esWB_Domain_Item]: WB_Domain_Item,
    [PASchema.esWB_Domain_Item_Text]: WB_Domain_Item_Text,
    [PASchema.esWB_Domain_Text]: WB_Domain_Text,
    [PASchema.esWB_Entity]: WB_Entity,
    [PASchema.esWB_Entity_AttributeType]: WB_Entity_AttributeType,
    [PASchema.esWB_Event]: WB_Event,
    [PASchema.esWB_EventFR]: WB_EvtFR,
    [PASchema.esWB_Event_Accrual]: WB_Event_Accrual,
    [PASchema.esWB_Event_Customer]: WB_Event_Customer,
    [PASchema.esWB_Event_Meta]: WB_Event_Meta,
    [PASchema.esWB_Event_Override]: WB_Event_Override,
    [PASchema.esWB_Event_Product]: WB_Event_Product,
    [PASchema.esWB_Event_Product_Group]: WB_Event_Product_Group,
    [PASchema.esWB_Event_Product_Group_Override]: WB_Event_Product_Group_Override,
    [PASchema.esWB_Event_Relationship]: WB_Event_Relationship,
    [PASchema.esWB_Event_Spend]: WB_Event_Spend,
    [PASchema.esWB_Event_Spend_PrdGrp]: WB_Event_Spend_PrdGrp,
    [PASchema.esWB_Event_Spend_PrdGrp_Customer]: WB_Event_Spend_PrdGrp_Customer,
    [PASchema.esWB_Event_Spend_PrdGrp_Override]: WB_Event_Spend_PrdGrp_Override,
    [PASchema.esWB_Event_Spend_PrdGrp_Redistrib]: WB_Event_Spend_PrdGrp_Redistrib,
    [PASchema.esWB_Event_Spend_Prd]: WB_Event_Spend_Prd,
    [PASchema.esWB_Event_Spend_Type]: WB_TPM_Event_Spend_Type,
    [PASchema.esWB_Event_Spend_Type_Relationship]: WB_TPM_Event_Spend_Type_Relationship,
    [PASchema.esWB_Event_Spend_Type_Account]: WB_TPM_Event_Spend_Type_Account,
    [PASchema.esWB_Event_Tag]: WB_Event_Tag,
    [PASchema.esWB_Event_Type]: WB_Event_Type,
    [PASchema.esWB_Event_Circular]: WB_Event_Circular,
    [PASchema.esWB_EvtShipPrd]: WB_EvtShipPrd,
    [PASchema.esWB_EvtShipCPrd]: WB_EvtShipCPrd,
    [PASchema.esWB_EvtSShpPrd]: WB_EvtSShpPrd,
    [PASchema.esWB_EvtSShpPrdO]: WB_EvtSShpPrdO,
    [PASchema.esWB_File]: WB_File,
    [PASchema.esWB_Fund_Type]: WB_Fund_Type,
    [PASchema.esWB_General_Ledger]: WB_General_Ledger,
    [PASchema.esWB_General_Ledger_Account]: WB_General_Ledger_Acct,
    [PASchema.esWB_General_Ledger_Policy]: WB_General_Ledger_Rule,
    [PASchema.esWB_General_Ledger_Policy_Account]: WB_General_Ledger_Rule_Acct,
    [PASchema.esWB_Job]: WB_Job,
    [PASchema.esWB_Job_Process]: WB_Job_Process,
    [PASchema.esWB_Job_Process_Queue]: WB_Job_Process_Queue,
    [PASchema.esWB_Job_Processor]: WB_Job_Processor,
    [PASchema.esWB_Job_Processor_ConfigR]: WB_Job_Processor_ConfigR,
    [PASchema.esWB_Job_Run]: WB_JobRun,
    [PASchema.esWB_Job_Trigger]: WB_Job_Trigger,
    [PASchema.esWB_Job_Schedule_Process]: WB_Job_Schedule_Process_RelationShip,
    [PASchema.esWB_Job_Param]: WB_Job_Param,
    [PASchema.esWB_Job_ParamSR]: WB_Job_ParamSR,
    [PASchema.esWB_BatchProcess]: WB_BatchProcess,
    [PASchema.esWB_BatchScope]: WB_BatchScope,
    [PASchema.esWB_BatchScopeCR]: WB_BatchScopeCR,
    [PASchema.esWB_BatchScopeMR]: WB_BatchScopeMR,
    [PASchema.esWB_BatchScopeSR]: WB_BatchScopeSR,
    [PASchema.esWB_Lift]: WB_Lift,
    [PASchema.esWB_Loader]: WB_Loader,
    [PASchema.esWB_Loader_KeyMap]: WB_Loader_KeyMap,
    [PASchema.esWB_Loader_MetricMap]: WB_Loader_MetricMap,
    [PASchema.esWB_Loader_MetricTerm]: WB_Loader_MetricTerm,
    [PASchema.esWB_Loader_Operation]: WB_Loader_Operation,
    [PASchema.esWB_Loader_Source]: WB_Loader_Source,
    [PASchema.esWB_Meta]: WB_Meta,
    [PASchema.esWB_Meta_Tags]: WB_Meta_Tags,
    [PASchema.esWB_Meta_Text]: WB_Meta_Text,
    [PASchema.esWB_MetricDefinition_GLAccount]: WB_MetricDefinition_GLAccount,
    [PASchema.esWB_MetricDefinition_EventSpend_Type]: WB_MetricDefinition_EventSpend_Type,
    [PASchema.esWB_Metric]: WB_Metric,
    [PASchema.esWB_Metric_Definition]: WB_Metric_Definition,
    [PASchema.esWB_MetricDefinition_Component]: WB_Metric_Definition_Component,
    [PASchema.esWB_Metric_View]: WB_Metric_View,
    [PASchema.esWB_Metric_View_Metric]: WB_Metric_View_Metric,
    [PASchema.esWB_Note]: WB_Note,
    [PASchema.esWB_Note_User]: WB_Note_User,
    [PASchema.esWB_Payment]: WB_Payment,
    [PASchema.esWB_Payment_Claim]: WB_Payment_Claims,
    [PASchema.esWB_Payment_Event_Spend]: WB_Payment_Event_Spend,
    [PASchema.esWB_Payment_Event_Spend_Product_Group]: WB_Payment_Event_Spend_Product_Group,
    [PASchema.esWB_Payment_Fund]: WB_Payment_Fund,
    [PASchema.esWB_Payment_Fund_Product_Group]: WB_Payment_Fund_Product_Group,
    [PASchema.esWB_Payment_Type]: WB_Payment_Type,
    [PASchema.esWB_Plan]: WB_Plan,
    [PASchema.esWB_Plan_Funding_Metrics]: WB_Plan_Funding_Metrics,
    [PASchema.esWB_Plan_Group]: WB_Plan_Group,
    [PASchema.esWB_Plan_Management]: WB_Plan_Management,
    [PASchema.esWB_Plan_Management_Period]: WB_Plan_Management_Period,
    [PASchema.esWB_Plan_Management_User]: WB_Plan_Management_User,
    [PASchema.esWB_Plan_Management_User_Group]: WB_Plan_Management_User_Group,
    [PASchema.esWB_Plan_Override]: WB_Plan_Override,
    [PASchema.esWB_Plan_Product]: WB_Plan_Product,
    [PASchema.esWB_Plan_Product_Group]: WB_Plan_Product_Group,
    [PASchema.esWB_Plan_Redistrib_Volume_Metrics]: WB_Plan_Redistrib_Volume_Metrics,
    [PASchema.esWB_Plan_Type]: WB_Plan_Type,
    [PASchema.esWB_Plan_Type_Event_Type]: WB_Plan_Type_Event_Type,
    [PASchema.esWB_Plan_Type_Fund_Type]: WB_Plan_Type_Fund_Type,
    [PASchema.esWB_Plan_Volume_Metrics]: WB_Plan_Volume_Metrics,
    [PASchema.esWB_Plan_Approval_Metrics]: WB_Plan_Approval_Metrics,
    [PASchema.esWB_Plan_Product_Metrics]: WB_Plan_Product_Metrics,
    [PASchema.esWB_Plan_Volume_Monthly_Metrics]: WB_Plan_Volume_Monthly_Metrics,
    [PASchema.esWB_Pricing_Engine]: WB_Pricing_Engine,
    [PASchema.esWB_Pricing_Engine_Price_Relationship]: WB_Pricing_Engine_Price_Relationship,
    [PASchema.esWB_Product_Condition]: WB_Product_Condition,
    [PASchema.esWB_Product_Condition_Type]: WB_Product_Condition_Type,
    [PASchema.esWB_Queue]: WB_Queue,
    [PASchema.esWB_Queue_RunId]: WB_Queue,
    [PASchema.esWB_ReportTile]: WB_ReportTile,
    [PASchema.esWB_ReportTile_Dimension]: WB_ReportTile_Dimension,
    [PASchema.esWB_Report]: WB_Report,
    [PASchema.esWB_Report_Customer_Hierarchy]: WB_Report_CustomerH,
    [PASchema.esWB_Report_Metric]: WB_Report_Metric,
    [PASchema.esWB_Report_Export]: WB_Report_Export,
    [PASchema.esWB_Report_Product_Group_Hierarchy]: WB_Report_ProductGroupH,
    [PASchema.esWB_Report_Time_Hierarchy]: WB_Report_TimeH,
    [PASchema.esWB_Session]: WB_Session,
    [PASchema.esWB_Snapshot]: WB_Snapshot,
    [PASchema.esWB_Snapshot_Msar]: WB_SnapshotMSAR,
    [PASchema.esWB_Snapshot_Type]: WB_Snapshot_Type,
    [PASchema.esWB_Snapshot_Param]: WB_Snapshot_Param,
    [PASchema.esWB_Snapshot_ParamGLR]: WB_Snapshot_ParamGLR,
    [PASchema.esWB_Snapshot_ParamGLELR]: WB_Snapshot_ParamGLELR,
    [PASchema.esWB_Snapshot_ParamSAR]: WB_Snapshot_ParamSAR,
    [PASchema.esWB_Snapshot_ParamAMR]: WB_Snapshot_ParamAMR,
    [PASchema.esWB_Snapshot_ParamCHR]: WB_Snapshot_ParamCHR,
    [PASchema.esWB_Snapshot_ParamPHR]: WB_Snapshot_ParamPHR,
    [PASchema.esWB_Snapshot_ParamGLCHR]: WB_Snapshot_ParamGLCHR,
    [PASchema.esWB_Snapshot_ParamGLPHR]: WB_Snapshot_ParamGLPHR,
    [PASchema.esWB_Snapshot_ParamPlnR]: WB_Snapshot_ParamPlnR,
    [PASchema.esWB_Snapshot_ParamETR]: WB_Snapshot_ParamETR,
    [PASchema.esWB_Snapshot_Customer_Relationship]: WB_Snapshot_Customer_Relationship,
    [PASchema.esWB_Snapshot_ProductGroup_Relationship]: WB_Snapshot_ProductGroup_Relationship,
    [PASchema.esWB_Snapshot_Period_Relationship]: WB_Snapshot_Period_Relationship,
    [PASchema.esWB_Snapshot_Plan_Relationship]: WB_Snapshot_Plan_Relationship,
    [PASchema.esWB_Plan_Volume_Metrics_Snapshot]: WB_Plan_Volume_Metrics_Snapshot,
    [PASchema.esWB_Event_Spend_Metrics_Snapshot]: WB_Event_Spend_Metrics_Snapshot,
    [PASchema.esWB_Plan_NFP_Snapshot]: WB_Plan_NFP_Snapshot,
    [PASchema.esWB_Spend_Allocation_Rule]: WB_Spend_Allocation_Rule,
    [PASchema.esWB_Spend_Allocation_Rule_Item]: WB_Spend_Allocation_Rule_Item,
    [PASchema.esWB_Spend_Method_Rule]: WB_Spend_Method_Rule,
    [PASchema.esWB_Spend_Type]: WB_Spend_Type,
    [PASchema.esWB_Staging]: WB_Staging,
    [PASchema.esWB_Staging_ClientRaw]: WB_Staging_ClientRaw,
    [PASchema.esWB_Staging_Archive]: WB_Staging_Archive,
    [PASchema.esWB_Status_History]: WB_Status_History,
    [PASchema.esWB_Status_History_Log]: WB_Status_History_Log,
    [PASchema.esWB_Status_Relationship]: WB_Status_Relationship,
    [PASchema.esWB_Subject_Area]: WB_Subject_Area,
    [PASchema.esWB_TPM_Event]: WB_TPM_Event,
    [PASchema.esWB_TPM_Event_Metrics]: WB_TPM_Event_Metrics,
    [PASchema.esWB_TPM_Event_Product]: WB_TPM_Event_Product,
    [PASchema.esWB_TPM_Event_Product_Group]: WB_TPM_Event_Product_Group,
    [PASchema.esWB_TPM_Event_Spend]: WB_TPM_Event_Spend,
    [PASchema.esWB_TPM_Event_Spend_Metrics]: WB_TPM_Event_Spend_Metrics,
    [PASchema.esWB_TPM_Event_Product_Metrics]: WB_TPM_Event_Product_Metrics,
    [PASchema.esWB_TPM_Event_Spend_Product]: WB_TPM_Event_Spend_Prd,
    [PASchema.esWB_TPM_Event_Spend_Product_Group]: WB_TPM_Event_Spend_PrdGrp,
    [PASchema.esWB_TPM_Event_Tag]: WB_TPM_Event_Tag,
    [PASchema.esWB_TPM_Event_Spend_Customer]: WB_TPM_Event_Spend_Customer,
    [PASchema.esWB_Tag]: WB_Tag,
    [PASchema.esWB_Tag_Source]: WB_Tag_Source,
    [PASchema.esWB_Tag_Metric]: WB_Tag_Metric,
    [PASchema.esWB_Tag_Relationship]: WB_Tag_Relationship,
    [PASchema.esWB_Tag_Text]: WB_Tag_Text,
    [PASchema.esWB_Tag_Function]: WB_Tag_Function,
    [PASchema.esWB_Tag_Function_Param]: WB_Tag_Function_Param,
    [PASchema.esWB_Tag_Rule]: WB_Tag_Rule,
    [PASchema.esWB_Tag_Rule_Param]: WB_Tag_Rule_Param,
    [PASchema.esWB_Timing]: WB_Timing,
    [PASchema.esWB_Transaction]: WB_Transaction,
    [PASchema.esWB_Transaction_Item]: WB_Transaction_Item,
    [PASchema.esWB_GLTransaction]: WB_GLTransaction,
    [PASchema.esWB_GLTransaction_Item]: WB_GLTransaction_Item,
    [PASchema.esWB_GLAccount_Balance]: WB_GLAccount_Balance,
    [PASchema.esWB_Transaction_Type]: WB_Transaction_Type,
    [PASchema.esWB_User]: WB_User,
    [PASchema.esWB_User_Customer]: WB_User_Customer,
    [PASchema.esWB_User_Dimension]: WB_User_Dimension,
    [PASchema.esWB_User_Group]: WB_User_Group,
    [PASchema.esWB_User_Group_Customer]: WB_User_Group_CR,
    [PASchema.esWB_User_Group_Product]: WB_User_Group_PR,
    [PASchema.esWB_User_Group_Role]: WB_User_Group_RR,
    [PASchema.esWB_User_Group_User]: WB_User_Group_UR,
    [PASchema.esWB_User_Reviewers]: WB_User_Reviewer,
    [PASchema.esWB_User_Role]: WB_User_Role,
    [PASchema.esWB_Workflow]: WB_Workflow,
    [PASchema.esWB_Workflow_Status]: WB_Workflow_Status,
    [PASchema.esWB_Workspace]: WB_Workspace,
    [PASchema.esWB_Workspace_Dimension]: WB_Workspace_Dimension,
    [PASchema.esWB_Workspace_Report]: WB_Workspace_Report,
    [PASchema.esWB_Workspace_Report_Dimension]: WB_Workspace_Report_Dimension,
    [PASchema.esWB_UI_Profile]: WB_UI_Profile,
    [PASchema.esWB_UI_AppSuite_Type]: WB_UI_AppSuite_Type,
    [PASchema.esWB_UI_AppSuite]: WB_UI_AppSuite,
    [PASchema.esWB_UI_AppSuite_App_Relationship]: WB_UI_AppSuite_App_Relationship,
    [PASchema.esWB_UI_AppModule]: WB_UI_AppModule,
    [PASchema.esWB_UI_AppExecutable]: WB_UI_AppExecutable,
    [PASchema.esWB_UI_Application]: WB_UI_Application,
    [PASchema.esWB_UI_App_Report]: WB_UI_App_Report,
    [PASchema.esWB_UI_Usage]: WB_UI_Usage,
    [PASchema.esWB_License]: WB_License,
    [PASchema.esWB_Benchmark]: WB_Benchmark,
    [PASchema.esWB_Schedule]: WB_Schedule,
    [PASchema.esWB_Search]: WB_Search,
    [PASchema.esWB_Search_Profile]: WB_Search_Profile,
    [PASchema.esWB_Search_ProfileCR]: WB_Search_ProfileCR,
    [PASchema.esWB_Search_ProfileFCR]: WB_Search_ProfileFCR,
    [PASchema.esWB_Search_ProfileGCR]: WB_Search_ProfileGCR,
    [PASchema.esWB_PEA_Event_Override]: WB_PEA_Event_Override,
    [PASchema.esWB_PEA_Event_ProductGroup_Override]: WB_PEA_Event_ProductGroup_Override,
    [PASchema.esWB_PEA_Event_Spend_Override]: WB_PEA_Event_Spend_Override,
    [PASchema.esWB_PEA_Event_Spend_ProductGroup_Override]: WB_PEA_Event_Spend_ProductGroup_Override,
});

// These tables need to be moved into the JSData Schemas
_.defaults(dctTableNameByEntitySet, {
    [PASchema.esWB_Approval]: "/AZR/WB_APPROVAL",
    [PASchema.esWB_AttributeType]: "/AZR/WB_ATTRIBUTEM",
    [PASchema.esWB_Audit_Log]: "/AZR/WB_AUDITLOG",
    [PASchema.esWB_Auth_Provider]: "/AZR/WB_AUTHPRVD",
    [PASchema.esWB_BaseLn]: "/AZR/WB_BASELN",
    [PASchema.esWB_BaseLnMt]: "/AZR/WB_BASELNMT",
    [PASchema.esWB_Baseline]: "/AZR/WB_BASELINE",
    [PASchema.esWB_Baseline_Metrics]: "/AZR/WB_BASELINEMT",
    [PASchema.esWB_BusinessUnit]: "/AZR/WB_BUSINESSUNIT",
    [PASchema.esWB_BusinessUnit_Source]: "/AZR/WB_BUSINESSUNITSR",
    [PASchema.esWB_BusinessUnit_User]: "/AZR/WB_USRBUSINESSUNITR",
    [PASchema.esWB_Circular_AdBlock]: "/AZR/WB_CIRCULAR_ADBLOCK",
    [PASchema.esWB_Circular_Config]: "/AZR/WB_CIRCULAR_CONFIG",
    [PASchema.esWB_Circular_ConfigCR]: "/AZR/WB_CIRCULAR_CONFIGCR",
    [PASchema.esWB_Circular]: "/AZR/WB_CIRCULAR",
    [PASchema.esWB_CircularCR]: "/AZR/WB_CIRCULARCR",
    [PASchema.esWB_CircularPR]: "/AZR/WB_CIRCULARPR",
    [PASchema.esWB_Claim_Type]: "/AZR/WB_CLMTYPE",
    [PASchema.esWB_Claim_Type_Payment_Type]: "/AZR/WB_CLMTYPEPMTTR",
    [PASchema.esWB_Claim]: "/AZR/WB_CLM",
    [PASchema.esWB_Claim_Plan_Match]: "/AZR/WB_CLMPR",
    [PASchema.esWB_Connection]: "/AZR/WB_CNX",
    [PASchema.esWB_ExchangeRateM]: "/AZR/WB_EXCHANGERATEM",
    [PASchema.esWB_ExchangeRateMT]: "/AZR/WB_EXCHANGERATEMT",
    [PASchema.esWB_ExchangeRateMR]: "/AZR/WB_EXCHANGERATEMR",
    [PASchema.esWB_CubeSource]: "/AZR/WB_CUBESOURCE",
    [PASchema.esWB_CubeSource_Dimension]: "/AZR/WB_CUBESOURCEDR",
    [PASchema.esWB_CubeSource_DataSource]: "/AZR/WB_CUBESOURCEDSR",
    [PASchema.esWB_CubeSource_DataSource_Dimension]: "/AZR/WB_CUBESOURCEDSDR",
    [PASchema.esWB_DataObject]: "/AZR/WB_DATAOBJECT",
    [PASchema.esWB_DataObject_Text]: "/AZR/WB_DATAOBJECTT",
    [PASchema.esWB_DataObject_Column]: "/AZR/WB_DATAOBJECT_COLUMN",
    [PASchema.esWB_DataObject_Column_Text]: "/AZR/WB_DATAOBJECT_COLUMNT",
    [PASchema.esWB_DataObject_Message]: "/AZR/WB_DATAOBJECT_MESSAGE",
    [PASchema.esWB_DataObject_Message_Text]: "/AZR/WB_DATAOBJECT_MESSAGET",
    [PASchema.esWB_Dimension]: "/AZR/WB_DIM",
    [PASchema.esWB_Domain]: "/AZR/WB_DOM",
    [PASchema.esWB_Domain_Item]: "/AZR/WB_DOMITEM",
    [PASchema.esWB_Domain_Item_Text]: "/AZR/WB_DOMITEMT",
    [PASchema.esWB_Domain_Text]: "/AZR/WB_DOMT",
    [PASchema.esWB_Entity]: "/AZR/WB_ENTITY",
    [PASchema.esWB_Entity_AttributeType]: "/AZR/WB_ENTITYAMR",
    [PASchema.esWB_Event]: "/AZR/WB_EVT",
    [PASchema.esWB_EventFR]: "/AZR/WB_EVTFR",
    [PASchema.esWB_Event_Circular]: "/AZR/WB_EVTCIR",
    [PASchema.esWB_Event_Accrual]: "/AZR/WB_EVTACR",
    [PASchema.esWB_Event_Customer]: "/AZR/WB_EVTSCST",
    [PASchema.esWB_Event_Meta]: "/AZR/WB_EVTMETAR",
    [PASchema.esWB_Event_Override]: "/AZR/WB_EVTO",
    [PASchema.esWB_Event_Product]: "/AZR/WB_EVTPRD",
    [PASchema.esWB_Event_Product_Group]: "/AZR/WB_EVTPG",
    [PASchema.esWB_Event_Product_Group_Override]: "/AZR/WB_EVTPGO",
    [PASchema.esWB_Event_Relationship]: "/AZR/WB_EVTR",
    [PASchema.esWB_Event_Spend]: "/AZR/WB_EVTS",
    [PASchema.esWB_Event_Spend_PrdGrp]: "/AZR/WB_EVTSPG",
    [PASchema.esWB_Event_Spend_PrdGrp_Customer]: "/AZR/WB_EVTSPGC",
    [PASchema.esWB_Event_Spend_PrdGrp_Override]: "/AZR/WB_EVTSPGO",
    [PASchema.esWB_Event_Spend_PrdGrp_Redistrib]: "/AZR/WB_EVTRSPG",
    [PASchema.esWB_Event_Spend_Prd]: "/AZR/WB_EVTSPRD",
    [PASchema.esWB_Event_Spend_Type]: "/AZR/WB_EVTSTYPE",
    [PASchema.esWB_Event_Spend_Type_Account]: "/AZR/WB_EVTSACCT",
    [PASchema.esWB_Event_Spend_Type_Relationship]: "/AZR/WB_EVTSTYPR",
    [PASchema.esWB_Event_Tag]: "/AZR/WB_EVTTAGR",
    [PASchema.esWB_Event_Type]: "/AZR/WB_EVTTYPE",
    [PASchema.esWB_EvtShipPrd]: "/AZR/WB_EVTSHIPPRD",
    [PASchema.esWB_EvtShipCPrd]: "/AZR/WB_EVTSHIPCPRD",
    [PASchema.esWB_EvtSShpPrd]: "/AZR/WB_EVTSSHPPRD",
    [PASchema.esWB_EvtSShpPrdO]: "/AZR/WB_EVTSSHPPRDO",
    [PASchema.esWB_File]: "/AZR/WB_FILE",
    [PASchema.esWB_Fund_Type]: "/AZR/WB_FUNDTYPE",
    [PASchema.esWB_General_Ledger]: "/AZR/WB_GL",
    [PASchema.esWB_General_Ledger_Account]: "/AZR/WB_GLACCT",
    [PASchema.esWB_General_Ledger_Policy]: "/AZR/WB_GLRL",
    [PASchema.esWB_General_Ledger_Policy_Account]: "/AZR/WB_GLRLACCT",
    [PASchema.esWB_Job]: "/AZR/WB_JOB",
    [PASchema.esWB_Job_Process]: "/AZR/WB_JOB_PROCESS",
    [PASchema.esWB_Job_Process_Queue]: "/AZR/WB_JOB_PROCESS_QUEUE",
    [PASchema.esWB_Job_Processor]: "/AZR/WB_JOB_PROCESSOR",
    [PASchema.esWB_Job_Processor_ConfigR]: "/AZR/WB_JOB_PROCESSOR_CONFIGR",
    [PASchema.esWB_Job_Run]: "/AZR/WB_JOBRUN",
    [PASchema.esWB_Job_Trigger]: "/AZR/WB_JOB_TRIGGER",
    [PASchema.esWB_Job_Schedule_Process]: "/AZR/WB_JOB_SCHEDULE_PROCESS",
    [PASchema.esWB_Job_Param]: "/AZR/WB_JOB_PARAM",
    [PASchema.esWB_Job_ParamSR]: "/AZR/WB_JOB_PARAMSR",
    [PASchema.esWB_BatchProcess]: "/AZR/WB_BATCHPROCESS",
    [PASchema.esWB_BatchScope]: "/AZR/WB_BATCHSCOPE",
    [PASchema.esWB_BatchScopeCR]: "/AZR/WB_BATCHSCOPECR",
    [PASchema.esWB_BatchScopeMR]: "/AZR/WB_BATCHSCOPEMR",
    [PASchema.esWB_BatchScopeSR]: "/AZR/WB_BATCHSCOPESR",
    [PASchema.esWB_Lift]: "/AZR/WB_LIFT",
    [PASchema.esWB_Loader]: "/AZR/WB_LOADER",
    [PASchema.esWB_Loader_KeyMap]: "/AZR/WB_LOADER_KEYMAP",
    [PASchema.esWB_Loader_MetricMap]: "/AZR/WB_LOADER_METRICMAP",
    [PASchema.esWB_Loader_MetricTerm]: "/AZR/WB_LOADER_METRICTERM",
    [PASchema.esWB_Loader_Operation]: "/AZR/WB_LOADER_OPERATION",
    [PASchema.esWB_Loader_Source]: "/AZR/WB_LOADER_SOURCE",
    [PASchema.esWB_MasterData_Set]: "/AZR/WB_MDSET",
    [PASchema.esWB_Meta]: "/AZR/WB_META",
    [PASchema.esWB_Meta_Tags]: "/AZR/WB_TAGMETAR",
    [PASchema.esWB_Meta_Text]: "/AZR/WB_METAT",
    [PASchema.esWB_MetricDefinition_GLAccount]: "/AZR/WB_MTRDFNGLR",
    [PASchema.esWB_MetricDefinition_EventSpend_Type]: "/AZR/WB_MTRDFNEVTSTYPER",
    [PASchema.esWB_Metric]: "/AZR/WB_METRICS",
    [PASchema.esWB_Metric_Definition]: "/AZR/WB_MTRDFN",
    [PASchema.esWB_MetricDefinition_Component]: "/AZR/WB_MTRDFNR",
    [PASchema.esWB_Metric_View]: "/AZR/WB_MTRVIEW",
    [PASchema.esWB_Metric_View_Metric]: "/AZR/WB_MTRVIEWR",
    [PASchema.esWB_Note]: "/AZR/WB_NOTE",
    [PASchema.esWB_Note_User]: "/AZR/WB_NOTEUSRR",
    [PASchema.esWB_Payment]: "/AZR/WB_PMT",
    [PASchema.esWB_Payment_Claim]: "/AZR/WB_PMTCLMR",
    [PASchema.esWB_Payment_Event_Spend]: "/AZR/WB_PMTEVTS",
    [PASchema.esWB_Payment_Event_Spend_Product_Group]: "/AZR/WB_PMTEVTSP",
    [PASchema.esWB_Payment_Fund]: "/AZR/WB_PMTFND",
    [PASchema.esWB_Payment_Fund_Product_Group]: "/AZR/WB_PMTFNDP",
    [PASchema.esWB_Payment_Type]: "/AZR/WB_PMTTYPE",
    [PASchema.esWB_Plan]: "/AZR/WB_PLAN",
    [PASchema.esWB_Plan_Funding_Metrics]: "/AZR/WB_PLANFMT",
    [PASchema.esWB_Plan_Group]: "/AZR/WB_PLANGRP",
    [PASchema.esWB_Plan_Management]: "/AZR/WB_PLNMGMT",
    [PASchema.esWB_Plan_Management_Period]: "/AZR/WB_PLNMGMTR",
    [PASchema.esWB_Plan_Management_User]: "/AZR/WB_PLNMGMTU",
    [PASchema.esWB_Plan_Management_User_Group]: "/AZR/WB_PLNMGMTG",
    [PASchema.esWB_Plan_Override]: "/AZR/WB_PLANO",
    [PASchema.esWB_Plan_Product]: "/AZR/WB_PLANPRD",
    [PASchema.esWB_Plan_Product_Group]: "/AZR/WB_PLANPG",
    [PASchema.esWB_Plan_Redistrib_Volume_Metrics]: "/AZR/WB_PLANRVMT",
    [PASchema.esWB_Plan_Type]: "/AZR/WB_PLANM",
    [PASchema.esWB_Plan_Type_Event_Type]: "/AZR/WB_PLANMEVT",
    [PASchema.esWB_Plan_Type_Fund_Type]: "/AZR/WB_PLANMFND",
    [PASchema.esWB_Plan_Volume_Metrics]: "/AZR/WB_PLANVMT",
    [PASchema.esWB_Plan_Approval_Metrics]: "/AZR/WB_PLANAMT",
    [PASchema.esWB_Plan_Product_Metrics]: "/AZR/WB_PLANPRDMT",
    [PASchema.esWB_Plan_Volume_Monthly_Metrics]: "/AZR/WB_PLANMMT",
    [PASchema.esWB_Pricing_Engine]: "/AZR/WB_PRICING_ENGINE",
    [PASchema.esWB_Pricing_Engine_Price_Relationship]: "/AZR/WB_PRICING_ENGINE_PR",
    [PASchema.esWB_Product_Condition]: "/AZR/PROD_CND",
    [PASchema.esWB_Product_Condition_Type]: "/AZR/PROD_CNDM",
    [PASchema.esWB_Queue]: "/AZR/WB_QUEUE",
    [PASchema.esWB_Queue_RunId]: "/AZR/WB_QUEUE",
    [PASchema.esWB_ReportTile]: "/AZR/WB_RPTTL",
    [PASchema.esWB_ReportTile_Dimension]: "/AZR/WB_RPTTLDR",
    [PASchema.esWB_Report]: "/AZR/WB_REPORT",
    [PASchema.esWB_Report_Customer_Hierarchy]: "/AZR/WB_RPT_CUSTH",
    [PASchema.esWB_Report_Metric]: "/AZR/WB_REPORT_METRICR",
    [PASchema.esWB_Report_Export]: "/AZR/WB_REPORT_EXPORT",
    [PASchema.esWB_Report_Product_Group_Hierarchy]: "/AZR/WB_RPT_PRDGRPH",
    [PASchema.esWB_Report_Time_Hierarchy]: "/AZR/WB_RPT_TIMEH",
    [PASchema.esWB_Search]: "/AZR/WB_SEARCH",
    [PASchema.esWB_Search_Profile]: "/AZR/WB_SEARCH_PROFILE",
    [PASchema.esWB_Search_ProfileCR]: "/AZR/WB_SEARCH_PROFILECR",
    [PASchema.esWB_Search_ProfileFCR]: "/AZR/WB_SEARCH_PROFILEFCR",
    [PASchema.esWB_Search_ProfileGCR]: "/AZR/WB_SEARCH_PROFILEGCR",
    [PASchema.esWB_Session]: "/AZR/WB_SESSION",
    [PASchema.esWB_Snapshot]: "/AZR/WB_SNAPSHOT",
    [PASchema.esWB_Snapshot_Msar]: "/AZR/WB_SNAPSHTMSAR",
    [PASchema.esWB_Snapshot_Type]: "/AZR/WB_SNAPSHTM",
    [PASchema.esWB_Snapshot_Param]: "/AZR/WB_SNAPSHOT_PARAM",
    [PASchema.esWB_Snapshot_ParamGLR]: "/AZR/WB_SNAPSHOT_PARAMGLR",
    [PASchema.esWB_Snapshot_ParamGLELR]: "/AZR/WB_SNAPSHOT_PARAMGLELR",
    [PASchema.esWB_Snapshot_ParamSAR]: "/AZR/WB_SNAPSHOT_PARAMSAR",
    [PASchema.esWB_Snapshot_ParamAMR]: "/AZR/WB_SNAPSHOT_PARAMAMR",
    [PASchema.esWB_Snapshot_ParamCHR]: "/AZR/WB_SNAPSHOT_PARAMCHR",
    [PASchema.esWB_Snapshot_ParamPHR]: "/AZR/WB_SNAPSHOT_PARAMPHR",
    [PASchema.esWB_Snapshot_ParamGLCHR]: "/AZR/WB_SNAPSHOT_PARAMGLCHR",
    [PASchema.esWB_Snapshot_ParamGLPHR]: "/AZR/WB_SNAPSHOT_PARAMGLPHR",
    [PASchema.esWB_Snapshot_ParamPlnR]: "/AZR/WB_SNAPSHOT_PARAMPLNR",
    [PASchema.esWB_Snapshot_ParamETR]: "/AZR/WB_SNAPSHOT_PARAMETR",
    [PASchema.esWB_Snapshot_Customer_Relationship]: "/AZR/WB_SNAPSHOT_CUSTR",
    [PASchema.esWB_Snapshot_ProductGroup_Relationship]: "/AZR/WB_SNAPSHOT_PRDR",
    [PASchema.esWB_Snapshot_Period_Relationship]: "/AZR/WB_SNAPSHOT_PERIODR",
    [PASchema.esWB_Snapshot_Plan_Relationship]: "/AZR/WB_SNAPSHOT_PLANR",
    [PASchema.esWB_Plan_Volume_Metrics_Snapshot]: "/AZR/WB_PLANVMTS",
    [PASchema.esWB_Event_Spend_Metrics_Snapshot]: "/AZR/WB_TEVTSMTS",
    [PASchema.esWB_Plan_NFP_Snapshot]: "/AZR/WB_PLANNFPS",
    [PASchema.esWB_Spend_Allocation_Rule]: "/AZR/WB_SPENDRL",
    [PASchema.esWB_Spend_Allocation_Rule_Item]: "/AZR/WB_SPENDRLR",
    [PASchema.esWB_Spend_Method_Rule]: "/AZR/WB_SPENDCLR",
    [PASchema.esWB_Spend_Type]: "/AZR/WB_SPENDM",
    [PASchema.esWB_Status_History]: "/AZR/WB_STATUSH",
    [PASchema.esWB_Status_History_Log]: "/AZR/WB_STATUSHL",
    [PASchema.esWB_Status_Relationship]: "/AZR/WB_STATUSR",
    [PASchema.esWB_Subject_Area]: "/AZR/WB_SUBJECT_AREA",
    [PASchema.esWB_TPM_Event]: "/AZR/WB_TEVT",
    [PASchema.esWB_TPM_Event_Metrics]: "/AZR/WB_TEVTMT",
    [PASchema.esWB_TPM_Event_Product]: "/AZR/WB_TEVTPRD",
    [PASchema.esWB_TPM_Event_Product_Group]: "/AZR/WB_TEVTPG",
    [PASchema.esWB_TPM_Event_Spend]: "/AZR/WB_TEVTS",
    [PASchema.esWB_TPM_Event_Spend_Metrics]: "/AZR/WB_TEVTSMT",
    [PASchema.esWB_TPM_Event_Product_Metrics]: "/AZR/WB_TEVTPRDMT",
    [PASchema.esWB_TPM_Event_Spend_Product]: "/AZR/WB_TEVTSPRD",
    [PASchema.esWB_TPM_Event_Spend_Product_Group]: "/AZR/WB_TEVTSPG",
    [PASchema.esWB_TPM_Event_Spend_Customer]: "/AZR/WB_TEVTSCST",
    [PASchema.esWB_TPM_Event_Tag]: "/AZR/WB_TEVTTAGR",
    [PASchema.esWB_Tag]: "/AZR/WB_TAG",
    [PASchema.esWB_Tag_Source]: "/AZR/WB_TAG_SOURCE",
    [PASchema.esWB_Tag_Metric]: "/AZR/WB_TAGMTRCR",
    [PASchema.esWB_Tag_Relationship]: "/AZR/WB_TAGR",
    [PASchema.esWB_Tag_Text]: "/AZR/WB_TAGT",
    [PASchema.esWB_Tag_Function]: "/AZR/WB_TAG_FUNCTION",
    [PASchema.esWB_Tag_Function_Param]: "/AZR/WB_TAG_FUNCTION_PARAM",
    [PASchema.esWB_Tag_Rule]: "/AZR/WB_TAG_RULE",
    [PASchema.esWB_Tag_Rule_Param]: "/AZR/WB_TAG_RULE_PARAM",
    [PASchema.esWB_Timing]: "/AZR/WB_TIMING",
    [PASchema.esWB_Transaction]: "/AZR/WB_TXN",
    [PASchema.esWB_Transaction_Item]: "/AZR/WB_TXNITEM",
    [PASchema.esWB_GLTransaction]: "/AZR/WB_GLTXN",
    [PASchema.esWB_GLTransaction_Item]: "/AZR/WB_GLTXN_ITEM",
    [PASchema.esWB_GLAccount_Balance]: "/AZR/WB_GLACCT_BAL",
    [PASchema.esWB_Transaction_Type]: "/AZR/WB_TXNTYPE",
    [PASchema.esWB_User]: "/AZR/WB_AUTHUSR",
    [PASchema.esWB_User_Customer]: "/AZR/WB_USRCUSTR",
    [PASchema.esWB_User_Dimension]: "/AZR/WB_USRDIMR",
    [PASchema.esWB_User_Group]: "/AZR/WB_USRGRP",
    [PASchema.esWB_User_Group_Customer]: "/AZR/WB_USRGRPCR",
    [PASchema.esWB_User_Group_Product]: "/AZR/WB_USRGRPPR",
    [PASchema.esWB_User_Group_Role]: "/AZR/WB_USRGRPRR",
    [PASchema.esWB_User_Group_User]: "/AZR/WB_USRGRPUR",
    [PASchema.esWB_User_Reviewers]: "/AZR/WB_USRRVWR",
    [PASchema.esWB_User_Role]: "/AZR/WB_USRROLER",
    [PASchema.esWB_Workflow]: "/AZR/WB_WORKFLOW",
    [PASchema.esWB_Workflow_Status]: "/AZR/WB_STATUS",
    [PASchema.esWB_Workspace]: "/AZR/WB_WRKSP",
    [PASchema.esWB_Workspace_Dimension]: "/AZR/WB_WRKSPDMR",
    [PASchema.esWB_Workspace_Report]: "/AZR/WB_WRKSPRTR",
    [PASchema.esWB_Workspace_Report_Dimension]: "/AZR/WB_WRKSPRDR",
    [PASchema.esWB_UI_Profile]: "/AZR/WB_UI_PROFILE",
    [PASchema.esWB_UI_AppSuite_Type]: "/AZR/WB_UI_APPSUITEM",
    [PASchema.esWB_UI_AppSuite]: "/AZR/WB_UI_APPSUITE",
    [PASchema.esWB_UI_AppSuite_App_Relationship]: "/AZR/WB_UI_APPSUITEAR",
    [PASchema.esWB_UI_AppModule]: "/AZR/WB_UI_APPMODULE",
    [PASchema.esWB_UI_AppExecutable]: "/AZR/WB_UI_APPEXEC",
    [PASchema.esWB_UI_Application]: "/AZR/WB_UI_APP",
    [PASchema.esWB_UI_App_Report]: "/AZR/WB_UI_APP_REPORT",
    [PASchema.esWB_UI_Usage]: "/AZR/WB_UI_USAGE",
    [PASchema.esWB_License]: "/AZR/WB_LICENSE",
    [PASchema.esWB_Benchmark]: "/AZR/WB_BENCHMARK",
    [PASchema.esWB_Schedule]: "/AZR/WB_SCHEDULE",
    [PASchema.esWB_Custom_Column]: "/AZR/WB_CUSTOM_COLUMN",
    [PASchema.esWB_Staging]: "/AZR/WB_STAGING",
    [PASchema.esWB_Staging_ClientRaw]: "/AZR/WB_STAGING_CLIENTRAW",
    [PASchema.esWB_Staging_Archive]: "/AZR/WB_STAGING_ARCHIVE",
    [PASchema.esWB_PEA_Event_Override]: "/AZR/WB_OVERRIDE",
    [PASchema.esWB_PEA_Event_ProductGroup_Override]: "/AZR/WB_OVERRIDE_PRDGRP",
    [PASchema.esWB_PEA_Event_Spend_Override]: "/AZR/WB_OVERRIDE_EVTS",
    [PASchema.esWB_PEA_Event_Spend_ProductGroup_Override]: "/AZR/WB_OVERRIDE_EVTSPG",
});

// TODO: Complete logical keys for metadata export
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_AttributeType]: ["WB_MDSET_ID", "ENTITY_DIMENSION", "ATTRIBUTEM_ID"],
    [PASchema.esWB_BusinessUnit]: ["BUSINESSUNIT_ID"],
    [PASchema.esWB_BusinessUnit_Source]: ["WB_BUSINESSUNIT_ID", "WB_SOURCE_ID"],
    [PASchema.esWB_Circular_Config]: ["CONFIG_ID"],
    [PASchema.esWB_Circular_ConfigCR]: ["WB_CIRCULARCONFIG_ID", "WB_DATAOBJECT_COLUMN_ID"],
    [PASchema.esWB_Circular_AdBlock]: ["ADBLOCK_ID", "SOURCE_ID"],
    [PASchema.esWB_Circular]: ["CIRCULAR_ID", "SOURCE_ID"],
    [PASchema.esWB_CircularCR]: ["WB_CIRCULAR_ID", "WB_CIRCULARADBLOCK_ID", "WB_CUST_ID"],
    [PASchema.esWB_CircularPR]: ["WB_CIRCULAR_ID", "WB_CIRCULARADBLOCK_ID", "WB_PROD_ID"],
    [PASchema.esWB_CubeSource]: ["CUBESOURCE_ID"],
    [PASchema.esWB_CubeSource_Dimension]: ["WB_CUBESOURCE_ID", "DIMENSION_TYPE"],
    [PASchema.esWB_CubeSource_DataSource]: ["WB_CUBESOURCE_ID", "ALIAS_ID"],
    [PASchema.esWB_CubeSource_DataSource_Dimension]: ["WB_CUBESOURCEDSR_ID", "DIMENSION_TYPE"],
    [PASchema.esWB_ExchangeRateM]: [],
    [PASchema.esWB_ExchangeRateMT]: [],
    [PASchema.esWB_ExchangeRateMR]: [],
    [PASchema.esWB_EvtShipPrd]: [],
    [PASchema.esWB_EvtShipCPrd]: [],
    [PASchema.esWB_EvtSShpPrd]: [],
    [PASchema.esWB_EvtSShpPrdO]: [],
    [PASchema.esWB_Entity]: ["WB_MDSET_ID", "ENTITY_ID"],
    [PASchema.esWB_DataObject]: ["DATAOBJECT_ID", "DATAOBJECT_TYPE"],
    [PASchema.esWB_DataObject_Text]: ["WB_DATAOBJECT_ID", "LANGUAGE"],
    [PASchema.esWB_DataObject_Column]: ["WB_DATAOBJECT_ID", "COLUMN_ID"],
    [PASchema.esWB_DataObject_Column_Text]: ["WB_DATAOBJECT_COLUMN_ID", "LANGUAGE"],
    [PASchema.esWB_DataObject_Message]: ["WB_DATAOBJECT_ID", "MESSAGE_ID"],
    [PASchema.esWB_DataObject_Message_Text]: ["WB_DATAOBJECT_MESSAGE_ID", "LANGUAGE"],
    [PASchema.esWB_Lift]: ["WB_CUST_ID", "WB_PRDGRP_ID", "LIFT_LEVER_ID", "LEVER_MIN"],
    [PASchema.esWB_Domain]: ["DOMAIN_ID"],
    [PASchema.esWB_Domain_Text]: ["WB_DOM_ID", "LANGUAGE"],
    [PASchema.esWB_Domain_Item]: ["WB_DOM_ID", "DOMAIN_ITEM_ID", "DOMAIN_ITEM_SUBCODE"],
    [PASchema.esWB_Domain_Item_Text]: ["WB_DOMITEM_ID", "LANGUAGE"],
    [PASchema.esWB_Product_Condition]: [], // Never a foreign key.
    [PASchema.esWB_Product_Condition_Type]: ["CONDITION_TYPE", "SOURCE_ID"],
    [PASchema.esWB_Spend_Allocation_Rule]: ["SPEND_RULE_ID"],
    [PASchema.esWB_Spend_Allocation_Rule_Item]: ["SPEND_ALLOCATION_RULE"],
    [PASchema.esWB_Spend_Method_Rule]: ["RATE_BASIS_ID"],
    [PASchema.esWB_Meta]: ["META_ID"],
    [PASchema.esWB_Meta_Text]: ["WB_META_ID"],
    [PASchema.esWB_Meta_Tags]: ["WB_TAG_ID", "WB_META_ID"],
    [PASchema.esWB_Tag]: ["TAG_ID"],
    [PASchema.esWB_Tag_Source]: ["TAG_SOURCE_ID"],
    [PASchema.esWB_Tag_Relationship]: ["WB_TAG_ID", "WB_TAG_ID_PRNT"],
    [PASchema.esWB_Tag_Text]: ["WB_TAG_ID"],
    [PASchema.esWB_Tag_Function]: ["TAG_FUNCTION_ID"],
    [PASchema.esWB_Tag_Function_Param]: ["TAG_FUNCTION_PARAM_ID"],
    [PASchema.esWB_Tag_Metric]: ["METRIC_ID"],
    [PASchema.esWB_Tag_Rule]: ["TAG_RULE_ID"],
    [PASchema.esWB_Tag_Rule_Param]: ["WB_TAG_RULE_PARAM_ID"],
    [PASchema.esWB_Metric]: ["REFERENCE_ID"],
    [PASchema.esWB_Partition]: ["WB_PARTITION_ID"],
    [PASchema.esWB_PartitionR]: ["WB_PARTITION_ID", "WB_CUST_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID", "WB_SOURCE_ID"],
    [PASchema.esWB_Plan_Group]: ["PLAN_GROUP_ID"],
    [PASchema.esWB_Plan]: ["PLAN_ID"],
    [PASchema.esWB_Plan_Product_Group]: ["WB_PLAN_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_Plan_Product]: ["WB_PLAN_ID", "WB_PLANPG_ID", "WB_PROD_ID"],
    [PASchema.esWB_Plan_Override]: ["WB_METRIC_ID_ACTUAL"],
    [PASchema.esWB_Event]: ["EVENT_ID"],
    [PASchema.esWB_EventFR]: [],
    [PASchema.esWB_Event_Product_Group]: [],
    [PASchema.esWB_Event_Product]: ["WB_EVT_ID", "WB_EVTPG_ID", "WB_PROD_ID"],
    [PASchema.esWB_Event_Customer]: ["WB_EVT_ID", "WB_CUST_ID_SOURCE"],
    [PASchema.esWB_Event_Meta]: ["ATTRIBUTE_ID"],
    [PASchema.esWB_Event_Tag]: ["WB_EVT_ID", "WB_TAG_ID"],
    [PASchema.esWB_Event_Relationship]: ["WB_EVT_ID", "REL_TYPE", "WB_EVT_ID_REL"],
    [PASchema.esWB_Event_Override]: ["WB_METRIC_ID_ACTUAL"],
    [PASchema.esWB_Event_Product_Group_Override]: ["WB_EVT_ID", "WB_PRDGRP_ID", "WB_METRIC_ID_ACTUAL"],
    [PASchema.esWB_Event_Spend]: ["WB_EVT_ID", "EVENT_SPEND_ID"],
    [PASchema.esWB_Event_Spend_PrdGrp]: ["WB_EVT_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_Event_Spend_Prd]: ["WB_EVT_ID", "WB_EVTSPG_ID", "WB_PROD_ID"],
    [PASchema.esWB_Event_Spend_PrdGrp_Customer]: ["WB_EVT_ID", "WB_EVTSPG_ID"],
    [PASchema.esWB_Event_Spend_PrdGrp_Override]: ["WB_EVT_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_Event_Spend_PrdGrp_Redistrib]: ["WB_EVT_ID", "WB_PRDGRP_ID", "WB_EVTSPG_ID"],
    [PASchema.esWB_Event_Circular]: ["WB_EVT_ID", "WB_CIRCULAR_ID"],
    [PASchema.esWB_Spend_Type]: ["SPEND_TYPE_ID", "SOURCE_ID"],
    [PASchema.esWB_Schedule]: ["OBJECT_TYPE_ID", "OBJECT_WB_ID"],
    [PASchema.esWB_Auth_Provider]: ["AUTHPRVD_ID"],
    [PASchema.esWB_User]: ["AUTHUSR_ID"],
    [PASchema.esWB_User_Customer]: ["WB_AUTHUSR_ID", "WB_CUST_ID"],
    [PASchema.esWB_User_Role]: ["WB_AUTHUSR_ID", "WB_CUST_ID", "WB_DOMITEM_ID"],
    [PASchema.esWB_User_Dimension]: ["WB_AUTHUSR_ID", "WB_DIMENSION_ID"],
    [PASchema.esWB_Session]: ["AUTH_REQUEST_TOKEN"],
    [PASchema.esWB_Audit_Log]: ["WB_AUTHUSR_ID", "WB_REFERENCE_ID"],
    [PASchema.esWB_Pricing_Engine]: ["PRICINGENGINE_ID"],
    [PASchema.esWB_Pricing_Engine_Price_Relationship]: ["WB_PRICINGENGINE_ID", "PRCCLC_ID"],
    [PASchema.esWB_Report]: ["REPORT_ID"],
    [PASchema.esWB_Job]: ["JOB_ID"],
    [PASchema.esWB_Job_Run]: ["WB_JOB_ID", "SOURCE_ID"],
    [PASchema.esWB_Job_Trigger]: [],
    [PASchema.esWB_Job_Processor_ConfigR]: ["MACHINE_TYPE_ID", "JOB_PROCESSOR_TYPE"],
    [PASchema.esWB_Connection]: ["CONNECTION_ID"],
    [PASchema.esWB_Dimension]: ["DIMENSION_ID"],
    [PASchema.esWB_ReportTile]: ["REPORT_ID"],
    [PASchema.esWB_ReportTile_Dimension]: ["WB_DIMENSION_ID", "WB_REPORTTILE_ID"],
    [PASchema.esWB_Report_Export]: [
        "WB_REPORT_ID",
        "WB_CUST_ID",
        "WB_PRDGRP_ID",
        "WB_PERIOD_ID",
        "WB_COMPANY_ID",
        "WB_MTRDFN_ID",
    ],
    [PASchema.esWB_Workspace]: ["WORKSPACE_ID"],
    [PASchema.esWB_Workspace_Dimension]: ["WB_WORKSPACE_ID", "WB_DIMENSION_ID"],
    [PASchema.esWB_Workspace_Report]: ["WB_WORKSPACE_ID", "WB_REPORTTILE_ID"],
    [PASchema.esWB_Workspace_Report_Dimension]: ["WB_WORKSPACE_RPTL_ID", "WB_DIMENSION_ID"],
    [PASchema.esWB_Note]: ["WB_APP_ID"],
    [PASchema.esWB_Note_User]: ["WB_NOTE_ID", "WB_AUTHUSR_ID"],
    [PASchema.esWB_File]: ["FILE_ID"],
    [PASchema.esWB_Snapshot]: ["SNAPSHOT_ID"],
    [PASchema.esWB_Snapshot_Type]: ["SNAPSHOT_TYPE_ID"],
    [PASchema.esWB_Snapshot_Param]: ["SNAPSHOT_PARAM_ID"],
    [PASchema.esWB_Snapshot_ParamGLR]: [],
    [PASchema.esWB_Snapshot_ParamGLELR]: [],
    [PASchema.esWB_Snapshot_ParamSAR]: [],
    [PASchema.esWB_Snapshot_ParamAMR]: [],
    [PASchema.esWB_Snapshot_ParamCHR]: [],
    [PASchema.esWB_Snapshot_ParamPHR]: [],
    [PASchema.esWB_Snapshot_ParamGLCHR]: [],
    [PASchema.esWB_Snapshot_ParamGLPHR]: [],
    [PASchema.esWB_Snapshot_ParamPlnR]: [],
    [PASchema.esWB_Snapshot_ParamETR]: [],
    [PASchema.esWB_Snapshot_Msar]: ["WB_SNAPSHOTM_ID", "WB_SUBJECTAREA_ID"],
    [PASchema.esWB_Snapshot_Customer_Relationship]: ["WB_SNAPSHOT_CUSTR_ID"],
    [PASchema.esWB_Snapshot_ProductGroup_Relationship]: ["WB_SNAPSHOT_PRDR_ID"],
    [PASchema.esWB_Snapshot_Period_Relationship]: ["WB_SNAPSHOT_PERIODR_ID"],
    [PASchema.esWB_Snapshot_Plan_Relationship]: ["WB_SNAPSHOT_PLANR_ID"],
    [PASchema.esWB_Plan_Volume_Metrics_Snapshot]: ["WB_PLANVMTS_ID"],
    [PASchema.esWB_Event_Spend_Metrics_Snapshot]: ["WB_TEVTSMTS_ID"],
    [PASchema.esWB_Plan_NFP_Snapshot]: ["WB_PLANNFPS_ID"],
    [PASchema.esWB_Event_Type]: ["TYPE_ID"],
    [PASchema.esWB_General_Ledger]: ["GENERAL_LEDGER_ID"],
    [PASchema.esWB_General_Ledger_Account]: ["GLACCOUNT_ID"],
    [PASchema.esWB_General_Ledger_Policy]: ["GLRULE_ID"],
    [PASchema.esWB_General_Ledger_Policy_Account]: ["GL_EXPENSETYPE_ID"],
    [PASchema.esWB_Fund_Type]: ["FUNDTYPE_ID"],
    [PASchema.esWB_Transaction_Type]: ["TXNTYPE_ID"],
    [PASchema.esWB_Transaction]: ["TXN_ID"],
    [PASchema.esWB_Transaction_Item]: ["WB_TXN_ID", "WB_CUST_ID", "WB_PRDGRP_ID", "WB_FUNDTYPE_ID"],
    [PASchema.esWB_Workflow]: ["WORKFLOW_ID"],
    [PASchema.esWB_Workflow_Status]: ["WB_WORKFLOW_ID", "STATUS_ID"],
    [PASchema.esWB_Status_Relationship]: ["WB_STATUS_ID", "WB_STATUS_ID_NEXT", "WB_DOMITEM_ID"],
    [PASchema.esWB_Plan_Type]: ["PLANM_ID"],
    [PASchema.esWB_Plan_Type_Fund_Type]: ["WB_PLANM_ID", "WB_FUNDTYPE_ID"],
    [PASchema.esWB_Plan_Type_Event_Type]: ["WB_PLANM_ID", "WB_EVTTYPE_ID"],
    [PASchema.esWB_BaseLn]: ["BASELINE_ID"],
    [PASchema.esWB_BaseLnMt]: ["WB_BASELINE_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID"],
    [PASchema.esWB_Baseline]: ["BASELINE_ID"],
    [PASchema.esWB_Baseline_Metrics]: ["WB_BASELINE_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID"],
    [PASchema.esWB_Plan_Management]: ["PLNMGMT_ID"],
    [PASchema.esWB_Plan_Management_Period]: ["WB_PLNMGMT_ID", "WB_PERIOD_ID", "WB_PRDGRP_ID", "WB_PLANM_ID"],
    [PASchema.esWB_Plan_Management_User]: ["WB_PLNMGMT_ID", "WB_AUTHUSR_ID"],
    [PASchema.esWB_Plan_Management_User_Group]: ["WB_PLNMGMT_ID", "WB_USRGRP_ID"],
    [PASchema.esWB_Payment_Type]: ["PAYMENT_TYPE_ID"],
    [PASchema.esWB_Payment]: ["PAYMENT_ID", "SOURCE_ROW_ID"],
    [PASchema.esWB_User_Group]: ["USRGRP_ID"],
    [PASchema.esWB_User_Group_Customer]: ["WB_USRGRP_ID", "WB_CUST_ID"],
    [PASchema.esWB_User_Group_Product]: ["WB_USRGRP_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_User_Group_User]: ["WB_USRGRP_ID", "WB_AUTHUSR_ID"],
    [PASchema.esWB_User_Group_Role]: ["WB_USRGRP_ID", "WB_DOMITEM_ID", "WB_CUST_ID"],
    [PASchema.esWB_TPM_Event]: ["EVENT_ID"],
    [PASchema.esWB_TPM_Event_Metrics]: ["WB_TEVT_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID"],
    [PASchema.esWB_TPM_Event_Product_Group]: ["WB_TEVT_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_TPM_Event_Product]: ["WB_TEVT_ID", "WB_PROD_ID"],
    [PASchema.esWB_TPM_Event_Tag]: ["WB_TEVT_ID", "WB_TAG_ID"],
    [PASchema.esWB_TPM_Event_Spend]: ["WB_TEVT_ID", "EVENT_SPEND_ID"],
    [PASchema.esWB_TPM_Event_Spend_Product_Group]: ["WB_TEVTS_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_TPM_Event_Spend_Product]: ["WB_TEVTS_ID", "WB_PROD_ID"],
    [PASchema.esWB_TPM_Event_Spend_Metrics]: ["WB_TEVTS_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID"],
    [PASchema.esWB_TPM_Event_Product_Metrics]: ["WB_TEVT_ID"],
    [PASchema.esWB_TPM_Event_Spend_Customer]: ["WB_TEVTS_ID", "WB_CUST_ID"],
    [PASchema.esWB_Plan_Volume_Metrics]: ["WB_PLAN_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID"],
    [PASchema.esWB_Plan_Volume_Monthly_Metrics]: ["WB_PLAN_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID"],
    [PASchema.esWB_Plan_Funding_Metrics]: ["WB_PLAN_ID", "WB_PRDGRP_ID", "WB_PERIOD_ID", "WB_FUNDTYPE_ID"],
    [PASchema.esWB_Event_Spend_Type]: ["SPENDTYPE_ID"],
    [PASchema.esWB_Event_Spend_Type_Account]: ["WB_EVTSTYPE_ID", "WB_FUNDTYPE_ID", "PAYMENT_METHOD", "GL_EXPENSE_ID"],
    [PASchema.esWB_Event_Accrual]: [],
    [PASchema.esWB_Payment_Claim]: ["WB_CLM_ID", "WB_PMT_ID"],
    [PASchema.esWB_Payment_Event_Spend]: ["WB_PMT_ID", "WB_TEVTS_ID"],
    [PASchema.esWB_Payment_Event_Spend_Product_Group]: ["WB_TEVTSP_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_Payment_Fund]: [
        "WB_PMT_ID",
        "WB_FUNDTYPE_ID",
        "WB_CUST_ID_FUNDING",
        "WB_PRDGRP_ID_FUNDING",
        "WB_PERIOD_ID_FUNDING",
    ],
    [PASchema.esWB_Payment_Fund_Product_Group]: ["WB_PMTFNDP_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_Status_History]: ["APP_ID", "APPMGR_ID"],
    [PASchema.esWB_Status_History_Log]: ["WB_STATUSH_ID"],
    [PASchema.esWB_User_Reviewers]: ["APP_ID", "APPMGR_ID"],
    [PASchema.esWB_Event_Spend_Type_Relationship]: ["WB_EVTTYPE_ID", "WB_EVTSTYPE_ID"],
    [PASchema.esWB_Subject_Area]: ["SUBJECT_AREA_ID"],
    [PASchema.esWB_Metric_Definition]: ["METRIC_ID", "WB_CUBESOURCE_ID"],
    [PASchema.esWB_MetricDefinition_GLAccount]: ["WB_MTRDFN_ID", "WB_GLACCT_ID"],
    [PASchema.esWB_MetricDefinition_EventSpend_Type]: ["WB_MTRDFN_ID", "WB_EVTSTYPE_ID"],
    [PASchema.esWB_Metric_View]: ["METRIC_VIEW_ID", "WB_CUBESOURCE_ID"],
    [PASchema.esWB_Metric_View_Metric]: [
        "WB_MTRDFN_ID",
        "WB_MTRVIEW_ID",
        "WB_CUBESOURCEDSR_ID",
        "WB_DATAOBJECT_COLUMN_ID",
    ],
    [PASchema.esWB_Approval]: ["APPROVAL_ID"],
    [PASchema.esWB_Custom_Column]: ["MAPPER_ID"],
    [PASchema.esWB_UI_Profile]: ["PROFILE_ID"],
    [PASchema.esWB_UI_AppSuite_Type]: ["APPSUITETYPE_ID"],
    [PASchema.esWB_UI_AppSuite]: ["APPSUITE_ID"],
    [PASchema.esWB_UI_AppSuite_App_Relationship]: ["WB_UI_APPSUITE_ID", "WB_UI_APP_ID"],
    [PASchema.esWB_UI_AppModule]: ["WB_UI_APP_ID", "WB_UI_APPEXEC_ID", "EXEC_PARAMETERS"],
    [PASchema.esWB_UI_Application]: ["APP_ID"],
    [PASchema.esWB_UI_AppExecutable]: ["APPEXEC_ID"],
    [PASchema.esWB_UI_App_Report]: ["WB_UI_APP_ID", "WB_REPORTTILE_ID"],
    [PASchema.esWB_UI_Usage]: ["WB_UI_APP_ID", "WB_AUTHUSR_ID", "WB_SESSION_ID", "WB_UI_APPMODULE_ID"],
    [PASchema.esWB_License]: [],
    [PASchema.esWB_Benchmark]: [],
    [PASchema.esWB_Claim_Type]: ["CLAIM_TYPE_ID"],
    [PASchema.esWB_Claim_Type_Payment_Type]: ["WB_CLMTYPE_ID", "WB_PMTTYPE_ID"],
    [PASchema.esWB_Claim]: ["CLAIM_ID", "SOURCE_ID"],
    [PASchema.esWB_Claim_Plan_Match]: [
        "WB_CUST_ID_PLANNING",
        "WB_CUST_ID_SUBPLANNING",
        "WB_PLAN_ID",
        "WB_TEVT_ID",
        "WB_TEVTS_ID",
    ],
    [PASchema.esWB_MetricDefinition_Component]: [],
    [PASchema.esWB_Search]: ["SEARCH_ID"],
    [PASchema.esWB_Search_Profile]: ["PROFILE_ID"],
    [PASchema.esWB_Search_ProfileCR]: ["WB_SEARCH_PROFILE_ID", "COLUMN_ID"],
    [PASchema.esWB_Search_ProfileFCR]: ["WB_SEARCH_PROFILE_ID", "COLUMN_ID"],
    [PASchema.esWB_Search_ProfileGCR]: ["WB_SEARCH_PROFILE_ID", "COLUMN_ID"],
    [PASchema.esWB_GLTransaction]: [],
    [PASchema.esWB_GLTransaction_Item]: [],
    [PASchema.esWB_GLAccount_Balance]: [],
    [PASchema.esWB_Job_Param]: ["SOURCE_TYPE", "SOURCE_WB_ID"],
    [PASchema.esWB_Staging]: [],
    [PASchema.esWB_Staging_ClientRaw]: [],
    [PASchema.esWB_Staging_Archive]: [],
    [PASchema.esWB_PEA_Event_Override]: ["WB_EVT_ID"],
    [PASchema.esWB_PEA_Event_ProductGroup_Override]: ["WB_OVERRIDE_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_PEA_Event_Spend_Override]: ["WB_OVERRIDE_ID", "WB_EVTS_ID"],
    [PASchema.esWB_PEA_Event_Spend_ProductGroup_Override]: ["WB_OVERRIDE_EVTS_ID", "WB_PRDGRP_ID"],
});

//maps tables to foreign keys that aren't part of JSDataRels for dataexporter/importer
//TODO: Fill out foreign key references that aren't part of the natural key
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_BusinessUnit]: {
        ["WB_PRICINGENGINE_ID"]: PASchema.esWB_Pricing_Engine,
        ["WB_CIRCULARCONFIG_ID"]: PASchema.esWB_Circular_Config,
        ["WB_BUSINESSUNIT_ID_PRNT"]: PASchema.esWB_BusinessUnit,
    },
    [PASchema.esWB_BusinessUnit_Source]: {
        ["WB_BUSINESSUNIT_ID"]: PASchema.esWB_BusinessUnit,
        ["WB_SOURCE_ID"]: PASchema.esWB_Source,
    },
    [PASchema.esWB_Circular_AdBlock]: {},
    [PASchema.esWB_Circular_Config]: {},
    [PASchema.esWB_Circular_ConfigCR]: {},
    [PASchema.esWB_Circular]: {},
    [PASchema.esWB_CircularCR]: {},
    [PASchema.esWB_CircularPR]: {},
    [PASchema.esWB_DataObject]: {
        ["WB_DATAOBJECT_ID_CLIENTRAW"]: PASchema.esWB_DataObject,
        ["WB_DATAOBJECT_ID_ERROR"]: PASchema.esWB_DataObject,
        ["WB_DATAOBJECT_ID_ARCHIVE"]: PASchema.esWB_DataObject,
    },
    [PASchema.esWB_DataObject_Column]: { ["WB_DATAOBJECT_COLUMN_ID_PK"]: PASchema.esWB_DataObject_Column },
    [PASchema.esWB_ExchangeRateM]: {
        ["WB_EXCHANGERATEM_ID_BUY"]: PASchema.esWB_ExchangeRateM,
        ["WB_EXCHANGERATEM_ID_SELL"]: PASchema.esWB_ExchangeRateM,
    },
    [PASchema.esWB_Domain]: {},
    [PASchema.esWB_Domain_Text]: { ["WB_DOM_ID"]: PASchema.esWB_Domain },
    [PASchema.esWB_Domain_Item]: { ["WB_DOM_ID"]: PASchema.esWB_Domain },
    [PASchema.esWB_Domain_Item_Text]: {
        ["WB_DOM_ID"]: PASchema.esWB_Domain,
        ["WB_DOMITEM_ID"]: PASchema.esWB_Domain_Item,
    },
    [PASchema.esWB_Product_Condition]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["PROD_CNDM_ID"]: PASchema.esWB_Product_Condition_Type,
    },
    [PASchema.esWB_Product_Condition_Type]: {},
    [PASchema.esWB_Spend_Allocation_Rule]: {},
    [PASchema.esWB_Spend_Allocation_Rule_Item]: {
        ["WB_SPENDRL_ID"]: PASchema.esWB_Spend_Allocation_Rule,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_EVTTYPE_ID"]: PASchema.esWB_Event_Type,
        ["WB_SPENDM_ID"]: PASchema.esWB_Spend_Type,
    },
    [PASchema.esWB_Spend_Method_Rule]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_SPENDM_ID"]: PASchema.esWB_Spend_Type,
        ["WB_EVTTYPE_ID"]: PASchema.esWB_Event_Type,
    },
    [PASchema.esWB_Meta]: { ["WB_META_TYPE_ID"]: PASchema.esWB_Meta },
    [PASchema.esWB_Meta_Text]: { ["WB_META_ID"]: PASchema.esWB_Meta },
    [PASchema.esWB_Meta_Tags]: { ["WB_TAG_ID"]: PASchema.esWB_Tag, ["WB_META_ID"]: PASchema.esWB_Meta },
    [PASchema.esWB_Tag]: {},
    [PASchema.esWB_Tag_Relationship]: { ["WB_TAG_ID"]: PASchema.esWB_Tag, ["WB_TAG_ID_PRNT"]: PASchema.esWB_Tag },
    [PASchema.esWB_Tag_Text]: { ["WB_TAG_ID"]: PASchema.esWB_Tag },
    [PASchema.esWB_Tag_Metric]: { ["WB_TAG_ID"]: PASchema.esWB_Tag },
    [PASchema.esWB_Tag_Function]: {},
    [PASchema.esWB_Tag_Function_Param]: {},
    [PASchema.esWB_Tag_Rule]: {},
    [PASchema.esWB_Tag_Rule_Param]: {
        ["WB_TAG_RULE_ID"]: PASchema.esWB_Tag_Rule,
        ["WB_TAG_FUNCTION_PARAM_ID"]: PASchema.esWB_Tag_Function_Param,
    },
    [PASchema.esWB_Metric]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
    },
    [PASchema.esWB_Plan_Group]: {},
    [PASchema.esWB_Plan]: {
        ["WB_PLANGRP_ID"]: PASchema.esWB_Plan_Group,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SUBPLANNING"]: PASchema.esWB_Customer,
        ["WB_PRDGRP_ID_PLANLEVEL"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
        ["WB_PLNMGMT_ID"]: PASchema.esWB_Plan_Management,
        ["WB_PLANM_ID"]: PASchema.esWB_Plan_Type,
        ["WB_BASELINE_ID_PY"]: PASchema.esWB_BaseLn,
        ["WB_BASELINE_ID_ALT"]: PASchema.esWB_BaseLn,
        ["WB_BASELINE_ID_CNS_PY"]: PASchema.esWB_Baseline,
        ["WB_BASELINE_ID_CNS_ALT"]: PASchema.esWB_Baseline,
        ["WB_BASELINE_ID_SHIP_PY"]: PASchema.esWB_Baseline,
        ["WB_BASELINE_ID_SHIP_ALT"]: PASchema.esWB_Baseline,
    },
    [PASchema.esWB_Plan_Product_Group]: {
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
    [PASchema.esWB_Plan_Product]: {
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_PLANPG_ID"]: PASchema.esWB_Plan_Product_Group,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
    },
    [PASchema.esWB_Plan_Override]: { ["WB_METRIC_ID_ACTUAL"]: PASchema.esWB_Metric },
    [PASchema.esWB_Event]: {
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SUBPLANNING"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_EventFR]: {},
    [PASchema.esWB_Event_Spend]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
    },
    [PASchema.esWB_Event_Product_Group]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_METRIC_ID_PLANNED"]: PASchema.esWB_Metric,
    },
    [PASchema.esWB_Event_Product]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_EVTPG_ID"]: PASchema.esWB_Event_Product_Group,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
    },
    [PASchema.esWB_Event_Customer]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_CUST_ID_SOURCE"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_Event_Meta]: { ["WB_EVT_ID"]: PASchema.esWB_Event, ["WB_META_ID"]: PASchema.esWB_Meta },
    [PASchema.esWB_Event_Tag]: { ["WB_EVT_ID"]: PASchema.esWB_Event, ["WB_TAG_ID"]: PASchema.esWB_Tag },
    [PASchema.esWB_Event_Override]: {
        ["WB_METRIC_ID_ACTUAL"]: PASchema.esWB_Metric,
        ["WB_METRIC_ID_ACTUALOVRD"]: PASchema.esWB_Metric,
        ["WB_METRIC_ID_ACTUALOVRD_PENDING"]: PASchema.esWB_Metric,
    },
    [PASchema.esWB_Event_Product_Group_Override]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_METRIC_ID_ACTUAL"]: PASchema.esWB_Metric,
        ["WB_METRIC_ID_ACTUALOVRD"]: PASchema.esWB_Metric,
        ["WB_METRIC_ID_ACTUALOVRD_PENDING"]: PASchema.esWB_Metric,
    },
    [PASchema.esWB_Event_Circular]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_CIRCULAR_ID"]: PASchema.esWB_Circular,
    },
    [PASchema.esWB_Event_Spend_PrdGrp]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_SPENDM_ID"]: PASchema.esWB_Spend_Type,
    },
    [PASchema.esWB_Event_Spend_Prd]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_EVTSPG_ID"]: PASchema.esWB_Event_Spend_PrdGrp,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
    },
    [PASchema.esWB_Event_Spend_PrdGrp_Customer]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_EVTSPG_ID"]: PASchema.esWB_Event_Spend_PrdGrp,
        ["WB_CUST_ID_SOURCE"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_Event_Spend_PrdGrp_Override]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_METRIC_ID_ACTUAL"]: PASchema.esWB_Metric,
        ["WB_METRIC_ID_ACTUALOVRD"]: PASchema.esWB_Metric,
        ["WB_METRIC_ID_ACTUALOVRD_PENDING"]: PASchema.esWB_Metric,
        ["WB_SPENDM_ID_OVRD"]: PASchema.esWB_Spend_Type,
    },
    [PASchema.esWB_Event_Spend_PrdGrp_Redistrib]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_EVTSPG_ID"]: PASchema.esWB_Event_Spend_PrdGrp,
        ["WB_SPENDRL_ID"]: PASchema.esWB_Spend_Allocation_Rule,
        ["WB_METRIC_ID_OVRLP"]: PASchema.esWB_Metric,
    },
    [PASchema.esWB_Event_Spend_Metrics_Snapshot]: {},
    [PASchema.esWB_EvtSShpPrd]: {},
    [PASchema.esWB_EvtSShpPrdO]: {},
    [PASchema.esWB_Plan_NFP_Snapshot]: {},
    [PASchema.esWB_Spend_Type]: { ["WB_SOURCE_ID"]: PASchema.esWB_Source },
    [PASchema.esWB_Auth_Provider]: { ["AUTHPRVD_ID"]: PASchema.esWB_User },
    [PASchema.esWB_User]: {
        ["WB_AUTHPRVD_ID"]: PASchema.esWB_Auth_Provider,
        ["WB_WORKSPACE_ID_LANDING"]: PASchema.esWB_Workspace,
    },
    [PASchema.esWB_User_Customer]: {
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_User_Role]: {
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
        ["WB_DOMITEM_ID"]: PASchema.esWB_Domain_Item,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_User_Dimension]: {
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
        ["WB_DIMENSION_ID"]: PASchema.esWB_Dimension,
    },
    [PASchema.esWB_Session]: { ["WB_SESSION_GUID"]: PASchema.esWB_Session, ["WB_AUTHUSR_ID"]: PASchema.esWB_User },
    [PASchema.esWB_Audit_Log]: {
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
        ["WB_SESSION_ID"]: PASchema.esWB_Session,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
    [PASchema.esWB_Pricing_Engine]: {
        ["WB_CUSTH_ID"]: PASchema.esWB_Customer_Hierarchy,
        ["WB_PRDH_ID"]: PASchema.esWB_Product_Hierarchy,
    },
    [PASchema.esWB_Pricing_Engine_Price_Relationship]: {
        ["WB_PRICINGENGINE_ID"]: PASchema.esWB_Pricing_Engine,
        ["WB_CUSTH_ID_ALT"]: PASchema.esWB_Customer_Hierarchy,
        ["WB_PRDH_ID_ALT"]: PASchema.esWB_Product_Hierarchy,
    },
    [PASchema.esWB_Job]: {},
    [PASchema.esWB_Job_Run]: { ["WB_JOB_ID"]: PASchema.esWB_Job },
    [PASchema.esWB_Connection]: {},
    [PASchema.esWB_Dimension]: { ["WB_CONNECTION_ID"]: PASchema.esWB_Connection },
    [PASchema.esWB_ReportTile]: { ["WB_CONNECTION_ID"]: PASchema.esWB_Connection },
    [PASchema.esWB_Report_Export]: { ["WB_REPORT_ID"]: PASchema.esWB_Report },
    [PASchema.esWB_ReportTile_Dimension]: {
        ["WB_DIMENSION_ID"]: PASchema.esWB_Dimension,
        ["WB_REPORTTILE_ID"]: PASchema.esWB_ReportTile,
    },
    [PASchema.esWB_Workspace]: { ["WB_AUTHUSR_ID"]: PASchema.esWB_User },
    [PASchema.esWB_Workspace_Dimension]: {
        ["WB_WORKSPACE_ID"]: PASchema.esWB_Workspace,
        ["WB_DIMENSION_ID"]: PASchema.esWB_Dimension,
    },
    [PASchema.esWB_Workspace_Report]: {
        ["WB_WORKSPACE_ID"]: PASchema.esWB_Workspace,
        ["WB_REPORTTILE_ID"]: PASchema.esWB_ReportTile,
    },
    [PASchema.esWB_Workspace_Report_Dimension]: {
        ["WB_WORKSPACE_RPTL_ID"]: PASchema.esWB_Workspace_Report,
        ["WB_DIMENSION_ID"]: PASchema.esWB_Dimension,
    },
    [PASchema.esWB_Note]: { ["WB_AUTHUSR_ID"]: PASchema.esWB_User },
    [PASchema.esWB_Note_User]: { ["WB_NOTE_ID"]: PASchema.esWB_Note, ["WB_AUTHUSR_ID"]: PASchema.esWB_User },
    [PASchema.esWB_File]: { ["WB_AUTHUSR_ID"]: PASchema.esWB_User },
    [PASchema.esWB_Product_Attribute_Group]: {},
    [PASchema.esWB_Product_Attribute_Group_Relationship]: {
        ["WB_PRDATTRGRP_ID"]: PASchema.esWB_Product_Attribute_Group,
    },
    [PASchema.esWB_Product_Attribute_Map]: {},
    [PASchema.esWB_Product_Attribute_Map_External_Relationship]: {
        ["WB_PRDATTRMAP_ID"]: PASchema.esWB_Product_Attribute_Map,
    },
    [PASchema.esWB_Product_Attribute_Map_Value_Relationship]: {
        ["WB_PRDATTRMAP_ID"]: PASchema.esWB_Product_Attribute_Map,
    },
    [PASchema.esWB_Snapshot]: {
        ["WB_SNAPSHOTM_ID"]: PASchema.esWB_Snapshot_Type,
        ["WB_SNAPSHOT_ID_PREV"]: PASchema.esWB_Snapshot,
        ["WB_PERIOD_ID_PARENT"]: PASchema.esWB_Period,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
        ["WB_AUTHUSR_ID_WF_NEXT"]: PASchema.esWB_User,
        ["WB_AUTHUSR_ID_CREATED_BY"]: PASchema.esWB_User,
    },
    [PASchema.esWB_Snapshot_Param]: {},
    [PASchema.esWB_Snapshot_ParamGLR]: {},
    [PASchema.esWB_Snapshot_ParamSAR]: {},
    [PASchema.esWB_Snapshot_ParamAMR]: {},
    [PASchema.esWB_Snapshot_ParamCHR]: {},
    [PASchema.esWB_Snapshot_ParamPHR]: {},
    [PASchema.esWB_Snapshot_ParamPlnR]: {},
    [PASchema.esWB_Snapshot_ParamETR]: {},
    [PASchema.esWB_Snapshot_Type]: {
        ["WB_PERIODM_ID"]: PASchema.esWB_Period_Type,
        ["WB_PERIODM_ID_PARENT"]: PASchema.esWB_Period_Type,
        ["WB_WORKFLOW_ID"]: PASchema.esWB_Workflow,
        ["WB_JOB_ID"]: PASchema.esWB_Job,
    },
    [PASchema.esWB_Snapshot_Msar]: {
        ["WB_SNAPSHOTM_ID"]: PASchema.esWB_Snapshot_Type,
        ["WB_SUBJECTAREA_ID"]: PASchema.esWB_Subject_Area,
    },
    [PASchema.esWB_Snapshot_Customer_Relationship]: { ["WB_SNAPSHOT_ID"]: PASchema.esWB_Snapshot },
    [PASchema.esWB_Snapshot_ProductGroup_Relationship]: { ["WB_SNAPSHOT_ID"]: PASchema.esWB_Snapshot },
    [PASchema.esWB_Snapshot_Period_Relationship]: { ["WB_SNAPSHOT_ID"]: PASchema.esWB_Snapshot },
    [PASchema.esWB_Snapshot_Plan_Relationship]: { ["WB_SNAPSHOT_ID"]: PASchema.esWB_Snapshot },
    [PASchema.esWB_Plan_Volume_Metrics_Snapshot]: { ["WB_SNAPSHOT_ID"]: PASchema.esWB_Snapshot },
    [PASchema.esWB_Event_Type]: {
        ["WB_PRDH_ID"]: PASchema.esWB_Product_Hierarchy,
        ["WB_WORKFLOW_ID"]: PASchema.esWB_Workflow,
        ["WB_TAGS_ID_USAGES"]: PASchema.esWB_Tag,
    },
    [PASchema.esWB_General_Ledger]: {},
    [PASchema.esWB_General_Ledger_Account]: { ["WB_GL_ID"]: PASchema.esWB_General_Ledger },
    [PASchema.esWB_General_Ledger_Policy]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_EVTSTYPE_ID"]: PASchema.esWB_Event_Spend_Type,
        ["WB_SPENDM_ID"]: PASchema.esWB_Spend_Type,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["WB_CUSTH_ID"]: PASchema.esWB_Customer_Hierarchy,
        ["WB_PRDH_ID"]: PASchema.esWB_Product_Hierarchy,
    },
    [PASchema.esWB_General_Ledger_Policy_Account]: {
        ["WB_GLRL_ID"]: PASchema.esWB_General_Ledger_Policy,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["WB_GLACCT_ID"]: PASchema.esWB_General_Ledger_Account,
    },
    [PASchema.esWB_Fund_Type]: {},
    [PASchema.esWB_Transaction_Type]: { ["WB_PERIODM_ID"]: PASchema.esWB_Period_Type },
    [PASchema.esWB_Transaction]: { ["WB_TXNTYPE_ID"]: PASchema.esWB_Transaction_Type },
    [PASchema.esWB_Transaction_Item]: {
        ["WB_TXN_ID"]: PASchema.esWB_Transaction,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_GLTransaction]: {},
    [PASchema.esWB_GLTransaction_Item]: {
        ["WB_GLTXN_ID"]: PASchema.esWB_GLTransaction,
    },
    [PASchema.esWB_GLAccount_Balance]: {},
    [PASchema.esWB_Workflow]: {},
    [PASchema.esWB_Workflow_Status]: { ["WB_WORKFLOW_ID"]: PASchema.esWB_Workflow },
    [PASchema.esWB_Status_Relationship]: {
        ["WB_STATUS_ID"]: PASchema.esWB_Workflow_Status,
        ["WB_STATUS_ID_NEXT"]: PASchema.esWB_Workflow_Status,
        ["WB_DOMITEM_ID"]: PASchema.esWB_Domain_Item,
    },
    [PASchema.esWB_Plan_Type]: {
        ["WB_PERIODH_ID"]: PASchema.esWB_Period_Hierarchy,
        ["WB_PERIODM_ID"]: PASchema.esWB_Period_Type,
        ["WB_PERIODM_ID_MONTH"]: PASchema.esWB_Period_Type,
        ["WB_PERIODH_ID_MONTH"]: PASchema.esWB_Period_Hierarchy,
        ["WB_PRDH_ID"]: PASchema.esWB_Product_Hierarchy,
        ["WB_CUSTH_ID"]: PASchema.esWB_Customer_Hierarchy,
        ["WB_CUSTH_ID_SUBPLANNING"]: PASchema.esWB_Customer_Hierarchy,
        ["WB_BUSINESSUNIT_ID"]: PASchema.esWB_BusinessUnit,
        ["WB_TAG_ID_USAGE"]: PASchema.esWB_Tag,
        ["WB_CUBESOURCE_ID"]: PASchema.esWB_CubeSource,
    },
    [PASchema.esWB_Plan_Type_Fund_Type]: {
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["PRD_CNDM_ID_STD"]: PASchema.esWB_Product_Condition_Type,
        ["PRD_CNDM_ID_ADDL"]: PASchema.esWB_Product_Condition_Type,
    },
    [PASchema.esWB_Plan_Type_Event_Type]: {
        ["WB_PLANM_ID"]: PASchema.esWB_Plan_Type,
        ["WB_EVTTYPE_ID"]: PASchema.esWB_Event_Type,
    },
    [PASchema.esWB_BaseLn]: { ["WB_PERIOD_ID"]: PASchema.esWB_Period, ["WB_CUST_ID"]: PASchema.esWB_Customer },
    [PASchema.esWB_BaseLnMt]: {
        ["WB_BASELINE_ID"]: PASchema.esWB_BaseLn,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_Baseline]: { ["WB_PERIOD_ID"]: PASchema.esWB_Period, ["WB_CUST_ID"]: PASchema.esWB_Customer },
    [PASchema.esWB_Baseline_Metrics]: {
        ["WB_BASELINE_ID"]: PASchema.esWB_Baseline,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_Plan_Management]: { ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer },
    [PASchema.esWB_Plan_Management_Period]: {
        ["WB_PLNMGMT_ID"]: PASchema.esWB_Plan_Management,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PLANM_ID"]: PASchema.esWB_Plan_Type,
    },
    [PASchema.esWB_Plan_Management_User]: {
        ["WB_PLNMGMT_ID"]: PASchema.esWB_Plan_Management,
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
    },
    [PASchema.esWB_Plan_Management_User_Group]: {
        ["WB_PLNMGMT_ID"]: PASchema.esWB_Plan_Management,
        ["WB_USRGRP_ID"]: PASchema.esWB_User_Group,
    },
    [PASchema.esWB_Payment_Type]: {
        ["WB_WORKFLOW_ID"]: PASchema.esWB_Workflow,
        ["WB_BUSINESSUNIT_ID"]: PASchema.esWB_BusinessUnit,
    },
    [PASchema.esWB_Payment]: {
        ["WB_PMTTYPE_ID"]: PASchema.esWB_Payment_Type,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SUBPLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_PAYTO"]: PASchema.esWB_Customer,
        ["WB_STATUS_ID"]: PASchema.esWB_Workflow_Status,
        ["WB_STATUS_ID_NEXT"]: PASchema.esWB_Workflow_Status,
        ["WB_AUTHUSR_ID_WF_NEXT"]: PASchema.esWB_User,
        ["WB_AUTHUSR_ID_CREATEDBY"]: PASchema.esWB_User,
        ["WB_PMT_ID_REFERENCE"]: PASchema.esWB_Payment_Event_Spend,
        ["WB_PMT_ID_CORRECTION"]: PASchema.esWB_Payment_Event_Spend,
    },
    [PASchema.esWB_User_Group]: {},
    [PASchema.esWB_User_Group_Customer]: {
        ["WB_USRGRP_ID"]: PASchema.esWB_User_Group,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_User_Group_Product]: {
        ["WB_USRGRP_ID"]: PASchema.esWB_User_Group,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
    [PASchema.esWB_User_Group_User]: {
        ["WB_USRGRP_ID"]: PASchema.esWB_User_Group,
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
    },
    [PASchema.esWB_User_Group_Role]: {
        ["WB_USRGRP_ID"]: PASchema.esWB_User_Group,
        ["WB_DOMITEM_ID"]: PASchema.esWB_Domain_Item,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_TPM_Event]: {
        ["WB_EVTTYPE_ID"]: PASchema.esWB_Event_Type,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SUBPLANNING"]: PASchema.esWB_Customer,
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_AUTHUSR_ID_WF_NEXT"]: PASchema.esWB_User,
        ["WB_AUTHUSR_ID_CREATEDBY"]: PASchema.esWB_User,
    },
    [PASchema.esWB_TPM_Event_Metrics]: {
        ["WB_TEVT_ID"]: PASchema.esWB_TPM_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_TPM_Event_Product_Group]: {
        ["WB_TEVT_ID"]: PASchema.esWB_TPM_Event,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
    [PASchema.esWB_TPM_Event_Product]: {
        ["WB_TEVT_ID"]: PASchema.esWB_TPM_Event,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
    },
    [PASchema.esWB_TPM_Event_Tag]: { ["WB_TEVT_ID"]: PASchema.esWB_TPM_Event, ["WB_TAG_ID"]: PASchema.esWB_Tag },
    [PASchema.esWB_TPM_Event_Spend]: {
        ["WB_TEVT_ID"]: PASchema.esWB_TPM_Event,
        ["WB_EVTSTYPE_ID"]: PASchema.esWB_Event_Spend_Type,
        ["WB_STATUS_ID"]: PASchema.esWB_Workflow_Status,
        ["WB_STATUS_ID_NEXT"]: PASchema.esWB_Workflow_Status,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["WB_STATUS_ID_CUSTPMT"]: PASchema.esWB_Workflow_Status,
        ["WB_STATUS_ID_NEXT_CUSTPMT"]: PASchema.esWB_Workflow_Status,
        ["WB_AUTHUSR_ID_CREATEDBY"]: PASchema.esWB_User,
        ["WB_GLACCT_ID"]: PASchema.esWB_General_Ledger_Account,
    },
    [PASchema.esWB_TPM_Event_Spend_Product_Group]: {
        ["WB_TEVTS_ID"]: PASchema.esWB_TPM_Event_Spend,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
    [PASchema.esWB_TPM_Event_Spend_Product]: {
        ["WB_TEVTS_ID"]: PASchema.esWB_TPM_Event_Spend,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
    },
    [PASchema.esWB_TPM_Event_Spend_Metrics]: {
        ["WB_TEVTS_ID"]: PASchema.esWB_TPM_Event_Spend,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_TPM_Event_Product_Metrics]: { ["WB_TEVT_ID"]: PASchema.esWB_TPM_Event },
    [PASchema.esWB_TPM_Event_Spend_Customer]: {
        ["WB_TEVTS_ID"]: PASchema.esWB_TPM_Event_Spend,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_Plan_Volume_Metrics]: {
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_Plan_Volume_Monthly_Metrics]: {
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_Plan_Funding_Metrics]: {
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
    },
    [PASchema.esWB_Customer_Distribution_Relationship]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_REL"]: PASchema.esWB_Customer,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
    [PASchema.esWB_Product_Group_UOM]: { ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group },
    [PASchema.esWB_Event_Spend_Type]: {
        ["WB_WORKFLOW_ID"]: PASchema.esWB_Workflow,
        ["FUNDTYPE_DEFAULT"]: PASchema.esWB_Fund_Type,
        ["CNDM_ID_ORDERDT_OFFSET"]: PASchema.esWB_Product_Condition_Type,
        ["CNDM_ID_DISTRIBDT_OFFSET"]: PASchema.esWB_Product_Condition_Type,
        ["CNDM_ID_SHIPDIR_OFFSET"]: PASchema.esWB_Product_Condition_Type,
        ["CNDM_ID_SHIPDIRDFT_OFFSET"]: PASchema.esWB_Product_Condition_Type,
        ["CNDM_ID_SHIPIND_OFFSET"]: PASchema.esWB_Product_Condition_Type,
        ["CNDM_ID_SHIPINDDFT_OFFSET"]: PASchema.esWB_Product_Condition_Type,
        ["CNDM_ID_SHIPPRF_OFFSET"]: PASchema.esWB_Product_Condition_Type,
        ["CNDM_ID_SHIPPRFDFT_OFFSET"]: PASchema.esWB_Product_Condition_Type,
    },
    [PASchema.esWB_Event_Spend_Type_Account]: {
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["WB_GLACCT_ID"]: PASchema.esWB_General_Ledger_Account,
    },
    [PASchema.esWB_Event_Accrual]: {
        ["WB_SNAPSHOT_ID"]: PASchema.esWB_Snapshot,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_PERIOD_ID_PLAN"]: PASchema.esWB_Period,
        ["WB_PRDGRP_ID_PLANLEVEL"]: PASchema.esWB_Product_Group,
        ["WB_EVT_ID"]: PASchema.esWB_Event,
        ["WB_EVTTYPE_ID"]: PASchema.esWB_Event_Type,
        ["WB_STATUS_ID_EVT"]: PASchema.esWB_Workflow_Status,
        ["WB_AUTHUSR_ID_CRBY_EVT"]: PASchema.esWB_User,
        ["WB_TEVTS_ID"]: PASchema.esWB_TPM_Event_Spend,
        ["WB_EVTSTYPE_ID"]: PASchema.esWB_Event_Spend_Type,
        ["WB_STATUS_ID_EVTS"]: PASchema.esWB_Workflow_Status,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_GLRL_ID"]: PASchema.esWB_General_Ledger_Policy,
        ["WB_GLACCT_ID"]: PASchema.esWB_General_Ledger_Account,
        ["WB_CUST_ID_ACCRUAL"]: PASchema.esWB_Customer,
        ["WB_PRDGRP_ID_ACCRUAL"]: PASchema.esWB_Product_Group,
        ["WB_PERIOD_ID_ACCRUAL"]: PASchema.esWB_Period,
    },
    [PASchema.esWB_Payment_Event_Spend]: {
        ["WB_PMT_ID"]: PASchema.esWB_Payment,
        ["WB_TEVTS_ID"]: PASchema.esWB_TPM_Event_Spend,
    },
    [PASchema.esWB_Payment_Event_Spend_Product_Group]: {
        ["WB_PMTEVTS_ID"]: PASchema.esWB_Payment_Event_Spend,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
    },
    [PASchema.esWB_Status_History]: {
        ["WB_STATUS_ID"]: PASchema.esWB_Workflow_Status,
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
    },
    [PASchema.esWB_Status_History_Log]: { ["WB_STATUSH_ID"]: PASchema.esWB_Status_History },
    [PASchema.esWB_User_Reviewers]: { ["WB_AUTHUSR_ID"]: PASchema.esWB_User },
    [PASchema.esWB_Event_Spend_Type_Relationship]: {
        ["WB_EVTTYPE_ID"]: PASchema.esWB_Event_Type,
        ["WB_EVTSTYPE_ID"]: PASchema.esWB_Event_Spend_Type,
    },
    [PASchema.esWB_Metric_Definition]: {
        ["WB_SUBJECTAREA_ID"]: PASchema.esWB_Subject_Area,
        ["WB_CUBESOURCE_ID"]: PASchema.esWB_CubeSource,
    },
    [PASchema.esWB_MetricDefinition_GLAccount]: {
        ["WB_MTRDFN_ID"]: PASchema.esWB_Metric_Definition,
        ["WB_GLACCT_ID"]: PASchema.esWB_General_Ledger_Account,
    },
    [PASchema.esWB_MetricDefinition_EventSpend_Type]: {
        ["WB_MTRDFN_ID"]: PASchema.esWB_Metric_Definition,
        ["WB_EVTSTYPE_ID"]: PASchema.esWB_Event_Spend_Type,
    },
    [PASchema.esWB_Metric_View]: {
        ["WB_CUBESOURCE_ID"]: PASchema.esWB_CubeSource,
    },
    [PASchema.esWB_Metric_View_Metric]: {
        ["WB_MTRDFN_ID"]: PASchema.esWB_Metric_Definition,
        ["WB_MTRVIEW_ID"]: PASchema.esWB_Metric_View,
        ["WB_CUBESOURCEDSR_ID"]: PASchema.esWB_CubeSource_DataSource,
        ["WB_DATAOBJECT_COLUMN_ID"]: PASchema.esWB_DataObject_Column,
    },
    [PASchema.esWB_Approval]: {
        ["WB_BUSINESSUNIT_ID"]: PASchema.esWB_BusinessUnit,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_EVTTYPE_ID"]: PASchema.esWB_Event_Type,
        ["WB_EVTSTYPE_ID"]: PASchema.esWB_Event_Spend_Type,
        ["WB_PMTTYPE_ID"]: PASchema.esWB_Payment_Type,
    },
    [PASchema.esWB_Custom_Column]: {},
    [PASchema.esWB_UI_Profile]: {},
    [PASchema.esWB_UI_AppSuite_Type]: {},
    [PASchema.esWB_UI_AppSuite]: {
        ["WB_UI_APPSUITEM_ID"]: PASchema.esWB_UI_AppSuite_Type,
        ["WB_UI_PROFILE_ID"]: PASchema.esWB_UI_Profile,
    },
    [PASchema.esWB_UI_AppSuite_App_Relationship]: {
        ["WB_UI_APPSUITE_ID"]: PASchema.esWB_UI_AppSuite,
        ["WB_UI_APP_ID"]: PASchema.esWB_UI_Application,
    },
    [PASchema.esWB_UI_AppModule]: {
        ["WB_UI_APP_ID"]: PASchema.esWB_UI_Application,
        ["WB_UI_APPEXEC_ID"]: PASchema.esWB_UI_AppExecutable,
    },
    [PASchema.esWB_UI_Application]: {},
    [PASchema.esWB_UI_AppExecutable]: {},
    [PASchema.esWB_UI_App_Report]: {
        ["WB_UI_APP_ID"]: PASchema.esWB_UI_Application,
        ["WB_REPORTTILE_ID"]: PASchema.esWB_ReportTile,
    },
    [PASchema.esWB_UI_Usage]: {
        ["WB_UI_APP_ID"]: PASchema.esWB_UI_Application,
        ["WB_AUTHUSR_ID"]: PASchema.esWB_User,
        ["WB_SESSION_ID"]: PASchema.esWB_Session,
        ["WB_UI_APPMODULE_ID"]: PASchema.esWB_UI_AppModule,
    },
    [PASchema.esWB_Claim_Type]: {
        ["WB_BUSINESSUNIT_ID"]: PASchema.esWB_BusinessUnit,
        ["WB_PMTTYPE_ID_WRITE_OFF"]: PASchema.esWB_Payment_Type,
        ["WB_GLACCT_ID_WRITE_OFF"]: PASchema.esWB_General_Ledger_Account,
    },
    [PASchema.esWB_Claim_Type_Payment_Type]: {
        ["WB_CLMTYPE_ID"]: PASchema.esWB_Claim_Type,
        ["WB_PMTTYPE_ID"]: PASchema.esWB_Payment_Type,
    },
    [PASchema.esWB_Claim]: {
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_CLAIM"]: PASchema.esWB_Customer,
    },
    [PASchema.esWB_Payment_Claim]: { ["WB_AUTHUSR_ID_CREATEDBY"]: PASchema.esWB_User },
    [PASchema.esWB_Payment_Fund]: { ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type },
    [PASchema.esWB_Claim_Plan_Match]: {
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SUBPLANNING"]: PASchema.esWB_Customer,
        ["WB_PLAN_ID"]: PASchema.esWB_Plan,
        ["WB_TEVT_ID"]: PASchema.esWB_TPM_Event,
        ["WB_TEVTS_ID"]: PASchema.esWB_TPM_Event_Spend,
    },
    [PASchema.esWB_Job_Param]: {
        ["WB_MDSET_ID"]: PASchema.esWB_MasterData_Set,
        ["WB_SALESORG_ID"]: PASchema.esWB_SalesOrg,
    },
    [PASchema.esWB_Job_ParamSR]: {
        ["WB_JOB_PARAM_ID"]: PASchema.esWB_Job_Param,
        ["WB_SCHEDULE_ID"]: PASchema.esWB_Schedule,
        ["WB_AUTHUSR_ID_CREATEDBY"]: PASchema.esWB_Schedule,
    },
    [PASchema.esWB_Staging]: {},
    [PASchema.esWB_Staging_ClientRaw]: {},
    [PASchema.esWB_Staging_Archive]: {},
    [PASchema.esWB_BatchScope]: {},
    [PASchema.esWB_BatchScopeCR]: {},
    [PASchema.esWB_BatchScopeMR]: {},
    [PASchema.esWB_BatchScopeSR]: {},
    [PASchema.esWB_PEA_Event_Override]: {
        ["WB_EVT_ID"]: PASchema.esWB_Event,
    },
    [PASchema.esWB_PEA_Event_ProductGroup_Override]: {
        ["WB_OVERRIDE_ID"]: PASchema.esWB_PEA_Event_Override,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
    [PASchema.esWB_PEA_Event_Spend_Override]: {
        ["WB_EVTS_ID"]: PASchema.esWB_Event_Spend,
        ["WB_OVERRIDE_ID"]: PASchema.esWB_PEA_Event_Override,
    },
    [PASchema.esWB_PEA_Event_Spend_ProductGroup_Override]: {
        ["WB_OVERRIDE_EVTS_ID"]: PASchema.esWB_PEA_Event_Spend_Override,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
    },
});

_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_Approval]: { sequence_name: "/AZR/WB_APPROVAL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_AttributeType]: { sequence_name: "/AZR/WB_ATTRIBUTEM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Audit_Log]: { sequence_name: "/AZR/WB_AUDITLOG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Auth_Provider]: { sequence_name: "/AZR/WB_AUTHPRVD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User]: { sequence_name: "/AZR/WB_AUTHUSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BaseLn]: { sequence_name: "/AZR/WB_BASELN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BaseLnMt]: { sequence_name: "/AZR/WB_BASELNMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BusinessUnit]: { sequence_name: "/AZR/WB_BUSINESSUNIT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BusinessUnit_Source]: { sequence_name: "/AZR/WB_BUSINESSUNITSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Circular_AdBlock]: { sequence_name: "/AZR/WB_CIRCULAR_ADBLOCK_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Circular_Config]: { sequence_name: "/AZR/WB_CIRCULAR_CONFIG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Circular_ConfigCR]: { sequence_name: "/AZR/WB_CIRCULAR_CONFIGCR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Circular]: { sequence_name: "/AZR/WB_CIRCULAR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_CircularCR]: { sequence_name: "/AZR/WB_CIRCULARCR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_CircularPR]: { sequence_name: "/AZR/WB_CIRCULARPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Claim_Type]: { sequence_name: "/AZR/WB_CLMTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Claim_Type_Payment_Type]: { sequence_name: "/AZR/WB_CLMTYPEPMTTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Claim]: { sequence_name: "/AZR/WB_CLM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Claim_Plan_Match]: { sequence_name: "/AZR/WB_CLMPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Connection]: { sequence_name: "/AZR/WB_CNX_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_CubeSource]: { sequence_name: "/AZR/WB_CUBESOURCE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_CubeSource_Dimension]: { sequence_name: "/AZR/WB_CUBESOURCEDR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_CubeSource_DataSource]: { sequence_name: "/AZR/WB_CUBESOURCEDSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_CubeSource_DataSource_Dimension]: {
        sequence_name: "/AZR/WB_CUBESOURCEDSDR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_ExchangeRateM]: { sequence_name: "/AZR/WB_EXCHANGERATEM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_ExchangeRateMT]: { sequence_name: "/AZR/WB_EXCHANGERATEMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_ExchangeRateMR]: { sequence_name: "/AZR/WB_EXCHANGERATEMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_DataObject]: { sequence_name: "/AZR/WB_DATAOBJECT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_DataObject_Text]: { sequence_name: "/AZR/WB_DATAOBJECTT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_DataObject_Column]: { sequence_name: "/AZR/WB_DATAOBJECT_COLUMN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_DataObject_Column_Text]: { sequence_name: "/AZR/WB_DATAOBJECT_COLUMNT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_DataObject_Message]: { sequence_name: "/AZR/WB_DATAOBJECT_MESSAGE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_DataObject_Message_Text]: {
        sequence_name: "/AZR/WB_DATAOBJECT_MESSAGET_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Dimension]: { sequence_name: "/AZR/WB_DIM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Domain]: { sequence_name: "/AZR/WB_DOM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Domain_Item]: { sequence_name: "/AZR/WB_DOMITEM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Domain_Item_Text]: { sequence_name: "/AZR/WB_DOMITEMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Domain_Text]: { sequence_name: "/AZR/WB_DOMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Entity]: { sequence_name: "/AZR/WB_ENTITY_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Entity_AttributeType]: { sequence_name: "/AZR/WB_ENTITYAMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event]: { sequence_name: "/AZR/WB_EVT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_EventFR]: { sequence_name: "/AZR/WB_EVTFR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Accrual]: { sequence_name: "/AZR/WB_EVTACR_SEQ", ...KeyGenSpecs_BigInt_default },
    [PASchema.esWB_Event_Customer]: { sequence_name: "/AZR/WB_EVTSCST_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Meta]: { sequence_name: "/AZR/WB_EVTMETAR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Override]: { sequence_name: "/AZR/WB_EVTO_SEQ", ...KeyGenSpecs_Poolsize_50 },
    [PASchema.esWB_Event_Product_Group]: { sequence_name: "/AZR/WB_EVTPG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Product_Group_Override]: { sequence_name: "/AZR/WB_EVTPGO_SEQ", ...KeyGenSpecs_Poolsize_250 },
    [PASchema.esWB_Event_Product]: { sequence_name: "/AZR/WB_EVTPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Relationship]: { sequence_name: "/AZR/WB_EVTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_PrdGrp_Redistrib]: { sequence_name: "/AZR/WB_EVTRSPG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_Type_Account]: { sequence_name: "/AZR/WB_EVTSACCT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend]: { sequence_name: "/AZR/WB_EVTS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_PrdGrp]: { sequence_name: "/AZR/WB_EVTSPG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_PrdGrp_Customer]: { sequence_name: "/AZR/WB_EVTSPGC_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_PrdGrp_Override]: { sequence_name: "/AZR/WB_EVTSPGO_SEQ", ...KeyGenSpecs_Poolsize_250 },
    [PASchema.esWB_Event_Spend_Prd]: { sequence_name: "/AZR/WB_EVTSPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_Type]: { sequence_name: "/AZR/WB_EVTSTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_Type_Relationship]: { sequence_name: "/AZR/WB_EVTSTYPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Spend_Metrics_Snapshot]: { sequence_name: "/AZR/WB_TEVTSMTS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Circular]: { sequence_name: "/AZR/WB_EVTCIR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_NFP_Snapshot]: { sequence_name: "/AZR/WB_PLANNFPS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Tag]: { sequence_name: "/AZR/WB_EVTTAGR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Type]: { sequence_name: "/AZR/WB_EVTTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_EvtShipPrd]: { sequence_name: "/AZR/WB_EVTSHIPPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_EvtShipCPrd]: { sequence_name: "/AZR/WB_EVTSHIPCPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_EvtSShpPrd]: { sequence_name: "/AZR/WB_EVTSSHPPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_EvtSShpPrdO]: { sequence_name: "/AZR/WB_EVTSSHPPRDO_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Proxy_Relationship]: { sequence_name: "/AZR/WB_EXTCUSTP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_External_Relationship]: { sequence_name: "/AZR/WB_EXTCUSTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_File]: { sequence_name: "/AZR/WB_FILE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Fund_Type]: { sequence_name: "/AZR/WB_FUNDTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_General_Ledger]: { sequence_name: "/AZR/WB_GL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_General_Ledger_Account]: { sequence_name: "/AZR/WB_GLACCT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_General_Ledger_Policy]: { sequence_name: "/AZR/WB_GLRL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_General_Ledger_Policy_Account]: { sequence_name: "/AZR/WB_GLRLACCT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job]: { sequence_name: "/AZR/WB_JOB_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Run]: { sequence_name: "/AZR/WB_JOB_RUN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Trigger]: { sequence_name: "/AZR/WB_JOB_TRIGGER_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Process]: { sequence_name: "/AZR/WB_JOB_PROCESS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Process_Queue]: { sequence_name: "/AZR/WB_JOB_PROCESS_QUEUE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Processor]: { sequence_name: "/AZR/WB_JOB_PROCESSOR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Processor_ConfigR]: {
        sequence_name: "/AZR/WB_JOB_PROCESSOR_CONFIGR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Job_Schedule_Process]: { sequence_name: "/AZR/WB_JOB_SCHEDULE_PROCESS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Lift]: { sequence_name: "/AZR/WB_LIFT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Loader]: { sequence_name: "/AZR/WB_LOADER_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Loader_KeyMap]: { sequence_name: "/AZR/WB_LOADER_KEYMAP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Loader_MetricMap]: { sequence_name: "/AZR/WB_LOADER_METRICMAP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Loader_MetricTerm]: { sequence_name: "/AZR/WB_LOADER_METRICTERM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Loader_Operation]: { sequence_name: "/AZR/WB_LOADER_OPERATION_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Loader_Source]: { sequence_name: "/AZR/WB_LOADER_SOURCE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_MasterData_Set]: { sequence_name: "/AZR/WB_MDSET_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Meta]: { sequence_name: "/AZR/WB_META_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Meta_Text]: { sequence_name: "/AZR/WB_METAT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Metric]: { sequence_name: "/AZR/WB_METRICS_SEQ", ...KeyGenSpecs_Poolsize_500 },
    [PASchema.esWB_MetricDefinition_Component]: { sequence_name: "/AZR/WB_MTRDFNR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Metric_Definition]: { sequence_name: "/AZR/WB_MTRDFN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_MetricDefinition_EventSpend_Type]: {
        sequence_name: "/AZR/WB_MTRDFNEVTSTYPER_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_MetricDefinition_GLAccount]: { sequence_name: "/AZR/WB_MTRDFNGLR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Metric_View]: { sequence_name: "/AZR/WB_MTRVIEW_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Metric_View_Metric]: { sequence_name: "/AZR/WB_MTRVIEWR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Note]: { sequence_name: "/AZR/WB_NOTE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Note_User]: { sequence_name: "/AZR/WB_NOTEUSRR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan]: { sequence_name: "/AZR/WB_PLAN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Approval_Metrics]: { sequence_name: "/AZR/WB_PLANAMT_ID", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Product_Metrics]: { sequence_name: "/AZR/WB_PLANPRDMT_ID", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Funding_Metrics]: { sequence_name: "/AZR/WB_PLANFMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Group]: { sequence_name: "/AZR/WB_PLANGRP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Type]: { sequence_name: "/AZR/WB_PLANM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Type_Event_Type]: { sequence_name: "/AZR/WB_PLANMEVT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Type_Fund_Type]: { sequence_name: "/AZR/WB_PLANMFND_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Volume_Monthly_Metrics]: { sequence_name: "/AZR/WB_PLANMMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Override]: { sequence_name: "/AZR/WB_PLANO_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Product_Group]: { sequence_name: "/AZR/WB_PLANPG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Product]: { sequence_name: "/AZR/WB_PLANPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Redistrib_Volume_Metrics]: { sequence_name: "/AZR/WB_PLANRVMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Volume_Metrics]: { sequence_name: "/AZR/WB_PLANVMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Management]: { sequence_name: "/AZR/WB_PLNMGMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Management_User_Group]: { sequence_name: "/AZR/WB_PLNMGMTG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Management_Period]: { sequence_name: "/AZR/WB_PLNMGMTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Management_User]: { sequence_name: "/AZR/WB_PLNMGMTU_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Payment]: { sequence_name: "/AZR/WB_PMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Payment_Claim]: { sequence_name: "/AZR/WB_PMTCLMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Payment_Event_Spend]: { sequence_name: "/AZR/WB_PMTEVTS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Payment_Event_Spend_Product_Group]: {
        sequence_name: "/AZR/WB_PMTEVTSP_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Payment_Fund]: { sequence_name: "/AZR/WB_PMTFND_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Payment_Fund_Product_Group]: { sequence_name: "/AZR/WB_PMTFNDP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Payment_Type]: { sequence_name: "/AZR/WB_PMTTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Condition]: { sequence_name: "/AZR/PROD_CND_SEQ", ...KeyGenSpecs_Poolsize_50 },
    [PASchema.esWB_Product_Condition_Type]: { sequence_name: "/AZR/PROD_CNDM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Pricing_Engine]: { sequence_name: "/AZR/WB_PRICING_ENGINE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Pricing_Engine_Price_Relationship]: {
        sequence_name: "/AZR/WB_PRICING_ENGINE_PR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Queue]: { sequence_name: "/AZR/WB_QUEUE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Queue_RunId]: { sequence_name: "/AZR/WB_QUEUE_RUN_ID_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Report]: { sequence_name: "/AZR/WB_REPORT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Report_Metric]: { sequence_name: "/AZR/WB_REPORT_METRICR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Report_Export]: { sequence_name: "/AZR/WB_REPORT_EXPORT_SEQ", ...KeyGenSpecs_BigInt_PoolSize_2000 },
    [PASchema.esWB_ReportTile]: { sequence_name: "/AZR/WB_RPTTL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_ReportTile_Dimension]: { sequence_name: "/AZR/WB_RPTTLDR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Report_Customer_Hierarchy]: { sequence_name: "/AZR/WB_RPT_CUSTH_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Report_Product_Group_Hierarchy]: {
        sequence_name: "/AZR/WB_RPT_PRDGRPH_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Report_Time_Hierarchy]: { sequence_name: "/AZR/WB_RPT_TIMEH_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Search]: { sequence_name: "/AZR/WB_SEARCH_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Search_Profile]: { sequence_name: "/AZR/WB_SEARCH_PROFILE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Search_ProfileCR]: { sequence_name: "/AZR/WB_SEARCH_PROFILECR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Search_ProfileFCR]: { sequence_name: "/AZR/WB_SEARCH_PROFILEFCR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Search_ProfileGCR]: { sequence_name: "/AZR/WB_SEARCH_PROFILEGCR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Session]: { sequence_name: "/AZR/WB_SESSION_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot]: { sequence_name: "/AZR/WB_SNAPSHOT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_Type]: { sequence_name: "/AZR/WB_SNAPSHTM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_Param]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamGLR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMGLR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamGLELR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMGLELR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamSAR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMSAR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamAMR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMAMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamCHR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMCHR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamPHR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMPHR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamGLCHR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMGLCHR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamGLPHR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMGLPHR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamPlnR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMPLNR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_ParamETR]: { sequence_name: "/AZR/WB_SNAPSHOT_PARAMETR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Plan_Volume_Metrics_Snapshot]: { sequence_name: "/AZR/WB_PLANVMTS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_Msar]: { sequence_name: "/AZR/WB_SNAPSHOT_CUSTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Snapshot_Customer_Relationship]: {
        sequence_name: "/AZR/WB_SNAPSHOT_CUSTR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Snapshot_ProductGroup_Relationship]: {
        sequence_name: "/AZR/WB_SNAPSHOT_PRDR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Snapshot_Period_Relationship]: {
        sequence_name: "/AZR/WB_SNAPSHOT_PERIODSEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Snapshot_Plan_Relationship]: { sequence_name: "/AZR/WB_SNAPSHOT_PLANR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Spend_Method_Rule]: { sequence_name: "/AZR/WB_SPENDCLR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Spend_Type]: { sequence_name: "/AZR/WB_EVTSTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Spend_Allocation_Rule]: { sequence_name: "/AZR/WB_SPENDRL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Spend_Allocation_Rule_Item]: { sequence_name: "/AZR/WB_SPENDRLR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Workflow_Status]: { sequence_name: "/AZR/WB_STATUS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Status_History]: { sequence_name: "/AZR/WB_STATUSH_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Status_History_Log]: { sequence_name: "/AZR/WB_STATUSHL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Status_Relationship]: { sequence_name: "/AZR/WB_STATUSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Subject_Area]: { sequence_name: "/AZR/WB_SUBJECT_AREA_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag]: { sequence_name: "/AZR/WB_TAG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Source]: { sequence_name: "/AZR/WB_TAG_SOURCE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Function]: { sequence_name: "/AZR/WB_TAG_FUNCTION_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Function_Param]: { sequence_name: "/AZR/WB_TAG_FUNCTION_PARAM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Meta_Tags]: { sequence_name: "/AZR/WB_TAGMETAR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Metric]: { sequence_name: "/AZR/WB_TAGMTRCR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Relationship]: { sequence_name: "/AZR/WB_TAGR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Text]: { sequence_name: "/AZR/WB_TAGT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Rule]: { sequence_name: "/AZR/WB_TAG_RULE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Tag_Rule_Param]: { sequence_name: "/AZR/WB_TAG_RULE_PARAM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event]: { sequence_name: "/AZR/WB_TEVT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Metrics]: { sequence_name: "/AZR/WB_TEVTMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Product_Group]: { sequence_name: "/AZR/WB_TEVTPG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Product]: { sequence_name: "/AZR/WB_TEVTPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Spend]: { sequence_name: "/AZR/WB_TEVTS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Spend_Metrics]: { sequence_name: "/AZR/WB_TEVTSMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Product_Metrics]: { sequence_name: "/AZR/WB_TEVTPRDMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Spend_Product_Group]: { sequence_name: "/AZR/WB_TEVTSPG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Spend_Product]: { sequence_name: "/AZR/WB_TEVTSPRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Tag]: { sequence_name: "/AZR/WB_TEVTTAGR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_TPM_Event_Spend_Customer]: { sequence_name: "/AZR/WB_TEVTSCST_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Timing]: { sequence_name: "/AZR/WB_TIMING_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Transaction]: { sequence_name: "/AZR/WB_TXN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Transaction_Item]: { sequence_name: "/AZR/WB_TXNITEM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_GLTransaction]: { sequence_name: "/AZR/WB_GLTXN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_GLTransaction_Item]: { sequence_name: "/AZR/WB_GLTXN_ITEM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_GLAccount_Balance]: { sequence_name: "/AZR/WB_GLACCT_BAL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Transaction_Type]: { sequence_name: "/AZR/WB_TXNTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Consumer_Product_Customer_Alignment]: {
        sequence_name: "/AZR/WB_UPCPRDPR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Consumer_Product_Alignment]: { sequence_name: "/AZR/WB_UPCPRDR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BusinessUnit_User]: { sequence_name: "/AZR/WB_USRBUSINESSUNITR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Customer]: { sequence_name: "/AZR/WB_USRCUSTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Dimension]: { sequence_name: "/AZR/WB_USRDIMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Group]: { sequence_name: "/AZR/WB_USRGRP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Group_Customer]: { sequence_name: "/AZR/WB_USRGRPCR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Group_Product]: { sequence_name: "/AZR/WB_USRGRPPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Group_Role]: { sequence_name: "/AZR/WB_USRGRPRR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Group_User]: { sequence_name: "/AZR/WB_USRGRPUR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Role]: { sequence_name: "/AZR/WB_USRROLER_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_User_Reviewers]: { sequence_name: "/AZR/WB_USRRVWR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Workflow]: { sequence_name: "/AZR/WB_WORKFLOW_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Workspace]: { sequence_name: "/AZR/WB_WRKSP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Workspace_Dimension]: { sequence_name: "/AZR/WB_WRKSPDMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Workspace_Report]: { sequence_name: "/AZR/WB_WRKSPRTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Workspace_Report_Dimension]: { sequence_name: "/AZR/WB_WRKSPRTDMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_Profile]: { sequence_name: "/AZR/WB_UI_PROFILE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_AppSuite_Type]: { sequence_name: "/AZR/WB_UI_APPSUITEM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_Usage]: { sequence_name: "/AZR/WB_UI_USAGE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_AppSuite]: { sequence_name: "/AZR/WB_UI_APPSUITE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_AppSuite_App_Relationship]: {
        sequence_name: "/AZR/WB_UI_APPSUITEAR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_UI_AppModule]: { sequence_name: "/AZR/WB_UI_APPMODULE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_AppExecutable]: { sequence_name: "/AZR/WB_UI_APPEXEC_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_Application]: { sequence_name: "/AZR/WB_UI_APP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UI_App_Report]: { sequence_name: "/AZR/WB_UI_APP_REPORT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_UOM]: { sequence_name: "/AZR/WB_UOM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_License]: { sequence_name: "/AZR/WB_LICENSE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Benchmark]: { sequence_name: "/AZR/WB_BENCHMARK_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Schedule]: { sequence_name: "/AZR/WB_SCHEDULE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Baseline]: { sequence_name: "/AZR/WB_BASELINE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Baseline_Metrics]: { sequence_name: "/AZR/WB_BASELINEMT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Custom_Column]: { sequence_name: "/AZR/WB_CUSTOM_COLUMN_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Param]: { sequence_name: "/AZR/WB_JOB_PARAM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Job_ParamSR]: { sequence_name: "/AZR/WB_JOB_PARAMSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BatchProcess]: { sequence_name: "/AZR/WB_BATCHPROCESS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScope]: { sequence_name: "/AZR/WB_BATCHSCOPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScopeCR]: { sequence_name: "/AZR/WB_BATCHSCOPECR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScopeMR]: { sequence_name: "/AZR/WB_BATCHSCOPEMR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScopeSR]: { sequence_name: "/AZR/WB_BATCHSCOPESR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Staging]: { sequence_name: "/AZR/WB_STAGING_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Staging_ClientRaw]: { sequence_name: "/AZR/WB_STAGING_CLIENTRAW_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Staging_Archive]: { sequence_name: "/AZR/WB_STAGING_ARCHIVE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PEA_Event_Override]: { sequence_name: "/AZR/WB_OVERRIDE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PEA_Event_ProductGroup_Override]: {
        sequence_name: "/AZR/WB_OVERRIDE_PRDGRP_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_PEA_Event_Spend_Override]: { sequence_name: "/AZR/WB_OVERRIDE_EVTS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PEA_Event_Spend_ProductGroup_Override]: {
        sequence_name: "/AZR/WB_OVERRIDE_EVTSPG_SEQ",
        ...KeyGenSpecs_default,
    },
});
